/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignUpIndexRouteImport } from './routes/sign-up/index'
import { Route as SignInIndexRouteImport } from './routes/sign-in/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password/index'
import { Route as SurveyRespondTokenRouteImport } from './routes/survey-respond/$token'
import { Route as SignUpOrgIdRouteImport } from './routes/sign-up/$orgId'
import { Route as SignInSplatRouteImport } from './routes/sign-in/$'
import { Route as SessionTasksSetupMfaRouteImport } from './routes/session-tasks/setup-mfa'
import { Route as QuickReportShareTokenRouteImport } from './routes/quick-report/$shareToken'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as GhgSurveyTokenRouteImport } from './routes/ghg-survey/$token'
import { Route as AuditorTokenRouteImport } from './routes/auditor/$token'
import { Route as AuthenticatedWorkforceReadinessRouteImport } from './routes/_authenticated/workforce-readiness'
import { Route as AuthenticatedVsmeRouteImport } from './routes/_authenticated/vsme'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedNis2RouteImport } from './routes/_authenticated/nis2'
import { Route as AuthenticatedHelpCentreRouteImport } from './routes/_authenticated/help-centre'
import { Route as AuthenticatedGhgRouteImport } from './routes/_authenticated/ghg'
import { Route as AuthenticatedEuTaxonomyRouteImport } from './routes/_authenticated/eu-taxonomy'
import { Route as AuthenticatedEsgRouteImport } from './routes/_authenticated/esg'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedControlsRouteImport } from './routes/_authenticated/controls'
import { Route as AuthenticatedBcpRouteImport } from './routes/_authenticated/bcp'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedVulnerabilitiesIndexRouteImport } from './routes/_authenticated/vulnerabilities/index'
import { Route as AuthenticatedThreatsIndexRouteImport } from './routes/_authenticated/threats/index'
import { Route as AuthenticatedSurveysIndexRouteImport } from './routes/_authenticated/surveys/index'
import { Route as AuthenticatedSuppliersIndexRouteImport } from './routes/_authenticated/suppliers/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRisksIndexRouteImport } from './routes/_authenticated/risks/index'
import { Route as AuthenticatedProceduresIndexRouteImport } from './routes/_authenticated/procedures/index'
import { Route as AuthenticatedPoliciesIndexRouteImport } from './routes/_authenticated/policies/index'
import { Route as AuthenticatedIncidentsIndexRouteImport } from './routes/_authenticated/incidents/index'
import { Route as AuthenticatedGapsIndexRouteImport } from './routes/_authenticated/gaps/index'
import { Route as AuthenticatedExternalReportingIndexRouteImport } from './routes/_authenticated/external-reporting/index'
import { Route as AuthenticatedEvidenceIndexRouteImport } from './routes/_authenticated/evidence/index'
import { Route as AuthenticatedEmployeesIndexRouteImport } from './routes/_authenticated/employees/index'
import { Route as AuthenticatedDatahubIndexRouteImport } from './routes/_authenticated/datahub/index'
import { Route as AuthenticatedControlsIndexRouteImport } from './routes/_authenticated/controls/index'
import { Route as AuthenticatedAuditIndexRouteImport } from './routes/_authenticated/audit/index'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as AuthenticatedAiIndexRouteImport } from './routes/_authenticated/ai/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as PortalQuestionnaireTokenRouteImport } from './routes/portal/questionnaire/$token'
import { Route as PortalProfileTokenRouteImport } from './routes/portal/profile/$token'
import { Route as PortalHomeTokenRouteImport } from './routes/portal/home/$token'
import { Route as PortalHistoryTokenRouteImport } from './routes/portal/history/$token'
import { Route as PortalAuthLoginRouteImport } from './routes/portal/auth/login'
import { Route as AuthenticatedWorkforceReadinessTrainingRegisterRouteImport } from './routes/_authenticated/workforce-readiness/training-register'
import { Route as AuthenticatedWorkforceReadinessMyTrainingsRouteImport } from './routes/_authenticated/workforce-readiness/my-trainings'
import { Route as AuthenticatedWorkforceReadinessAwarenessCampaignsRouteImport } from './routes/_authenticated/workforce-readiness/awareness-campaigns'
import { Route as AuthenticatedVulnerabilitiesWorkspaceRouteImport } from './routes/_authenticated/vulnerabilities/workspace'
import { Route as AuthenticatedVulnerabilitiesSubsidiariesRouteImport } from './routes/_authenticated/vulnerabilities/subsidiaries'
import { Route as AuthenticatedVulnerabilitiesSoc2ComplianceRouteImport } from './routes/_authenticated/vulnerabilities/soc2-compliance'
import { Route as AuthenticatedVulnerabilitiesSlaReportRouteImport } from './routes/_authenticated/vulnerabilities/sla-report'
import { Route as AuthenticatedVulnerabilitiesSettingsRouteImport } from './routes/_authenticated/vulnerabilities/settings'
import { Route as AuthenticatedVulnerabilitiesNis2ReportRouteImport } from './routes/_authenticated/vulnerabilities/nis2-report'
import { Route as AuthenticatedVulnerabilitiesNewRouteImport } from './routes/_authenticated/vulnerabilities/new'
import { Route as AuthenticatedVulnerabilitiesDashboardRouteImport } from './routes/_authenticated/vulnerabilities/dashboard'
import { Route as AuthenticatedVulnerabilitiesConsolidatedReportRouteImport } from './routes/_authenticated/vulnerabilities/consolidated-report'
import { Route as AuthenticatedVulnerabilitiesAuditReportRouteImport } from './routes/_authenticated/vulnerabilities/audit-report'
import { Route as AuthenticatedVulnerabilitiesVulnerabilityIdRouteImport } from './routes/_authenticated/vulnerabilities/$vulnerabilityId'
import { Route as AuthenticatedVsmeSectionRouteImport } from './routes/_authenticated/vsme/$section'
import { Route as AuthenticatedTasksMyRouteImport } from './routes/_authenticated/tasks/my'
import { Route as AuthenticatedTasksConsoleRouteImport } from './routes/_authenticated/tasks/console'
import { Route as AuthenticatedTasksApprovalsRouteImport } from './routes/_authenticated/tasks/approvals'
import { Route as AuthenticatedTasksTaskIdRouteImport } from './routes/_authenticated/tasks/$taskId'
import { Route as AuthenticatedSuppliersRiskRouteImport } from './routes/_authenticated/suppliers/risk'
import { Route as AuthenticatedSuppliersRegisterRouteImport } from './routes/_authenticated/suppliers/register'
import { Route as AuthenticatedSuppliersComplianceMatrixRouteImport } from './routes/_authenticated/suppliers/compliance-matrix'
import { Route as AuthenticatedSuppliersSupplierIdRouteImport } from './routes/_authenticated/suppliers/$supplierId'
import { Route as AuthenticatedSettingsVulnerabilitySettingsRouteImport } from './routes/_authenticated/settings/vulnerability-settings'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedSettingsTaskSchedulesRouteImport } from './routes/_authenticated/settings/task-schedules'
import { Route as AuthenticatedSettingsSupplierCategoriesRouteImport } from './routes/_authenticated/settings/supplier-categories'
import { Route as AuthenticatedSettingsSubsidiariesRouteImport } from './routes/_authenticated/settings/subsidiaries'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsScannerIntegrationsRouteImport } from './routes/_authenticated/settings/scanner-integrations'
import { Route as AuthenticatedSettingsRolesRouteImport } from './routes/_authenticated/settings/roles'
import { Route as AuthenticatedSettingsRiskRouteImport } from './routes/_authenticated/settings/risk'
import { Route as AuthenticatedSettingsReportingPeriodsRouteImport } from './routes/_authenticated/settings/reporting-periods'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsPolicyCategoriesRouteImport } from './routes/_authenticated/settings/policy-categories'
import { Route as AuthenticatedSettingsOrganizationsRouteImport } from './routes/_authenticated/settings/organizations'
import { Route as AuthenticatedSettingsOrganisationStructureRouteImport } from './routes/_authenticated/settings/organisation-structure'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsNis2GapPriorityRouteImport } from './routes/_authenticated/settings/nis2-gap-priority'
import { Route as AuthenticatedSettingsNis2ClassificationRouteImport } from './routes/_authenticated/settings/nis2-classification'
import { Route as AuthenticatedSettingsMyActivityRouteImport } from './routes/_authenticated/settings/my-activity'
import { Route as AuthenticatedSettingsIncidentCategoriesRouteImport } from './routes/_authenticated/settings/incident-categories'
import { Route as AuthenticatedSettingsGhgSourcesRouteImport } from './routes/_authenticated/settings/ghg-sources'
import { Route as AuthenticatedSettingsGhgPermissionsRouteImport } from './routes/_authenticated/settings/ghg-permissions'
import { Route as AuthenticatedSettingsGhgFacilitiesRouteImport } from './routes/_authenticated/settings/ghg-facilities'
import { Route as AuthenticatedSettingsGhgBoundaryRouteImport } from './routes/_authenticated/settings/ghg-boundary'
import { Route as AuthenticatedSettingsGapDetectionRulesRouteImport } from './routes/_authenticated/settings/gap-detection-rules'
import { Route as AuthenticatedSettingsEvidenceCollectionsRouteImport } from './routes/_authenticated/settings/evidence-collections'
import { Route as AuthenticatedSettingsCredentialsRouteImport } from './routes/_authenticated/settings/credentials'
import { Route as AuthenticatedSettingsConfigrationRouteImport } from './routes/_authenticated/settings/configration'
import { Route as AuthenticatedSettingsComplianceFrameworksRouteImport } from './routes/_authenticated/settings/compliance-frameworks'
import { Route as AuthenticatedSettingsBcpReviewSettingsRouteImport } from './routes/_authenticated/settings/bcp-review-settings'
import { Route as AuthenticatedSettingsBcpExerciseSettingsRouteImport } from './routes/_authenticated/settings/bcp-exercise-settings'
import { Route as AuthenticatedSettingsAuditorsRouteImport } from './routes/_authenticated/settings/auditors'
import { Route as AuthenticatedSettingsAuditWebhooksRouteImport } from './routes/_authenticated/settings/audit-webhooks'
import { Route as AuthenticatedSettingsAuditSettingsRouteImport } from './routes/_authenticated/settings/audit-settings'
import { Route as AuthenticatedSettingsAuditLogRouteImport } from './routes/_authenticated/settings/audit-log'
import { Route as AuthenticatedSettingsAuditAlertsRouteImport } from './routes/_authenticated/settings/audit-alerts'
import { Route as AuthenticatedSettingsAssetTagsRouteImport } from './routes/_authenticated/settings/asset-tags'
import { Route as AuthenticatedSettingsAssetCustomFieldsRouteImport } from './routes/_authenticated/settings/asset-custom-fields'
import { Route as AuthenticatedSettingsAssetConnectorsRouteImport } from './routes/_authenticated/settings/asset-connectors'
import { Route as AuthenticatedSettingsAssetCategoriesRouteImport } from './routes/_authenticated/settings/asset-categories'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAiSettingsRouteImport } from './routes/_authenticated/settings/ai-settings'
import { Route as AuthenticatedSettingsAiConversationsRouteImport } from './routes/_authenticated/settings/ai-conversations'
import { Route as AuthenticatedSettingsAccessLogRouteImport } from './routes/_authenticated/settings/access-log'
import { Route as AuthenticatedRisksNewRouteImport } from './routes/_authenticated/risks/new'
import { Route as AuthenticatedRisksHeatmapRouteImport } from './routes/_authenticated/risks/heatmap'
import { Route as AuthenticatedRisksDashboardRouteImport } from './routes/_authenticated/risks/dashboard'
import { Route as AuthenticatedRisksAiSuggestionsRouteImport } from './routes/_authenticated/risks/ai-suggestions'
import { Route as AuthenticatedRisksRiskIdRouteImport } from './routes/_authenticated/risks/$riskId'
import { Route as AuthenticatedProceduresProcedureIdRouteImport } from './routes/_authenticated/procedures/$procedureId'
import { Route as AuthenticatedPoliciesWizardRouteImport } from './routes/_authenticated/policies/wizard'
import { Route as AuthenticatedPoliciesDocumentsRouteImport } from './routes/_authenticated/policies/documents'
import { Route as AuthenticatedPoliciesCreateRouteImport } from './routes/_authenticated/policies/create'
import { Route as AuthenticatedPoliciesComplianceDashboardRouteImport } from './routes/_authenticated/policies/compliance-dashboard'
import { Route as AuthenticatedPoliciesPolicyIdRouteImport } from './routes/_authenticated/policies/$policyId'
import { Route as AuthenticatedNis2SupplyChainSecurityRouteImport } from './routes/_authenticated/nis2/supply-chain-security'
import { Route as AuthenticatedNis2SelfAssessmentRouteImport } from './routes/_authenticated/nis2/self-assessment'
import { Route as AuthenticatedNis2RiskManagementRouteImport } from './routes/_authenticated/nis2/risk-management'
import { Route as AuthenticatedNis2PolicyGovernanceRouteImport } from './routes/_authenticated/nis2/policy-governance'
import { Route as AuthenticatedNis2PoliciesGovernanceRouteImport } from './routes/_authenticated/nis2/policies-governance'
import { Route as AuthenticatedNis2OverviewRouteImport } from './routes/_authenticated/nis2/overview'
import { Route as AuthenticatedNis2OnboardingRouteImport } from './routes/_authenticated/nis2/onboarding'
import { Route as AuthenticatedNis2MeasureDRouteImport } from './routes/_authenticated/nis2/measure-d'
import { Route as AuthenticatedNis2MeasureARouteImport } from './routes/_authenticated/nis2/measure-a'
import { Route as AuthenticatedNis2KnowledgeBaseRouteImport } from './routes/_authenticated/nis2/knowledge-base'
import { Route as AuthenticatedNis2IsmsRouteImport } from './routes/_authenticated/nis2/isms'
import { Route as AuthenticatedNis2IncidentManagementRouteImport } from './routes/_authenticated/nis2/incident-management'
import { Route as AuthenticatedNis2HumanResourcesSecurityRouteImport } from './routes/_authenticated/nis2/human-resources-security'
import { Route as AuthenticatedNis2HrTrainingRouteImport } from './routes/_authenticated/nis2/hr-training'
import { Route as AuthenticatedNis2GapsRouteImport } from './routes/_authenticated/nis2/gaps'
import { Route as AuthenticatedNis2GapAnalysisRouteImport } from './routes/_authenticated/nis2/gap-analysis'
import { Route as AuthenticatedNis2EvidenceRouteImport } from './routes/_authenticated/nis2/evidence'
import { Route as AuthenticatedNis2EntityClassificationRouteImport } from './routes/_authenticated/nis2/entity-classification'
import { Route as AuthenticatedNis2DashboardRouteImport } from './routes/_authenticated/nis2/dashboard'
import { Route as AuthenticatedNis2BusinessContinuityRouteImport } from './routes/_authenticated/nis2/business-continuity'
import { Route as AuthenticatedNis2AssetsMeasuresRouteImport } from './routes/_authenticated/nis2/assets-measures'
import { Route as AuthenticatedNis2AssetsAndMeasuresRouteImport } from './routes/_authenticated/nis2/assets-and-measures'
import { Route as AuthenticatedNis2AssetRegisterRouteImport } from './routes/_authenticated/nis2/asset-register'
import { Route as AuthenticatedIncidentsSubsidiariesRouteImport } from './routes/_authenticated/incidents/subsidiaries'
import { Route as AuthenticatedIncidentsSettingsRouteImport } from './routes/_authenticated/incidents/settings'
import { Route as AuthenticatedIncidentsQuickReportRouteImport } from './routes/_authenticated/incidents/quick-report'
import { Route as AuthenticatedIncidentsNewRouteImport } from './routes/_authenticated/incidents/new'
import { Route as AuthenticatedIncidentsDashboardRouteImport } from './routes/_authenticated/incidents/dashboard'
import { Route as AuthenticatedIncidentsIncidentIdRouteImport } from './routes/_authenticated/incidents/$incidentId'
import { Route as AuthenticatedHelpCentreRegulationsRouteImport } from './routes/_authenticated/help-centre.regulations'
import { Route as AuthenticatedHelpCentrePlatformGuidesRouteImport } from './routes/_authenticated/help-centre.platform-guides'
import { Route as AuthenticatedGhgYoyComparisonRouteImport } from './routes/_authenticated/ghg/yoy-comparison'
import { Route as AuthenticatedGhgWasteRouteImport } from './routes/_authenticated/ghg/waste'
import { Route as AuthenticatedGhgTravelImportRouteImport } from './routes/_authenticated/ghg/travel-import'
import { Route as AuthenticatedGhgTasksRouteImport } from './routes/_authenticated/ghg/tasks'
import { Route as AuthenticatedGhgScope3ScreeningRouteImport } from './routes/_authenticated/ghg/scope3-screening'
import { Route as AuthenticatedGhgScope2RouteImport } from './routes/_authenticated/ghg/scope2'
import { Route as AuthenticatedGhgScope1RouteImport } from './routes/_authenticated/ghg/scope1'
import { Route as AuthenticatedGhgReportRouteImport } from './routes/_authenticated/ghg/report'
import { Route as AuthenticatedGhgRecalculationsRouteImport } from './routes/_authenticated/ghg/recalculations'
import { Route as AuthenticatedGhgProtocolComplianceRouteImport } from './routes/_authenticated/ghg/protocol-compliance'
import { Route as AuthenticatedGhgPoliciesRouteImport } from './routes/_authenticated/ghg/policies'
import { Route as AuthenticatedGhgOverviewRouteImport } from './routes/_authenticated/ghg/overview'
import { Route as AuthenticatedGhgNetZeroRouteImport } from './routes/_authenticated/ghg/net-zero'
import { Route as AuthenticatedGhgMarketInstrumentsRouteImport } from './routes/_authenticated/ghg/market-instruments'
import { Route as AuthenticatedGhgIso14064ComplianceRouteImport } from './routes/_authenticated/ghg/iso14064-compliance'
import { Route as AuthenticatedGhgIndustryComparisonRouteImport } from './routes/_authenticated/ghg/industry-comparison'
import { Route as AuthenticatedGhgGapAnalysisRouteImport } from './routes/_authenticated/ghg/gap-analysis'
import { Route as AuthenticatedGhgEmissionsRouteImport } from './routes/_authenticated/ghg/emissions'
import { Route as AuthenticatedGhgEmissionInsightsRouteImport } from './routes/_authenticated/ghg/emission-insights'
import { Route as AuthenticatedGhgEmissionFactorsRouteImport } from './routes/_authenticated/ghg/emission-factors'
import { Route as AuthenticatedGhgDataQualityRouteImport } from './routes/_authenticated/ghg/data-quality'
import { Route as AuthenticatedGhgDashboardRouteImport } from './routes/_authenticated/ghg/dashboard'
import { Route as AuthenticatedGhgCommutingRouteImport } from './routes/_authenticated/ghg/commuting'
import { Route as AuthenticatedGhgCollectRouteImport } from './routes/_authenticated/ghg/collect'
import { Route as AuthenticatedGhgCdpQuestionnaireRouteImport } from './routes/_authenticated/ghg/cdp-questionnaire'
import { Route as AuthenticatedGhgBusinessTravelRouteImport } from './routes/_authenticated/ghg/business-travel'
import { Route as AuthenticatedGhgBestPracticesRouteImport } from './routes/_authenticated/ghg/best-practices'
import { Route as AuthenticatedGhgAuditRouteImport } from './routes/_authenticated/ghg/audit'
import { Route as AuthenticatedGhgActivityGroupsRouteImport } from './routes/_authenticated/ghg/activity-groups'
import { Route as AuthenticatedExternalReportingReportIdRouteImport } from './routes/_authenticated/external-reporting/$reportId'
import { Route as AuthenticatedEvidenceRepositoryRouteImport } from './routes/_authenticated/evidence/repository'
import { Route as AuthenticatedEvidenceLogsRouteImport } from './routes/_authenticated/evidence/logs'
import { Route as AuthenticatedEvidenceEvidenceIdRouteImport } from './routes/_authenticated/evidence/$evidenceId'
import { Route as AuthenticatedEuTaxonomySectionRouteImport } from './routes/_authenticated/eu-taxonomy/$section'
import { Route as AuthenticatedEsgSectionRouteImport } from './routes/_authenticated/esg/$section'
import { Route as AuthenticatedEmployeesNewRouteImport } from './routes/_authenticated/employees/new'
import { Route as AuthenticatedEmployeesImportRouteImport } from './routes/_authenticated/employees/import'
import { Route as AuthenticatedEmployeesEmployeeIdRouteImport } from './routes/_authenticated/employees/$employeeId'
import { Route as AuthenticatedDatahubValidationErrorsRouteImport } from './routes/_authenticated/datahub/validation-errors'
import { Route as AuthenticatedDatahubUploadRouteImport } from './routes/_authenticated/datahub/upload'
import { Route as AuthenticatedDatahubTemplatesRouteImport } from './routes/_authenticated/datahub/templates'
import { Route as AuthenticatedDatahubQualityIssuesRouteImport } from './routes/_authenticated/datahub/quality-issues'
import { Route as AuthenticatedDatahubQualityDashboardRouteImport } from './routes/_authenticated/datahub/quality-dashboard'
import { Route as AuthenticatedDatahubPeriodsRouteImport } from './routes/_authenticated/datahub/periods'
import { Route as AuthenticatedDatahubMyEntriesRouteImport } from './routes/_authenticated/datahub/my-entries'
import { Route as AuthenticatedDatahubEntryRouteImport } from './routes/_authenticated/datahub/entry'
import { Route as AuthenticatedDatahubDocumentsRouteImport } from './routes/_authenticated/datahub/documents'
import { Route as AuthenticatedDatahubConsolidatedRouteImport } from './routes/_authenticated/datahub/consolidated'
import { Route as AuthenticatedDatahubComparisonRouteImport } from './routes/_authenticated/datahub/comparison'
import { Route as AuthenticatedDatahubAuditRouteImport } from './routes/_authenticated/datahub/audit'
import { Route as AuthenticatedControlsControlIdRouteImport } from './routes/_authenticated/controls/$controlId'
import { Route as AuthenticatedComplianceAlertsRouteImport } from './routes/_authenticated/compliance/alerts'
import { Route as AuthenticatedBcpPlansRouteImport } from './routes/_authenticated/bcp/plans'
import { Route as AuthenticatedBcpFindingsRouteImport } from './routes/_authenticated/bcp/findings'
import { Route as AuthenticatedBcpDashboardRouteImport } from './routes/_authenticated/bcp/dashboard'
import { Route as AuthenticatedBcpContinuityRouteImport } from './routes/_authenticated/bcp/continuity'
import { Route as AuthenticatedBcpBiaRouteImport } from './routes/_authenticated/bcp/bia'
import { Route as AuthenticatedBcpBcpRouteImport } from './routes/_authenticated/bcp/bcp'
import { Route as AuthenticatedAuditReportsRouteImport } from './routes/_authenticated/audit/reports'
import { Route as AuthenticatedAuditFindingsRouteImport } from './routes/_authenticated/audit/findings'
import { Route as AuthenticatedAuditEvidenceUploadRouteImport } from './routes/_authenticated/audit/evidence-upload'
import { Route as AuthenticatedAuditEvidenceLibraryRouteImport } from './routes/_authenticated/audit/evidence-library'
import { Route as AuthenticatedAuditCalendarRouteImport } from './routes/_authenticated/audit/calendar'
import { Route as AuthenticatedAssetsImportRouteImport } from './routes/_authenticated/assets/import'
import { Route as AuthenticatedAssetsAssetIdRouteImport } from './routes/_authenticated/assets/$assetId'
import { Route as AuthenticatedAnalyticsGhgOverviewRouteImport } from './routes/_authenticated/analytics/ghg-overview'
import { Route as AuthenticatedAiUsageRouteImport } from './routes/_authenticated/ai/usage'
import { Route as AuthenticatedAiQualityRouteImport } from './routes/_authenticated/ai/quality'
import { Route as AuthenticatedAiInsightsRouteImport } from './routes/_authenticated/ai/insights'
import { Route as AuthenticatedAiDocumentsRouteImport } from './routes/_authenticated/ai/documents'
import { Route as AuthenticatedAdminSystemPromptsRouteImport } from './routes/_authenticated/admin/system-prompts'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminOrganizationsRouteImport } from './routes/_authenticated/admin/organizations'
import { Route as AuthenticatedAdminLlmSettingsRouteImport } from './routes/_authenticated/admin/llm-settings'
import { Route as AuthenticatedAdminKnowledgeBasesRouteImport } from './routes/_authenticated/admin/knowledge-bases'
import { Route as AuthenticatedAdminAiCostsRouteImport } from './routes/_authenticated/admin/ai-costs'
import { Route as PortalAuthForgotPasswordIndexRouteImport } from './routes/portal/auth/forgot-password/index'
import { Route as AuthenticatedVulnerabilitiesApprovalsIndexRouteImport } from './routes/_authenticated/vulnerabilities/approvals/index'
import { Route as AuthenticatedTasksPlaybooksIndexRouteImport } from './routes/_authenticated/tasks/playbooks/index'
import { Route as AuthenticatedSurveysSchedulesIndexRouteImport } from './routes/_authenticated/surveys/schedules/index'
import { Route as AuthenticatedSurveysCampaignsIndexRouteImport } from './routes/_authenticated/surveys/campaigns/index'
import { Route as AuthenticatedSettingsSecurityIndexRouteImport } from './routes/_authenticated/settings/security/index'
import { Route as AuthenticatedRisksApprovalsIndexRouteImport } from './routes/_authenticated/risks/approvals/index'
import { Route as AuthenticatedNis2ReportsIndexRouteImport } from './routes/_authenticated/nis2/reports/index'
import { Route as AuthenticatedNis2MeasuresIndexRouteImport } from './routes/_authenticated/nis2/measures/index'
import { Route as AuthenticatedNis2InspectionPreparationIndexRouteImport } from './routes/_authenticated/nis2/inspection-preparation/index'
import { Route as AuthenticatedGhgVerificationIndexRouteImport } from './routes/_authenticated/ghg/verification/index'
import { Route as AuthenticatedGhgVerificationStatementsIndexRouteImport } from './routes/_authenticated/ghg/verification-statements/index'
import { Route as AuthenticatedGhgThirdPartyVerificationIndexRouteImport } from './routes/_authenticated/ghg/third-party-verification/index'
import { Route as AuthenticatedGhgTargetsIndexRouteImport } from './routes/_authenticated/ghg/targets/index'
import { Route as AuthenticatedGhgSetupIndexRouteImport } from './routes/_authenticated/ghg/setup/index'
import { Route as AuthenticatedGhgSettingsIndexRouteImport } from './routes/_authenticated/ghg/settings/index'
import { Route as AuthenticatedGhgScenariosIndexRouteImport } from './routes/_authenticated/ghg/scenarios/index'
import { Route as AuthenticatedGhgReportsIndexRouteImport } from './routes/_authenticated/ghg/reports/index'
import { Route as AuthenticatedGhgReductionInitiativesIndexRouteImport } from './routes/_authenticated/ghg/reduction-initiatives/index'
import { Route as AuthenticatedGhgRecalculationsIndexRouteImport } from './routes/_authenticated/ghg/recalculations/index'
import { Route as AuthenticatedGhgIntegrationsIndexRouteImport } from './routes/_authenticated/ghg/integrations/index'
import { Route as AuthenticatedGhgExportsIndexRouteImport } from './routes/_authenticated/ghg/exports/index'
import { Route as AuthenticatedGhgCommutingSurveysIndexRouteImport } from './routes/_authenticated/ghg/commuting-surveys/index'
import { Route as AuthenticatedGhgApprovalsIndexRouteImport } from './routes/_authenticated/ghg/approvals/index'
import { Route as AuthenticatedGhgActivityDataIndexRouteImport } from './routes/_authenticated/ghg/activity-data/index'
import { Route as AuthenticatedEsgOnboardingIndexRouteImport } from './routes/_authenticated/esg/onboarding/index'
import { Route as AuthenticatedEsgDoubleMaterialityIndexRouteImport } from './routes/_authenticated/esg/double-materiality/index'
import { Route as AuthenticatedEmployeesEmployeeIdIndexRouteImport } from './routes/_authenticated/employees/$employeeId/index'
import { Route as AuthenticatedDatahubIntegrationsIndexRouteImport } from './routes/_authenticated/datahub/integrations/index'
import { Route as AuthenticatedDatahubDatapointsIndexRouteImport } from './routes/_authenticated/datahub/datapoints/index'
import { Route as AuthenticatedDatahubCollectionsIndexRouteImport } from './routes/_authenticated/datahub/collections/index'
import { Route as AuthenticatedBcpResourcesIndexRouteImport } from './routes/_authenticated/bcp/resources/index'
import { Route as AuthenticatedBcpPlansIndexRouteImport } from './routes/_authenticated/bcp/plans/index'
import { Route as AuthenticatedBcpExercisesIndexRouteImport } from './routes/_authenticated/bcp/exercises/index'
import { Route as AuthenticatedAuditEvidenceIndexRouteImport } from './routes/_authenticated/audit/evidence/index'
import { Route as AuthenticatedAuditAuditsIndexRouteImport } from './routes/_authenticated/audit/audits/index'
import { Route as AuthenticatedAnalyticsReportStudioIndexRouteImport } from './routes/_authenticated/analytics/report-studio/index'
import { Route as AuthenticatedAnalyticsDashboardsIndexRouteImport } from './routes/_authenticated/analytics/dashboards/index'
import { Route as AuthenticatedAiScansIndexRouteImport } from './routes/_authenticated/ai/scans/index'
import { Route as AuthenticatedAiDocumentsIndexRouteImport } from './routes/_authenticated/ai/documents/index'
import { Route as PortalAuthResetPasswordTokenRouteImport } from './routes/portal/auth/reset-password/$token'
import { Route as PortalAuthCreateAccountTokenRouteImport } from './routes/portal/auth/create-account/$token'
import { Route as AuditorAccessAccessIdTasksRouteImport } from './routes/auditor/access.$accessId.tasks'
import { Route as AuditorAccessAccessIdNis2RouteImport } from './routes/auditor/access.$accessId.nis2'
import { Route as AuditorAccessAccessIdControlsRouteImport } from './routes/auditor/access.$accessId.controls'
import { Route as AuditorAccessAccessIdBcpRouteImport } from './routes/auditor/access.$accessId.bcp'
import { Route as AuditorAccessAccessIdAuditRouteImport } from './routes/auditor/access.$accessId.audit'
import { Route as AuditorAccessAccessIdAssetsRouteImport } from './routes/auditor/access.$accessId.assets'
import { Route as AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRouteImport } from './routes/_authenticated/workforce-readiness/training-register/$trainingId'
import { Route as AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRouteImport } from './routes/_authenticated/workforce-readiness/awareness-campaigns/$campaignId'
import { Route as AuthenticatedTasksPlaybooksActivateRouteImport } from './routes/_authenticated/tasks/playbooks/activate'
import { Route as AuthenticatedTasksConsoleApprovalsRouteImport } from './routes/_authenticated/tasks/console/approvals'
import { Route as AuthenticatedSurveysTemplatesNewRouteImport } from './routes/_authenticated/surveys/templates/new'
import { Route as AuthenticatedSurveysTemplatesTemplateIdRouteImport } from './routes/_authenticated/surveys/templates/$templateId'
import { Route as AuthenticatedSurveysCampaignsNewRouteImport } from './routes/_authenticated/surveys/campaigns/new'
import { Route as AuthenticatedSurveysCampaignsCampaignIdRouteImport } from './routes/_authenticated/surveys/campaigns/$campaignId'
import { Route as AuthenticatedSuppliersAdminRiskConfigRouteImport } from './routes/_authenticated/suppliers/admin/risk-config'
import { Route as AuthenticatedSettingsSecuritySessionsRouteImport } from './routes/_authenticated/settings/security/sessions'
import { Route as AuthenticatedSettingsNis2RemindersRouteImport } from './routes/_authenticated/settings/nis2/reminders'
import { Route as AuthenticatedSettingsAiConversationsConversationIdRouteImport } from './routes/_authenticated/settings/ai-conversations.$conversationId'
import { Route as AuthenticatedPoliciesPolicyIdReviewRouteImport } from './routes/_authenticated/policies/$policyId.review'
import { Route as AuthenticatedPoliciesPolicyIdEditRouteImport } from './routes/_authenticated/policies/$policyId.edit'
import { Route as AuthenticatedNis2ReportsScheduledRouteImport } from './routes/_authenticated/nis2/reports/scheduled'
import { Route as AuthenticatedNis2ReportsExecutiveRouteImport } from './routes/_authenticated/nis2/reports/executive'
import { Route as AuthenticatedNis2ReportsCrossBorderRouteImport } from './routes/_authenticated/nis2/reports/cross-border'
import { Route as AuthenticatedNis2ReportsConsolidatedRouteImport } from './routes/_authenticated/nis2/reports/consolidated'
import { Route as AuthenticatedNis2ReportsComplianceRouteImport } from './routes/_authenticated/nis2/reports/compliance'
import { Route as AuthenticatedNis2ReportsBoardRouteImport } from './routes/_authenticated/nis2/reports/board'
import { Route as AuthenticatedNis2ReportsAuditPreparationRouteImport } from './routes/_authenticated/nis2/reports/audit-preparation'
import { Route as AuthenticatedNis2ReportsActivityRouteImport } from './routes/_authenticated/nis2/reports/activity'
import { Route as AuthenticatedNis2MeasuresMeasureCodeRouteImport } from './routes/_authenticated/nis2/measures/$measureCode'
import { Route as AuthenticatedNis2InspectionPreparationPreparationIdRouteImport } from './routes/_authenticated/nis2/inspection-preparation/$preparationId'
import { Route as AuthenticatedIncidentsSettingsSlaRouteImport } from './routes/_authenticated/incidents/settings/sla'
import { Route as AuthenticatedGhgVerificationChecklistIdRouteImport } from './routes/_authenticated/ghg/verification/$checklistId'
import { Route as AuthenticatedGhgVerificationStatementsStatementIdRouteImport } from './routes/_authenticated/ghg/verification-statements/$statementId'
import { Route as AuthenticatedGhgThirdPartyVerificationEngagementIdRouteImport } from './routes/_authenticated/ghg/third-party-verification/$engagementId'
import { Route as AuthenticatedGhgTargetsNewRouteImport } from './routes/_authenticated/ghg/targets/new'
import { Route as AuthenticatedGhgTargetsTargetIdRouteImport } from './routes/_authenticated/ghg/targets/$targetId'
import { Route as AuthenticatedGhgSettingsScope2RouteImport } from './routes/_authenticated/ghg/settings/scope2'
import { Route as AuthenticatedGhgSettingsScope1RouteImport } from './routes/_authenticated/ghg/settings/scope1'
import { Route as AuthenticatedGhgScope3SoldProductsRouteImport } from './routes/_authenticated/ghg/scope3/sold-products'
import { Route as AuthenticatedGhgScope3AddRouteImport } from './routes/_authenticated/ghg/scope3/add'
import { Route as AuthenticatedGhgScope3CategoryRouteImport } from './routes/_authenticated/ghg/scope3/$category'
import { Route as AuthenticatedGhgScenariosNewRouteImport } from './routes/_authenticated/ghg/scenarios/new'
import { Route as AuthenticatedGhgScenariosCompareRouteImport } from './routes/_authenticated/ghg/scenarios/compare'
import { Route as AuthenticatedGhgScenariosScenarioIdRouteImport } from './routes/_authenticated/ghg/scenarios/$scenarioId'
import { Route as AuthenticatedGhgReductionInitiativesNewRouteImport } from './routes/_authenticated/ghg/reduction-initiatives/new'
import { Route as AuthenticatedGhgReductionInitiativesInitiativeIdRouteImport } from './routes/_authenticated/ghg/reduction-initiatives/$initiativeId'
import { Route as AuthenticatedGhgRecalculationsRecalculationIdRouteImport } from './routes/_authenticated/ghg/recalculations/$recalculationId'
import { Route as AuthenticatedGhgIntegrationsConnectorIdRouteImport } from './routes/_authenticated/ghg/integrations/$connectorId'
import { Route as AuthenticatedGhgFacilitiesDashboardRouteImport } from './routes/_authenticated/ghg/facilities/dashboard'
import { Route as AuthenticatedGhgCommutingSurveysNewRouteImport } from './routes/_authenticated/ghg/commuting-surveys/new'
import { Route as AuthenticatedGhgCommutingSurveysSurveyIdRouteImport } from './routes/_authenticated/ghg/commuting-surveys/$surveyId'
import { Route as AuthenticatedGhgCalculationsScope3RouteImport } from './routes/_authenticated/ghg/calculations/scope3'
import { Route as AuthenticatedGhgCalculationsScope2RouteImport } from './routes/_authenticated/ghg/calculations/scope2'
import { Route as AuthenticatedGhgCalculationsScope1RouteImport } from './routes/_authenticated/ghg/calculations/scope1'
import { Route as AuthenticatedGhgActivityDataImportRouteImport } from './routes/_authenticated/ghg/activity-data/import'
import { Route as AuthenticatedGhgActivityDataDocumentOcrRouteImport } from './routes/_authenticated/ghg/activity-data/document-ocr'
import { Route as AuthenticatedGhgActivityDataAssignmentQueueRouteImport } from './routes/_authenticated/ghg/activity-data/assignment-queue'
import { Route as AuthenticatedGhgActivityDataEntryIdRouteImport } from './routes/_authenticated/ghg/activity-data/$entryId'
import { Route as AuthenticatedEvidenceAttestationsNewRouteImport } from './routes/_authenticated/evidence/attestations/new'
import { Route as AuthenticatedEsgOnboardingOnboardingIdRouteImport } from './routes/_authenticated/esg/onboarding/$onboardingId'
import { Route as AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRouteImport } from './routes/_authenticated/esg/double-materiality/datapoints-policies'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId'
import { Route as AuthenticatedEmployeesEmployeeIdEditRouteImport } from './routes/_authenticated/employees/$employeeId/edit'
import { Route as AuthenticatedDatahubIntegrationsTransformationRulesRouteImport } from './routes/_authenticated/datahub/integrations/transformation-rules'
import { Route as AuthenticatedDatahubGovernanceScheduledExportsRouteImport } from './routes/_authenticated/datahub/governance/scheduled-exports'
import { Route as AuthenticatedDatahubGovernanceApprovalQueueRouteImport } from './routes/_authenticated/datahub/governance/approval-queue'
import { Route as AuthenticatedDatahubGovernanceApprovalConfigRouteImport } from './routes/_authenticated/datahub/governance/approval-config'
import { Route as AuthenticatedDatahubEntryWizardRouteImport } from './routes/_authenticated/datahub/entry.wizard'
import { Route as AuthenticatedDatahubDatapointsDatapointIdRouteImport } from './routes/_authenticated/datahub/datapoints/$datapointId'
import { Route as AuthenticatedDatahubCollectionsCollectionIdRouteImport } from './routes/_authenticated/datahub/collections/$collectionId'
import { Route as AuthenticatedBcpResourcesSitesRouteImport } from './routes/_authenticated/bcp/resources/sites'
import { Route as AuthenticatedBcpReportsPlanStatusRouteImport } from './routes/_authenticated/bcp/reports.plan-status'
import { Route as AuthenticatedBcpReportsNis2ComplianceRouteImport } from './routes/_authenticated/bcp/reports.nis2-compliance'
import { Route as AuthenticatedBcpReportsIso22301RouteImport } from './routes/_authenticated/bcp/reports.iso-22301'
import { Route as AuthenticatedBcpReportsGapAnalysisRouteImport } from './routes/_authenticated/bcp/reports.gap-analysis'
import { Route as AuthenticatedBcpReportsExerciseSummaryRouteImport } from './routes/_authenticated/bcp/reports.exercise-summary'
import { Route as AuthenticatedBcpPlansRecoveryRouteImport } from './routes/_authenticated/bcp/plans/recovery'
import { Route as AuthenticatedBcpPlansNewRecoveryProcedureRouteImport } from './routes/_authenticated/bcp/plans/new-recovery-procedure'
import { Route as AuthenticatedBcpPlansNewItDrRouteImport } from './routes/_authenticated/bcp/plans/new-it-dr'
import { Route as AuthenticatedBcpPlansNewCrisisCommunicationRouteImport } from './routes/_authenticated/bcp/plans.new-crisis-communication'
import { Route as AuthenticatedBcpPlansNewRouteImport } from './routes/_authenticated/bcp/plans/new'
import { Route as AuthenticatedBcpPlansItDrRouteImport } from './routes/_authenticated/bcp/plans/it-dr'
import { Route as AuthenticatedBcpPlansCrisisCommRouteImport } from './routes/_authenticated/bcp/plans/crisis-comm'
import { Route as AuthenticatedBcpPlansBcpRouteImport } from './routes/_authenticated/bcp/plans/bcp'
import { Route as AuthenticatedBcpPlansPlanIdRouteImport } from './routes/_authenticated/bcp/plans/$planId'
import { Route as AuthenticatedBcpExercisesScheduleRouteImport } from './routes/_authenticated/bcp/exercises/schedule'
import { Route as AuthenticatedBcpExercisesNewRouteImport } from './routes/_authenticated/bcp/exercises/new'
import { Route as AuthenticatedBcpExercisesExerciseIdRouteImport } from './routes/_authenticated/bcp/exercises.$exerciseId'
import { Route as AuthenticatedBcpBiaBiaIdRouteImport } from './routes/_authenticated/bcp/bia.$biaId'
import { Route as AuthenticatedAuditEvidenceEvidenceIdRouteImport } from './routes/_authenticated/audit/evidence/$evidenceId'
import { Route as AuthenticatedAuditAuditsNewRouteImport } from './routes/_authenticated/audit/audits/new'
import { Route as AuthenticatedAnalyticsReportStudioTemplatesRouteImport } from './routes/_authenticated/analytics/report-studio/templates'
import { Route as AuthenticatedAnalyticsReportStudioNewRouteImport } from './routes/_authenticated/analytics/report-studio/new'
import { Route as AuthenticatedAnalyticsReportStudioReportIdRouteImport } from './routes/_authenticated/analytics/report-studio/$reportId'
import { Route as AuthenticatedAnalyticsDashboardsDashboardIdRouteImport } from './routes/_authenticated/analytics/dashboards/$dashboardId'
import { Route as AuthenticatedAiScansScanIdRouteImport } from './routes/_authenticated/ai/scans/$scanId'
import { Route as AuthenticatedAiOnboardingModuleRouteImport } from './routes/_authenticated/ai/onboarding/$module'
import { Route as AuthenticatedAdminPoliciesTemplatesRouteImport } from './routes/_authenticated/admin/policies/templates'
import { Route as AuthenticatedAdminPoliciesApprovalConfigsRouteImport } from './routes/_authenticated/admin/policies/approval-configs'
import { Route as AuthenticatedAdminPoliciesAccessControlsRouteImport } from './routes/_authenticated/admin/policies/access-controls'
import { Route as AuthenticatedAdminIncidentsTagsRouteImport } from './routes/_authenticated/admin/incidents/tags'
import { Route as AuthenticatedTasksPlaybooksTemplatesIndexRouteImport } from './routes/_authenticated/tasks/playbooks/templates/index'
import { Route as AuthenticatedTasksPlaybooksActivationIdIndexRouteImport } from './routes/_authenticated/tasks/playbooks/$activationId.index'
import { Route as AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRouteImport } from './routes/_authenticated/suppliers/admin/questionnaire-templates/index'
import { Route as AuthenticatedGhgVerificationInternalIndexRouteImport } from './routes/_authenticated/ghg/verification/internal/index'
import { Route as AuthenticatedGhgScope3CategoryIndexRouteImport } from './routes/_authenticated/ghg/scope3/$category/index'
import { Route as AuthenticatedGhgReportsCustomIndexRouteImport } from './routes/_authenticated/ghg/reports/custom/index'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/index'
import { Route as AuthenticatedDatahubCollectionsCollectionIdIndexRouteImport } from './routes/_authenticated/datahub/collections/$collectionId/index'
import { Route as AuthenticatedBcpPlansPlanIdIndexRouteImport } from './routes/_authenticated/bcp/plans/$planId.index'
import { Route as AuthenticatedBcpExercisesExerciseIdIndexRouteImport } from './routes/_authenticated/bcp/exercises.$exerciseId.index'
import { Route as AuthenticatedAuditAuditsAuditIdIndexRouteImport } from './routes/_authenticated/audit/audits/$auditId/index'
import { Route as AuditorAccessAccessIdNis2MeasuresRouteImport } from './routes/auditor/access.$accessId.nis2.measures'
import { Route as AuditorAccessAccessIdNis2IncidentsRouteImport } from './routes/auditor/access.$accessId.nis2.incidents'
import { Route as AuditorAccessAccessIdNis2GapsRouteImport } from './routes/auditor/access.$accessId.nis2.gaps'
import { Route as AuditorAccessAccessIdNis2EvidenceRouteImport } from './routes/auditor/access.$accessId.nis2.evidence'
import { Route as AuditorAccessAccessIdNis2AssessmentsRouteImport } from './routes/auditor/access.$accessId.nis2.assessments'
import { Route as AuditorAccessAccessIdBcpPlansRouteImport } from './routes/auditor/access.$accessId.bcp.plans'
import { Route as AuditorAccessAccessIdBcpFindingsRouteImport } from './routes/auditor/access.$accessId.bcp.findings'
import { Route as AuditorAccessAccessIdBcpExercisesRouteImport } from './routes/auditor/access.$accessId.bcp.exercises'
import { Route as AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRouteImport } from './routes/_authenticated/tasks/playbooks/templates/task-templates'
import { Route as AuthenticatedTasksPlaybooksTemplatesNewRouteImport } from './routes/_authenticated/tasks/playbooks/templates/new'
import { Route as AuthenticatedTasksPlaybooksTemplatesTemplateIdRouteImport } from './routes/_authenticated/tasks/playbooks/templates/$templateId'
import { Route as AuthenticatedTasksPlaybooksActivationIdSetupRouteImport } from './routes/_authenticated/tasks/playbooks/$activationId.setup'
import { Route as AuthenticatedSuppliersQuestionnairesSentIdReviewRouteImport } from './routes/_authenticated/suppliers/questionnaires/$sentId.review'
import { Route as AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRouteImport } from './routes/_authenticated/suppliers/admin/questionnaire-templates/new'
import { Route as AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRouteImport } from './routes/_authenticated/suppliers/admin/questionnaire-templates/$templateId'
import { Route as AuthenticatedSuppliersSupplierIdReviewsReviewIdRouteImport } from './routes/_authenticated/suppliers/$supplierId/reviews/$reviewId'
import { Route as AuthenticatedSettingsTeamMembersUserIdRouteImport } from './routes/_authenticated/settings/team.members.$userId'
import { Route as AuthenticatedPoliciesProceduresInstanceIdExecuteRouteImport } from './routes/_authenticated/policies/procedures.$instanceId.execute'
import { Route as AuthenticatedPoliciesPolicyIdScansScanIdRouteImport } from './routes/_authenticated/policies/$policyId.scans.$scanId'
import { Route as AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRouteImport } from './routes/_authenticated/nis2/incidents/$incidentId/progress-updates'
import { Route as AuthenticatedNis2IncidentsIncidentIdNotificationRouteImport } from './routes/_authenticated/nis2/incidents/$incidentId/notification'
import { Route as AuthenticatedNis2IncidentsIncidentIdFinalReportRouteImport } from './routes/_authenticated/nis2/incidents/$incidentId/final-report'
import { Route as AuthenticatedNis2IncidentsIncidentIdEarlyWarningRouteImport } from './routes/_authenticated/nis2/incidents/$incidentId/early-warning'
import { Route as AuthenticatedGhgVerificationInternalVerificationIdRouteImport } from './routes/_authenticated/ghg/verification/internal/$verificationId'
import { Route as AuthenticatedGhgScope3CategoryDeriveRouteImport } from './routes/_authenticated/ghg/scope3/$category.derive'
import { Route as AuthenticatedGhgReportsCustomNewRouteImport } from './routes/_authenticated/ghg/reports/custom/new'
import { Route as AuthenticatedGhgReportsCustomReportIdRouteImport } from './routes/_authenticated/ghg/reports/custom/$reportId'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/value-chain'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/stakeholders'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/risks'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/quality'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/overview'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/matrix'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/impacts'
import { Route as AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRouteImport } from './routes/_authenticated/esg/double-materiality/$assessmentId/assessment'
import { Route as AuthenticatedDatahubUploadsUploadIdReviewRouteImport } from './routes/_authenticated/datahub/uploads/$uploadId.review'
import { Route as AuthenticatedDatahubUploadsUploadIdMapRouteImport } from './routes/_authenticated/datahub/uploads/$uploadId.map'
import { Route as AuthenticatedDatahubIntegrationsIntegrationIdMappingsRouteImport } from './routes/_authenticated/datahub/integrations/$integrationId/mappings'
import { Route as AuthenticatedDatahubDatapointsDatapointIdEntryRouteImport } from './routes/_authenticated/datahub/datapoints/$datapointId/entry'
import { Route as AuthenticatedDatahubCollectionsCollectionIdImportRouteImport } from './routes/_authenticated/datahub/collections/$collectionId/import'
import { Route as AuthenticatedDatahubCollectionsCollectionIdEntryRouteImport } from './routes/_authenticated/datahub/collections/$collectionId/entry'
import { Route as AuthenticatedBcpResourcesSitesSiteIdRouteImport } from './routes/_authenticated/bcp/resources/sites.$siteId'
import { Route as AuthenticatedBcpPlansPlanIdReviewRouteImport } from './routes/_authenticated/bcp/plans/$planId.review'
import { Route as AuthenticatedBcpPlansPlanIdEditRouteImport } from './routes/_authenticated/bcp/plans/$planId.edit'
import { Route as AuthenticatedBcpExercisesExerciseIdConductRouteImport } from './routes/_authenticated/bcp/exercises.$exerciseId.conduct'
import { Route as AuthenticatedAuditAuditsAuditIdSettingsRouteImport } from './routes/_authenticated/audit/audits/$auditId/settings'
import { Route as AuthenticatedAiDocumentsDocumentIdExtractRouteImport } from './routes/_authenticated/ai/documents/$documentId.extract'
import { Route as AuditorAccessAccessIdBcpPlansPlanIdRouteImport } from './routes/auditor/access.$accessId.bcp.plans.$planId'
import { Route as AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRouteImport } from './routes/_authenticated/settings/team.members.$userId.history-connections'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpIndexRoute = SignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyRespondTokenRoute = SurveyRespondTokenRouteImport.update({
  id: '/survey-respond/$token',
  path: '/survey-respond/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpOrgIdRoute = SignUpOrgIdRouteImport.update({
  id: '/sign-up/$orgId',
  path: '/sign-up/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionTasksSetupMfaRoute = SessionTasksSetupMfaRouteImport.update({
  id: '/session-tasks/setup-mfa',
  path: '/session-tasks/setup-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickReportShareTokenRoute = QuickReportShareTokenRouteImport.update({
  id: '/quick-report/$shareToken',
  path: '/quick-report/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const GhgSurveyTokenRoute = GhgSurveyTokenRouteImport.update({
  id: '/ghg-survey/$token',
  path: '/ghg-survey/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditorTokenRoute = AuditorTokenRouteImport.update({
  id: '/auditor/$token',
  path: '/auditor/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkforceReadinessRoute =
  AuthenticatedWorkforceReadinessRouteImport.update({
    id: '/workforce-readiness',
    path: '/workforce-readiness',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVsmeRoute = AuthenticatedVsmeRouteImport.update({
  id: '/vsme',
  path: '/vsme',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNis2Route = AuthenticatedNis2RouteImport.update({
  id: '/nis2',
  path: '/nis2',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHelpCentreRoute = AuthenticatedHelpCentreRouteImport.update({
  id: '/help-centre',
  path: '/help-centre',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGhgRoute = AuthenticatedGhgRouteImport.update({
  id: '/ghg',
  path: '/ghg',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEuTaxonomyRoute = AuthenticatedEuTaxonomyRouteImport.update({
  id: '/eu-taxonomy',
  path: '/eu-taxonomy',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEsgRoute = AuthenticatedEsgRouteImport.update({
  id: '/esg',
  path: '/esg',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedControlsRoute = AuthenticatedControlsRouteImport.update({
  id: '/controls',
  path: '/controls',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBcpRoute = AuthenticatedBcpRouteImport.update({
  id: '/bcp',
  path: '/bcp',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVulnerabilitiesIndexRoute =
  AuthenticatedVulnerabilitiesIndexRouteImport.update({
    id: '/vulnerabilities/',
    path: '/vulnerabilities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedThreatsIndexRoute =
  AuthenticatedThreatsIndexRouteImport.update({
    id: '/threats/',
    path: '/threats/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysIndexRoute =
  AuthenticatedSurveysIndexRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersIndexRoute =
  AuthenticatedSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedRisksIndexRoute = AuthenticatedRisksIndexRouteImport.update({
  id: '/risks/',
  path: '/risks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProceduresIndexRoute =
  AuthenticatedProceduresIndexRouteImport.update({
    id: '/procedures/',
    path: '/procedures/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesIndexRoute =
  AuthenticatedPoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsIndexRoute =
  AuthenticatedIncidentsIndexRouteImport.update({
    id: '/incidents/',
    path: '/incidents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGapsIndexRoute = AuthenticatedGapsIndexRouteImport.update({
  id: '/gaps/',
  path: '/gaps/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExternalReportingIndexRoute =
  AuthenticatedExternalReportingIndexRouteImport.update({
    id: '/external-reporting/',
    path: '/external-reporting/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEvidenceIndexRoute =
  AuthenticatedEvidenceIndexRouteImport.update({
    id: '/evidence/',
    path: '/evidence/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesIndexRoute =
  AuthenticatedEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubIndexRoute =
  AuthenticatedDatahubIndexRouteImport.update({
    id: '/datahub/',
    path: '/datahub/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedControlsIndexRoute =
  AuthenticatedControlsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedControlsRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/assets/',
    path: '/assets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAiIndexRoute = AuthenticatedAiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PortalQuestionnaireTokenRoute =
  PortalQuestionnaireTokenRouteImport.update({
    id: '/portal/questionnaire/$token',
    path: '/portal/questionnaire/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalProfileTokenRoute = PortalProfileTokenRouteImport.update({
  id: '/portal/profile/$token',
  path: '/portal/profile/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalHomeTokenRoute = PortalHomeTokenRouteImport.update({
  id: '/portal/home/$token',
  path: '/portal/home/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalHistoryTokenRoute = PortalHistoryTokenRouteImport.update({
  id: '/portal/history/$token',
  path: '/portal/history/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalAuthLoginRoute = PortalAuthLoginRouteImport.update({
  id: '/portal/auth/login',
  path: '/portal/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkforceReadinessTrainingRegisterRoute =
  AuthenticatedWorkforceReadinessTrainingRegisterRouteImport.update({
    id: '/training-register',
    path: '/training-register',
    getParentRoute: () => AuthenticatedWorkforceReadinessRoute,
  } as any)
const AuthenticatedWorkforceReadinessMyTrainingsRoute =
  AuthenticatedWorkforceReadinessMyTrainingsRouteImport.update({
    id: '/my-trainings',
    path: '/my-trainings',
    getParentRoute: () => AuthenticatedWorkforceReadinessRoute,
  } as any)
const AuthenticatedWorkforceReadinessAwarenessCampaignsRoute =
  AuthenticatedWorkforceReadinessAwarenessCampaignsRouteImport.update({
    id: '/awareness-campaigns',
    path: '/awareness-campaigns',
    getParentRoute: () => AuthenticatedWorkforceReadinessRoute,
  } as any)
const AuthenticatedVulnerabilitiesWorkspaceRoute =
  AuthenticatedVulnerabilitiesWorkspaceRouteImport.update({
    id: '/vulnerabilities/workspace',
    path: '/vulnerabilities/workspace',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesSubsidiariesRoute =
  AuthenticatedVulnerabilitiesSubsidiariesRouteImport.update({
    id: '/vulnerabilities/subsidiaries',
    path: '/vulnerabilities/subsidiaries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesSoc2ComplianceRoute =
  AuthenticatedVulnerabilitiesSoc2ComplianceRouteImport.update({
    id: '/vulnerabilities/soc2-compliance',
    path: '/vulnerabilities/soc2-compliance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesSlaReportRoute =
  AuthenticatedVulnerabilitiesSlaReportRouteImport.update({
    id: '/vulnerabilities/sla-report',
    path: '/vulnerabilities/sla-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesSettingsRoute =
  AuthenticatedVulnerabilitiesSettingsRouteImport.update({
    id: '/vulnerabilities/settings',
    path: '/vulnerabilities/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesNis2ReportRoute =
  AuthenticatedVulnerabilitiesNis2ReportRouteImport.update({
    id: '/vulnerabilities/nis2-report',
    path: '/vulnerabilities/nis2-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesNewRoute =
  AuthenticatedVulnerabilitiesNewRouteImport.update({
    id: '/vulnerabilities/new',
    path: '/vulnerabilities/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesDashboardRoute =
  AuthenticatedVulnerabilitiesDashboardRouteImport.update({
    id: '/vulnerabilities/dashboard',
    path: '/vulnerabilities/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesConsolidatedReportRoute =
  AuthenticatedVulnerabilitiesConsolidatedReportRouteImport.update({
    id: '/vulnerabilities/consolidated-report',
    path: '/vulnerabilities/consolidated-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesAuditReportRoute =
  AuthenticatedVulnerabilitiesAuditReportRouteImport.update({
    id: '/vulnerabilities/audit-report',
    path: '/vulnerabilities/audit-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVulnerabilitiesVulnerabilityIdRoute =
  AuthenticatedVulnerabilitiesVulnerabilityIdRouteImport.update({
    id: '/vulnerabilities/$vulnerabilityId',
    path: '/vulnerabilities/$vulnerabilityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVsmeSectionRoute =
  AuthenticatedVsmeSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedVsmeRoute,
  } as any)
const AuthenticatedTasksMyRoute = AuthenticatedTasksMyRouteImport.update({
  id: '/tasks/my',
  path: '/tasks/my',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksConsoleRoute =
  AuthenticatedTasksConsoleRouteImport.update({
    id: '/tasks/console',
    path: '/tasks/console',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksApprovalsRoute =
  AuthenticatedTasksApprovalsRouteImport.update({
    id: '/tasks/approvals',
    path: '/tasks/approvals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdRoute =
  AuthenticatedTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersRiskRoute =
  AuthenticatedSuppliersRiskRouteImport.update({
    id: '/suppliers/risk',
    path: '/suppliers/risk',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersRegisterRoute =
  AuthenticatedSuppliersRegisterRouteImport.update({
    id: '/suppliers/register',
    path: '/suppliers/register',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersComplianceMatrixRoute =
  AuthenticatedSuppliersComplianceMatrixRouteImport.update({
    id: '/suppliers/compliance-matrix',
    path: '/suppliers/compliance-matrix',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersSupplierIdRoute =
  AuthenticatedSuppliersSupplierIdRouteImport.update({
    id: '/suppliers/$supplierId',
    path: '/suppliers/$supplierId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsVulnerabilitySettingsRoute =
  AuthenticatedSettingsVulnerabilitySettingsRouteImport.update({
    id: '/vulnerability-settings',
    path: '/vulnerability-settings',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTeamRoute =
  AuthenticatedSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTaskSchedulesRoute =
  AuthenticatedSettingsTaskSchedulesRouteImport.update({
    id: '/task-schedules',
    path: '/task-schedules',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSupplierCategoriesRoute =
  AuthenticatedSettingsSupplierCategoriesRouteImport.update({
    id: '/supplier-categories',
    path: '/supplier-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSubsidiariesRoute =
  AuthenticatedSettingsSubsidiariesRouteImport.update({
    id: '/subsidiaries',
    path: '/subsidiaries',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsScannerIntegrationsRoute =
  AuthenticatedSettingsScannerIntegrationsRouteImport.update({
    id: '/scanner-integrations',
    path: '/scanner-integrations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsRolesRoute =
  AuthenticatedSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsRiskRoute =
  AuthenticatedSettingsRiskRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsReportingPeriodsRoute =
  AuthenticatedSettingsReportingPeriodsRouteImport.update({
    id: '/reporting-periods',
    path: '/reporting-periods',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPolicyCategoriesRoute =
  AuthenticatedSettingsPolicyCategoriesRouteImport.update({
    id: '/policy-categories',
    path: '/policy-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrganizationsRoute =
  AuthenticatedSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrganisationStructureRoute =
  AuthenticatedSettingsOrganisationStructureRouteImport.update({
    id: '/organisation-structure',
    path: '/organisation-structure',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNis2GapPriorityRoute =
  AuthenticatedSettingsNis2GapPriorityRouteImport.update({
    id: '/nis2-gap-priority',
    path: '/nis2-gap-priority',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNis2ClassificationRoute =
  AuthenticatedSettingsNis2ClassificationRouteImport.update({
    id: '/nis2-classification',
    path: '/nis2-classification',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMyActivityRoute =
  AuthenticatedSettingsMyActivityRouteImport.update({
    id: '/my-activity',
    path: '/my-activity',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsIncidentCategoriesRoute =
  AuthenticatedSettingsIncidentCategoriesRouteImport.update({
    id: '/incident-categories',
    path: '/incident-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGhgSourcesRoute =
  AuthenticatedSettingsGhgSourcesRouteImport.update({
    id: '/ghg-sources',
    path: '/ghg-sources',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGhgPermissionsRoute =
  AuthenticatedSettingsGhgPermissionsRouteImport.update({
    id: '/ghg-permissions',
    path: '/ghg-permissions',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGhgFacilitiesRoute =
  AuthenticatedSettingsGhgFacilitiesRouteImport.update({
    id: '/ghg-facilities',
    path: '/ghg-facilities',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGhgBoundaryRoute =
  AuthenticatedSettingsGhgBoundaryRouteImport.update({
    id: '/ghg-boundary',
    path: '/ghg-boundary',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGapDetectionRulesRoute =
  AuthenticatedSettingsGapDetectionRulesRouteImport.update({
    id: '/gap-detection-rules',
    path: '/gap-detection-rules',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsEvidenceCollectionsRoute =
  AuthenticatedSettingsEvidenceCollectionsRouteImport.update({
    id: '/evidence-collections',
    path: '/evidence-collections',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsCredentialsRoute =
  AuthenticatedSettingsCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsConfigrationRoute =
  AuthenticatedSettingsConfigrationRouteImport.update({
    id: '/configration',
    path: '/configration',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsComplianceFrameworksRoute =
  AuthenticatedSettingsComplianceFrameworksRouteImport.update({
    id: '/compliance-frameworks',
    path: '/compliance-frameworks',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBcpReviewSettingsRoute =
  AuthenticatedSettingsBcpReviewSettingsRouteImport.update({
    id: '/bcp-review-settings',
    path: '/bcp-review-settings',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBcpExerciseSettingsRoute =
  AuthenticatedSettingsBcpExerciseSettingsRouteImport.update({
    id: '/bcp-exercise-settings',
    path: '/bcp-exercise-settings',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditorsRoute =
  AuthenticatedSettingsAuditorsRouteImport.update({
    id: '/auditors',
    path: '/auditors',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditWebhooksRoute =
  AuthenticatedSettingsAuditWebhooksRouteImport.update({
    id: '/audit-webhooks',
    path: '/audit-webhooks',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditSettingsRoute =
  AuthenticatedSettingsAuditSettingsRouteImport.update({
    id: '/audit-settings',
    path: '/audit-settings',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditLogRoute =
  AuthenticatedSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditAlertsRoute =
  AuthenticatedSettingsAuditAlertsRouteImport.update({
    id: '/audit-alerts',
    path: '/audit-alerts',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAssetTagsRoute =
  AuthenticatedSettingsAssetTagsRouteImport.update({
    id: '/asset-tags',
    path: '/asset-tags',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAssetCustomFieldsRoute =
  AuthenticatedSettingsAssetCustomFieldsRouteImport.update({
    id: '/asset-custom-fields',
    path: '/asset-custom-fields',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAssetConnectorsRoute =
  AuthenticatedSettingsAssetConnectorsRouteImport.update({
    id: '/asset-connectors',
    path: '/asset-connectors',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAssetCategoriesRoute =
  AuthenticatedSettingsAssetCategoriesRouteImport.update({
    id: '/asset-categories',
    path: '/asset-categories',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAiSettingsRoute =
  AuthenticatedSettingsAiSettingsRouteImport.update({
    id: '/ai-settings',
    path: '/ai-settings',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAiConversationsRoute =
  AuthenticatedSettingsAiConversationsRouteImport.update({
    id: '/ai-conversations',
    path: '/ai-conversations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAccessLogRoute =
  AuthenticatedSettingsAccessLogRouteImport.update({
    id: '/access-log',
    path: '/access-log',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedRisksNewRoute = AuthenticatedRisksNewRouteImport.update({
  id: '/risks/new',
  path: '/risks/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRisksHeatmapRoute =
  AuthenticatedRisksHeatmapRouteImport.update({
    id: '/risks/heatmap',
    path: '/risks/heatmap',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRisksDashboardRoute =
  AuthenticatedRisksDashboardRouteImport.update({
    id: '/risks/dashboard',
    path: '/risks/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRisksAiSuggestionsRoute =
  AuthenticatedRisksAiSuggestionsRouteImport.update({
    id: '/risks/ai-suggestions',
    path: '/risks/ai-suggestions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRisksRiskIdRoute =
  AuthenticatedRisksRiskIdRouteImport.update({
    id: '/risks/$riskId',
    path: '/risks/$riskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProceduresProcedureIdRoute =
  AuthenticatedProceduresProcedureIdRouteImport.update({
    id: '/procedures/$procedureId',
    path: '/procedures/$procedureId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesWizardRoute =
  AuthenticatedPoliciesWizardRouteImport.update({
    id: '/policies/wizard',
    path: '/policies/wizard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesDocumentsRoute =
  AuthenticatedPoliciesDocumentsRouteImport.update({
    id: '/policies/documents',
    path: '/policies/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesCreateRoute =
  AuthenticatedPoliciesCreateRouteImport.update({
    id: '/policies/create',
    path: '/policies/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesComplianceDashboardRoute =
  AuthenticatedPoliciesComplianceDashboardRouteImport.update({
    id: '/policies/compliance-dashboard',
    path: '/policies/compliance-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesPolicyIdRoute =
  AuthenticatedPoliciesPolicyIdRouteImport.update({
    id: '/policies/$policyId',
    path: '/policies/$policyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNis2SupplyChainSecurityRoute =
  AuthenticatedNis2SupplyChainSecurityRouteImport.update({
    id: '/supply-chain-security',
    path: '/supply-chain-security',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2SelfAssessmentRoute =
  AuthenticatedNis2SelfAssessmentRouteImport.update({
    id: '/self-assessment',
    path: '/self-assessment',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2RiskManagementRoute =
  AuthenticatedNis2RiskManagementRouteImport.update({
    id: '/risk-management',
    path: '/risk-management',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2PolicyGovernanceRoute =
  AuthenticatedNis2PolicyGovernanceRouteImport.update({
    id: '/policy-governance',
    path: '/policy-governance',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2PoliciesGovernanceRoute =
  AuthenticatedNis2PoliciesGovernanceRouteImport.update({
    id: '/policies-governance',
    path: '/policies-governance',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2OverviewRoute =
  AuthenticatedNis2OverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2OnboardingRoute =
  AuthenticatedNis2OnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2MeasureDRoute =
  AuthenticatedNis2MeasureDRouteImport.update({
    id: '/measure-d',
    path: '/measure-d',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2MeasureARoute =
  AuthenticatedNis2MeasureARouteImport.update({
    id: '/measure-a',
    path: '/measure-a',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2KnowledgeBaseRoute =
  AuthenticatedNis2KnowledgeBaseRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2IsmsRoute = AuthenticatedNis2IsmsRouteImport.update({
  id: '/isms',
  path: '/isms',
  getParentRoute: () => AuthenticatedNis2Route,
} as any)
const AuthenticatedNis2IncidentManagementRoute =
  AuthenticatedNis2IncidentManagementRouteImport.update({
    id: '/incident-management',
    path: '/incident-management',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2HumanResourcesSecurityRoute =
  AuthenticatedNis2HumanResourcesSecurityRouteImport.update({
    id: '/human-resources-security',
    path: '/human-resources-security',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2HrTrainingRoute =
  AuthenticatedNis2HrTrainingRouteImport.update({
    id: '/hr-training',
    path: '/hr-training',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2GapsRoute = AuthenticatedNis2GapsRouteImport.update({
  id: '/gaps',
  path: '/gaps',
  getParentRoute: () => AuthenticatedNis2Route,
} as any)
const AuthenticatedNis2GapAnalysisRoute =
  AuthenticatedNis2GapAnalysisRouteImport.update({
    id: '/gap-analysis',
    path: '/gap-analysis',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2EvidenceRoute =
  AuthenticatedNis2EvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2EntityClassificationRoute =
  AuthenticatedNis2EntityClassificationRouteImport.update({
    id: '/entity-classification',
    path: '/entity-classification',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2DashboardRoute =
  AuthenticatedNis2DashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2BusinessContinuityRoute =
  AuthenticatedNis2BusinessContinuityRouteImport.update({
    id: '/business-continuity',
    path: '/business-continuity',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2AssetsMeasuresRoute =
  AuthenticatedNis2AssetsMeasuresRouteImport.update({
    id: '/assets-measures',
    path: '/assets-measures',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2AssetsAndMeasuresRoute =
  AuthenticatedNis2AssetsAndMeasuresRouteImport.update({
    id: '/assets-and-measures',
    path: '/assets-and-measures',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2AssetRegisterRoute =
  AuthenticatedNis2AssetRegisterRouteImport.update({
    id: '/asset-register',
    path: '/asset-register',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedIncidentsSubsidiariesRoute =
  AuthenticatedIncidentsSubsidiariesRouteImport.update({
    id: '/incidents/subsidiaries',
    path: '/incidents/subsidiaries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsSettingsRoute =
  AuthenticatedIncidentsSettingsRouteImport.update({
    id: '/incidents/settings',
    path: '/incidents/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsQuickReportRoute =
  AuthenticatedIncidentsQuickReportRouteImport.update({
    id: '/incidents/quick-report',
    path: '/incidents/quick-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsNewRoute =
  AuthenticatedIncidentsNewRouteImport.update({
    id: '/incidents/new',
    path: '/incidents/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsDashboardRoute =
  AuthenticatedIncidentsDashboardRouteImport.update({
    id: '/incidents/dashboard',
    path: '/incidents/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsIncidentIdRoute =
  AuthenticatedIncidentsIncidentIdRouteImport.update({
    id: '/incidents/$incidentId',
    path: '/incidents/$incidentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelpCentreRegulationsRoute =
  AuthenticatedHelpCentreRegulationsRouteImport.update({
    id: '/regulations',
    path: '/regulations',
    getParentRoute: () => AuthenticatedHelpCentreRoute,
  } as any)
const AuthenticatedHelpCentrePlatformGuidesRoute =
  AuthenticatedHelpCentrePlatformGuidesRouteImport.update({
    id: '/platform-guides',
    path: '/platform-guides',
    getParentRoute: () => AuthenticatedHelpCentreRoute,
  } as any)
const AuthenticatedGhgYoyComparisonRoute =
  AuthenticatedGhgYoyComparisonRouteImport.update({
    id: '/yoy-comparison',
    path: '/yoy-comparison',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgWasteRoute = AuthenticatedGhgWasteRouteImport.update({
  id: '/waste',
  path: '/waste',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgTravelImportRoute =
  AuthenticatedGhgTravelImportRouteImport.update({
    id: '/travel-import',
    path: '/travel-import',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgTasksRoute = AuthenticatedGhgTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgScope3ScreeningRoute =
  AuthenticatedGhgScope3ScreeningRouteImport.update({
    id: '/scope3-screening',
    path: '/scope3-screening',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope2Route = AuthenticatedGhgScope2RouteImport.update({
  id: '/scope2',
  path: '/scope2',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgScope1Route = AuthenticatedGhgScope1RouteImport.update({
  id: '/scope1',
  path: '/scope1',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgReportRoute = AuthenticatedGhgReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgRecalculationsRoute =
  AuthenticatedGhgRecalculationsRouteImport.update({
    id: '/recalculations',
    path: '/recalculations',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgProtocolComplianceRoute =
  AuthenticatedGhgProtocolComplianceRouteImport.update({
    id: '/protocol-compliance',
    path: '/protocol-compliance',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgPoliciesRoute =
  AuthenticatedGhgPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgOverviewRoute =
  AuthenticatedGhgOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgNetZeroRoute = AuthenticatedGhgNetZeroRouteImport.update({
  id: '/net-zero',
  path: '/net-zero',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgMarketInstrumentsRoute =
  AuthenticatedGhgMarketInstrumentsRouteImport.update({
    id: '/market-instruments',
    path: '/market-instruments',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgIso14064ComplianceRoute =
  AuthenticatedGhgIso14064ComplianceRouteImport.update({
    id: '/iso14064-compliance',
    path: '/iso14064-compliance',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgIndustryComparisonRoute =
  AuthenticatedGhgIndustryComparisonRouteImport.update({
    id: '/industry-comparison',
    path: '/industry-comparison',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgGapAnalysisRoute =
  AuthenticatedGhgGapAnalysisRouteImport.update({
    id: '/gap-analysis',
    path: '/gap-analysis',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgEmissionsRoute =
  AuthenticatedGhgEmissionsRouteImport.update({
    id: '/emissions',
    path: '/emissions',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgEmissionInsightsRoute =
  AuthenticatedGhgEmissionInsightsRouteImport.update({
    id: '/emission-insights',
    path: '/emission-insights',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgEmissionFactorsRoute =
  AuthenticatedGhgEmissionFactorsRouteImport.update({
    id: '/emission-factors',
    path: '/emission-factors',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgDataQualityRoute =
  AuthenticatedGhgDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgDashboardRoute =
  AuthenticatedGhgDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCommutingRoute =
  AuthenticatedGhgCommutingRouteImport.update({
    id: '/commuting',
    path: '/commuting',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCollectRoute = AuthenticatedGhgCollectRouteImport.update({
  id: '/collect',
  path: '/collect',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgCdpQuestionnaireRoute =
  AuthenticatedGhgCdpQuestionnaireRouteImport.update({
    id: '/cdp-questionnaire',
    path: '/cdp-questionnaire',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgBusinessTravelRoute =
  AuthenticatedGhgBusinessTravelRouteImport.update({
    id: '/business-travel',
    path: '/business-travel',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgBestPracticesRoute =
  AuthenticatedGhgBestPracticesRouteImport.update({
    id: '/best-practices',
    path: '/best-practices',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgAuditRoute = AuthenticatedGhgAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedGhgRoute,
} as any)
const AuthenticatedGhgActivityGroupsRoute =
  AuthenticatedGhgActivityGroupsRouteImport.update({
    id: '/activity-groups',
    path: '/activity-groups',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedExternalReportingReportIdRoute =
  AuthenticatedExternalReportingReportIdRouteImport.update({
    id: '/external-reporting/$reportId',
    path: '/external-reporting/$reportId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEvidenceRepositoryRoute =
  AuthenticatedEvidenceRepositoryRouteImport.update({
    id: '/evidence/repository',
    path: '/evidence/repository',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEvidenceLogsRoute =
  AuthenticatedEvidenceLogsRouteImport.update({
    id: '/evidence/logs',
    path: '/evidence/logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEvidenceEvidenceIdRoute =
  AuthenticatedEvidenceEvidenceIdRouteImport.update({
    id: '/evidence/$evidenceId',
    path: '/evidence/$evidenceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEuTaxonomySectionRoute =
  AuthenticatedEuTaxonomySectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedEuTaxonomyRoute,
  } as any)
const AuthenticatedEsgSectionRoute = AuthenticatedEsgSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => AuthenticatedEsgRoute,
} as any)
const AuthenticatedEmployeesNewRoute =
  AuthenticatedEmployeesNewRouteImport.update({
    id: '/employees/new',
    path: '/employees/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesImportRoute =
  AuthenticatedEmployeesImportRouteImport.update({
    id: '/employees/import',
    path: '/employees/import',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesEmployeeIdRoute =
  AuthenticatedEmployeesEmployeeIdRouteImport.update({
    id: '/employees/$employeeId',
    path: '/employees/$employeeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubValidationErrorsRoute =
  AuthenticatedDatahubValidationErrorsRouteImport.update({
    id: '/datahub/validation-errors',
    path: '/datahub/validation-errors',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubUploadRoute =
  AuthenticatedDatahubUploadRouteImport.update({
    id: '/datahub/upload',
    path: '/datahub/upload',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubTemplatesRoute =
  AuthenticatedDatahubTemplatesRouteImport.update({
    id: '/datahub/templates',
    path: '/datahub/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubQualityIssuesRoute =
  AuthenticatedDatahubQualityIssuesRouteImport.update({
    id: '/datahub/quality-issues',
    path: '/datahub/quality-issues',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubQualityDashboardRoute =
  AuthenticatedDatahubQualityDashboardRouteImport.update({
    id: '/datahub/quality-dashboard',
    path: '/datahub/quality-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubPeriodsRoute =
  AuthenticatedDatahubPeriodsRouteImport.update({
    id: '/datahub/periods',
    path: '/datahub/periods',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubMyEntriesRoute =
  AuthenticatedDatahubMyEntriesRouteImport.update({
    id: '/datahub/my-entries',
    path: '/datahub/my-entries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubEntryRoute =
  AuthenticatedDatahubEntryRouteImport.update({
    id: '/datahub/entry',
    path: '/datahub/entry',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubDocumentsRoute =
  AuthenticatedDatahubDocumentsRouteImport.update({
    id: '/datahub/documents',
    path: '/datahub/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubConsolidatedRoute =
  AuthenticatedDatahubConsolidatedRouteImport.update({
    id: '/datahub/consolidated',
    path: '/datahub/consolidated',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubComparisonRoute =
  AuthenticatedDatahubComparisonRouteImport.update({
    id: '/datahub/comparison',
    path: '/datahub/comparison',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubAuditRoute =
  AuthenticatedDatahubAuditRouteImport.update({
    id: '/datahub/audit',
    path: '/datahub/audit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedControlsControlIdRoute =
  AuthenticatedControlsControlIdRouteImport.update({
    id: '/$controlId',
    path: '/$controlId',
    getParentRoute: () => AuthenticatedControlsRoute,
  } as any)
const AuthenticatedComplianceAlertsRoute =
  AuthenticatedComplianceAlertsRouteImport.update({
    id: '/compliance/alerts',
    path: '/compliance/alerts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBcpPlansRoute = AuthenticatedBcpPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthenticatedBcpRoute,
} as any)
const AuthenticatedBcpFindingsRoute =
  AuthenticatedBcpFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpDashboardRoute =
  AuthenticatedBcpDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpContinuityRoute =
  AuthenticatedBcpContinuityRouteImport.update({
    id: '/continuity',
    path: '/continuity',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpBiaRoute = AuthenticatedBcpBiaRouteImport.update({
  id: '/bia',
  path: '/bia',
  getParentRoute: () => AuthenticatedBcpRoute,
} as any)
const AuthenticatedBcpBcpRoute = AuthenticatedBcpBcpRouteImport.update({
  id: '/bcp',
  path: '/bcp',
  getParentRoute: () => AuthenticatedBcpRoute,
} as any)
const AuthenticatedAuditReportsRoute =
  AuthenticatedAuditReportsRouteImport.update({
    id: '/audit/reports',
    path: '/audit/reports',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditFindingsRoute =
  AuthenticatedAuditFindingsRouteImport.update({
    id: '/audit/findings',
    path: '/audit/findings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditEvidenceUploadRoute =
  AuthenticatedAuditEvidenceUploadRouteImport.update({
    id: '/audit/evidence-upload',
    path: '/audit/evidence-upload',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditEvidenceLibraryRoute =
  AuthenticatedAuditEvidenceLibraryRouteImport.update({
    id: '/audit/evidence-library',
    path: '/audit/evidence-library',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditCalendarRoute =
  AuthenticatedAuditCalendarRouteImport.update({
    id: '/audit/calendar',
    path: '/audit/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsImportRoute =
  AuthenticatedAssetsImportRouteImport.update({
    id: '/assets/import',
    path: '/assets/import',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsAssetIdRoute =
  AuthenticatedAssetsAssetIdRouteImport.update({
    id: '/assets/$assetId',
    path: '/assets/$assetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsGhgOverviewRoute =
  AuthenticatedAnalyticsGhgOverviewRouteImport.update({
    id: '/ghg-overview',
    path: '/ghg-overview',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAiUsageRoute = AuthenticatedAiUsageRouteImport.update({
  id: '/ai/usage',
  path: '/ai/usage',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiQualityRoute = AuthenticatedAiQualityRouteImport.update({
  id: '/ai/quality',
  path: '/ai/quality',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiInsightsRoute = AuthenticatedAiInsightsRouteImport.update({
  id: '/ai/insights',
  path: '/ai/insights',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiDocumentsRoute =
  AuthenticatedAiDocumentsRouteImport.update({
    id: '/ai/documents',
    path: '/ai/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSystemPromptsRoute =
  AuthenticatedAdminSystemPromptsRouteImport.update({
    id: '/admin/system-prompts',
    path: '/admin/system-prompts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/admin/settings',
    path: '/admin/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminOrganizationsRoute =
  AuthenticatedAdminOrganizationsRouteImport.update({
    id: '/admin/organizations',
    path: '/admin/organizations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminLlmSettingsRoute =
  AuthenticatedAdminLlmSettingsRouteImport.update({
    id: '/admin/llm-settings',
    path: '/admin/llm-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminKnowledgeBasesRoute =
  AuthenticatedAdminKnowledgeBasesRouteImport.update({
    id: '/admin/knowledge-bases',
    path: '/admin/knowledge-bases',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminAiCostsRoute =
  AuthenticatedAdminAiCostsRouteImport.update({
    id: '/admin/ai-costs',
    path: '/admin/ai-costs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PortalAuthForgotPasswordIndexRoute =
  PortalAuthForgotPasswordIndexRouteImport.update({
    id: '/portal/auth/forgot-password/',
    path: '/portal/auth/forgot-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedVulnerabilitiesApprovalsIndexRoute =
  AuthenticatedVulnerabilitiesApprovalsIndexRouteImport.update({
    id: '/vulnerabilities/approvals/',
    path: '/vulnerabilities/approvals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksIndexRoute =
  AuthenticatedTasksPlaybooksIndexRouteImport.update({
    id: '/tasks/playbooks/',
    path: '/tasks/playbooks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysSchedulesIndexRoute =
  AuthenticatedSurveysSchedulesIndexRouteImport.update({
    id: '/surveys/schedules/',
    path: '/surveys/schedules/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysCampaignsIndexRoute =
  AuthenticatedSurveysCampaignsIndexRouteImport.update({
    id: '/surveys/campaigns/',
    path: '/surveys/campaigns/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSecurityIndexRoute =
  AuthenticatedSettingsSecurityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsSecurityRoute,
  } as any)
const AuthenticatedRisksApprovalsIndexRoute =
  AuthenticatedRisksApprovalsIndexRouteImport.update({
    id: '/risks/approvals/',
    path: '/risks/approvals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNis2ReportsIndexRoute =
  AuthenticatedNis2ReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2MeasuresIndexRoute =
  AuthenticatedNis2MeasuresIndexRouteImport.update({
    id: '/measures/',
    path: '/measures/',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2InspectionPreparationIndexRoute =
  AuthenticatedNis2InspectionPreparationIndexRouteImport.update({
    id: '/inspection-preparation/',
    path: '/inspection-preparation/',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedGhgVerificationIndexRoute =
  AuthenticatedGhgVerificationIndexRouteImport.update({
    id: '/verification/',
    path: '/verification/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgVerificationStatementsIndexRoute =
  AuthenticatedGhgVerificationStatementsIndexRouteImport.update({
    id: '/verification-statements/',
    path: '/verification-statements/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgThirdPartyVerificationIndexRoute =
  AuthenticatedGhgThirdPartyVerificationIndexRouteImport.update({
    id: '/third-party-verification/',
    path: '/third-party-verification/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgTargetsIndexRoute =
  AuthenticatedGhgTargetsIndexRouteImport.update({
    id: '/targets/',
    path: '/targets/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgSetupIndexRoute =
  AuthenticatedGhgSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgSettingsIndexRoute =
  AuthenticatedGhgSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScenariosIndexRoute =
  AuthenticatedGhgScenariosIndexRouteImport.update({
    id: '/scenarios/',
    path: '/scenarios/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgReportsIndexRoute =
  AuthenticatedGhgReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgReductionInitiativesIndexRoute =
  AuthenticatedGhgReductionInitiativesIndexRouteImport.update({
    id: '/reduction-initiatives/',
    path: '/reduction-initiatives/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgRecalculationsIndexRoute =
  AuthenticatedGhgRecalculationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGhgRecalculationsRoute,
  } as any)
const AuthenticatedGhgIntegrationsIndexRoute =
  AuthenticatedGhgIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgExportsIndexRoute =
  AuthenticatedGhgExportsIndexRouteImport.update({
    id: '/exports/',
    path: '/exports/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCommutingSurveysIndexRoute =
  AuthenticatedGhgCommutingSurveysIndexRouteImport.update({
    id: '/commuting-surveys/',
    path: '/commuting-surveys/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgApprovalsIndexRoute =
  AuthenticatedGhgApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgActivityDataIndexRoute =
  AuthenticatedGhgActivityDataIndexRouteImport.update({
    id: '/activity-data/',
    path: '/activity-data/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedEsgOnboardingIndexRoute =
  AuthenticatedEsgOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedEsgRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityIndexRoute =
  AuthenticatedEsgDoubleMaterialityIndexRouteImport.update({
    id: '/double-materiality/',
    path: '/double-materiality/',
    getParentRoute: () => AuthenticatedEsgRoute,
  } as any)
const AuthenticatedEmployeesEmployeeIdIndexRoute =
  AuthenticatedEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEmployeesEmployeeIdRoute,
  } as any)
const AuthenticatedDatahubIntegrationsIndexRoute =
  AuthenticatedDatahubIntegrationsIndexRouteImport.update({
    id: '/datahub/integrations/',
    path: '/datahub/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubDatapointsIndexRoute =
  AuthenticatedDatahubDatapointsIndexRouteImport.update({
    id: '/datahub/datapoints/',
    path: '/datahub/datapoints/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubCollectionsIndexRoute =
  AuthenticatedDatahubCollectionsIndexRouteImport.update({
    id: '/datahub/collections/',
    path: '/datahub/collections/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBcpResourcesIndexRoute =
  AuthenticatedBcpResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpPlansIndexRoute =
  AuthenticatedBcpPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpExercisesIndexRoute =
  AuthenticatedBcpExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedAuditEvidenceIndexRoute =
  AuthenticatedAuditEvidenceIndexRouteImport.update({
    id: '/audit/evidence/',
    path: '/audit/evidence/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditAuditsIndexRoute =
  AuthenticatedAuditAuditsIndexRouteImport.update({
    id: '/audit/audits/',
    path: '/audit/audits/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsReportStudioIndexRoute =
  AuthenticatedAnalyticsReportStudioIndexRouteImport.update({
    id: '/report-studio/',
    path: '/report-studio/',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsDashboardsIndexRoute =
  AuthenticatedAnalyticsDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAiScansIndexRoute =
  AuthenticatedAiScansIndexRouteImport.update({
    id: '/ai/scans/',
    path: '/ai/scans/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiDocumentsIndexRoute =
  AuthenticatedAiDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAiDocumentsRoute,
  } as any)
const PortalAuthResetPasswordTokenRoute =
  PortalAuthResetPasswordTokenRouteImport.update({
    id: '/portal/auth/reset-password/$token',
    path: '/portal/auth/reset-password/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalAuthCreateAccountTokenRoute =
  PortalAuthCreateAccountTokenRouteImport.update({
    id: '/portal/auth/create-account/$token',
    path: '/portal/auth/create-account/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdTasksRoute =
  AuditorAccessAccessIdTasksRouteImport.update({
    id: '/auditor/access/$accessId/tasks',
    path: '/auditor/access/$accessId/tasks',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdNis2Route =
  AuditorAccessAccessIdNis2RouteImport.update({
    id: '/auditor/access/$accessId/nis2',
    path: '/auditor/access/$accessId/nis2',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdControlsRoute =
  AuditorAccessAccessIdControlsRouteImport.update({
    id: '/auditor/access/$accessId/controls',
    path: '/auditor/access/$accessId/controls',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdBcpRoute =
  AuditorAccessAccessIdBcpRouteImport.update({
    id: '/auditor/access/$accessId/bcp',
    path: '/auditor/access/$accessId/bcp',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdAuditRoute =
  AuditorAccessAccessIdAuditRouteImport.update({
    id: '/auditor/access/$accessId/audit',
    path: '/auditor/access/$accessId/audit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuditorAccessAccessIdAssetsRoute =
  AuditorAccessAccessIdAssetsRouteImport.update({
    id: '/auditor/access/$accessId/assets',
    path: '/auditor/access/$accessId/assets',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute =
  AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRouteImport.update({
    id: '/$trainingId',
    path: '/$trainingId',
    getParentRoute: () => AuthenticatedWorkforceReadinessTrainingRegisterRoute,
  } as any)
const AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute =
  AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRouteImport.update(
    {
      id: '/$campaignId',
      path: '/$campaignId',
      getParentRoute: () =>
        AuthenticatedWorkforceReadinessAwarenessCampaignsRoute,
    } as any,
  )
const AuthenticatedTasksPlaybooksActivateRoute =
  AuthenticatedTasksPlaybooksActivateRouteImport.update({
    id: '/tasks/playbooks/activate',
    path: '/tasks/playbooks/activate',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksConsoleApprovalsRoute =
  AuthenticatedTasksConsoleApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AuthenticatedTasksConsoleRoute,
  } as any)
const AuthenticatedSurveysTemplatesNewRoute =
  AuthenticatedSurveysTemplatesNewRouteImport.update({
    id: '/surveys/templates/new',
    path: '/surveys/templates/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysTemplatesTemplateIdRoute =
  AuthenticatedSurveysTemplatesTemplateIdRouteImport.update({
    id: '/surveys/templates/$templateId',
    path: '/surveys/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysCampaignsNewRoute =
  AuthenticatedSurveysCampaignsNewRouteImport.update({
    id: '/surveys/campaigns/new',
    path: '/surveys/campaigns/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysCampaignsCampaignIdRoute =
  AuthenticatedSurveysCampaignsCampaignIdRouteImport.update({
    id: '/surveys/campaigns/$campaignId',
    path: '/surveys/campaigns/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersAdminRiskConfigRoute =
  AuthenticatedSuppliersAdminRiskConfigRouteImport.update({
    id: '/suppliers/admin/risk-config',
    path: '/suppliers/admin/risk-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSecuritySessionsRoute =
  AuthenticatedSettingsSecuritySessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => AuthenticatedSettingsSecurityRoute,
  } as any)
const AuthenticatedSettingsNis2RemindersRoute =
  AuthenticatedSettingsNis2RemindersRouteImport.update({
    id: '/nis2/reminders',
    path: '/nis2/reminders',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAiConversationsConversationIdRoute =
  AuthenticatedSettingsAiConversationsConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthenticatedSettingsAiConversationsRoute,
  } as any)
const AuthenticatedPoliciesPolicyIdReviewRoute =
  AuthenticatedPoliciesPolicyIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedPoliciesPolicyIdRoute,
  } as any)
const AuthenticatedPoliciesPolicyIdEditRoute =
  AuthenticatedPoliciesPolicyIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedPoliciesPolicyIdRoute,
  } as any)
const AuthenticatedNis2ReportsScheduledRoute =
  AuthenticatedNis2ReportsScheduledRouteImport.update({
    id: '/reports/scheduled',
    path: '/reports/scheduled',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsExecutiveRoute =
  AuthenticatedNis2ReportsExecutiveRouteImport.update({
    id: '/reports/executive',
    path: '/reports/executive',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsCrossBorderRoute =
  AuthenticatedNis2ReportsCrossBorderRouteImport.update({
    id: '/reports/cross-border',
    path: '/reports/cross-border',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsConsolidatedRoute =
  AuthenticatedNis2ReportsConsolidatedRouteImport.update({
    id: '/reports/consolidated',
    path: '/reports/consolidated',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsComplianceRoute =
  AuthenticatedNis2ReportsComplianceRouteImport.update({
    id: '/reports/compliance',
    path: '/reports/compliance',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsBoardRoute =
  AuthenticatedNis2ReportsBoardRouteImport.update({
    id: '/reports/board',
    path: '/reports/board',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsAuditPreparationRoute =
  AuthenticatedNis2ReportsAuditPreparationRouteImport.update({
    id: '/reports/audit-preparation',
    path: '/reports/audit-preparation',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2ReportsActivityRoute =
  AuthenticatedNis2ReportsActivityRouteImport.update({
    id: '/reports/activity',
    path: '/reports/activity',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2MeasuresMeasureCodeRoute =
  AuthenticatedNis2MeasuresMeasureCodeRouteImport.update({
    id: '/measures/$measureCode',
    path: '/measures/$measureCode',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2InspectionPreparationPreparationIdRoute =
  AuthenticatedNis2InspectionPreparationPreparationIdRouteImport.update({
    id: '/inspection-preparation/$preparationId',
    path: '/inspection-preparation/$preparationId',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedIncidentsSettingsSlaRoute =
  AuthenticatedIncidentsSettingsSlaRouteImport.update({
    id: '/sla',
    path: '/sla',
    getParentRoute: () => AuthenticatedIncidentsSettingsRoute,
  } as any)
const AuthenticatedGhgVerificationChecklistIdRoute =
  AuthenticatedGhgVerificationChecklistIdRouteImport.update({
    id: '/verification/$checklistId',
    path: '/verification/$checklistId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgVerificationStatementsStatementIdRoute =
  AuthenticatedGhgVerificationStatementsStatementIdRouteImport.update({
    id: '/verification-statements/$statementId',
    path: '/verification-statements/$statementId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgThirdPartyVerificationEngagementIdRoute =
  AuthenticatedGhgThirdPartyVerificationEngagementIdRouteImport.update({
    id: '/third-party-verification/$engagementId',
    path: '/third-party-verification/$engagementId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgTargetsNewRoute =
  AuthenticatedGhgTargetsNewRouteImport.update({
    id: '/targets/new',
    path: '/targets/new',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgTargetsTargetIdRoute =
  AuthenticatedGhgTargetsTargetIdRouteImport.update({
    id: '/targets/$targetId',
    path: '/targets/$targetId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgSettingsScope2Route =
  AuthenticatedGhgSettingsScope2RouteImport.update({
    id: '/settings/scope2',
    path: '/settings/scope2',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgSettingsScope1Route =
  AuthenticatedGhgSettingsScope1RouteImport.update({
    id: '/settings/scope1',
    path: '/settings/scope1',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope3SoldProductsRoute =
  AuthenticatedGhgScope3SoldProductsRouteImport.update({
    id: '/scope3/sold-products',
    path: '/scope3/sold-products',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope3AddRoute =
  AuthenticatedGhgScope3AddRouteImport.update({
    id: '/scope3/add',
    path: '/scope3/add',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope3CategoryRoute =
  AuthenticatedGhgScope3CategoryRouteImport.update({
    id: '/scope3/$category',
    path: '/scope3/$category',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScenariosNewRoute =
  AuthenticatedGhgScenariosNewRouteImport.update({
    id: '/scenarios/new',
    path: '/scenarios/new',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScenariosCompareRoute =
  AuthenticatedGhgScenariosCompareRouteImport.update({
    id: '/scenarios/compare',
    path: '/scenarios/compare',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScenariosScenarioIdRoute =
  AuthenticatedGhgScenariosScenarioIdRouteImport.update({
    id: '/scenarios/$scenarioId',
    path: '/scenarios/$scenarioId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgReductionInitiativesNewRoute =
  AuthenticatedGhgReductionInitiativesNewRouteImport.update({
    id: '/reduction-initiatives/new',
    path: '/reduction-initiatives/new',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgReductionInitiativesInitiativeIdRoute =
  AuthenticatedGhgReductionInitiativesInitiativeIdRouteImport.update({
    id: '/reduction-initiatives/$initiativeId',
    path: '/reduction-initiatives/$initiativeId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgRecalculationsRecalculationIdRoute =
  AuthenticatedGhgRecalculationsRecalculationIdRouteImport.update({
    id: '/$recalculationId',
    path: '/$recalculationId',
    getParentRoute: () => AuthenticatedGhgRecalculationsRoute,
  } as any)
const AuthenticatedGhgIntegrationsConnectorIdRoute =
  AuthenticatedGhgIntegrationsConnectorIdRouteImport.update({
    id: '/integrations/$connectorId',
    path: '/integrations/$connectorId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgFacilitiesDashboardRoute =
  AuthenticatedGhgFacilitiesDashboardRouteImport.update({
    id: '/facilities/dashboard',
    path: '/facilities/dashboard',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCommutingSurveysNewRoute =
  AuthenticatedGhgCommutingSurveysNewRouteImport.update({
    id: '/commuting-surveys/new',
    path: '/commuting-surveys/new',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCommutingSurveysSurveyIdRoute =
  AuthenticatedGhgCommutingSurveysSurveyIdRouteImport.update({
    id: '/commuting-surveys/$surveyId',
    path: '/commuting-surveys/$surveyId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCalculationsScope3Route =
  AuthenticatedGhgCalculationsScope3RouteImport.update({
    id: '/calculations/scope3',
    path: '/calculations/scope3',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCalculationsScope2Route =
  AuthenticatedGhgCalculationsScope2RouteImport.update({
    id: '/calculations/scope2',
    path: '/calculations/scope2',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgCalculationsScope1Route =
  AuthenticatedGhgCalculationsScope1RouteImport.update({
    id: '/calculations/scope1',
    path: '/calculations/scope1',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgActivityDataImportRoute =
  AuthenticatedGhgActivityDataImportRouteImport.update({
    id: '/activity-data/import',
    path: '/activity-data/import',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgActivityDataDocumentOcrRoute =
  AuthenticatedGhgActivityDataDocumentOcrRouteImport.update({
    id: '/activity-data/document-ocr',
    path: '/activity-data/document-ocr',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgActivityDataAssignmentQueueRoute =
  AuthenticatedGhgActivityDataAssignmentQueueRouteImport.update({
    id: '/activity-data/assignment-queue',
    path: '/activity-data/assignment-queue',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgActivityDataEntryIdRoute =
  AuthenticatedGhgActivityDataEntryIdRouteImport.update({
    id: '/activity-data/$entryId',
    path: '/activity-data/$entryId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedEvidenceAttestationsNewRoute =
  AuthenticatedEvidenceAttestationsNewRouteImport.update({
    id: '/evidence/attestations/new',
    path: '/evidence/attestations/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEsgOnboardingOnboardingIdRoute =
  AuthenticatedEsgOnboardingOnboardingIdRouteImport.update({
    id: '/onboarding/$onboardingId',
    path: '/onboarding/$onboardingId',
    getParentRoute: () => AuthenticatedEsgRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute =
  AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRouteImport.update({
    id: '/double-materiality/datapoints-policies',
    path: '/double-materiality/datapoints-policies',
    getParentRoute: () => AuthenticatedEsgRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdRouteImport.update({
    id: '/double-materiality/$assessmentId',
    path: '/double-materiality/$assessmentId',
    getParentRoute: () => AuthenticatedEsgRoute,
  } as any)
const AuthenticatedEmployeesEmployeeIdEditRoute =
  AuthenticatedEmployeesEmployeeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedEmployeesEmployeeIdRoute,
  } as any)
const AuthenticatedDatahubIntegrationsTransformationRulesRoute =
  AuthenticatedDatahubIntegrationsTransformationRulesRouteImport.update({
    id: '/datahub/integrations/transformation-rules',
    path: '/datahub/integrations/transformation-rules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubGovernanceScheduledExportsRoute =
  AuthenticatedDatahubGovernanceScheduledExportsRouteImport.update({
    id: '/datahub/governance/scheduled-exports',
    path: '/datahub/governance/scheduled-exports',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubGovernanceApprovalQueueRoute =
  AuthenticatedDatahubGovernanceApprovalQueueRouteImport.update({
    id: '/datahub/governance/approval-queue',
    path: '/datahub/governance/approval-queue',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubGovernanceApprovalConfigRoute =
  AuthenticatedDatahubGovernanceApprovalConfigRouteImport.update({
    id: '/datahub/governance/approval-config',
    path: '/datahub/governance/approval-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubEntryWizardRoute =
  AuthenticatedDatahubEntryWizardRouteImport.update({
    id: '/wizard',
    path: '/wizard',
    getParentRoute: () => AuthenticatedDatahubEntryRoute,
  } as any)
const AuthenticatedDatahubDatapointsDatapointIdRoute =
  AuthenticatedDatahubDatapointsDatapointIdRouteImport.update({
    id: '/datahub/datapoints/$datapointId',
    path: '/datahub/datapoints/$datapointId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubCollectionsCollectionIdRoute =
  AuthenticatedDatahubCollectionsCollectionIdRouteImport.update({
    id: '/datahub/collections/$collectionId',
    path: '/datahub/collections/$collectionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBcpResourcesSitesRoute =
  AuthenticatedBcpResourcesSitesRouteImport.update({
    id: '/resources/sites',
    path: '/resources/sites',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpReportsPlanStatusRoute =
  AuthenticatedBcpReportsPlanStatusRouteImport.update({
    id: '/reports/plan-status',
    path: '/reports/plan-status',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpReportsNis2ComplianceRoute =
  AuthenticatedBcpReportsNis2ComplianceRouteImport.update({
    id: '/reports/nis2-compliance',
    path: '/reports/nis2-compliance',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpReportsIso22301Route =
  AuthenticatedBcpReportsIso22301RouteImport.update({
    id: '/reports/iso-22301',
    path: '/reports/iso-22301',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpReportsGapAnalysisRoute =
  AuthenticatedBcpReportsGapAnalysisRouteImport.update({
    id: '/reports/gap-analysis',
    path: '/reports/gap-analysis',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpReportsExerciseSummaryRoute =
  AuthenticatedBcpReportsExerciseSummaryRouteImport.update({
    id: '/reports/exercise-summary',
    path: '/reports/exercise-summary',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpPlansRecoveryRoute =
  AuthenticatedBcpPlansRecoveryRouteImport.update({
    id: '/recovery',
    path: '/recovery',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansNewRecoveryProcedureRoute =
  AuthenticatedBcpPlansNewRecoveryProcedureRouteImport.update({
    id: '/new-recovery-procedure',
    path: '/new-recovery-procedure',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansNewItDrRoute =
  AuthenticatedBcpPlansNewItDrRouteImport.update({
    id: '/new-it-dr',
    path: '/new-it-dr',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansNewCrisisCommunicationRoute =
  AuthenticatedBcpPlansNewCrisisCommunicationRouteImport.update({
    id: '/new-crisis-communication',
    path: '/new-crisis-communication',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansNewRoute =
  AuthenticatedBcpPlansNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansItDrRoute =
  AuthenticatedBcpPlansItDrRouteImport.update({
    id: '/it-dr',
    path: '/it-dr',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansCrisisCommRoute =
  AuthenticatedBcpPlansCrisisCommRouteImport.update({
    id: '/crisis-comm',
    path: '/crisis-comm',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansBcpRoute =
  AuthenticatedBcpPlansBcpRouteImport.update({
    id: '/bcp',
    path: '/bcp',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpPlansPlanIdRoute =
  AuthenticatedBcpPlansPlanIdRouteImport.update({
    id: '/$planId',
    path: '/$planId',
    getParentRoute: () => AuthenticatedBcpPlansRoute,
  } as any)
const AuthenticatedBcpExercisesScheduleRoute =
  AuthenticatedBcpExercisesScheduleRouteImport.update({
    id: '/exercises/schedule',
    path: '/exercises/schedule',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpExercisesNewRoute =
  AuthenticatedBcpExercisesNewRouteImport.update({
    id: '/exercises/new',
    path: '/exercises/new',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpExercisesExerciseIdRoute =
  AuthenticatedBcpExercisesExerciseIdRouteImport.update({
    id: '/exercises/$exerciseId',
    path: '/exercises/$exerciseId',
    getParentRoute: () => AuthenticatedBcpRoute,
  } as any)
const AuthenticatedBcpBiaBiaIdRoute =
  AuthenticatedBcpBiaBiaIdRouteImport.update({
    id: '/$biaId',
    path: '/$biaId',
    getParentRoute: () => AuthenticatedBcpBiaRoute,
  } as any)
const AuthenticatedAuditEvidenceEvidenceIdRoute =
  AuthenticatedAuditEvidenceEvidenceIdRouteImport.update({
    id: '/audit/evidence/$evidenceId',
    path: '/audit/evidence/$evidenceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditAuditsNewRoute =
  AuthenticatedAuditAuditsNewRouteImport.update({
    id: '/audit/audits/new',
    path: '/audit/audits/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsReportStudioTemplatesRoute =
  AuthenticatedAnalyticsReportStudioTemplatesRouteImport.update({
    id: '/report-studio/templates',
    path: '/report-studio/templates',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsReportStudioNewRoute =
  AuthenticatedAnalyticsReportStudioNewRouteImport.update({
    id: '/report-studio/new',
    path: '/report-studio/new',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsReportStudioReportIdRoute =
  AuthenticatedAnalyticsReportStudioReportIdRouteImport.update({
    id: '/report-studio/$reportId',
    path: '/report-studio/$reportId',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsDashboardsDashboardIdRoute =
  AuthenticatedAnalyticsDashboardsDashboardIdRouteImport.update({
    id: '/dashboards/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAiScansScanIdRoute =
  AuthenticatedAiScansScanIdRouteImport.update({
    id: '/ai/scans/$scanId',
    path: '/ai/scans/$scanId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiOnboardingModuleRoute =
  AuthenticatedAiOnboardingModuleRouteImport.update({
    id: '/ai/onboarding/$module',
    path: '/ai/onboarding/$module',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPoliciesTemplatesRoute =
  AuthenticatedAdminPoliciesTemplatesRouteImport.update({
    id: '/admin/policies/templates',
    path: '/admin/policies/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPoliciesApprovalConfigsRoute =
  AuthenticatedAdminPoliciesApprovalConfigsRouteImport.update({
    id: '/admin/policies/approval-configs',
    path: '/admin/policies/approval-configs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPoliciesAccessControlsRoute =
  AuthenticatedAdminPoliciesAccessControlsRouteImport.update({
    id: '/admin/policies/access-controls',
    path: '/admin/policies/access-controls',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIncidentsTagsRoute =
  AuthenticatedAdminIncidentsTagsRouteImport.update({
    id: '/admin/incidents/tags',
    path: '/admin/incidents/tags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksTemplatesIndexRoute =
  AuthenticatedTasksPlaybooksTemplatesIndexRouteImport.update({
    id: '/tasks/playbooks/templates/',
    path: '/tasks/playbooks/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksActivationIdIndexRoute =
  AuthenticatedTasksPlaybooksActivationIdIndexRouteImport.update({
    id: '/tasks/playbooks/$activationId/',
    path: '/tasks/playbooks/$activationId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute =
  AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRouteImport.update({
    id: '/suppliers/admin/questionnaire-templates/',
    path: '/suppliers/admin/questionnaire-templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGhgVerificationInternalIndexRoute =
  AuthenticatedGhgVerificationInternalIndexRouteImport.update({
    id: '/verification/internal/',
    path: '/verification/internal/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope3CategoryIndexRoute =
  AuthenticatedGhgScope3CategoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGhgScope3CategoryRoute,
  } as any)
const AuthenticatedGhgReportsCustomIndexRoute =
  AuthenticatedGhgReportsCustomIndexRouteImport.update({
    id: '/reports/custom/',
    path: '/reports/custom/',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedDatahubCollectionsCollectionIdIndexRoute =
  AuthenticatedDatahubCollectionsCollectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDatahubCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedBcpPlansPlanIdIndexRoute =
  AuthenticatedBcpPlansPlanIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBcpPlansPlanIdRoute,
  } as any)
const AuthenticatedBcpExercisesExerciseIdIndexRoute =
  AuthenticatedBcpExercisesExerciseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBcpExercisesExerciseIdRoute,
  } as any)
const AuthenticatedAuditAuditsAuditIdIndexRoute =
  AuthenticatedAuditAuditsAuditIdIndexRouteImport.update({
    id: '/audit/audits/$auditId/',
    path: '/audit/audits/$auditId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuditorAccessAccessIdNis2MeasuresRoute =
  AuditorAccessAccessIdNis2MeasuresRouteImport.update({
    id: '/measures',
    path: '/measures',
    getParentRoute: () => AuditorAccessAccessIdNis2Route,
  } as any)
const AuditorAccessAccessIdNis2IncidentsRoute =
  AuditorAccessAccessIdNis2IncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => AuditorAccessAccessIdNis2Route,
  } as any)
const AuditorAccessAccessIdNis2GapsRoute =
  AuditorAccessAccessIdNis2GapsRouteImport.update({
    id: '/gaps',
    path: '/gaps',
    getParentRoute: () => AuditorAccessAccessIdNis2Route,
  } as any)
const AuditorAccessAccessIdNis2EvidenceRoute =
  AuditorAccessAccessIdNis2EvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => AuditorAccessAccessIdNis2Route,
  } as any)
const AuditorAccessAccessIdNis2AssessmentsRoute =
  AuditorAccessAccessIdNis2AssessmentsRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => AuditorAccessAccessIdNis2Route,
  } as any)
const AuditorAccessAccessIdBcpPlansRoute =
  AuditorAccessAccessIdBcpPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuditorAccessAccessIdBcpRoute,
  } as any)
const AuditorAccessAccessIdBcpFindingsRoute =
  AuditorAccessAccessIdBcpFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => AuditorAccessAccessIdBcpRoute,
  } as any)
const AuditorAccessAccessIdBcpExercisesRoute =
  AuditorAccessAccessIdBcpExercisesRouteImport.update({
    id: '/exercises',
    path: '/exercises',
    getParentRoute: () => AuditorAccessAccessIdBcpRoute,
  } as any)
const AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute =
  AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRouteImport.update({
    id: '/tasks/playbooks/templates/task-templates',
    path: '/tasks/playbooks/templates/task-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksTemplatesNewRoute =
  AuthenticatedTasksPlaybooksTemplatesNewRouteImport.update({
    id: '/tasks/playbooks/templates/new',
    path: '/tasks/playbooks/templates/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute =
  AuthenticatedTasksPlaybooksTemplatesTemplateIdRouteImport.update({
    id: '/tasks/playbooks/templates/$templateId',
    path: '/tasks/playbooks/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksPlaybooksActivationIdSetupRoute =
  AuthenticatedTasksPlaybooksActivationIdSetupRouteImport.update({
    id: '/tasks/playbooks/$activationId/setup',
    path: '/tasks/playbooks/$activationId/setup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersQuestionnairesSentIdReviewRoute =
  AuthenticatedSuppliersQuestionnairesSentIdReviewRouteImport.update({
    id: '/suppliers/questionnaires/$sentId/review',
    path: '/suppliers/questionnaires/$sentId/review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute =
  AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRouteImport.update({
    id: '/suppliers/admin/questionnaire-templates/new',
    path: '/suppliers/admin/questionnaire-templates/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute =
  AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRouteImport.update(
    {
      id: '/suppliers/admin/questionnaire-templates/$templateId',
      path: '/suppliers/admin/questionnaire-templates/$templateId',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute =
  AuthenticatedSuppliersSupplierIdReviewsReviewIdRouteImport.update({
    id: '/reviews/$reviewId',
    path: '/reviews/$reviewId',
    getParentRoute: () => AuthenticatedSuppliersSupplierIdRoute,
  } as any)
const AuthenticatedSettingsTeamMembersUserIdRoute =
  AuthenticatedSettingsTeamMembersUserIdRouteImport.update({
    id: '/members/$userId',
    path: '/members/$userId',
    getParentRoute: () => AuthenticatedSettingsTeamRoute,
  } as any)
const AuthenticatedPoliciesProceduresInstanceIdExecuteRoute =
  AuthenticatedPoliciesProceduresInstanceIdExecuteRouteImport.update({
    id: '/policies/procedures/$instanceId/execute',
    path: '/policies/procedures/$instanceId/execute',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPoliciesPolicyIdScansScanIdRoute =
  AuthenticatedPoliciesPolicyIdScansScanIdRouteImport.update({
    id: '/scans/$scanId',
    path: '/scans/$scanId',
    getParentRoute: () => AuthenticatedPoliciesPolicyIdRoute,
  } as any)
const AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute =
  AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRouteImport.update({
    id: '/incidents/$incidentId/progress-updates',
    path: '/incidents/$incidentId/progress-updates',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2IncidentsIncidentIdNotificationRoute =
  AuthenticatedNis2IncidentsIncidentIdNotificationRouteImport.update({
    id: '/incidents/$incidentId/notification',
    path: '/incidents/$incidentId/notification',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2IncidentsIncidentIdFinalReportRoute =
  AuthenticatedNis2IncidentsIncidentIdFinalReportRouteImport.update({
    id: '/incidents/$incidentId/final-report',
    path: '/incidents/$incidentId/final-report',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute =
  AuthenticatedNis2IncidentsIncidentIdEarlyWarningRouteImport.update({
    id: '/incidents/$incidentId/early-warning',
    path: '/incidents/$incidentId/early-warning',
    getParentRoute: () => AuthenticatedNis2Route,
  } as any)
const AuthenticatedGhgVerificationInternalVerificationIdRoute =
  AuthenticatedGhgVerificationInternalVerificationIdRouteImport.update({
    id: '/verification/internal/$verificationId',
    path: '/verification/internal/$verificationId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgScope3CategoryDeriveRoute =
  AuthenticatedGhgScope3CategoryDeriveRouteImport.update({
    id: '/derive',
    path: '/derive',
    getParentRoute: () => AuthenticatedGhgScope3CategoryRoute,
  } as any)
const AuthenticatedGhgReportsCustomNewRoute =
  AuthenticatedGhgReportsCustomNewRouteImport.update({
    id: '/reports/custom/new',
    path: '/reports/custom/new',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedGhgReportsCustomReportIdRoute =
  AuthenticatedGhgReportsCustomReportIdRouteImport.update({
    id: '/reports/custom/$reportId',
    path: '/reports/custom/$reportId',
    getParentRoute: () => AuthenticatedGhgRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRouteImport.update({
    id: '/value-chain',
    path: '/value-chain',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRouteImport.update({
    id: '/stakeholders',
    path: '/stakeholders',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRouteImport.update({
    id: '/risks',
    path: '/risks',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRouteImport.update({
    id: '/quality',
    path: '/quality',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRouteImport.update({
    id: '/matrix',
    path: '/matrix',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRouteImport.update({
    id: '/impacts',
    path: '/impacts',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute =
  AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRouteImport.update({
    id: '/assessment',
    path: '/assessment',
    getParentRoute: () => AuthenticatedEsgDoubleMaterialityAssessmentIdRoute,
  } as any)
const AuthenticatedDatahubUploadsUploadIdReviewRoute =
  AuthenticatedDatahubUploadsUploadIdReviewRouteImport.update({
    id: '/datahub/uploads/$uploadId/review',
    path: '/datahub/uploads/$uploadId/review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubUploadsUploadIdMapRoute =
  AuthenticatedDatahubUploadsUploadIdMapRouteImport.update({
    id: '/datahub/uploads/$uploadId/map',
    path: '/datahub/uploads/$uploadId/map',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute =
  AuthenticatedDatahubIntegrationsIntegrationIdMappingsRouteImport.update({
    id: '/datahub/integrations/$integrationId/mappings',
    path: '/datahub/integrations/$integrationId/mappings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDatahubDatapointsDatapointIdEntryRoute =
  AuthenticatedDatahubDatapointsDatapointIdEntryRouteImport.update({
    id: '/entry',
    path: '/entry',
    getParentRoute: () => AuthenticatedDatahubDatapointsDatapointIdRoute,
  } as any)
const AuthenticatedDatahubCollectionsCollectionIdImportRoute =
  AuthenticatedDatahubCollectionsCollectionIdImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedDatahubCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedDatahubCollectionsCollectionIdEntryRoute =
  AuthenticatedDatahubCollectionsCollectionIdEntryRouteImport.update({
    id: '/entry',
    path: '/entry',
    getParentRoute: () => AuthenticatedDatahubCollectionsCollectionIdRoute,
  } as any)
const AuthenticatedBcpResourcesSitesSiteIdRoute =
  AuthenticatedBcpResourcesSitesSiteIdRouteImport.update({
    id: '/$siteId',
    path: '/$siteId',
    getParentRoute: () => AuthenticatedBcpResourcesSitesRoute,
  } as any)
const AuthenticatedBcpPlansPlanIdReviewRoute =
  AuthenticatedBcpPlansPlanIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedBcpPlansPlanIdRoute,
  } as any)
const AuthenticatedBcpPlansPlanIdEditRoute =
  AuthenticatedBcpPlansPlanIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedBcpPlansPlanIdRoute,
  } as any)
const AuthenticatedBcpExercisesExerciseIdConductRoute =
  AuthenticatedBcpExercisesExerciseIdConductRouteImport.update({
    id: '/conduct',
    path: '/conduct',
    getParentRoute: () => AuthenticatedBcpExercisesExerciseIdRoute,
  } as any)
const AuthenticatedAuditAuditsAuditIdSettingsRoute =
  AuthenticatedAuditAuditsAuditIdSettingsRouteImport.update({
    id: '/audit/audits/$auditId/settings',
    path: '/audit/audits/$auditId/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiDocumentsDocumentIdExtractRoute =
  AuthenticatedAiDocumentsDocumentIdExtractRouteImport.update({
    id: '/$documentId/extract',
    path: '/$documentId/extract',
    getParentRoute: () => AuthenticatedAiDocumentsRoute,
  } as any)
const AuditorAccessAccessIdBcpPlansPlanIdRoute =
  AuditorAccessAccessIdBcpPlansPlanIdRouteImport.update({
    id: '/$planId',
    path: '/$planId',
    getParentRoute: () => AuditorAccessAccessIdBcpPlansRoute,
  } as any)
const AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute =
  AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRouteImport.update({
    id: '/history-connections',
    path: '/history-connections',
    getParentRoute: () => AuthenticatedSettingsTeamMembersUserIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/bcp': typeof AuthenticatedBcpRouteWithChildren
  '/controls': typeof AuthenticatedControlsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/esg': typeof AuthenticatedEsgRouteWithChildren
  '/eu-taxonomy': typeof AuthenticatedEuTaxonomyRouteWithChildren
  '/ghg': typeof AuthenticatedGhgRouteWithChildren
  '/help-centre': typeof AuthenticatedHelpCentreRouteWithChildren
  '/nis2': typeof AuthenticatedNis2RouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/vsme': typeof AuthenticatedVsmeRouteWithChildren
  '/workforce-readiness': typeof AuthenticatedWorkforceReadinessRouteWithChildren
  '/auditor/$token': typeof AuditorTokenRoute
  '/ghg-survey/$token': typeof GhgSurveyTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/quick-report/$shareToken': typeof QuickReportShareTokenRoute
  '/session-tasks/setup-mfa': typeof SessionTasksSetupMfaRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$orgId': typeof SignUpOrgIdRoute
  '/survey-respond/$token': typeof SurveyRespondTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/sign-up': typeof SignUpIndexRoute
  '/admin/ai-costs': typeof AuthenticatedAdminAiCostsRoute
  '/admin/knowledge-bases': typeof AuthenticatedAdminKnowledgeBasesRoute
  '/admin/llm-settings': typeof AuthenticatedAdminLlmSettingsRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/system-prompts': typeof AuthenticatedAdminSystemPromptsRoute
  '/ai/documents': typeof AuthenticatedAiDocumentsRouteWithChildren
  '/ai/insights': typeof AuthenticatedAiInsightsRoute
  '/ai/quality': typeof AuthenticatedAiQualityRoute
  '/ai/usage': typeof AuthenticatedAiUsageRoute
  '/analytics/ghg-overview': typeof AuthenticatedAnalyticsGhgOverviewRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/assets/import': typeof AuthenticatedAssetsImportRoute
  '/audit/calendar': typeof AuthenticatedAuditCalendarRoute
  '/audit/evidence-library': typeof AuthenticatedAuditEvidenceLibraryRoute
  '/audit/evidence-upload': typeof AuthenticatedAuditEvidenceUploadRoute
  '/audit/findings': typeof AuthenticatedAuditFindingsRoute
  '/audit/reports': typeof AuthenticatedAuditReportsRoute
  '/bcp/bcp': typeof AuthenticatedBcpBcpRoute
  '/bcp/bia': typeof AuthenticatedBcpBiaRouteWithChildren
  '/bcp/continuity': typeof AuthenticatedBcpContinuityRoute
  '/bcp/dashboard': typeof AuthenticatedBcpDashboardRoute
  '/bcp/findings': typeof AuthenticatedBcpFindingsRoute
  '/bcp/plans': typeof AuthenticatedBcpPlansRouteWithChildren
  '/compliance/alerts': typeof AuthenticatedComplianceAlertsRoute
  '/controls/$controlId': typeof AuthenticatedControlsControlIdRoute
  '/datahub/audit': typeof AuthenticatedDatahubAuditRoute
  '/datahub/comparison': typeof AuthenticatedDatahubComparisonRoute
  '/datahub/consolidated': typeof AuthenticatedDatahubConsolidatedRoute
  '/datahub/documents': typeof AuthenticatedDatahubDocumentsRoute
  '/datahub/entry': typeof AuthenticatedDatahubEntryRouteWithChildren
  '/datahub/my-entries': typeof AuthenticatedDatahubMyEntriesRoute
  '/datahub/periods': typeof AuthenticatedDatahubPeriodsRoute
  '/datahub/quality-dashboard': typeof AuthenticatedDatahubQualityDashboardRoute
  '/datahub/quality-issues': typeof AuthenticatedDatahubQualityIssuesRoute
  '/datahub/templates': typeof AuthenticatedDatahubTemplatesRoute
  '/datahub/upload': typeof AuthenticatedDatahubUploadRoute
  '/datahub/validation-errors': typeof AuthenticatedDatahubValidationErrorsRoute
  '/employees/$employeeId': typeof AuthenticatedEmployeesEmployeeIdRouteWithChildren
  '/employees/import': typeof AuthenticatedEmployeesImportRoute
  '/employees/new': typeof AuthenticatedEmployeesNewRoute
  '/esg/$section': typeof AuthenticatedEsgSectionRoute
  '/eu-taxonomy/$section': typeof AuthenticatedEuTaxonomySectionRoute
  '/evidence/$evidenceId': typeof AuthenticatedEvidenceEvidenceIdRoute
  '/evidence/logs': typeof AuthenticatedEvidenceLogsRoute
  '/evidence/repository': typeof AuthenticatedEvidenceRepositoryRoute
  '/external-reporting/$reportId': typeof AuthenticatedExternalReportingReportIdRoute
  '/ghg/activity-groups': typeof AuthenticatedGhgActivityGroupsRoute
  '/ghg/audit': typeof AuthenticatedGhgAuditRoute
  '/ghg/best-practices': typeof AuthenticatedGhgBestPracticesRoute
  '/ghg/business-travel': typeof AuthenticatedGhgBusinessTravelRoute
  '/ghg/cdp-questionnaire': typeof AuthenticatedGhgCdpQuestionnaireRoute
  '/ghg/collect': typeof AuthenticatedGhgCollectRoute
  '/ghg/commuting': typeof AuthenticatedGhgCommutingRoute
  '/ghg/dashboard': typeof AuthenticatedGhgDashboardRoute
  '/ghg/data-quality': typeof AuthenticatedGhgDataQualityRoute
  '/ghg/emission-factors': typeof AuthenticatedGhgEmissionFactorsRoute
  '/ghg/emission-insights': typeof AuthenticatedGhgEmissionInsightsRoute
  '/ghg/emissions': typeof AuthenticatedGhgEmissionsRoute
  '/ghg/gap-analysis': typeof AuthenticatedGhgGapAnalysisRoute
  '/ghg/industry-comparison': typeof AuthenticatedGhgIndustryComparisonRoute
  '/ghg/iso14064-compliance': typeof AuthenticatedGhgIso14064ComplianceRoute
  '/ghg/market-instruments': typeof AuthenticatedGhgMarketInstrumentsRoute
  '/ghg/net-zero': typeof AuthenticatedGhgNetZeroRoute
  '/ghg/overview': typeof AuthenticatedGhgOverviewRoute
  '/ghg/policies': typeof AuthenticatedGhgPoliciesRoute
  '/ghg/protocol-compliance': typeof AuthenticatedGhgProtocolComplianceRoute
  '/ghg/recalculations': typeof AuthenticatedGhgRecalculationsRouteWithChildren
  '/ghg/report': typeof AuthenticatedGhgReportRoute
  '/ghg/scope1': typeof AuthenticatedGhgScope1Route
  '/ghg/scope2': typeof AuthenticatedGhgScope2Route
  '/ghg/scope3-screening': typeof AuthenticatedGhgScope3ScreeningRoute
  '/ghg/tasks': typeof AuthenticatedGhgTasksRoute
  '/ghg/travel-import': typeof AuthenticatedGhgTravelImportRoute
  '/ghg/waste': typeof AuthenticatedGhgWasteRoute
  '/ghg/yoy-comparison': typeof AuthenticatedGhgYoyComparisonRoute
  '/help-centre/platform-guides': typeof AuthenticatedHelpCentrePlatformGuidesRoute
  '/help-centre/regulations': typeof AuthenticatedHelpCentreRegulationsRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/incidents/dashboard': typeof AuthenticatedIncidentsDashboardRoute
  '/incidents/new': typeof AuthenticatedIncidentsNewRoute
  '/incidents/quick-report': typeof AuthenticatedIncidentsQuickReportRoute
  '/incidents/settings': typeof AuthenticatedIncidentsSettingsRouteWithChildren
  '/incidents/subsidiaries': typeof AuthenticatedIncidentsSubsidiariesRoute
  '/nis2/asset-register': typeof AuthenticatedNis2AssetRegisterRoute
  '/nis2/assets-and-measures': typeof AuthenticatedNis2AssetsAndMeasuresRoute
  '/nis2/assets-measures': typeof AuthenticatedNis2AssetsMeasuresRoute
  '/nis2/business-continuity': typeof AuthenticatedNis2BusinessContinuityRoute
  '/nis2/dashboard': typeof AuthenticatedNis2DashboardRoute
  '/nis2/entity-classification': typeof AuthenticatedNis2EntityClassificationRoute
  '/nis2/evidence': typeof AuthenticatedNis2EvidenceRoute
  '/nis2/gap-analysis': typeof AuthenticatedNis2GapAnalysisRoute
  '/nis2/gaps': typeof AuthenticatedNis2GapsRoute
  '/nis2/hr-training': typeof AuthenticatedNis2HrTrainingRoute
  '/nis2/human-resources-security': typeof AuthenticatedNis2HumanResourcesSecurityRoute
  '/nis2/incident-management': typeof AuthenticatedNis2IncidentManagementRoute
  '/nis2/isms': typeof AuthenticatedNis2IsmsRoute
  '/nis2/knowledge-base': typeof AuthenticatedNis2KnowledgeBaseRoute
  '/nis2/measure-a': typeof AuthenticatedNis2MeasureARoute
  '/nis2/measure-d': typeof AuthenticatedNis2MeasureDRoute
  '/nis2/onboarding': typeof AuthenticatedNis2OnboardingRoute
  '/nis2/overview': typeof AuthenticatedNis2OverviewRoute
  '/nis2/policies-governance': typeof AuthenticatedNis2PoliciesGovernanceRoute
  '/nis2/policy-governance': typeof AuthenticatedNis2PolicyGovernanceRoute
  '/nis2/risk-management': typeof AuthenticatedNis2RiskManagementRoute
  '/nis2/self-assessment': typeof AuthenticatedNis2SelfAssessmentRoute
  '/nis2/supply-chain-security': typeof AuthenticatedNis2SupplyChainSecurityRoute
  '/policies/$policyId': typeof AuthenticatedPoliciesPolicyIdRouteWithChildren
  '/policies/compliance-dashboard': typeof AuthenticatedPoliciesComplianceDashboardRoute
  '/policies/create': typeof AuthenticatedPoliciesCreateRoute
  '/policies/documents': typeof AuthenticatedPoliciesDocumentsRoute
  '/policies/wizard': typeof AuthenticatedPoliciesWizardRoute
  '/procedures/$procedureId': typeof AuthenticatedProceduresProcedureIdRoute
  '/risks/$riskId': typeof AuthenticatedRisksRiskIdRoute
  '/risks/ai-suggestions': typeof AuthenticatedRisksAiSuggestionsRoute
  '/risks/dashboard': typeof AuthenticatedRisksDashboardRoute
  '/risks/heatmap': typeof AuthenticatedRisksHeatmapRoute
  '/risks/new': typeof AuthenticatedRisksNewRoute
  '/settings/access-log': typeof AuthenticatedSettingsAccessLogRoute
  '/settings/ai-conversations': typeof AuthenticatedSettingsAiConversationsRouteWithChildren
  '/settings/ai-settings': typeof AuthenticatedSettingsAiSettingsRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/asset-categories': typeof AuthenticatedSettingsAssetCategoriesRoute
  '/settings/asset-connectors': typeof AuthenticatedSettingsAssetConnectorsRoute
  '/settings/asset-custom-fields': typeof AuthenticatedSettingsAssetCustomFieldsRoute
  '/settings/asset-tags': typeof AuthenticatedSettingsAssetTagsRoute
  '/settings/audit-alerts': typeof AuthenticatedSettingsAuditAlertsRoute
  '/settings/audit-log': typeof AuthenticatedSettingsAuditLogRoute
  '/settings/audit-settings': typeof AuthenticatedSettingsAuditSettingsRoute
  '/settings/audit-webhooks': typeof AuthenticatedSettingsAuditWebhooksRoute
  '/settings/auditors': typeof AuthenticatedSettingsAuditorsRoute
  '/settings/bcp-exercise-settings': typeof AuthenticatedSettingsBcpExerciseSettingsRoute
  '/settings/bcp-review-settings': typeof AuthenticatedSettingsBcpReviewSettingsRoute
  '/settings/compliance-frameworks': typeof AuthenticatedSettingsComplianceFrameworksRoute
  '/settings/configration': typeof AuthenticatedSettingsConfigrationRoute
  '/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/settings/evidence-collections': typeof AuthenticatedSettingsEvidenceCollectionsRoute
  '/settings/gap-detection-rules': typeof AuthenticatedSettingsGapDetectionRulesRoute
  '/settings/ghg-boundary': typeof AuthenticatedSettingsGhgBoundaryRoute
  '/settings/ghg-facilities': typeof AuthenticatedSettingsGhgFacilitiesRoute
  '/settings/ghg-permissions': typeof AuthenticatedSettingsGhgPermissionsRoute
  '/settings/ghg-sources': typeof AuthenticatedSettingsGhgSourcesRoute
  '/settings/incident-categories': typeof AuthenticatedSettingsIncidentCategoriesRoute
  '/settings/my-activity': typeof AuthenticatedSettingsMyActivityRoute
  '/settings/nis2-classification': typeof AuthenticatedSettingsNis2ClassificationRoute
  '/settings/nis2-gap-priority': typeof AuthenticatedSettingsNis2GapPriorityRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/organisation-structure': typeof AuthenticatedSettingsOrganisationStructureRoute
  '/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/settings/policy-categories': typeof AuthenticatedSettingsPolicyCategoriesRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/reporting-periods': typeof AuthenticatedSettingsReportingPeriodsRoute
  '/settings/risk': typeof AuthenticatedSettingsRiskRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/scanner-integrations': typeof AuthenticatedSettingsScannerIntegrationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRouteWithChildren
  '/settings/subsidiaries': typeof AuthenticatedSettingsSubsidiariesRoute
  '/settings/supplier-categories': typeof AuthenticatedSettingsSupplierCategoriesRoute
  '/settings/task-schedules': typeof AuthenticatedSettingsTaskSchedulesRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRouteWithChildren
  '/settings/vulnerability-settings': typeof AuthenticatedSettingsVulnerabilitySettingsRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRouteWithChildren
  '/suppliers/compliance-matrix': typeof AuthenticatedSuppliersComplianceMatrixRoute
  '/suppliers/register': typeof AuthenticatedSuppliersRegisterRoute
  '/suppliers/risk': typeof AuthenticatedSuppliersRiskRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/tasks/approvals': typeof AuthenticatedTasksApprovalsRoute
  '/tasks/console': typeof AuthenticatedTasksConsoleRouteWithChildren
  '/tasks/my': typeof AuthenticatedTasksMyRoute
  '/vsme/$section': typeof AuthenticatedVsmeSectionRoute
  '/vulnerabilities/$vulnerabilityId': typeof AuthenticatedVulnerabilitiesVulnerabilityIdRoute
  '/vulnerabilities/audit-report': typeof AuthenticatedVulnerabilitiesAuditReportRoute
  '/vulnerabilities/consolidated-report': typeof AuthenticatedVulnerabilitiesConsolidatedReportRoute
  '/vulnerabilities/dashboard': typeof AuthenticatedVulnerabilitiesDashboardRoute
  '/vulnerabilities/new': typeof AuthenticatedVulnerabilitiesNewRoute
  '/vulnerabilities/nis2-report': typeof AuthenticatedVulnerabilitiesNis2ReportRoute
  '/vulnerabilities/settings': typeof AuthenticatedVulnerabilitiesSettingsRoute
  '/vulnerabilities/sla-report': typeof AuthenticatedVulnerabilitiesSlaReportRoute
  '/vulnerabilities/soc2-compliance': typeof AuthenticatedVulnerabilitiesSoc2ComplianceRoute
  '/vulnerabilities/subsidiaries': typeof AuthenticatedVulnerabilitiesSubsidiariesRoute
  '/vulnerabilities/workspace': typeof AuthenticatedVulnerabilitiesWorkspaceRoute
  '/workforce-readiness/awareness-campaigns': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren
  '/workforce-readiness/my-trainings': typeof AuthenticatedWorkforceReadinessMyTrainingsRoute
  '/workforce-readiness/training-register': typeof AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren
  '/portal/auth/login': typeof PortalAuthLoginRoute
  '/portal/history/$token': typeof PortalHistoryTokenRoute
  '/portal/home/$token': typeof PortalHomeTokenRoute
  '/portal/profile/$token': typeof PortalProfileTokenRoute
  '/portal/questionnaire/$token': typeof PortalQuestionnaireTokenRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/ai': typeof AuthenticatedAiIndexRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/controls/': typeof AuthenticatedControlsIndexRoute
  '/datahub': typeof AuthenticatedDatahubIndexRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/evidence': typeof AuthenticatedEvidenceIndexRoute
  '/external-reporting': typeof AuthenticatedExternalReportingIndexRoute
  '/gaps': typeof AuthenticatedGapsIndexRoute
  '/incidents': typeof AuthenticatedIncidentsIndexRoute
  '/policies': typeof AuthenticatedPoliciesIndexRoute
  '/procedures': typeof AuthenticatedProceduresIndexRoute
  '/risks': typeof AuthenticatedRisksIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/surveys': typeof AuthenticatedSurveysIndexRoute
  '/threats': typeof AuthenticatedThreatsIndexRoute
  '/vulnerabilities': typeof AuthenticatedVulnerabilitiesIndexRoute
  '/admin/incidents/tags': typeof AuthenticatedAdminIncidentsTagsRoute
  '/admin/policies/access-controls': typeof AuthenticatedAdminPoliciesAccessControlsRoute
  '/admin/policies/approval-configs': typeof AuthenticatedAdminPoliciesApprovalConfigsRoute
  '/admin/policies/templates': typeof AuthenticatedAdminPoliciesTemplatesRoute
  '/ai/onboarding/$module': typeof AuthenticatedAiOnboardingModuleRoute
  '/ai/scans/$scanId': typeof AuthenticatedAiScansScanIdRoute
  '/analytics/dashboards/$dashboardId': typeof AuthenticatedAnalyticsDashboardsDashboardIdRoute
  '/analytics/report-studio/$reportId': typeof AuthenticatedAnalyticsReportStudioReportIdRoute
  '/analytics/report-studio/new': typeof AuthenticatedAnalyticsReportStudioNewRoute
  '/analytics/report-studio/templates': typeof AuthenticatedAnalyticsReportStudioTemplatesRoute
  '/audit/audits/new': typeof AuthenticatedAuditAuditsNewRoute
  '/audit/evidence/$evidenceId': typeof AuthenticatedAuditEvidenceEvidenceIdRoute
  '/bcp/bia/$biaId': typeof AuthenticatedBcpBiaBiaIdRoute
  '/bcp/exercises/$exerciseId': typeof AuthenticatedBcpExercisesExerciseIdRouteWithChildren
  '/bcp/exercises/new': typeof AuthenticatedBcpExercisesNewRoute
  '/bcp/exercises/schedule': typeof AuthenticatedBcpExercisesScheduleRoute
  '/bcp/plans/$planId': typeof AuthenticatedBcpPlansPlanIdRouteWithChildren
  '/bcp/plans/bcp': typeof AuthenticatedBcpPlansBcpRoute
  '/bcp/plans/crisis-comm': typeof AuthenticatedBcpPlansCrisisCommRoute
  '/bcp/plans/it-dr': typeof AuthenticatedBcpPlansItDrRoute
  '/bcp/plans/new': typeof AuthenticatedBcpPlansNewRoute
  '/bcp/plans/new-crisis-communication': typeof AuthenticatedBcpPlansNewCrisisCommunicationRoute
  '/bcp/plans/new-it-dr': typeof AuthenticatedBcpPlansNewItDrRoute
  '/bcp/plans/new-recovery-procedure': typeof AuthenticatedBcpPlansNewRecoveryProcedureRoute
  '/bcp/plans/recovery': typeof AuthenticatedBcpPlansRecoveryRoute
  '/bcp/reports/exercise-summary': typeof AuthenticatedBcpReportsExerciseSummaryRoute
  '/bcp/reports/gap-analysis': typeof AuthenticatedBcpReportsGapAnalysisRoute
  '/bcp/reports/iso-22301': typeof AuthenticatedBcpReportsIso22301Route
  '/bcp/reports/nis2-compliance': typeof AuthenticatedBcpReportsNis2ComplianceRoute
  '/bcp/reports/plan-status': typeof AuthenticatedBcpReportsPlanStatusRoute
  '/bcp/resources/sites': typeof AuthenticatedBcpResourcesSitesRouteWithChildren
  '/datahub/collections/$collectionId': typeof AuthenticatedDatahubCollectionsCollectionIdRouteWithChildren
  '/datahub/datapoints/$datapointId': typeof AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren
  '/datahub/entry/wizard': typeof AuthenticatedDatahubEntryWizardRoute
  '/datahub/governance/approval-config': typeof AuthenticatedDatahubGovernanceApprovalConfigRoute
  '/datahub/governance/approval-queue': typeof AuthenticatedDatahubGovernanceApprovalQueueRoute
  '/datahub/governance/scheduled-exports': typeof AuthenticatedDatahubGovernanceScheduledExportsRoute
  '/datahub/integrations/transformation-rules': typeof AuthenticatedDatahubIntegrationsTransformationRulesRoute
  '/employees/$employeeId/edit': typeof AuthenticatedEmployeesEmployeeIdEditRoute
  '/esg/double-materiality/$assessmentId': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRouteWithChildren
  '/esg/double-materiality/datapoints-policies': typeof AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute
  '/esg/onboarding/$onboardingId': typeof AuthenticatedEsgOnboardingOnboardingIdRoute
  '/evidence/attestations/new': typeof AuthenticatedEvidenceAttestationsNewRoute
  '/ghg/activity-data/$entryId': typeof AuthenticatedGhgActivityDataEntryIdRoute
  '/ghg/activity-data/assignment-queue': typeof AuthenticatedGhgActivityDataAssignmentQueueRoute
  '/ghg/activity-data/document-ocr': typeof AuthenticatedGhgActivityDataDocumentOcrRoute
  '/ghg/activity-data/import': typeof AuthenticatedGhgActivityDataImportRoute
  '/ghg/calculations/scope1': typeof AuthenticatedGhgCalculationsScope1Route
  '/ghg/calculations/scope2': typeof AuthenticatedGhgCalculationsScope2Route
  '/ghg/calculations/scope3': typeof AuthenticatedGhgCalculationsScope3Route
  '/ghg/commuting-surveys/$surveyId': typeof AuthenticatedGhgCommutingSurveysSurveyIdRoute
  '/ghg/commuting-surveys/new': typeof AuthenticatedGhgCommutingSurveysNewRoute
  '/ghg/facilities/dashboard': typeof AuthenticatedGhgFacilitiesDashboardRoute
  '/ghg/integrations/$connectorId': typeof AuthenticatedGhgIntegrationsConnectorIdRoute
  '/ghg/recalculations/$recalculationId': typeof AuthenticatedGhgRecalculationsRecalculationIdRoute
  '/ghg/reduction-initiatives/$initiativeId': typeof AuthenticatedGhgReductionInitiativesInitiativeIdRoute
  '/ghg/reduction-initiatives/new': typeof AuthenticatedGhgReductionInitiativesNewRoute
  '/ghg/scenarios/$scenarioId': typeof AuthenticatedGhgScenariosScenarioIdRoute
  '/ghg/scenarios/compare': typeof AuthenticatedGhgScenariosCompareRoute
  '/ghg/scenarios/new': typeof AuthenticatedGhgScenariosNewRoute
  '/ghg/scope3/$category': typeof AuthenticatedGhgScope3CategoryRouteWithChildren
  '/ghg/scope3/add': typeof AuthenticatedGhgScope3AddRoute
  '/ghg/scope3/sold-products': typeof AuthenticatedGhgScope3SoldProductsRoute
  '/ghg/settings/scope1': typeof AuthenticatedGhgSettingsScope1Route
  '/ghg/settings/scope2': typeof AuthenticatedGhgSettingsScope2Route
  '/ghg/targets/$targetId': typeof AuthenticatedGhgTargetsTargetIdRoute
  '/ghg/targets/new': typeof AuthenticatedGhgTargetsNewRoute
  '/ghg/third-party-verification/$engagementId': typeof AuthenticatedGhgThirdPartyVerificationEngagementIdRoute
  '/ghg/verification-statements/$statementId': typeof AuthenticatedGhgVerificationStatementsStatementIdRoute
  '/ghg/verification/$checklistId': typeof AuthenticatedGhgVerificationChecklistIdRoute
  '/incidents/settings/sla': typeof AuthenticatedIncidentsSettingsSlaRoute
  '/nis2/inspection-preparation/$preparationId': typeof AuthenticatedNis2InspectionPreparationPreparationIdRoute
  '/nis2/measures/$measureCode': typeof AuthenticatedNis2MeasuresMeasureCodeRoute
  '/nis2/reports/activity': typeof AuthenticatedNis2ReportsActivityRoute
  '/nis2/reports/audit-preparation': typeof AuthenticatedNis2ReportsAuditPreparationRoute
  '/nis2/reports/board': typeof AuthenticatedNis2ReportsBoardRoute
  '/nis2/reports/compliance': typeof AuthenticatedNis2ReportsComplianceRoute
  '/nis2/reports/consolidated': typeof AuthenticatedNis2ReportsConsolidatedRoute
  '/nis2/reports/cross-border': typeof AuthenticatedNis2ReportsCrossBorderRoute
  '/nis2/reports/executive': typeof AuthenticatedNis2ReportsExecutiveRoute
  '/nis2/reports/scheduled': typeof AuthenticatedNis2ReportsScheduledRoute
  '/policies/$policyId/edit': typeof AuthenticatedPoliciesPolicyIdEditRoute
  '/policies/$policyId/review': typeof AuthenticatedPoliciesPolicyIdReviewRoute
  '/settings/ai-conversations/$conversationId': typeof AuthenticatedSettingsAiConversationsConversationIdRoute
  '/settings/nis2/reminders': typeof AuthenticatedSettingsNis2RemindersRoute
  '/settings/security/sessions': typeof AuthenticatedSettingsSecuritySessionsRoute
  '/suppliers/admin/risk-config': typeof AuthenticatedSuppliersAdminRiskConfigRoute
  '/surveys/campaigns/$campaignId': typeof AuthenticatedSurveysCampaignsCampaignIdRoute
  '/surveys/campaigns/new': typeof AuthenticatedSurveysCampaignsNewRoute
  '/surveys/templates/$templateId': typeof AuthenticatedSurveysTemplatesTemplateIdRoute
  '/surveys/templates/new': typeof AuthenticatedSurveysTemplatesNewRoute
  '/tasks/console/approvals': typeof AuthenticatedTasksConsoleApprovalsRoute
  '/tasks/playbooks/activate': typeof AuthenticatedTasksPlaybooksActivateRoute
  '/workforce-readiness/awareness-campaigns/$campaignId': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute
  '/workforce-readiness/training-register/$trainingId': typeof AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute
  '/auditor/access/$accessId/assets': typeof AuditorAccessAccessIdAssetsRoute
  '/auditor/access/$accessId/audit': typeof AuditorAccessAccessIdAuditRoute
  '/auditor/access/$accessId/bcp': typeof AuditorAccessAccessIdBcpRouteWithChildren
  '/auditor/access/$accessId/controls': typeof AuditorAccessAccessIdControlsRoute
  '/auditor/access/$accessId/nis2': typeof AuditorAccessAccessIdNis2RouteWithChildren
  '/auditor/access/$accessId/tasks': typeof AuditorAccessAccessIdTasksRoute
  '/portal/auth/create-account/$token': typeof PortalAuthCreateAccountTokenRoute
  '/portal/auth/reset-password/$token': typeof PortalAuthResetPasswordTokenRoute
  '/ai/documents/': typeof AuthenticatedAiDocumentsIndexRoute
  '/ai/scans': typeof AuthenticatedAiScansIndexRoute
  '/analytics/dashboards': typeof AuthenticatedAnalyticsDashboardsIndexRoute
  '/analytics/report-studio': typeof AuthenticatedAnalyticsReportStudioIndexRoute
  '/audit/audits': typeof AuthenticatedAuditAuditsIndexRoute
  '/audit/evidence': typeof AuthenticatedAuditEvidenceIndexRoute
  '/bcp/exercises': typeof AuthenticatedBcpExercisesIndexRoute
  '/bcp/plans/': typeof AuthenticatedBcpPlansIndexRoute
  '/bcp/resources': typeof AuthenticatedBcpResourcesIndexRoute
  '/datahub/collections': typeof AuthenticatedDatahubCollectionsIndexRoute
  '/datahub/datapoints': typeof AuthenticatedDatahubDatapointsIndexRoute
  '/datahub/integrations': typeof AuthenticatedDatahubIntegrationsIndexRoute
  '/employees/$employeeId/': typeof AuthenticatedEmployeesEmployeeIdIndexRoute
  '/esg/double-materiality': typeof AuthenticatedEsgDoubleMaterialityIndexRoute
  '/esg/onboarding': typeof AuthenticatedEsgOnboardingIndexRoute
  '/ghg/activity-data': typeof AuthenticatedGhgActivityDataIndexRoute
  '/ghg/approvals': typeof AuthenticatedGhgApprovalsIndexRoute
  '/ghg/commuting-surveys': typeof AuthenticatedGhgCommutingSurveysIndexRoute
  '/ghg/exports': typeof AuthenticatedGhgExportsIndexRoute
  '/ghg/integrations': typeof AuthenticatedGhgIntegrationsIndexRoute
  '/ghg/recalculations/': typeof AuthenticatedGhgRecalculationsIndexRoute
  '/ghg/reduction-initiatives': typeof AuthenticatedGhgReductionInitiativesIndexRoute
  '/ghg/reports': typeof AuthenticatedGhgReportsIndexRoute
  '/ghg/scenarios': typeof AuthenticatedGhgScenariosIndexRoute
  '/ghg/settings': typeof AuthenticatedGhgSettingsIndexRoute
  '/ghg/setup': typeof AuthenticatedGhgSetupIndexRoute
  '/ghg/targets': typeof AuthenticatedGhgTargetsIndexRoute
  '/ghg/third-party-verification': typeof AuthenticatedGhgThirdPartyVerificationIndexRoute
  '/ghg/verification-statements': typeof AuthenticatedGhgVerificationStatementsIndexRoute
  '/ghg/verification': typeof AuthenticatedGhgVerificationIndexRoute
  '/nis2/inspection-preparation': typeof AuthenticatedNis2InspectionPreparationIndexRoute
  '/nis2/measures': typeof AuthenticatedNis2MeasuresIndexRoute
  '/nis2/reports': typeof AuthenticatedNis2ReportsIndexRoute
  '/risks/approvals': typeof AuthenticatedRisksApprovalsIndexRoute
  '/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute
  '/surveys/campaigns': typeof AuthenticatedSurveysCampaignsIndexRoute
  '/surveys/schedules': typeof AuthenticatedSurveysSchedulesIndexRoute
  '/tasks/playbooks': typeof AuthenticatedTasksPlaybooksIndexRoute
  '/vulnerabilities/approvals': typeof AuthenticatedVulnerabilitiesApprovalsIndexRoute
  '/portal/auth/forgot-password': typeof PortalAuthForgotPasswordIndexRoute
  '/ai/documents/$documentId/extract': typeof AuthenticatedAiDocumentsDocumentIdExtractRoute
  '/audit/audits/$auditId/settings': typeof AuthenticatedAuditAuditsAuditIdSettingsRoute
  '/bcp/exercises/$exerciseId/conduct': typeof AuthenticatedBcpExercisesExerciseIdConductRoute
  '/bcp/plans/$planId/edit': typeof AuthenticatedBcpPlansPlanIdEditRoute
  '/bcp/plans/$planId/review': typeof AuthenticatedBcpPlansPlanIdReviewRoute
  '/bcp/resources/sites/$siteId': typeof AuthenticatedBcpResourcesSitesSiteIdRoute
  '/datahub/collections/$collectionId/entry': typeof AuthenticatedDatahubCollectionsCollectionIdEntryRoute
  '/datahub/collections/$collectionId/import': typeof AuthenticatedDatahubCollectionsCollectionIdImportRoute
  '/datahub/datapoints/$datapointId/entry': typeof AuthenticatedDatahubDatapointsDatapointIdEntryRoute
  '/datahub/integrations/$integrationId/mappings': typeof AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute
  '/datahub/uploads/$uploadId/map': typeof AuthenticatedDatahubUploadsUploadIdMapRoute
  '/datahub/uploads/$uploadId/review': typeof AuthenticatedDatahubUploadsUploadIdReviewRoute
  '/esg/double-materiality/$assessmentId/assessment': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute
  '/esg/double-materiality/$assessmentId/impacts': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute
  '/esg/double-materiality/$assessmentId/matrix': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute
  '/esg/double-materiality/$assessmentId/overview': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute
  '/esg/double-materiality/$assessmentId/quality': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute
  '/esg/double-materiality/$assessmentId/risks': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute
  '/esg/double-materiality/$assessmentId/stakeholders': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute
  '/esg/double-materiality/$assessmentId/value-chain': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute
  '/ghg/reports/custom/$reportId': typeof AuthenticatedGhgReportsCustomReportIdRoute
  '/ghg/reports/custom/new': typeof AuthenticatedGhgReportsCustomNewRoute
  '/ghg/scope3/$category/derive': typeof AuthenticatedGhgScope3CategoryDeriveRoute
  '/ghg/verification/internal/$verificationId': typeof AuthenticatedGhgVerificationInternalVerificationIdRoute
  '/nis2/incidents/$incidentId/early-warning': typeof AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute
  '/nis2/incidents/$incidentId/final-report': typeof AuthenticatedNis2IncidentsIncidentIdFinalReportRoute
  '/nis2/incidents/$incidentId/notification': typeof AuthenticatedNis2IncidentsIncidentIdNotificationRoute
  '/nis2/incidents/$incidentId/progress-updates': typeof AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute
  '/policies/$policyId/scans/$scanId': typeof AuthenticatedPoliciesPolicyIdScansScanIdRoute
  '/policies/procedures/$instanceId/execute': typeof AuthenticatedPoliciesProceduresInstanceIdExecuteRoute
  '/settings/team/members/$userId': typeof AuthenticatedSettingsTeamMembersUserIdRouteWithChildren
  '/suppliers/$supplierId/reviews/$reviewId': typeof AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute
  '/suppliers/admin/questionnaire-templates/$templateId': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute
  '/suppliers/admin/questionnaire-templates/new': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute
  '/suppliers/questionnaires/$sentId/review': typeof AuthenticatedSuppliersQuestionnairesSentIdReviewRoute
  '/tasks/playbooks/$activationId/setup': typeof AuthenticatedTasksPlaybooksActivationIdSetupRoute
  '/tasks/playbooks/templates/$templateId': typeof AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute
  '/tasks/playbooks/templates/new': typeof AuthenticatedTasksPlaybooksTemplatesNewRoute
  '/tasks/playbooks/templates/task-templates': typeof AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute
  '/auditor/access/$accessId/bcp/exercises': typeof AuditorAccessAccessIdBcpExercisesRoute
  '/auditor/access/$accessId/bcp/findings': typeof AuditorAccessAccessIdBcpFindingsRoute
  '/auditor/access/$accessId/bcp/plans': typeof AuditorAccessAccessIdBcpPlansRouteWithChildren
  '/auditor/access/$accessId/nis2/assessments': typeof AuditorAccessAccessIdNis2AssessmentsRoute
  '/auditor/access/$accessId/nis2/evidence': typeof AuditorAccessAccessIdNis2EvidenceRoute
  '/auditor/access/$accessId/nis2/gaps': typeof AuditorAccessAccessIdNis2GapsRoute
  '/auditor/access/$accessId/nis2/incidents': typeof AuditorAccessAccessIdNis2IncidentsRoute
  '/auditor/access/$accessId/nis2/measures': typeof AuditorAccessAccessIdNis2MeasuresRoute
  '/audit/audits/$auditId': typeof AuthenticatedAuditAuditsAuditIdIndexRoute
  '/bcp/exercises/$exerciseId/': typeof AuthenticatedBcpExercisesExerciseIdIndexRoute
  '/bcp/plans/$planId/': typeof AuthenticatedBcpPlansPlanIdIndexRoute
  '/datahub/collections/$collectionId/': typeof AuthenticatedDatahubCollectionsCollectionIdIndexRoute
  '/esg/double-materiality/$assessmentId/': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute
  '/ghg/reports/custom': typeof AuthenticatedGhgReportsCustomIndexRoute
  '/ghg/scope3/$category/': typeof AuthenticatedGhgScope3CategoryIndexRoute
  '/ghg/verification/internal': typeof AuthenticatedGhgVerificationInternalIndexRoute
  '/suppliers/admin/questionnaire-templates': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute
  '/tasks/playbooks/$activationId': typeof AuthenticatedTasksPlaybooksActivationIdIndexRoute
  '/tasks/playbooks/templates': typeof AuthenticatedTasksPlaybooksTemplatesIndexRoute
  '/settings/team/members/$userId/history-connections': typeof AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute
  '/auditor/access/$accessId/bcp/plans/$planId': typeof AuditorAccessAccessIdBcpPlansPlanIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bcp': typeof AuthenticatedBcpRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/esg': typeof AuthenticatedEsgRouteWithChildren
  '/eu-taxonomy': typeof AuthenticatedEuTaxonomyRouteWithChildren
  '/ghg': typeof AuthenticatedGhgRouteWithChildren
  '/help-centre': typeof AuthenticatedHelpCentreRouteWithChildren
  '/nis2': typeof AuthenticatedNis2RouteWithChildren
  '/vsme': typeof AuthenticatedVsmeRouteWithChildren
  '/workforce-readiness': typeof AuthenticatedWorkforceReadinessRouteWithChildren
  '/auditor/$token': typeof AuditorTokenRoute
  '/ghg-survey/$token': typeof GhgSurveyTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/quick-report/$shareToken': typeof QuickReportShareTokenRoute
  '/session-tasks/setup-mfa': typeof SessionTasksSetupMfaRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$orgId': typeof SignUpOrgIdRoute
  '/survey-respond/$token': typeof SurveyRespondTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/sign-up': typeof SignUpIndexRoute
  '/admin/ai-costs': typeof AuthenticatedAdminAiCostsRoute
  '/admin/knowledge-bases': typeof AuthenticatedAdminKnowledgeBasesRoute
  '/admin/llm-settings': typeof AuthenticatedAdminLlmSettingsRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/system-prompts': typeof AuthenticatedAdminSystemPromptsRoute
  '/ai/insights': typeof AuthenticatedAiInsightsRoute
  '/ai/quality': typeof AuthenticatedAiQualityRoute
  '/ai/usage': typeof AuthenticatedAiUsageRoute
  '/analytics/ghg-overview': typeof AuthenticatedAnalyticsGhgOverviewRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/assets/import': typeof AuthenticatedAssetsImportRoute
  '/audit/calendar': typeof AuthenticatedAuditCalendarRoute
  '/audit/evidence-library': typeof AuthenticatedAuditEvidenceLibraryRoute
  '/audit/evidence-upload': typeof AuthenticatedAuditEvidenceUploadRoute
  '/audit/findings': typeof AuthenticatedAuditFindingsRoute
  '/audit/reports': typeof AuthenticatedAuditReportsRoute
  '/bcp/bcp': typeof AuthenticatedBcpBcpRoute
  '/bcp/bia': typeof AuthenticatedBcpBiaRouteWithChildren
  '/bcp/continuity': typeof AuthenticatedBcpContinuityRoute
  '/bcp/dashboard': typeof AuthenticatedBcpDashboardRoute
  '/bcp/findings': typeof AuthenticatedBcpFindingsRoute
  '/compliance/alerts': typeof AuthenticatedComplianceAlertsRoute
  '/controls/$controlId': typeof AuthenticatedControlsControlIdRoute
  '/datahub/audit': typeof AuthenticatedDatahubAuditRoute
  '/datahub/comparison': typeof AuthenticatedDatahubComparisonRoute
  '/datahub/consolidated': typeof AuthenticatedDatahubConsolidatedRoute
  '/datahub/documents': typeof AuthenticatedDatahubDocumentsRoute
  '/datahub/entry': typeof AuthenticatedDatahubEntryRouteWithChildren
  '/datahub/my-entries': typeof AuthenticatedDatahubMyEntriesRoute
  '/datahub/periods': typeof AuthenticatedDatahubPeriodsRoute
  '/datahub/quality-dashboard': typeof AuthenticatedDatahubQualityDashboardRoute
  '/datahub/quality-issues': typeof AuthenticatedDatahubQualityIssuesRoute
  '/datahub/templates': typeof AuthenticatedDatahubTemplatesRoute
  '/datahub/upload': typeof AuthenticatedDatahubUploadRoute
  '/datahub/validation-errors': typeof AuthenticatedDatahubValidationErrorsRoute
  '/employees/import': typeof AuthenticatedEmployeesImportRoute
  '/employees/new': typeof AuthenticatedEmployeesNewRoute
  '/esg/$section': typeof AuthenticatedEsgSectionRoute
  '/eu-taxonomy/$section': typeof AuthenticatedEuTaxonomySectionRoute
  '/evidence/$evidenceId': typeof AuthenticatedEvidenceEvidenceIdRoute
  '/evidence/logs': typeof AuthenticatedEvidenceLogsRoute
  '/evidence/repository': typeof AuthenticatedEvidenceRepositoryRoute
  '/external-reporting/$reportId': typeof AuthenticatedExternalReportingReportIdRoute
  '/ghg/activity-groups': typeof AuthenticatedGhgActivityGroupsRoute
  '/ghg/audit': typeof AuthenticatedGhgAuditRoute
  '/ghg/best-practices': typeof AuthenticatedGhgBestPracticesRoute
  '/ghg/business-travel': typeof AuthenticatedGhgBusinessTravelRoute
  '/ghg/cdp-questionnaire': typeof AuthenticatedGhgCdpQuestionnaireRoute
  '/ghg/collect': typeof AuthenticatedGhgCollectRoute
  '/ghg/commuting': typeof AuthenticatedGhgCommutingRoute
  '/ghg/dashboard': typeof AuthenticatedGhgDashboardRoute
  '/ghg/data-quality': typeof AuthenticatedGhgDataQualityRoute
  '/ghg/emission-factors': typeof AuthenticatedGhgEmissionFactorsRoute
  '/ghg/emission-insights': typeof AuthenticatedGhgEmissionInsightsRoute
  '/ghg/emissions': typeof AuthenticatedGhgEmissionsRoute
  '/ghg/gap-analysis': typeof AuthenticatedGhgGapAnalysisRoute
  '/ghg/industry-comparison': typeof AuthenticatedGhgIndustryComparisonRoute
  '/ghg/iso14064-compliance': typeof AuthenticatedGhgIso14064ComplianceRoute
  '/ghg/market-instruments': typeof AuthenticatedGhgMarketInstrumentsRoute
  '/ghg/net-zero': typeof AuthenticatedGhgNetZeroRoute
  '/ghg/overview': typeof AuthenticatedGhgOverviewRoute
  '/ghg/policies': typeof AuthenticatedGhgPoliciesRoute
  '/ghg/protocol-compliance': typeof AuthenticatedGhgProtocolComplianceRoute
  '/ghg/report': typeof AuthenticatedGhgReportRoute
  '/ghg/scope1': typeof AuthenticatedGhgScope1Route
  '/ghg/scope2': typeof AuthenticatedGhgScope2Route
  '/ghg/scope3-screening': typeof AuthenticatedGhgScope3ScreeningRoute
  '/ghg/tasks': typeof AuthenticatedGhgTasksRoute
  '/ghg/travel-import': typeof AuthenticatedGhgTravelImportRoute
  '/ghg/waste': typeof AuthenticatedGhgWasteRoute
  '/ghg/yoy-comparison': typeof AuthenticatedGhgYoyComparisonRoute
  '/help-centre/platform-guides': typeof AuthenticatedHelpCentrePlatformGuidesRoute
  '/help-centre/regulations': typeof AuthenticatedHelpCentreRegulationsRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/incidents/dashboard': typeof AuthenticatedIncidentsDashboardRoute
  '/incidents/new': typeof AuthenticatedIncidentsNewRoute
  '/incidents/quick-report': typeof AuthenticatedIncidentsQuickReportRoute
  '/incidents/settings': typeof AuthenticatedIncidentsSettingsRouteWithChildren
  '/incidents/subsidiaries': typeof AuthenticatedIncidentsSubsidiariesRoute
  '/nis2/asset-register': typeof AuthenticatedNis2AssetRegisterRoute
  '/nis2/assets-and-measures': typeof AuthenticatedNis2AssetsAndMeasuresRoute
  '/nis2/assets-measures': typeof AuthenticatedNis2AssetsMeasuresRoute
  '/nis2/business-continuity': typeof AuthenticatedNis2BusinessContinuityRoute
  '/nis2/dashboard': typeof AuthenticatedNis2DashboardRoute
  '/nis2/entity-classification': typeof AuthenticatedNis2EntityClassificationRoute
  '/nis2/evidence': typeof AuthenticatedNis2EvidenceRoute
  '/nis2/gap-analysis': typeof AuthenticatedNis2GapAnalysisRoute
  '/nis2/gaps': typeof AuthenticatedNis2GapsRoute
  '/nis2/hr-training': typeof AuthenticatedNis2HrTrainingRoute
  '/nis2/human-resources-security': typeof AuthenticatedNis2HumanResourcesSecurityRoute
  '/nis2/incident-management': typeof AuthenticatedNis2IncidentManagementRoute
  '/nis2/isms': typeof AuthenticatedNis2IsmsRoute
  '/nis2/knowledge-base': typeof AuthenticatedNis2KnowledgeBaseRoute
  '/nis2/measure-a': typeof AuthenticatedNis2MeasureARoute
  '/nis2/measure-d': typeof AuthenticatedNis2MeasureDRoute
  '/nis2/onboarding': typeof AuthenticatedNis2OnboardingRoute
  '/nis2/overview': typeof AuthenticatedNis2OverviewRoute
  '/nis2/policies-governance': typeof AuthenticatedNis2PoliciesGovernanceRoute
  '/nis2/policy-governance': typeof AuthenticatedNis2PolicyGovernanceRoute
  '/nis2/risk-management': typeof AuthenticatedNis2RiskManagementRoute
  '/nis2/self-assessment': typeof AuthenticatedNis2SelfAssessmentRoute
  '/nis2/supply-chain-security': typeof AuthenticatedNis2SupplyChainSecurityRoute
  '/policies/$policyId': typeof AuthenticatedPoliciesPolicyIdRouteWithChildren
  '/policies/compliance-dashboard': typeof AuthenticatedPoliciesComplianceDashboardRoute
  '/policies/create': typeof AuthenticatedPoliciesCreateRoute
  '/policies/documents': typeof AuthenticatedPoliciesDocumentsRoute
  '/policies/wizard': typeof AuthenticatedPoliciesWizardRoute
  '/procedures/$procedureId': typeof AuthenticatedProceduresProcedureIdRoute
  '/risks/$riskId': typeof AuthenticatedRisksRiskIdRoute
  '/risks/ai-suggestions': typeof AuthenticatedRisksAiSuggestionsRoute
  '/risks/dashboard': typeof AuthenticatedRisksDashboardRoute
  '/risks/heatmap': typeof AuthenticatedRisksHeatmapRoute
  '/risks/new': typeof AuthenticatedRisksNewRoute
  '/settings/access-log': typeof AuthenticatedSettingsAccessLogRoute
  '/settings/ai-conversations': typeof AuthenticatedSettingsAiConversationsRouteWithChildren
  '/settings/ai-settings': typeof AuthenticatedSettingsAiSettingsRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/asset-categories': typeof AuthenticatedSettingsAssetCategoriesRoute
  '/settings/asset-connectors': typeof AuthenticatedSettingsAssetConnectorsRoute
  '/settings/asset-custom-fields': typeof AuthenticatedSettingsAssetCustomFieldsRoute
  '/settings/asset-tags': typeof AuthenticatedSettingsAssetTagsRoute
  '/settings/audit-alerts': typeof AuthenticatedSettingsAuditAlertsRoute
  '/settings/audit-log': typeof AuthenticatedSettingsAuditLogRoute
  '/settings/audit-settings': typeof AuthenticatedSettingsAuditSettingsRoute
  '/settings/audit-webhooks': typeof AuthenticatedSettingsAuditWebhooksRoute
  '/settings/auditors': typeof AuthenticatedSettingsAuditorsRoute
  '/settings/bcp-exercise-settings': typeof AuthenticatedSettingsBcpExerciseSettingsRoute
  '/settings/bcp-review-settings': typeof AuthenticatedSettingsBcpReviewSettingsRoute
  '/settings/compliance-frameworks': typeof AuthenticatedSettingsComplianceFrameworksRoute
  '/settings/configration': typeof AuthenticatedSettingsConfigrationRoute
  '/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/settings/evidence-collections': typeof AuthenticatedSettingsEvidenceCollectionsRoute
  '/settings/gap-detection-rules': typeof AuthenticatedSettingsGapDetectionRulesRoute
  '/settings/ghg-boundary': typeof AuthenticatedSettingsGhgBoundaryRoute
  '/settings/ghg-facilities': typeof AuthenticatedSettingsGhgFacilitiesRoute
  '/settings/ghg-permissions': typeof AuthenticatedSettingsGhgPermissionsRoute
  '/settings/ghg-sources': typeof AuthenticatedSettingsGhgSourcesRoute
  '/settings/incident-categories': typeof AuthenticatedSettingsIncidentCategoriesRoute
  '/settings/my-activity': typeof AuthenticatedSettingsMyActivityRoute
  '/settings/nis2-classification': typeof AuthenticatedSettingsNis2ClassificationRoute
  '/settings/nis2-gap-priority': typeof AuthenticatedSettingsNis2GapPriorityRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/organisation-structure': typeof AuthenticatedSettingsOrganisationStructureRoute
  '/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/settings/policy-categories': typeof AuthenticatedSettingsPolicyCategoriesRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/reporting-periods': typeof AuthenticatedSettingsReportingPeriodsRoute
  '/settings/risk': typeof AuthenticatedSettingsRiskRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/scanner-integrations': typeof AuthenticatedSettingsScannerIntegrationsRoute
  '/settings/subsidiaries': typeof AuthenticatedSettingsSubsidiariesRoute
  '/settings/supplier-categories': typeof AuthenticatedSettingsSupplierCategoriesRoute
  '/settings/task-schedules': typeof AuthenticatedSettingsTaskSchedulesRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRouteWithChildren
  '/settings/vulnerability-settings': typeof AuthenticatedSettingsVulnerabilitySettingsRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRouteWithChildren
  '/suppliers/compliance-matrix': typeof AuthenticatedSuppliersComplianceMatrixRoute
  '/suppliers/register': typeof AuthenticatedSuppliersRegisterRoute
  '/suppliers/risk': typeof AuthenticatedSuppliersRiskRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/tasks/approvals': typeof AuthenticatedTasksApprovalsRoute
  '/tasks/console': typeof AuthenticatedTasksConsoleRouteWithChildren
  '/tasks/my': typeof AuthenticatedTasksMyRoute
  '/vsme/$section': typeof AuthenticatedVsmeSectionRoute
  '/vulnerabilities/$vulnerabilityId': typeof AuthenticatedVulnerabilitiesVulnerabilityIdRoute
  '/vulnerabilities/audit-report': typeof AuthenticatedVulnerabilitiesAuditReportRoute
  '/vulnerabilities/consolidated-report': typeof AuthenticatedVulnerabilitiesConsolidatedReportRoute
  '/vulnerabilities/dashboard': typeof AuthenticatedVulnerabilitiesDashboardRoute
  '/vulnerabilities/new': typeof AuthenticatedVulnerabilitiesNewRoute
  '/vulnerabilities/nis2-report': typeof AuthenticatedVulnerabilitiesNis2ReportRoute
  '/vulnerabilities/settings': typeof AuthenticatedVulnerabilitiesSettingsRoute
  '/vulnerabilities/sla-report': typeof AuthenticatedVulnerabilitiesSlaReportRoute
  '/vulnerabilities/soc2-compliance': typeof AuthenticatedVulnerabilitiesSoc2ComplianceRoute
  '/vulnerabilities/subsidiaries': typeof AuthenticatedVulnerabilitiesSubsidiariesRoute
  '/vulnerabilities/workspace': typeof AuthenticatedVulnerabilitiesWorkspaceRoute
  '/workforce-readiness/awareness-campaigns': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren
  '/workforce-readiness/my-trainings': typeof AuthenticatedWorkforceReadinessMyTrainingsRoute
  '/workforce-readiness/training-register': typeof AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren
  '/portal/auth/login': typeof PortalAuthLoginRoute
  '/portal/history/$token': typeof PortalHistoryTokenRoute
  '/portal/home/$token': typeof PortalHomeTokenRoute
  '/portal/profile/$token': typeof PortalProfileTokenRoute
  '/portal/questionnaire/$token': typeof PortalQuestionnaireTokenRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/ai': typeof AuthenticatedAiIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/controls': typeof AuthenticatedControlsIndexRoute
  '/datahub': typeof AuthenticatedDatahubIndexRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/evidence': typeof AuthenticatedEvidenceIndexRoute
  '/external-reporting': typeof AuthenticatedExternalReportingIndexRoute
  '/gaps': typeof AuthenticatedGapsIndexRoute
  '/incidents': typeof AuthenticatedIncidentsIndexRoute
  '/policies': typeof AuthenticatedPoliciesIndexRoute
  '/procedures': typeof AuthenticatedProceduresIndexRoute
  '/risks': typeof AuthenticatedRisksIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/surveys': typeof AuthenticatedSurveysIndexRoute
  '/threats': typeof AuthenticatedThreatsIndexRoute
  '/vulnerabilities': typeof AuthenticatedVulnerabilitiesIndexRoute
  '/admin/incidents/tags': typeof AuthenticatedAdminIncidentsTagsRoute
  '/admin/policies/access-controls': typeof AuthenticatedAdminPoliciesAccessControlsRoute
  '/admin/policies/approval-configs': typeof AuthenticatedAdminPoliciesApprovalConfigsRoute
  '/admin/policies/templates': typeof AuthenticatedAdminPoliciesTemplatesRoute
  '/ai/onboarding/$module': typeof AuthenticatedAiOnboardingModuleRoute
  '/ai/scans/$scanId': typeof AuthenticatedAiScansScanIdRoute
  '/analytics/dashboards/$dashboardId': typeof AuthenticatedAnalyticsDashboardsDashboardIdRoute
  '/analytics/report-studio/$reportId': typeof AuthenticatedAnalyticsReportStudioReportIdRoute
  '/analytics/report-studio/new': typeof AuthenticatedAnalyticsReportStudioNewRoute
  '/analytics/report-studio/templates': typeof AuthenticatedAnalyticsReportStudioTemplatesRoute
  '/audit/audits/new': typeof AuthenticatedAuditAuditsNewRoute
  '/audit/evidence/$evidenceId': typeof AuthenticatedAuditEvidenceEvidenceIdRoute
  '/bcp/bia/$biaId': typeof AuthenticatedBcpBiaBiaIdRoute
  '/bcp/exercises/new': typeof AuthenticatedBcpExercisesNewRoute
  '/bcp/exercises/schedule': typeof AuthenticatedBcpExercisesScheduleRoute
  '/bcp/plans/bcp': typeof AuthenticatedBcpPlansBcpRoute
  '/bcp/plans/crisis-comm': typeof AuthenticatedBcpPlansCrisisCommRoute
  '/bcp/plans/it-dr': typeof AuthenticatedBcpPlansItDrRoute
  '/bcp/plans/new': typeof AuthenticatedBcpPlansNewRoute
  '/bcp/plans/new-crisis-communication': typeof AuthenticatedBcpPlansNewCrisisCommunicationRoute
  '/bcp/plans/new-it-dr': typeof AuthenticatedBcpPlansNewItDrRoute
  '/bcp/plans/new-recovery-procedure': typeof AuthenticatedBcpPlansNewRecoveryProcedureRoute
  '/bcp/plans/recovery': typeof AuthenticatedBcpPlansRecoveryRoute
  '/bcp/reports/exercise-summary': typeof AuthenticatedBcpReportsExerciseSummaryRoute
  '/bcp/reports/gap-analysis': typeof AuthenticatedBcpReportsGapAnalysisRoute
  '/bcp/reports/iso-22301': typeof AuthenticatedBcpReportsIso22301Route
  '/bcp/reports/nis2-compliance': typeof AuthenticatedBcpReportsNis2ComplianceRoute
  '/bcp/reports/plan-status': typeof AuthenticatedBcpReportsPlanStatusRoute
  '/bcp/resources/sites': typeof AuthenticatedBcpResourcesSitesRouteWithChildren
  '/datahub/datapoints/$datapointId': typeof AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren
  '/datahub/entry/wizard': typeof AuthenticatedDatahubEntryWizardRoute
  '/datahub/governance/approval-config': typeof AuthenticatedDatahubGovernanceApprovalConfigRoute
  '/datahub/governance/approval-queue': typeof AuthenticatedDatahubGovernanceApprovalQueueRoute
  '/datahub/governance/scheduled-exports': typeof AuthenticatedDatahubGovernanceScheduledExportsRoute
  '/datahub/integrations/transformation-rules': typeof AuthenticatedDatahubIntegrationsTransformationRulesRoute
  '/employees/$employeeId/edit': typeof AuthenticatedEmployeesEmployeeIdEditRoute
  '/esg/double-materiality/datapoints-policies': typeof AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute
  '/esg/onboarding/$onboardingId': typeof AuthenticatedEsgOnboardingOnboardingIdRoute
  '/evidence/attestations/new': typeof AuthenticatedEvidenceAttestationsNewRoute
  '/ghg/activity-data/$entryId': typeof AuthenticatedGhgActivityDataEntryIdRoute
  '/ghg/activity-data/assignment-queue': typeof AuthenticatedGhgActivityDataAssignmentQueueRoute
  '/ghg/activity-data/document-ocr': typeof AuthenticatedGhgActivityDataDocumentOcrRoute
  '/ghg/activity-data/import': typeof AuthenticatedGhgActivityDataImportRoute
  '/ghg/calculations/scope1': typeof AuthenticatedGhgCalculationsScope1Route
  '/ghg/calculations/scope2': typeof AuthenticatedGhgCalculationsScope2Route
  '/ghg/calculations/scope3': typeof AuthenticatedGhgCalculationsScope3Route
  '/ghg/commuting-surveys/$surveyId': typeof AuthenticatedGhgCommutingSurveysSurveyIdRoute
  '/ghg/commuting-surveys/new': typeof AuthenticatedGhgCommutingSurveysNewRoute
  '/ghg/facilities/dashboard': typeof AuthenticatedGhgFacilitiesDashboardRoute
  '/ghg/integrations/$connectorId': typeof AuthenticatedGhgIntegrationsConnectorIdRoute
  '/ghg/recalculations/$recalculationId': typeof AuthenticatedGhgRecalculationsRecalculationIdRoute
  '/ghg/reduction-initiatives/$initiativeId': typeof AuthenticatedGhgReductionInitiativesInitiativeIdRoute
  '/ghg/reduction-initiatives/new': typeof AuthenticatedGhgReductionInitiativesNewRoute
  '/ghg/scenarios/$scenarioId': typeof AuthenticatedGhgScenariosScenarioIdRoute
  '/ghg/scenarios/compare': typeof AuthenticatedGhgScenariosCompareRoute
  '/ghg/scenarios/new': typeof AuthenticatedGhgScenariosNewRoute
  '/ghg/scope3/add': typeof AuthenticatedGhgScope3AddRoute
  '/ghg/scope3/sold-products': typeof AuthenticatedGhgScope3SoldProductsRoute
  '/ghg/settings/scope1': typeof AuthenticatedGhgSettingsScope1Route
  '/ghg/settings/scope2': typeof AuthenticatedGhgSettingsScope2Route
  '/ghg/targets/$targetId': typeof AuthenticatedGhgTargetsTargetIdRoute
  '/ghg/targets/new': typeof AuthenticatedGhgTargetsNewRoute
  '/ghg/third-party-verification/$engagementId': typeof AuthenticatedGhgThirdPartyVerificationEngagementIdRoute
  '/ghg/verification-statements/$statementId': typeof AuthenticatedGhgVerificationStatementsStatementIdRoute
  '/ghg/verification/$checklistId': typeof AuthenticatedGhgVerificationChecklistIdRoute
  '/incidents/settings/sla': typeof AuthenticatedIncidentsSettingsSlaRoute
  '/nis2/inspection-preparation/$preparationId': typeof AuthenticatedNis2InspectionPreparationPreparationIdRoute
  '/nis2/measures/$measureCode': typeof AuthenticatedNis2MeasuresMeasureCodeRoute
  '/nis2/reports/activity': typeof AuthenticatedNis2ReportsActivityRoute
  '/nis2/reports/audit-preparation': typeof AuthenticatedNis2ReportsAuditPreparationRoute
  '/nis2/reports/board': typeof AuthenticatedNis2ReportsBoardRoute
  '/nis2/reports/compliance': typeof AuthenticatedNis2ReportsComplianceRoute
  '/nis2/reports/consolidated': typeof AuthenticatedNis2ReportsConsolidatedRoute
  '/nis2/reports/cross-border': typeof AuthenticatedNis2ReportsCrossBorderRoute
  '/nis2/reports/executive': typeof AuthenticatedNis2ReportsExecutiveRoute
  '/nis2/reports/scheduled': typeof AuthenticatedNis2ReportsScheduledRoute
  '/policies/$policyId/edit': typeof AuthenticatedPoliciesPolicyIdEditRoute
  '/policies/$policyId/review': typeof AuthenticatedPoliciesPolicyIdReviewRoute
  '/settings/ai-conversations/$conversationId': typeof AuthenticatedSettingsAiConversationsConversationIdRoute
  '/settings/nis2/reminders': typeof AuthenticatedSettingsNis2RemindersRoute
  '/settings/security/sessions': typeof AuthenticatedSettingsSecuritySessionsRoute
  '/suppliers/admin/risk-config': typeof AuthenticatedSuppliersAdminRiskConfigRoute
  '/surveys/campaigns/$campaignId': typeof AuthenticatedSurveysCampaignsCampaignIdRoute
  '/surveys/campaigns/new': typeof AuthenticatedSurveysCampaignsNewRoute
  '/surveys/templates/$templateId': typeof AuthenticatedSurveysTemplatesTemplateIdRoute
  '/surveys/templates/new': typeof AuthenticatedSurveysTemplatesNewRoute
  '/tasks/console/approvals': typeof AuthenticatedTasksConsoleApprovalsRoute
  '/tasks/playbooks/activate': typeof AuthenticatedTasksPlaybooksActivateRoute
  '/workforce-readiness/awareness-campaigns/$campaignId': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute
  '/workforce-readiness/training-register/$trainingId': typeof AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute
  '/auditor/access/$accessId/assets': typeof AuditorAccessAccessIdAssetsRoute
  '/auditor/access/$accessId/audit': typeof AuditorAccessAccessIdAuditRoute
  '/auditor/access/$accessId/bcp': typeof AuditorAccessAccessIdBcpRouteWithChildren
  '/auditor/access/$accessId/controls': typeof AuditorAccessAccessIdControlsRoute
  '/auditor/access/$accessId/nis2': typeof AuditorAccessAccessIdNis2RouteWithChildren
  '/auditor/access/$accessId/tasks': typeof AuditorAccessAccessIdTasksRoute
  '/portal/auth/create-account/$token': typeof PortalAuthCreateAccountTokenRoute
  '/portal/auth/reset-password/$token': typeof PortalAuthResetPasswordTokenRoute
  '/ai/documents': typeof AuthenticatedAiDocumentsIndexRoute
  '/ai/scans': typeof AuthenticatedAiScansIndexRoute
  '/analytics/dashboards': typeof AuthenticatedAnalyticsDashboardsIndexRoute
  '/analytics/report-studio': typeof AuthenticatedAnalyticsReportStudioIndexRoute
  '/audit/audits': typeof AuthenticatedAuditAuditsIndexRoute
  '/audit/evidence': typeof AuthenticatedAuditEvidenceIndexRoute
  '/bcp/exercises': typeof AuthenticatedBcpExercisesIndexRoute
  '/bcp/plans': typeof AuthenticatedBcpPlansIndexRoute
  '/bcp/resources': typeof AuthenticatedBcpResourcesIndexRoute
  '/datahub/collections': typeof AuthenticatedDatahubCollectionsIndexRoute
  '/datahub/datapoints': typeof AuthenticatedDatahubDatapointsIndexRoute
  '/datahub/integrations': typeof AuthenticatedDatahubIntegrationsIndexRoute
  '/employees/$employeeId': typeof AuthenticatedEmployeesEmployeeIdIndexRoute
  '/esg/double-materiality': typeof AuthenticatedEsgDoubleMaterialityIndexRoute
  '/esg/onboarding': typeof AuthenticatedEsgOnboardingIndexRoute
  '/ghg/activity-data': typeof AuthenticatedGhgActivityDataIndexRoute
  '/ghg/approvals': typeof AuthenticatedGhgApprovalsIndexRoute
  '/ghg/commuting-surveys': typeof AuthenticatedGhgCommutingSurveysIndexRoute
  '/ghg/exports': typeof AuthenticatedGhgExportsIndexRoute
  '/ghg/integrations': typeof AuthenticatedGhgIntegrationsIndexRoute
  '/ghg/recalculations': typeof AuthenticatedGhgRecalculationsIndexRoute
  '/ghg/reduction-initiatives': typeof AuthenticatedGhgReductionInitiativesIndexRoute
  '/ghg/reports': typeof AuthenticatedGhgReportsIndexRoute
  '/ghg/scenarios': typeof AuthenticatedGhgScenariosIndexRoute
  '/ghg/settings': typeof AuthenticatedGhgSettingsIndexRoute
  '/ghg/setup': typeof AuthenticatedGhgSetupIndexRoute
  '/ghg/targets': typeof AuthenticatedGhgTargetsIndexRoute
  '/ghg/third-party-verification': typeof AuthenticatedGhgThirdPartyVerificationIndexRoute
  '/ghg/verification-statements': typeof AuthenticatedGhgVerificationStatementsIndexRoute
  '/ghg/verification': typeof AuthenticatedGhgVerificationIndexRoute
  '/nis2/inspection-preparation': typeof AuthenticatedNis2InspectionPreparationIndexRoute
  '/nis2/measures': typeof AuthenticatedNis2MeasuresIndexRoute
  '/nis2/reports': typeof AuthenticatedNis2ReportsIndexRoute
  '/risks/approvals': typeof AuthenticatedRisksApprovalsIndexRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityIndexRoute
  '/surveys/campaigns': typeof AuthenticatedSurveysCampaignsIndexRoute
  '/surveys/schedules': typeof AuthenticatedSurveysSchedulesIndexRoute
  '/tasks/playbooks': typeof AuthenticatedTasksPlaybooksIndexRoute
  '/vulnerabilities/approvals': typeof AuthenticatedVulnerabilitiesApprovalsIndexRoute
  '/portal/auth/forgot-password': typeof PortalAuthForgotPasswordIndexRoute
  '/ai/documents/$documentId/extract': typeof AuthenticatedAiDocumentsDocumentIdExtractRoute
  '/audit/audits/$auditId/settings': typeof AuthenticatedAuditAuditsAuditIdSettingsRoute
  '/bcp/exercises/$exerciseId/conduct': typeof AuthenticatedBcpExercisesExerciseIdConductRoute
  '/bcp/plans/$planId/edit': typeof AuthenticatedBcpPlansPlanIdEditRoute
  '/bcp/plans/$planId/review': typeof AuthenticatedBcpPlansPlanIdReviewRoute
  '/bcp/resources/sites/$siteId': typeof AuthenticatedBcpResourcesSitesSiteIdRoute
  '/datahub/collections/$collectionId/entry': typeof AuthenticatedDatahubCollectionsCollectionIdEntryRoute
  '/datahub/collections/$collectionId/import': typeof AuthenticatedDatahubCollectionsCollectionIdImportRoute
  '/datahub/datapoints/$datapointId/entry': typeof AuthenticatedDatahubDatapointsDatapointIdEntryRoute
  '/datahub/integrations/$integrationId/mappings': typeof AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute
  '/datahub/uploads/$uploadId/map': typeof AuthenticatedDatahubUploadsUploadIdMapRoute
  '/datahub/uploads/$uploadId/review': typeof AuthenticatedDatahubUploadsUploadIdReviewRoute
  '/esg/double-materiality/$assessmentId/assessment': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute
  '/esg/double-materiality/$assessmentId/impacts': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute
  '/esg/double-materiality/$assessmentId/matrix': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute
  '/esg/double-materiality/$assessmentId/overview': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute
  '/esg/double-materiality/$assessmentId/quality': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute
  '/esg/double-materiality/$assessmentId/risks': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute
  '/esg/double-materiality/$assessmentId/stakeholders': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute
  '/esg/double-materiality/$assessmentId/value-chain': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute
  '/ghg/reports/custom/$reportId': typeof AuthenticatedGhgReportsCustomReportIdRoute
  '/ghg/reports/custom/new': typeof AuthenticatedGhgReportsCustomNewRoute
  '/ghg/scope3/$category/derive': typeof AuthenticatedGhgScope3CategoryDeriveRoute
  '/ghg/verification/internal/$verificationId': typeof AuthenticatedGhgVerificationInternalVerificationIdRoute
  '/nis2/incidents/$incidentId/early-warning': typeof AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute
  '/nis2/incidents/$incidentId/final-report': typeof AuthenticatedNis2IncidentsIncidentIdFinalReportRoute
  '/nis2/incidents/$incidentId/notification': typeof AuthenticatedNis2IncidentsIncidentIdNotificationRoute
  '/nis2/incidents/$incidentId/progress-updates': typeof AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute
  '/policies/$policyId/scans/$scanId': typeof AuthenticatedPoliciesPolicyIdScansScanIdRoute
  '/policies/procedures/$instanceId/execute': typeof AuthenticatedPoliciesProceduresInstanceIdExecuteRoute
  '/settings/team/members/$userId': typeof AuthenticatedSettingsTeamMembersUserIdRouteWithChildren
  '/suppliers/$supplierId/reviews/$reviewId': typeof AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute
  '/suppliers/admin/questionnaire-templates/$templateId': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute
  '/suppliers/admin/questionnaire-templates/new': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute
  '/suppliers/questionnaires/$sentId/review': typeof AuthenticatedSuppliersQuestionnairesSentIdReviewRoute
  '/tasks/playbooks/$activationId/setup': typeof AuthenticatedTasksPlaybooksActivationIdSetupRoute
  '/tasks/playbooks/templates/$templateId': typeof AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute
  '/tasks/playbooks/templates/new': typeof AuthenticatedTasksPlaybooksTemplatesNewRoute
  '/tasks/playbooks/templates/task-templates': typeof AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute
  '/auditor/access/$accessId/bcp/exercises': typeof AuditorAccessAccessIdBcpExercisesRoute
  '/auditor/access/$accessId/bcp/findings': typeof AuditorAccessAccessIdBcpFindingsRoute
  '/auditor/access/$accessId/bcp/plans': typeof AuditorAccessAccessIdBcpPlansRouteWithChildren
  '/auditor/access/$accessId/nis2/assessments': typeof AuditorAccessAccessIdNis2AssessmentsRoute
  '/auditor/access/$accessId/nis2/evidence': typeof AuditorAccessAccessIdNis2EvidenceRoute
  '/auditor/access/$accessId/nis2/gaps': typeof AuditorAccessAccessIdNis2GapsRoute
  '/auditor/access/$accessId/nis2/incidents': typeof AuditorAccessAccessIdNis2IncidentsRoute
  '/auditor/access/$accessId/nis2/measures': typeof AuditorAccessAccessIdNis2MeasuresRoute
  '/audit/audits/$auditId': typeof AuthenticatedAuditAuditsAuditIdIndexRoute
  '/bcp/exercises/$exerciseId': typeof AuthenticatedBcpExercisesExerciseIdIndexRoute
  '/bcp/plans/$planId': typeof AuthenticatedBcpPlansPlanIdIndexRoute
  '/datahub/collections/$collectionId': typeof AuthenticatedDatahubCollectionsCollectionIdIndexRoute
  '/esg/double-materiality/$assessmentId': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute
  '/ghg/reports/custom': typeof AuthenticatedGhgReportsCustomIndexRoute
  '/ghg/scope3/$category': typeof AuthenticatedGhgScope3CategoryIndexRoute
  '/ghg/verification/internal': typeof AuthenticatedGhgVerificationInternalIndexRoute
  '/suppliers/admin/questionnaire-templates': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute
  '/tasks/playbooks/$activationId': typeof AuthenticatedTasksPlaybooksActivationIdIndexRoute
  '/tasks/playbooks/templates': typeof AuthenticatedTasksPlaybooksTemplatesIndexRoute
  '/settings/team/members/$userId/history-connections': typeof AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute
  '/auditor/access/$accessId/bcp/plans/$planId': typeof AuditorAccessAccessIdBcpPlansPlanIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/_authenticated/bcp': typeof AuthenticatedBcpRouteWithChildren
  '/_authenticated/controls': typeof AuthenticatedControlsRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/esg': typeof AuthenticatedEsgRouteWithChildren
  '/_authenticated/eu-taxonomy': typeof AuthenticatedEuTaxonomyRouteWithChildren
  '/_authenticated/ghg': typeof AuthenticatedGhgRouteWithChildren
  '/_authenticated/help-centre': typeof AuthenticatedHelpCentreRouteWithChildren
  '/_authenticated/nis2': typeof AuthenticatedNis2RouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/vsme': typeof AuthenticatedVsmeRouteWithChildren
  '/_authenticated/workforce-readiness': typeof AuthenticatedWorkforceReadinessRouteWithChildren
  '/auditor/$token': typeof AuditorTokenRoute
  '/ghg-survey/$token': typeof GhgSurveyTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/quick-report/$shareToken': typeof QuickReportShareTokenRoute
  '/session-tasks/setup-mfa': typeof SessionTasksSetupMfaRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$orgId': typeof SignUpOrgIdRoute
  '/survey-respond/$token': typeof SurveyRespondTokenRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/sign-up/': typeof SignUpIndexRoute
  '/_authenticated/admin/ai-costs': typeof AuthenticatedAdminAiCostsRoute
  '/_authenticated/admin/knowledge-bases': typeof AuthenticatedAdminKnowledgeBasesRoute
  '/_authenticated/admin/llm-settings': typeof AuthenticatedAdminLlmSettingsRoute
  '/_authenticated/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/system-prompts': typeof AuthenticatedAdminSystemPromptsRoute
  '/_authenticated/ai/documents': typeof AuthenticatedAiDocumentsRouteWithChildren
  '/_authenticated/ai/insights': typeof AuthenticatedAiInsightsRoute
  '/_authenticated/ai/quality': typeof AuthenticatedAiQualityRoute
  '/_authenticated/ai/usage': typeof AuthenticatedAiUsageRoute
  '/_authenticated/analytics/ghg-overview': typeof AuthenticatedAnalyticsGhgOverviewRoute
  '/_authenticated/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/_authenticated/assets/import': typeof AuthenticatedAssetsImportRoute
  '/_authenticated/audit/calendar': typeof AuthenticatedAuditCalendarRoute
  '/_authenticated/audit/evidence-library': typeof AuthenticatedAuditEvidenceLibraryRoute
  '/_authenticated/audit/evidence-upload': typeof AuthenticatedAuditEvidenceUploadRoute
  '/_authenticated/audit/findings': typeof AuthenticatedAuditFindingsRoute
  '/_authenticated/audit/reports': typeof AuthenticatedAuditReportsRoute
  '/_authenticated/bcp/bcp': typeof AuthenticatedBcpBcpRoute
  '/_authenticated/bcp/bia': typeof AuthenticatedBcpBiaRouteWithChildren
  '/_authenticated/bcp/continuity': typeof AuthenticatedBcpContinuityRoute
  '/_authenticated/bcp/dashboard': typeof AuthenticatedBcpDashboardRoute
  '/_authenticated/bcp/findings': typeof AuthenticatedBcpFindingsRoute
  '/_authenticated/bcp/plans': typeof AuthenticatedBcpPlansRouteWithChildren
  '/_authenticated/compliance/alerts': typeof AuthenticatedComplianceAlertsRoute
  '/_authenticated/controls/$controlId': typeof AuthenticatedControlsControlIdRoute
  '/_authenticated/datahub/audit': typeof AuthenticatedDatahubAuditRoute
  '/_authenticated/datahub/comparison': typeof AuthenticatedDatahubComparisonRoute
  '/_authenticated/datahub/consolidated': typeof AuthenticatedDatahubConsolidatedRoute
  '/_authenticated/datahub/documents': typeof AuthenticatedDatahubDocumentsRoute
  '/_authenticated/datahub/entry': typeof AuthenticatedDatahubEntryRouteWithChildren
  '/_authenticated/datahub/my-entries': typeof AuthenticatedDatahubMyEntriesRoute
  '/_authenticated/datahub/periods': typeof AuthenticatedDatahubPeriodsRoute
  '/_authenticated/datahub/quality-dashboard': typeof AuthenticatedDatahubQualityDashboardRoute
  '/_authenticated/datahub/quality-issues': typeof AuthenticatedDatahubQualityIssuesRoute
  '/_authenticated/datahub/templates': typeof AuthenticatedDatahubTemplatesRoute
  '/_authenticated/datahub/upload': typeof AuthenticatedDatahubUploadRoute
  '/_authenticated/datahub/validation-errors': typeof AuthenticatedDatahubValidationErrorsRoute
  '/_authenticated/employees/$employeeId': typeof AuthenticatedEmployeesEmployeeIdRouteWithChildren
  '/_authenticated/employees/import': typeof AuthenticatedEmployeesImportRoute
  '/_authenticated/employees/new': typeof AuthenticatedEmployeesNewRoute
  '/_authenticated/esg/$section': typeof AuthenticatedEsgSectionRoute
  '/_authenticated/eu-taxonomy/$section': typeof AuthenticatedEuTaxonomySectionRoute
  '/_authenticated/evidence/$evidenceId': typeof AuthenticatedEvidenceEvidenceIdRoute
  '/_authenticated/evidence/logs': typeof AuthenticatedEvidenceLogsRoute
  '/_authenticated/evidence/repository': typeof AuthenticatedEvidenceRepositoryRoute
  '/_authenticated/external-reporting/$reportId': typeof AuthenticatedExternalReportingReportIdRoute
  '/_authenticated/ghg/activity-groups': typeof AuthenticatedGhgActivityGroupsRoute
  '/_authenticated/ghg/audit': typeof AuthenticatedGhgAuditRoute
  '/_authenticated/ghg/best-practices': typeof AuthenticatedGhgBestPracticesRoute
  '/_authenticated/ghg/business-travel': typeof AuthenticatedGhgBusinessTravelRoute
  '/_authenticated/ghg/cdp-questionnaire': typeof AuthenticatedGhgCdpQuestionnaireRoute
  '/_authenticated/ghg/collect': typeof AuthenticatedGhgCollectRoute
  '/_authenticated/ghg/commuting': typeof AuthenticatedGhgCommutingRoute
  '/_authenticated/ghg/dashboard': typeof AuthenticatedGhgDashboardRoute
  '/_authenticated/ghg/data-quality': typeof AuthenticatedGhgDataQualityRoute
  '/_authenticated/ghg/emission-factors': typeof AuthenticatedGhgEmissionFactorsRoute
  '/_authenticated/ghg/emission-insights': typeof AuthenticatedGhgEmissionInsightsRoute
  '/_authenticated/ghg/emissions': typeof AuthenticatedGhgEmissionsRoute
  '/_authenticated/ghg/gap-analysis': typeof AuthenticatedGhgGapAnalysisRoute
  '/_authenticated/ghg/industry-comparison': typeof AuthenticatedGhgIndustryComparisonRoute
  '/_authenticated/ghg/iso14064-compliance': typeof AuthenticatedGhgIso14064ComplianceRoute
  '/_authenticated/ghg/market-instruments': typeof AuthenticatedGhgMarketInstrumentsRoute
  '/_authenticated/ghg/net-zero': typeof AuthenticatedGhgNetZeroRoute
  '/_authenticated/ghg/overview': typeof AuthenticatedGhgOverviewRoute
  '/_authenticated/ghg/policies': typeof AuthenticatedGhgPoliciesRoute
  '/_authenticated/ghg/protocol-compliance': typeof AuthenticatedGhgProtocolComplianceRoute
  '/_authenticated/ghg/recalculations': typeof AuthenticatedGhgRecalculationsRouteWithChildren
  '/_authenticated/ghg/report': typeof AuthenticatedGhgReportRoute
  '/_authenticated/ghg/scope1': typeof AuthenticatedGhgScope1Route
  '/_authenticated/ghg/scope2': typeof AuthenticatedGhgScope2Route
  '/_authenticated/ghg/scope3-screening': typeof AuthenticatedGhgScope3ScreeningRoute
  '/_authenticated/ghg/tasks': typeof AuthenticatedGhgTasksRoute
  '/_authenticated/ghg/travel-import': typeof AuthenticatedGhgTravelImportRoute
  '/_authenticated/ghg/waste': typeof AuthenticatedGhgWasteRoute
  '/_authenticated/ghg/yoy-comparison': typeof AuthenticatedGhgYoyComparisonRoute
  '/_authenticated/help-centre/platform-guides': typeof AuthenticatedHelpCentrePlatformGuidesRoute
  '/_authenticated/help-centre/regulations': typeof AuthenticatedHelpCentreRegulationsRoute
  '/_authenticated/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/_authenticated/incidents/dashboard': typeof AuthenticatedIncidentsDashboardRoute
  '/_authenticated/incidents/new': typeof AuthenticatedIncidentsNewRoute
  '/_authenticated/incidents/quick-report': typeof AuthenticatedIncidentsQuickReportRoute
  '/_authenticated/incidents/settings': typeof AuthenticatedIncidentsSettingsRouteWithChildren
  '/_authenticated/incidents/subsidiaries': typeof AuthenticatedIncidentsSubsidiariesRoute
  '/_authenticated/nis2/asset-register': typeof AuthenticatedNis2AssetRegisterRoute
  '/_authenticated/nis2/assets-and-measures': typeof AuthenticatedNis2AssetsAndMeasuresRoute
  '/_authenticated/nis2/assets-measures': typeof AuthenticatedNis2AssetsMeasuresRoute
  '/_authenticated/nis2/business-continuity': typeof AuthenticatedNis2BusinessContinuityRoute
  '/_authenticated/nis2/dashboard': typeof AuthenticatedNis2DashboardRoute
  '/_authenticated/nis2/entity-classification': typeof AuthenticatedNis2EntityClassificationRoute
  '/_authenticated/nis2/evidence': typeof AuthenticatedNis2EvidenceRoute
  '/_authenticated/nis2/gap-analysis': typeof AuthenticatedNis2GapAnalysisRoute
  '/_authenticated/nis2/gaps': typeof AuthenticatedNis2GapsRoute
  '/_authenticated/nis2/hr-training': typeof AuthenticatedNis2HrTrainingRoute
  '/_authenticated/nis2/human-resources-security': typeof AuthenticatedNis2HumanResourcesSecurityRoute
  '/_authenticated/nis2/incident-management': typeof AuthenticatedNis2IncidentManagementRoute
  '/_authenticated/nis2/isms': typeof AuthenticatedNis2IsmsRoute
  '/_authenticated/nis2/knowledge-base': typeof AuthenticatedNis2KnowledgeBaseRoute
  '/_authenticated/nis2/measure-a': typeof AuthenticatedNis2MeasureARoute
  '/_authenticated/nis2/measure-d': typeof AuthenticatedNis2MeasureDRoute
  '/_authenticated/nis2/onboarding': typeof AuthenticatedNis2OnboardingRoute
  '/_authenticated/nis2/overview': typeof AuthenticatedNis2OverviewRoute
  '/_authenticated/nis2/policies-governance': typeof AuthenticatedNis2PoliciesGovernanceRoute
  '/_authenticated/nis2/policy-governance': typeof AuthenticatedNis2PolicyGovernanceRoute
  '/_authenticated/nis2/risk-management': typeof AuthenticatedNis2RiskManagementRoute
  '/_authenticated/nis2/self-assessment': typeof AuthenticatedNis2SelfAssessmentRoute
  '/_authenticated/nis2/supply-chain-security': typeof AuthenticatedNis2SupplyChainSecurityRoute
  '/_authenticated/policies/$policyId': typeof AuthenticatedPoliciesPolicyIdRouteWithChildren
  '/_authenticated/policies/compliance-dashboard': typeof AuthenticatedPoliciesComplianceDashboardRoute
  '/_authenticated/policies/create': typeof AuthenticatedPoliciesCreateRoute
  '/_authenticated/policies/documents': typeof AuthenticatedPoliciesDocumentsRoute
  '/_authenticated/policies/wizard': typeof AuthenticatedPoliciesWizardRoute
  '/_authenticated/procedures/$procedureId': typeof AuthenticatedProceduresProcedureIdRoute
  '/_authenticated/risks/$riskId': typeof AuthenticatedRisksRiskIdRoute
  '/_authenticated/risks/ai-suggestions': typeof AuthenticatedRisksAiSuggestionsRoute
  '/_authenticated/risks/dashboard': typeof AuthenticatedRisksDashboardRoute
  '/_authenticated/risks/heatmap': typeof AuthenticatedRisksHeatmapRoute
  '/_authenticated/risks/new': typeof AuthenticatedRisksNewRoute
  '/_authenticated/settings/access-log': typeof AuthenticatedSettingsAccessLogRoute
  '/_authenticated/settings/ai-conversations': typeof AuthenticatedSettingsAiConversationsRouteWithChildren
  '/_authenticated/settings/ai-settings': typeof AuthenticatedSettingsAiSettingsRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/asset-categories': typeof AuthenticatedSettingsAssetCategoriesRoute
  '/_authenticated/settings/asset-connectors': typeof AuthenticatedSettingsAssetConnectorsRoute
  '/_authenticated/settings/asset-custom-fields': typeof AuthenticatedSettingsAssetCustomFieldsRoute
  '/_authenticated/settings/asset-tags': typeof AuthenticatedSettingsAssetTagsRoute
  '/_authenticated/settings/audit-alerts': typeof AuthenticatedSettingsAuditAlertsRoute
  '/_authenticated/settings/audit-log': typeof AuthenticatedSettingsAuditLogRoute
  '/_authenticated/settings/audit-settings': typeof AuthenticatedSettingsAuditSettingsRoute
  '/_authenticated/settings/audit-webhooks': typeof AuthenticatedSettingsAuditWebhooksRoute
  '/_authenticated/settings/auditors': typeof AuthenticatedSettingsAuditorsRoute
  '/_authenticated/settings/bcp-exercise-settings': typeof AuthenticatedSettingsBcpExerciseSettingsRoute
  '/_authenticated/settings/bcp-review-settings': typeof AuthenticatedSettingsBcpReviewSettingsRoute
  '/_authenticated/settings/compliance-frameworks': typeof AuthenticatedSettingsComplianceFrameworksRoute
  '/_authenticated/settings/configration': typeof AuthenticatedSettingsConfigrationRoute
  '/_authenticated/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/_authenticated/settings/evidence-collections': typeof AuthenticatedSettingsEvidenceCollectionsRoute
  '/_authenticated/settings/gap-detection-rules': typeof AuthenticatedSettingsGapDetectionRulesRoute
  '/_authenticated/settings/ghg-boundary': typeof AuthenticatedSettingsGhgBoundaryRoute
  '/_authenticated/settings/ghg-facilities': typeof AuthenticatedSettingsGhgFacilitiesRoute
  '/_authenticated/settings/ghg-permissions': typeof AuthenticatedSettingsGhgPermissionsRoute
  '/_authenticated/settings/ghg-sources': typeof AuthenticatedSettingsGhgSourcesRoute
  '/_authenticated/settings/incident-categories': typeof AuthenticatedSettingsIncidentCategoriesRoute
  '/_authenticated/settings/my-activity': typeof AuthenticatedSettingsMyActivityRoute
  '/_authenticated/settings/nis2-classification': typeof AuthenticatedSettingsNis2ClassificationRoute
  '/_authenticated/settings/nis2-gap-priority': typeof AuthenticatedSettingsNis2GapPriorityRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/organisation-structure': typeof AuthenticatedSettingsOrganisationStructureRoute
  '/_authenticated/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/_authenticated/settings/policy-categories': typeof AuthenticatedSettingsPolicyCategoriesRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/reporting-periods': typeof AuthenticatedSettingsReportingPeriodsRoute
  '/_authenticated/settings/risk': typeof AuthenticatedSettingsRiskRoute
  '/_authenticated/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/_authenticated/settings/scanner-integrations': typeof AuthenticatedSettingsScannerIntegrationsRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRouteWithChildren
  '/_authenticated/settings/subsidiaries': typeof AuthenticatedSettingsSubsidiariesRoute
  '/_authenticated/settings/supplier-categories': typeof AuthenticatedSettingsSupplierCategoriesRoute
  '/_authenticated/settings/task-schedules': typeof AuthenticatedSettingsTaskSchedulesRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRouteWithChildren
  '/_authenticated/settings/vulnerability-settings': typeof AuthenticatedSettingsVulnerabilitySettingsRoute
  '/_authenticated/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRouteWithChildren
  '/_authenticated/suppliers/compliance-matrix': typeof AuthenticatedSuppliersComplianceMatrixRoute
  '/_authenticated/suppliers/register': typeof AuthenticatedSuppliersRegisterRoute
  '/_authenticated/suppliers/risk': typeof AuthenticatedSuppliersRiskRoute
  '/_authenticated/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/_authenticated/tasks/approvals': typeof AuthenticatedTasksApprovalsRoute
  '/_authenticated/tasks/console': typeof AuthenticatedTasksConsoleRouteWithChildren
  '/_authenticated/tasks/my': typeof AuthenticatedTasksMyRoute
  '/_authenticated/vsme/$section': typeof AuthenticatedVsmeSectionRoute
  '/_authenticated/vulnerabilities/$vulnerabilityId': typeof AuthenticatedVulnerabilitiesVulnerabilityIdRoute
  '/_authenticated/vulnerabilities/audit-report': typeof AuthenticatedVulnerabilitiesAuditReportRoute
  '/_authenticated/vulnerabilities/consolidated-report': typeof AuthenticatedVulnerabilitiesConsolidatedReportRoute
  '/_authenticated/vulnerabilities/dashboard': typeof AuthenticatedVulnerabilitiesDashboardRoute
  '/_authenticated/vulnerabilities/new': typeof AuthenticatedVulnerabilitiesNewRoute
  '/_authenticated/vulnerabilities/nis2-report': typeof AuthenticatedVulnerabilitiesNis2ReportRoute
  '/_authenticated/vulnerabilities/settings': typeof AuthenticatedVulnerabilitiesSettingsRoute
  '/_authenticated/vulnerabilities/sla-report': typeof AuthenticatedVulnerabilitiesSlaReportRoute
  '/_authenticated/vulnerabilities/soc2-compliance': typeof AuthenticatedVulnerabilitiesSoc2ComplianceRoute
  '/_authenticated/vulnerabilities/subsidiaries': typeof AuthenticatedVulnerabilitiesSubsidiariesRoute
  '/_authenticated/vulnerabilities/workspace': typeof AuthenticatedVulnerabilitiesWorkspaceRoute
  '/_authenticated/workforce-readiness/awareness-campaigns': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren
  '/_authenticated/workforce-readiness/my-trainings': typeof AuthenticatedWorkforceReadinessMyTrainingsRoute
  '/_authenticated/workforce-readiness/training-register': typeof AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren
  '/portal/auth/login': typeof PortalAuthLoginRoute
  '/portal/history/$token': typeof PortalHistoryTokenRoute
  '/portal/home/$token': typeof PortalHomeTokenRoute
  '/portal/profile/$token': typeof PortalProfileTokenRoute
  '/portal/questionnaire/$token': typeof PortalQuestionnaireTokenRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/ai/': typeof AuthenticatedAiIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/controls/': typeof AuthenticatedControlsIndexRoute
  '/_authenticated/datahub/': typeof AuthenticatedDatahubIndexRoute
  '/_authenticated/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/_authenticated/evidence/': typeof AuthenticatedEvidenceIndexRoute
  '/_authenticated/external-reporting/': typeof AuthenticatedExternalReportingIndexRoute
  '/_authenticated/gaps/': typeof AuthenticatedGapsIndexRoute
  '/_authenticated/incidents/': typeof AuthenticatedIncidentsIndexRoute
  '/_authenticated/policies/': typeof AuthenticatedPoliciesIndexRoute
  '/_authenticated/procedures/': typeof AuthenticatedProceduresIndexRoute
  '/_authenticated/risks/': typeof AuthenticatedRisksIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/_authenticated/surveys/': typeof AuthenticatedSurveysIndexRoute
  '/_authenticated/threats/': typeof AuthenticatedThreatsIndexRoute
  '/_authenticated/vulnerabilities/': typeof AuthenticatedVulnerabilitiesIndexRoute
  '/_authenticated/admin/incidents/tags': typeof AuthenticatedAdminIncidentsTagsRoute
  '/_authenticated/admin/policies/access-controls': typeof AuthenticatedAdminPoliciesAccessControlsRoute
  '/_authenticated/admin/policies/approval-configs': typeof AuthenticatedAdminPoliciesApprovalConfigsRoute
  '/_authenticated/admin/policies/templates': typeof AuthenticatedAdminPoliciesTemplatesRoute
  '/_authenticated/ai/onboarding/$module': typeof AuthenticatedAiOnboardingModuleRoute
  '/_authenticated/ai/scans/$scanId': typeof AuthenticatedAiScansScanIdRoute
  '/_authenticated/analytics/dashboards/$dashboardId': typeof AuthenticatedAnalyticsDashboardsDashboardIdRoute
  '/_authenticated/analytics/report-studio/$reportId': typeof AuthenticatedAnalyticsReportStudioReportIdRoute
  '/_authenticated/analytics/report-studio/new': typeof AuthenticatedAnalyticsReportStudioNewRoute
  '/_authenticated/analytics/report-studio/templates': typeof AuthenticatedAnalyticsReportStudioTemplatesRoute
  '/_authenticated/audit/audits/new': typeof AuthenticatedAuditAuditsNewRoute
  '/_authenticated/audit/evidence/$evidenceId': typeof AuthenticatedAuditEvidenceEvidenceIdRoute
  '/_authenticated/bcp/bia/$biaId': typeof AuthenticatedBcpBiaBiaIdRoute
  '/_authenticated/bcp/exercises/$exerciseId': typeof AuthenticatedBcpExercisesExerciseIdRouteWithChildren
  '/_authenticated/bcp/exercises/new': typeof AuthenticatedBcpExercisesNewRoute
  '/_authenticated/bcp/exercises/schedule': typeof AuthenticatedBcpExercisesScheduleRoute
  '/_authenticated/bcp/plans/$planId': typeof AuthenticatedBcpPlansPlanIdRouteWithChildren
  '/_authenticated/bcp/plans/bcp': typeof AuthenticatedBcpPlansBcpRoute
  '/_authenticated/bcp/plans/crisis-comm': typeof AuthenticatedBcpPlansCrisisCommRoute
  '/_authenticated/bcp/plans/it-dr': typeof AuthenticatedBcpPlansItDrRoute
  '/_authenticated/bcp/plans/new': typeof AuthenticatedBcpPlansNewRoute
  '/_authenticated/bcp/plans/new-crisis-communication': typeof AuthenticatedBcpPlansNewCrisisCommunicationRoute
  '/_authenticated/bcp/plans/new-it-dr': typeof AuthenticatedBcpPlansNewItDrRoute
  '/_authenticated/bcp/plans/new-recovery-procedure': typeof AuthenticatedBcpPlansNewRecoveryProcedureRoute
  '/_authenticated/bcp/plans/recovery': typeof AuthenticatedBcpPlansRecoveryRoute
  '/_authenticated/bcp/reports/exercise-summary': typeof AuthenticatedBcpReportsExerciseSummaryRoute
  '/_authenticated/bcp/reports/gap-analysis': typeof AuthenticatedBcpReportsGapAnalysisRoute
  '/_authenticated/bcp/reports/iso-22301': typeof AuthenticatedBcpReportsIso22301Route
  '/_authenticated/bcp/reports/nis2-compliance': typeof AuthenticatedBcpReportsNis2ComplianceRoute
  '/_authenticated/bcp/reports/plan-status': typeof AuthenticatedBcpReportsPlanStatusRoute
  '/_authenticated/bcp/resources/sites': typeof AuthenticatedBcpResourcesSitesRouteWithChildren
  '/_authenticated/datahub/collections/$collectionId': typeof AuthenticatedDatahubCollectionsCollectionIdRouteWithChildren
  '/_authenticated/datahub/datapoints/$datapointId': typeof AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren
  '/_authenticated/datahub/entry/wizard': typeof AuthenticatedDatahubEntryWizardRoute
  '/_authenticated/datahub/governance/approval-config': typeof AuthenticatedDatahubGovernanceApprovalConfigRoute
  '/_authenticated/datahub/governance/approval-queue': typeof AuthenticatedDatahubGovernanceApprovalQueueRoute
  '/_authenticated/datahub/governance/scheduled-exports': typeof AuthenticatedDatahubGovernanceScheduledExportsRoute
  '/_authenticated/datahub/integrations/transformation-rules': typeof AuthenticatedDatahubIntegrationsTransformationRulesRoute
  '/_authenticated/employees/$employeeId/edit': typeof AuthenticatedEmployeesEmployeeIdEditRoute
  '/_authenticated/esg/double-materiality/$assessmentId': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRouteWithChildren
  '/_authenticated/esg/double-materiality/datapoints-policies': typeof AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute
  '/_authenticated/esg/onboarding/$onboardingId': typeof AuthenticatedEsgOnboardingOnboardingIdRoute
  '/_authenticated/evidence/attestations/new': typeof AuthenticatedEvidenceAttestationsNewRoute
  '/_authenticated/ghg/activity-data/$entryId': typeof AuthenticatedGhgActivityDataEntryIdRoute
  '/_authenticated/ghg/activity-data/assignment-queue': typeof AuthenticatedGhgActivityDataAssignmentQueueRoute
  '/_authenticated/ghg/activity-data/document-ocr': typeof AuthenticatedGhgActivityDataDocumentOcrRoute
  '/_authenticated/ghg/activity-data/import': typeof AuthenticatedGhgActivityDataImportRoute
  '/_authenticated/ghg/calculations/scope1': typeof AuthenticatedGhgCalculationsScope1Route
  '/_authenticated/ghg/calculations/scope2': typeof AuthenticatedGhgCalculationsScope2Route
  '/_authenticated/ghg/calculations/scope3': typeof AuthenticatedGhgCalculationsScope3Route
  '/_authenticated/ghg/commuting-surveys/$surveyId': typeof AuthenticatedGhgCommutingSurveysSurveyIdRoute
  '/_authenticated/ghg/commuting-surveys/new': typeof AuthenticatedGhgCommutingSurveysNewRoute
  '/_authenticated/ghg/facilities/dashboard': typeof AuthenticatedGhgFacilitiesDashboardRoute
  '/_authenticated/ghg/integrations/$connectorId': typeof AuthenticatedGhgIntegrationsConnectorIdRoute
  '/_authenticated/ghg/recalculations/$recalculationId': typeof AuthenticatedGhgRecalculationsRecalculationIdRoute
  '/_authenticated/ghg/reduction-initiatives/$initiativeId': typeof AuthenticatedGhgReductionInitiativesInitiativeIdRoute
  '/_authenticated/ghg/reduction-initiatives/new': typeof AuthenticatedGhgReductionInitiativesNewRoute
  '/_authenticated/ghg/scenarios/$scenarioId': typeof AuthenticatedGhgScenariosScenarioIdRoute
  '/_authenticated/ghg/scenarios/compare': typeof AuthenticatedGhgScenariosCompareRoute
  '/_authenticated/ghg/scenarios/new': typeof AuthenticatedGhgScenariosNewRoute
  '/_authenticated/ghg/scope3/$category': typeof AuthenticatedGhgScope3CategoryRouteWithChildren
  '/_authenticated/ghg/scope3/add': typeof AuthenticatedGhgScope3AddRoute
  '/_authenticated/ghg/scope3/sold-products': typeof AuthenticatedGhgScope3SoldProductsRoute
  '/_authenticated/ghg/settings/scope1': typeof AuthenticatedGhgSettingsScope1Route
  '/_authenticated/ghg/settings/scope2': typeof AuthenticatedGhgSettingsScope2Route
  '/_authenticated/ghg/targets/$targetId': typeof AuthenticatedGhgTargetsTargetIdRoute
  '/_authenticated/ghg/targets/new': typeof AuthenticatedGhgTargetsNewRoute
  '/_authenticated/ghg/third-party-verification/$engagementId': typeof AuthenticatedGhgThirdPartyVerificationEngagementIdRoute
  '/_authenticated/ghg/verification-statements/$statementId': typeof AuthenticatedGhgVerificationStatementsStatementIdRoute
  '/_authenticated/ghg/verification/$checklistId': typeof AuthenticatedGhgVerificationChecklistIdRoute
  '/_authenticated/incidents/settings/sla': typeof AuthenticatedIncidentsSettingsSlaRoute
  '/_authenticated/nis2/inspection-preparation/$preparationId': typeof AuthenticatedNis2InspectionPreparationPreparationIdRoute
  '/_authenticated/nis2/measures/$measureCode': typeof AuthenticatedNis2MeasuresMeasureCodeRoute
  '/_authenticated/nis2/reports/activity': typeof AuthenticatedNis2ReportsActivityRoute
  '/_authenticated/nis2/reports/audit-preparation': typeof AuthenticatedNis2ReportsAuditPreparationRoute
  '/_authenticated/nis2/reports/board': typeof AuthenticatedNis2ReportsBoardRoute
  '/_authenticated/nis2/reports/compliance': typeof AuthenticatedNis2ReportsComplianceRoute
  '/_authenticated/nis2/reports/consolidated': typeof AuthenticatedNis2ReportsConsolidatedRoute
  '/_authenticated/nis2/reports/cross-border': typeof AuthenticatedNis2ReportsCrossBorderRoute
  '/_authenticated/nis2/reports/executive': typeof AuthenticatedNis2ReportsExecutiveRoute
  '/_authenticated/nis2/reports/scheduled': typeof AuthenticatedNis2ReportsScheduledRoute
  '/_authenticated/policies/$policyId/edit': typeof AuthenticatedPoliciesPolicyIdEditRoute
  '/_authenticated/policies/$policyId/review': typeof AuthenticatedPoliciesPolicyIdReviewRoute
  '/_authenticated/settings/ai-conversations/$conversationId': typeof AuthenticatedSettingsAiConversationsConversationIdRoute
  '/_authenticated/settings/nis2/reminders': typeof AuthenticatedSettingsNis2RemindersRoute
  '/_authenticated/settings/security/sessions': typeof AuthenticatedSettingsSecuritySessionsRoute
  '/_authenticated/suppliers/admin/risk-config': typeof AuthenticatedSuppliersAdminRiskConfigRoute
  '/_authenticated/surveys/campaigns/$campaignId': typeof AuthenticatedSurveysCampaignsCampaignIdRoute
  '/_authenticated/surveys/campaigns/new': typeof AuthenticatedSurveysCampaignsNewRoute
  '/_authenticated/surveys/templates/$templateId': typeof AuthenticatedSurveysTemplatesTemplateIdRoute
  '/_authenticated/surveys/templates/new': typeof AuthenticatedSurveysTemplatesNewRoute
  '/_authenticated/tasks/console/approvals': typeof AuthenticatedTasksConsoleApprovalsRoute
  '/_authenticated/tasks/playbooks/activate': typeof AuthenticatedTasksPlaybooksActivateRoute
  '/_authenticated/workforce-readiness/awareness-campaigns/$campaignId': typeof AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute
  '/_authenticated/workforce-readiness/training-register/$trainingId': typeof AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute
  '/auditor/access/$accessId/assets': typeof AuditorAccessAccessIdAssetsRoute
  '/auditor/access/$accessId/audit': typeof AuditorAccessAccessIdAuditRoute
  '/auditor/access/$accessId/bcp': typeof AuditorAccessAccessIdBcpRouteWithChildren
  '/auditor/access/$accessId/controls': typeof AuditorAccessAccessIdControlsRoute
  '/auditor/access/$accessId/nis2': typeof AuditorAccessAccessIdNis2RouteWithChildren
  '/auditor/access/$accessId/tasks': typeof AuditorAccessAccessIdTasksRoute
  '/portal/auth/create-account/$token': typeof PortalAuthCreateAccountTokenRoute
  '/portal/auth/reset-password/$token': typeof PortalAuthResetPasswordTokenRoute
  '/_authenticated/ai/documents/': typeof AuthenticatedAiDocumentsIndexRoute
  '/_authenticated/ai/scans/': typeof AuthenticatedAiScansIndexRoute
  '/_authenticated/analytics/dashboards/': typeof AuthenticatedAnalyticsDashboardsIndexRoute
  '/_authenticated/analytics/report-studio/': typeof AuthenticatedAnalyticsReportStudioIndexRoute
  '/_authenticated/audit/audits/': typeof AuthenticatedAuditAuditsIndexRoute
  '/_authenticated/audit/evidence/': typeof AuthenticatedAuditEvidenceIndexRoute
  '/_authenticated/bcp/exercises/': typeof AuthenticatedBcpExercisesIndexRoute
  '/_authenticated/bcp/plans/': typeof AuthenticatedBcpPlansIndexRoute
  '/_authenticated/bcp/resources/': typeof AuthenticatedBcpResourcesIndexRoute
  '/_authenticated/datahub/collections/': typeof AuthenticatedDatahubCollectionsIndexRoute
  '/_authenticated/datahub/datapoints/': typeof AuthenticatedDatahubDatapointsIndexRoute
  '/_authenticated/datahub/integrations/': typeof AuthenticatedDatahubIntegrationsIndexRoute
  '/_authenticated/employees/$employeeId/': typeof AuthenticatedEmployeesEmployeeIdIndexRoute
  '/_authenticated/esg/double-materiality/': typeof AuthenticatedEsgDoubleMaterialityIndexRoute
  '/_authenticated/esg/onboarding/': typeof AuthenticatedEsgOnboardingIndexRoute
  '/_authenticated/ghg/activity-data/': typeof AuthenticatedGhgActivityDataIndexRoute
  '/_authenticated/ghg/approvals/': typeof AuthenticatedGhgApprovalsIndexRoute
  '/_authenticated/ghg/commuting-surveys/': typeof AuthenticatedGhgCommutingSurveysIndexRoute
  '/_authenticated/ghg/exports/': typeof AuthenticatedGhgExportsIndexRoute
  '/_authenticated/ghg/integrations/': typeof AuthenticatedGhgIntegrationsIndexRoute
  '/_authenticated/ghg/recalculations/': typeof AuthenticatedGhgRecalculationsIndexRoute
  '/_authenticated/ghg/reduction-initiatives/': typeof AuthenticatedGhgReductionInitiativesIndexRoute
  '/_authenticated/ghg/reports/': typeof AuthenticatedGhgReportsIndexRoute
  '/_authenticated/ghg/scenarios/': typeof AuthenticatedGhgScenariosIndexRoute
  '/_authenticated/ghg/settings/': typeof AuthenticatedGhgSettingsIndexRoute
  '/_authenticated/ghg/setup/': typeof AuthenticatedGhgSetupIndexRoute
  '/_authenticated/ghg/targets/': typeof AuthenticatedGhgTargetsIndexRoute
  '/_authenticated/ghg/third-party-verification/': typeof AuthenticatedGhgThirdPartyVerificationIndexRoute
  '/_authenticated/ghg/verification-statements/': typeof AuthenticatedGhgVerificationStatementsIndexRoute
  '/_authenticated/ghg/verification/': typeof AuthenticatedGhgVerificationIndexRoute
  '/_authenticated/nis2/inspection-preparation/': typeof AuthenticatedNis2InspectionPreparationIndexRoute
  '/_authenticated/nis2/measures/': typeof AuthenticatedNis2MeasuresIndexRoute
  '/_authenticated/nis2/reports/': typeof AuthenticatedNis2ReportsIndexRoute
  '/_authenticated/risks/approvals/': typeof AuthenticatedRisksApprovalsIndexRoute
  '/_authenticated/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute
  '/_authenticated/surveys/campaigns/': typeof AuthenticatedSurveysCampaignsIndexRoute
  '/_authenticated/surveys/schedules/': typeof AuthenticatedSurveysSchedulesIndexRoute
  '/_authenticated/tasks/playbooks/': typeof AuthenticatedTasksPlaybooksIndexRoute
  '/_authenticated/vulnerabilities/approvals/': typeof AuthenticatedVulnerabilitiesApprovalsIndexRoute
  '/portal/auth/forgot-password/': typeof PortalAuthForgotPasswordIndexRoute
  '/_authenticated/ai/documents/$documentId/extract': typeof AuthenticatedAiDocumentsDocumentIdExtractRoute
  '/_authenticated/audit/audits/$auditId/settings': typeof AuthenticatedAuditAuditsAuditIdSettingsRoute
  '/_authenticated/bcp/exercises/$exerciseId/conduct': typeof AuthenticatedBcpExercisesExerciseIdConductRoute
  '/_authenticated/bcp/plans/$planId/edit': typeof AuthenticatedBcpPlansPlanIdEditRoute
  '/_authenticated/bcp/plans/$planId/review': typeof AuthenticatedBcpPlansPlanIdReviewRoute
  '/_authenticated/bcp/resources/sites/$siteId': typeof AuthenticatedBcpResourcesSitesSiteIdRoute
  '/_authenticated/datahub/collections/$collectionId/entry': typeof AuthenticatedDatahubCollectionsCollectionIdEntryRoute
  '/_authenticated/datahub/collections/$collectionId/import': typeof AuthenticatedDatahubCollectionsCollectionIdImportRoute
  '/_authenticated/datahub/datapoints/$datapointId/entry': typeof AuthenticatedDatahubDatapointsDatapointIdEntryRoute
  '/_authenticated/datahub/integrations/$integrationId/mappings': typeof AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute
  '/_authenticated/datahub/uploads/$uploadId/map': typeof AuthenticatedDatahubUploadsUploadIdMapRoute
  '/_authenticated/datahub/uploads/$uploadId/review': typeof AuthenticatedDatahubUploadsUploadIdReviewRoute
  '/_authenticated/esg/double-materiality/$assessmentId/assessment': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute
  '/_authenticated/esg/double-materiality/$assessmentId/impacts': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute
  '/_authenticated/esg/double-materiality/$assessmentId/matrix': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute
  '/_authenticated/esg/double-materiality/$assessmentId/overview': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute
  '/_authenticated/esg/double-materiality/$assessmentId/quality': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute
  '/_authenticated/esg/double-materiality/$assessmentId/risks': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute
  '/_authenticated/esg/double-materiality/$assessmentId/stakeholders': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute
  '/_authenticated/esg/double-materiality/$assessmentId/value-chain': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute
  '/_authenticated/ghg/reports/custom/$reportId': typeof AuthenticatedGhgReportsCustomReportIdRoute
  '/_authenticated/ghg/reports/custom/new': typeof AuthenticatedGhgReportsCustomNewRoute
  '/_authenticated/ghg/scope3/$category/derive': typeof AuthenticatedGhgScope3CategoryDeriveRoute
  '/_authenticated/ghg/verification/internal/$verificationId': typeof AuthenticatedGhgVerificationInternalVerificationIdRoute
  '/_authenticated/nis2/incidents/$incidentId/early-warning': typeof AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute
  '/_authenticated/nis2/incidents/$incidentId/final-report': typeof AuthenticatedNis2IncidentsIncidentIdFinalReportRoute
  '/_authenticated/nis2/incidents/$incidentId/notification': typeof AuthenticatedNis2IncidentsIncidentIdNotificationRoute
  '/_authenticated/nis2/incidents/$incidentId/progress-updates': typeof AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute
  '/_authenticated/policies/$policyId/scans/$scanId': typeof AuthenticatedPoliciesPolicyIdScansScanIdRoute
  '/_authenticated/policies/procedures/$instanceId/execute': typeof AuthenticatedPoliciesProceduresInstanceIdExecuteRoute
  '/_authenticated/settings/team/members/$userId': typeof AuthenticatedSettingsTeamMembersUserIdRouteWithChildren
  '/_authenticated/suppliers/$supplierId/reviews/$reviewId': typeof AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute
  '/_authenticated/suppliers/admin/questionnaire-templates/$templateId': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute
  '/_authenticated/suppliers/admin/questionnaire-templates/new': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute
  '/_authenticated/suppliers/questionnaires/$sentId/review': typeof AuthenticatedSuppliersQuestionnairesSentIdReviewRoute
  '/_authenticated/tasks/playbooks/$activationId/setup': typeof AuthenticatedTasksPlaybooksActivationIdSetupRoute
  '/_authenticated/tasks/playbooks/templates/$templateId': typeof AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute
  '/_authenticated/tasks/playbooks/templates/new': typeof AuthenticatedTasksPlaybooksTemplatesNewRoute
  '/_authenticated/tasks/playbooks/templates/task-templates': typeof AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute
  '/auditor/access/$accessId/bcp/exercises': typeof AuditorAccessAccessIdBcpExercisesRoute
  '/auditor/access/$accessId/bcp/findings': typeof AuditorAccessAccessIdBcpFindingsRoute
  '/auditor/access/$accessId/bcp/plans': typeof AuditorAccessAccessIdBcpPlansRouteWithChildren
  '/auditor/access/$accessId/nis2/assessments': typeof AuditorAccessAccessIdNis2AssessmentsRoute
  '/auditor/access/$accessId/nis2/evidence': typeof AuditorAccessAccessIdNis2EvidenceRoute
  '/auditor/access/$accessId/nis2/gaps': typeof AuditorAccessAccessIdNis2GapsRoute
  '/auditor/access/$accessId/nis2/incidents': typeof AuditorAccessAccessIdNis2IncidentsRoute
  '/auditor/access/$accessId/nis2/measures': typeof AuditorAccessAccessIdNis2MeasuresRoute
  '/_authenticated/audit/audits/$auditId/': typeof AuthenticatedAuditAuditsAuditIdIndexRoute
  '/_authenticated/bcp/exercises/$exerciseId/': typeof AuthenticatedBcpExercisesExerciseIdIndexRoute
  '/_authenticated/bcp/plans/$planId/': typeof AuthenticatedBcpPlansPlanIdIndexRoute
  '/_authenticated/datahub/collections/$collectionId/': typeof AuthenticatedDatahubCollectionsCollectionIdIndexRoute
  '/_authenticated/esg/double-materiality/$assessmentId/': typeof AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute
  '/_authenticated/ghg/reports/custom/': typeof AuthenticatedGhgReportsCustomIndexRoute
  '/_authenticated/ghg/scope3/$category/': typeof AuthenticatedGhgScope3CategoryIndexRoute
  '/_authenticated/ghg/verification/internal/': typeof AuthenticatedGhgVerificationInternalIndexRoute
  '/_authenticated/suppliers/admin/questionnaire-templates/': typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute
  '/_authenticated/tasks/playbooks/$activationId/': typeof AuthenticatedTasksPlaybooksActivationIdIndexRoute
  '/_authenticated/tasks/playbooks/templates/': typeof AuthenticatedTasksPlaybooksTemplatesIndexRoute
  '/_authenticated/settings/team/members/$userId/history-connections': typeof AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute
  '/auditor/access/$accessId/bcp/plans/$planId': typeof AuditorAccessAccessIdBcpPlansPlanIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/bcp'
    | '/controls'
    | '/dashboard'
    | '/esg'
    | '/eu-taxonomy'
    | '/ghg'
    | '/help-centre'
    | '/nis2'
    | '/settings'
    | '/vsme'
    | '/workforce-readiness'
    | '/auditor/$token'
    | '/ghg-survey/$token'
    | '/invite/$token'
    | '/quick-report/$shareToken'
    | '/session-tasks/setup-mfa'
    | '/sign-in/$'
    | '/sign-up/$orgId'
    | '/survey-respond/$token'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/ai-costs'
    | '/admin/knowledge-bases'
    | '/admin/llm-settings'
    | '/admin/organizations'
    | '/admin/settings'
    | '/admin/system-prompts'
    | '/ai/documents'
    | '/ai/insights'
    | '/ai/quality'
    | '/ai/usage'
    | '/analytics/ghg-overview'
    | '/assets/$assetId'
    | '/assets/import'
    | '/audit/calendar'
    | '/audit/evidence-library'
    | '/audit/evidence-upload'
    | '/audit/findings'
    | '/audit/reports'
    | '/bcp/bcp'
    | '/bcp/bia'
    | '/bcp/continuity'
    | '/bcp/dashboard'
    | '/bcp/findings'
    | '/bcp/plans'
    | '/compliance/alerts'
    | '/controls/$controlId'
    | '/datahub/audit'
    | '/datahub/comparison'
    | '/datahub/consolidated'
    | '/datahub/documents'
    | '/datahub/entry'
    | '/datahub/my-entries'
    | '/datahub/periods'
    | '/datahub/quality-dashboard'
    | '/datahub/quality-issues'
    | '/datahub/templates'
    | '/datahub/upload'
    | '/datahub/validation-errors'
    | '/employees/$employeeId'
    | '/employees/import'
    | '/employees/new'
    | '/esg/$section'
    | '/eu-taxonomy/$section'
    | '/evidence/$evidenceId'
    | '/evidence/logs'
    | '/evidence/repository'
    | '/external-reporting/$reportId'
    | '/ghg/activity-groups'
    | '/ghg/audit'
    | '/ghg/best-practices'
    | '/ghg/business-travel'
    | '/ghg/cdp-questionnaire'
    | '/ghg/collect'
    | '/ghg/commuting'
    | '/ghg/dashboard'
    | '/ghg/data-quality'
    | '/ghg/emission-factors'
    | '/ghg/emission-insights'
    | '/ghg/emissions'
    | '/ghg/gap-analysis'
    | '/ghg/industry-comparison'
    | '/ghg/iso14064-compliance'
    | '/ghg/market-instruments'
    | '/ghg/net-zero'
    | '/ghg/overview'
    | '/ghg/policies'
    | '/ghg/protocol-compliance'
    | '/ghg/recalculations'
    | '/ghg/report'
    | '/ghg/scope1'
    | '/ghg/scope2'
    | '/ghg/scope3-screening'
    | '/ghg/tasks'
    | '/ghg/travel-import'
    | '/ghg/waste'
    | '/ghg/yoy-comparison'
    | '/help-centre/platform-guides'
    | '/help-centre/regulations'
    | '/incidents/$incidentId'
    | '/incidents/dashboard'
    | '/incidents/new'
    | '/incidents/quick-report'
    | '/incidents/settings'
    | '/incidents/subsidiaries'
    | '/nis2/asset-register'
    | '/nis2/assets-and-measures'
    | '/nis2/assets-measures'
    | '/nis2/business-continuity'
    | '/nis2/dashboard'
    | '/nis2/entity-classification'
    | '/nis2/evidence'
    | '/nis2/gap-analysis'
    | '/nis2/gaps'
    | '/nis2/hr-training'
    | '/nis2/human-resources-security'
    | '/nis2/incident-management'
    | '/nis2/isms'
    | '/nis2/knowledge-base'
    | '/nis2/measure-a'
    | '/nis2/measure-d'
    | '/nis2/onboarding'
    | '/nis2/overview'
    | '/nis2/policies-governance'
    | '/nis2/policy-governance'
    | '/nis2/risk-management'
    | '/nis2/self-assessment'
    | '/nis2/supply-chain-security'
    | '/policies/$policyId'
    | '/policies/compliance-dashboard'
    | '/policies/create'
    | '/policies/documents'
    | '/policies/wizard'
    | '/procedures/$procedureId'
    | '/risks/$riskId'
    | '/risks/ai-suggestions'
    | '/risks/dashboard'
    | '/risks/heatmap'
    | '/risks/new'
    | '/settings/access-log'
    | '/settings/ai-conversations'
    | '/settings/ai-settings'
    | '/settings/appearance'
    | '/settings/asset-categories'
    | '/settings/asset-connectors'
    | '/settings/asset-custom-fields'
    | '/settings/asset-tags'
    | '/settings/audit-alerts'
    | '/settings/audit-log'
    | '/settings/audit-settings'
    | '/settings/audit-webhooks'
    | '/settings/auditors'
    | '/settings/bcp-exercise-settings'
    | '/settings/bcp-review-settings'
    | '/settings/compliance-frameworks'
    | '/settings/configration'
    | '/settings/credentials'
    | '/settings/evidence-collections'
    | '/settings/gap-detection-rules'
    | '/settings/ghg-boundary'
    | '/settings/ghg-facilities'
    | '/settings/ghg-permissions'
    | '/settings/ghg-sources'
    | '/settings/incident-categories'
    | '/settings/my-activity'
    | '/settings/nis2-classification'
    | '/settings/nis2-gap-priority'
    | '/settings/notifications'
    | '/settings/organisation-structure'
    | '/settings/organizations'
    | '/settings/policy-categories'
    | '/settings/profile'
    | '/settings/reporting-periods'
    | '/settings/risk'
    | '/settings/roles'
    | '/settings/scanner-integrations'
    | '/settings/security'
    | '/settings/subsidiaries'
    | '/settings/supplier-categories'
    | '/settings/task-schedules'
    | '/settings/team'
    | '/settings/vulnerability-settings'
    | '/suppliers/$supplierId'
    | '/suppliers/compliance-matrix'
    | '/suppliers/register'
    | '/suppliers/risk'
    | '/tasks/$taskId'
    | '/tasks/approvals'
    | '/tasks/console'
    | '/tasks/my'
    | '/vsme/$section'
    | '/vulnerabilities/$vulnerabilityId'
    | '/vulnerabilities/audit-report'
    | '/vulnerabilities/consolidated-report'
    | '/vulnerabilities/dashboard'
    | '/vulnerabilities/new'
    | '/vulnerabilities/nis2-report'
    | '/vulnerabilities/settings'
    | '/vulnerabilities/sla-report'
    | '/vulnerabilities/soc2-compliance'
    | '/vulnerabilities/subsidiaries'
    | '/vulnerabilities/workspace'
    | '/workforce-readiness/awareness-campaigns'
    | '/workforce-readiness/my-trainings'
    | '/workforce-readiness/training-register'
    | '/portal/auth/login'
    | '/portal/history/$token'
    | '/portal/home/$token'
    | '/portal/profile/$token'
    | '/portal/questionnaire/$token'
    | '/admin'
    | '/ai'
    | '/analytics/'
    | '/assets'
    | '/audit'
    | '/controls/'
    | '/datahub'
    | '/employees'
    | '/evidence'
    | '/external-reporting'
    | '/gaps'
    | '/incidents'
    | '/policies'
    | '/procedures'
    | '/risks'
    | '/settings/'
    | '/suppliers'
    | '/surveys'
    | '/threats'
    | '/vulnerabilities'
    | '/admin/incidents/tags'
    | '/admin/policies/access-controls'
    | '/admin/policies/approval-configs'
    | '/admin/policies/templates'
    | '/ai/onboarding/$module'
    | '/ai/scans/$scanId'
    | '/analytics/dashboards/$dashboardId'
    | '/analytics/report-studio/$reportId'
    | '/analytics/report-studio/new'
    | '/analytics/report-studio/templates'
    | '/audit/audits/new'
    | '/audit/evidence/$evidenceId'
    | '/bcp/bia/$biaId'
    | '/bcp/exercises/$exerciseId'
    | '/bcp/exercises/new'
    | '/bcp/exercises/schedule'
    | '/bcp/plans/$planId'
    | '/bcp/plans/bcp'
    | '/bcp/plans/crisis-comm'
    | '/bcp/plans/it-dr'
    | '/bcp/plans/new'
    | '/bcp/plans/new-crisis-communication'
    | '/bcp/plans/new-it-dr'
    | '/bcp/plans/new-recovery-procedure'
    | '/bcp/plans/recovery'
    | '/bcp/reports/exercise-summary'
    | '/bcp/reports/gap-analysis'
    | '/bcp/reports/iso-22301'
    | '/bcp/reports/nis2-compliance'
    | '/bcp/reports/plan-status'
    | '/bcp/resources/sites'
    | '/datahub/collections/$collectionId'
    | '/datahub/datapoints/$datapointId'
    | '/datahub/entry/wizard'
    | '/datahub/governance/approval-config'
    | '/datahub/governance/approval-queue'
    | '/datahub/governance/scheduled-exports'
    | '/datahub/integrations/transformation-rules'
    | '/employees/$employeeId/edit'
    | '/esg/double-materiality/$assessmentId'
    | '/esg/double-materiality/datapoints-policies'
    | '/esg/onboarding/$onboardingId'
    | '/evidence/attestations/new'
    | '/ghg/activity-data/$entryId'
    | '/ghg/activity-data/assignment-queue'
    | '/ghg/activity-data/document-ocr'
    | '/ghg/activity-data/import'
    | '/ghg/calculations/scope1'
    | '/ghg/calculations/scope2'
    | '/ghg/calculations/scope3'
    | '/ghg/commuting-surveys/$surveyId'
    | '/ghg/commuting-surveys/new'
    | '/ghg/facilities/dashboard'
    | '/ghg/integrations/$connectorId'
    | '/ghg/recalculations/$recalculationId'
    | '/ghg/reduction-initiatives/$initiativeId'
    | '/ghg/reduction-initiatives/new'
    | '/ghg/scenarios/$scenarioId'
    | '/ghg/scenarios/compare'
    | '/ghg/scenarios/new'
    | '/ghg/scope3/$category'
    | '/ghg/scope3/add'
    | '/ghg/scope3/sold-products'
    | '/ghg/settings/scope1'
    | '/ghg/settings/scope2'
    | '/ghg/targets/$targetId'
    | '/ghg/targets/new'
    | '/ghg/third-party-verification/$engagementId'
    | '/ghg/verification-statements/$statementId'
    | '/ghg/verification/$checklistId'
    | '/incidents/settings/sla'
    | '/nis2/inspection-preparation/$preparationId'
    | '/nis2/measures/$measureCode'
    | '/nis2/reports/activity'
    | '/nis2/reports/audit-preparation'
    | '/nis2/reports/board'
    | '/nis2/reports/compliance'
    | '/nis2/reports/consolidated'
    | '/nis2/reports/cross-border'
    | '/nis2/reports/executive'
    | '/nis2/reports/scheduled'
    | '/policies/$policyId/edit'
    | '/policies/$policyId/review'
    | '/settings/ai-conversations/$conversationId'
    | '/settings/nis2/reminders'
    | '/settings/security/sessions'
    | '/suppliers/admin/risk-config'
    | '/surveys/campaigns/$campaignId'
    | '/surveys/campaigns/new'
    | '/surveys/templates/$templateId'
    | '/surveys/templates/new'
    | '/tasks/console/approvals'
    | '/tasks/playbooks/activate'
    | '/workforce-readiness/awareness-campaigns/$campaignId'
    | '/workforce-readiness/training-register/$trainingId'
    | '/auditor/access/$accessId/assets'
    | '/auditor/access/$accessId/audit'
    | '/auditor/access/$accessId/bcp'
    | '/auditor/access/$accessId/controls'
    | '/auditor/access/$accessId/nis2'
    | '/auditor/access/$accessId/tasks'
    | '/portal/auth/create-account/$token'
    | '/portal/auth/reset-password/$token'
    | '/ai/documents/'
    | '/ai/scans'
    | '/analytics/dashboards'
    | '/analytics/report-studio'
    | '/audit/audits'
    | '/audit/evidence'
    | '/bcp/exercises'
    | '/bcp/plans/'
    | '/bcp/resources'
    | '/datahub/collections'
    | '/datahub/datapoints'
    | '/datahub/integrations'
    | '/employees/$employeeId/'
    | '/esg/double-materiality'
    | '/esg/onboarding'
    | '/ghg/activity-data'
    | '/ghg/approvals'
    | '/ghg/commuting-surveys'
    | '/ghg/exports'
    | '/ghg/integrations'
    | '/ghg/recalculations/'
    | '/ghg/reduction-initiatives'
    | '/ghg/reports'
    | '/ghg/scenarios'
    | '/ghg/settings'
    | '/ghg/setup'
    | '/ghg/targets'
    | '/ghg/third-party-verification'
    | '/ghg/verification-statements'
    | '/ghg/verification'
    | '/nis2/inspection-preparation'
    | '/nis2/measures'
    | '/nis2/reports'
    | '/risks/approvals'
    | '/settings/security/'
    | '/surveys/campaigns'
    | '/surveys/schedules'
    | '/tasks/playbooks'
    | '/vulnerabilities/approvals'
    | '/portal/auth/forgot-password'
    | '/ai/documents/$documentId/extract'
    | '/audit/audits/$auditId/settings'
    | '/bcp/exercises/$exerciseId/conduct'
    | '/bcp/plans/$planId/edit'
    | '/bcp/plans/$planId/review'
    | '/bcp/resources/sites/$siteId'
    | '/datahub/collections/$collectionId/entry'
    | '/datahub/collections/$collectionId/import'
    | '/datahub/datapoints/$datapointId/entry'
    | '/datahub/integrations/$integrationId/mappings'
    | '/datahub/uploads/$uploadId/map'
    | '/datahub/uploads/$uploadId/review'
    | '/esg/double-materiality/$assessmentId/assessment'
    | '/esg/double-materiality/$assessmentId/impacts'
    | '/esg/double-materiality/$assessmentId/matrix'
    | '/esg/double-materiality/$assessmentId/overview'
    | '/esg/double-materiality/$assessmentId/quality'
    | '/esg/double-materiality/$assessmentId/risks'
    | '/esg/double-materiality/$assessmentId/stakeholders'
    | '/esg/double-materiality/$assessmentId/value-chain'
    | '/ghg/reports/custom/$reportId'
    | '/ghg/reports/custom/new'
    | '/ghg/scope3/$category/derive'
    | '/ghg/verification/internal/$verificationId'
    | '/nis2/incidents/$incidentId/early-warning'
    | '/nis2/incidents/$incidentId/final-report'
    | '/nis2/incidents/$incidentId/notification'
    | '/nis2/incidents/$incidentId/progress-updates'
    | '/policies/$policyId/scans/$scanId'
    | '/policies/procedures/$instanceId/execute'
    | '/settings/team/members/$userId'
    | '/suppliers/$supplierId/reviews/$reviewId'
    | '/suppliers/admin/questionnaire-templates/$templateId'
    | '/suppliers/admin/questionnaire-templates/new'
    | '/suppliers/questionnaires/$sentId/review'
    | '/tasks/playbooks/$activationId/setup'
    | '/tasks/playbooks/templates/$templateId'
    | '/tasks/playbooks/templates/new'
    | '/tasks/playbooks/templates/task-templates'
    | '/auditor/access/$accessId/bcp/exercises'
    | '/auditor/access/$accessId/bcp/findings'
    | '/auditor/access/$accessId/bcp/plans'
    | '/auditor/access/$accessId/nis2/assessments'
    | '/auditor/access/$accessId/nis2/evidence'
    | '/auditor/access/$accessId/nis2/gaps'
    | '/auditor/access/$accessId/nis2/incidents'
    | '/auditor/access/$accessId/nis2/measures'
    | '/audit/audits/$auditId'
    | '/bcp/exercises/$exerciseId/'
    | '/bcp/plans/$planId/'
    | '/datahub/collections/$collectionId/'
    | '/esg/double-materiality/$assessmentId/'
    | '/ghg/reports/custom'
    | '/ghg/scope3/$category/'
    | '/ghg/verification/internal'
    | '/suppliers/admin/questionnaire-templates'
    | '/tasks/playbooks/$activationId'
    | '/tasks/playbooks/templates'
    | '/settings/team/members/$userId/history-connections'
    | '/auditor/access/$accessId/bcp/plans/$planId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bcp'
    | '/dashboard'
    | '/esg'
    | '/eu-taxonomy'
    | '/ghg'
    | '/help-centre'
    | '/nis2'
    | '/vsme'
    | '/workforce-readiness'
    | '/auditor/$token'
    | '/ghg-survey/$token'
    | '/invite/$token'
    | '/quick-report/$shareToken'
    | '/session-tasks/setup-mfa'
    | '/sign-in/$'
    | '/sign-up/$orgId'
    | '/survey-respond/$token'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/ai-costs'
    | '/admin/knowledge-bases'
    | '/admin/llm-settings'
    | '/admin/organizations'
    | '/admin/settings'
    | '/admin/system-prompts'
    | '/ai/insights'
    | '/ai/quality'
    | '/ai/usage'
    | '/analytics/ghg-overview'
    | '/assets/$assetId'
    | '/assets/import'
    | '/audit/calendar'
    | '/audit/evidence-library'
    | '/audit/evidence-upload'
    | '/audit/findings'
    | '/audit/reports'
    | '/bcp/bcp'
    | '/bcp/bia'
    | '/bcp/continuity'
    | '/bcp/dashboard'
    | '/bcp/findings'
    | '/compliance/alerts'
    | '/controls/$controlId'
    | '/datahub/audit'
    | '/datahub/comparison'
    | '/datahub/consolidated'
    | '/datahub/documents'
    | '/datahub/entry'
    | '/datahub/my-entries'
    | '/datahub/periods'
    | '/datahub/quality-dashboard'
    | '/datahub/quality-issues'
    | '/datahub/templates'
    | '/datahub/upload'
    | '/datahub/validation-errors'
    | '/employees/import'
    | '/employees/new'
    | '/esg/$section'
    | '/eu-taxonomy/$section'
    | '/evidence/$evidenceId'
    | '/evidence/logs'
    | '/evidence/repository'
    | '/external-reporting/$reportId'
    | '/ghg/activity-groups'
    | '/ghg/audit'
    | '/ghg/best-practices'
    | '/ghg/business-travel'
    | '/ghg/cdp-questionnaire'
    | '/ghg/collect'
    | '/ghg/commuting'
    | '/ghg/dashboard'
    | '/ghg/data-quality'
    | '/ghg/emission-factors'
    | '/ghg/emission-insights'
    | '/ghg/emissions'
    | '/ghg/gap-analysis'
    | '/ghg/industry-comparison'
    | '/ghg/iso14064-compliance'
    | '/ghg/market-instruments'
    | '/ghg/net-zero'
    | '/ghg/overview'
    | '/ghg/policies'
    | '/ghg/protocol-compliance'
    | '/ghg/report'
    | '/ghg/scope1'
    | '/ghg/scope2'
    | '/ghg/scope3-screening'
    | '/ghg/tasks'
    | '/ghg/travel-import'
    | '/ghg/waste'
    | '/ghg/yoy-comparison'
    | '/help-centre/platform-guides'
    | '/help-centre/regulations'
    | '/incidents/$incidentId'
    | '/incidents/dashboard'
    | '/incidents/new'
    | '/incidents/quick-report'
    | '/incidents/settings'
    | '/incidents/subsidiaries'
    | '/nis2/asset-register'
    | '/nis2/assets-and-measures'
    | '/nis2/assets-measures'
    | '/nis2/business-continuity'
    | '/nis2/dashboard'
    | '/nis2/entity-classification'
    | '/nis2/evidence'
    | '/nis2/gap-analysis'
    | '/nis2/gaps'
    | '/nis2/hr-training'
    | '/nis2/human-resources-security'
    | '/nis2/incident-management'
    | '/nis2/isms'
    | '/nis2/knowledge-base'
    | '/nis2/measure-a'
    | '/nis2/measure-d'
    | '/nis2/onboarding'
    | '/nis2/overview'
    | '/nis2/policies-governance'
    | '/nis2/policy-governance'
    | '/nis2/risk-management'
    | '/nis2/self-assessment'
    | '/nis2/supply-chain-security'
    | '/policies/$policyId'
    | '/policies/compliance-dashboard'
    | '/policies/create'
    | '/policies/documents'
    | '/policies/wizard'
    | '/procedures/$procedureId'
    | '/risks/$riskId'
    | '/risks/ai-suggestions'
    | '/risks/dashboard'
    | '/risks/heatmap'
    | '/risks/new'
    | '/settings/access-log'
    | '/settings/ai-conversations'
    | '/settings/ai-settings'
    | '/settings/appearance'
    | '/settings/asset-categories'
    | '/settings/asset-connectors'
    | '/settings/asset-custom-fields'
    | '/settings/asset-tags'
    | '/settings/audit-alerts'
    | '/settings/audit-log'
    | '/settings/audit-settings'
    | '/settings/audit-webhooks'
    | '/settings/auditors'
    | '/settings/bcp-exercise-settings'
    | '/settings/bcp-review-settings'
    | '/settings/compliance-frameworks'
    | '/settings/configration'
    | '/settings/credentials'
    | '/settings/evidence-collections'
    | '/settings/gap-detection-rules'
    | '/settings/ghg-boundary'
    | '/settings/ghg-facilities'
    | '/settings/ghg-permissions'
    | '/settings/ghg-sources'
    | '/settings/incident-categories'
    | '/settings/my-activity'
    | '/settings/nis2-classification'
    | '/settings/nis2-gap-priority'
    | '/settings/notifications'
    | '/settings/organisation-structure'
    | '/settings/organizations'
    | '/settings/policy-categories'
    | '/settings/profile'
    | '/settings/reporting-periods'
    | '/settings/risk'
    | '/settings/roles'
    | '/settings/scanner-integrations'
    | '/settings/subsidiaries'
    | '/settings/supplier-categories'
    | '/settings/task-schedules'
    | '/settings/team'
    | '/settings/vulnerability-settings'
    | '/suppliers/$supplierId'
    | '/suppliers/compliance-matrix'
    | '/suppliers/register'
    | '/suppliers/risk'
    | '/tasks/$taskId'
    | '/tasks/approvals'
    | '/tasks/console'
    | '/tasks/my'
    | '/vsme/$section'
    | '/vulnerabilities/$vulnerabilityId'
    | '/vulnerabilities/audit-report'
    | '/vulnerabilities/consolidated-report'
    | '/vulnerabilities/dashboard'
    | '/vulnerabilities/new'
    | '/vulnerabilities/nis2-report'
    | '/vulnerabilities/settings'
    | '/vulnerabilities/sla-report'
    | '/vulnerabilities/soc2-compliance'
    | '/vulnerabilities/subsidiaries'
    | '/vulnerabilities/workspace'
    | '/workforce-readiness/awareness-campaigns'
    | '/workforce-readiness/my-trainings'
    | '/workforce-readiness/training-register'
    | '/portal/auth/login'
    | '/portal/history/$token'
    | '/portal/home/$token'
    | '/portal/profile/$token'
    | '/portal/questionnaire/$token'
    | '/admin'
    | '/ai'
    | '/analytics'
    | '/assets'
    | '/audit'
    | '/controls'
    | '/datahub'
    | '/employees'
    | '/evidence'
    | '/external-reporting'
    | '/gaps'
    | '/incidents'
    | '/policies'
    | '/procedures'
    | '/risks'
    | '/settings'
    | '/suppliers'
    | '/surveys'
    | '/threats'
    | '/vulnerabilities'
    | '/admin/incidents/tags'
    | '/admin/policies/access-controls'
    | '/admin/policies/approval-configs'
    | '/admin/policies/templates'
    | '/ai/onboarding/$module'
    | '/ai/scans/$scanId'
    | '/analytics/dashboards/$dashboardId'
    | '/analytics/report-studio/$reportId'
    | '/analytics/report-studio/new'
    | '/analytics/report-studio/templates'
    | '/audit/audits/new'
    | '/audit/evidence/$evidenceId'
    | '/bcp/bia/$biaId'
    | '/bcp/exercises/new'
    | '/bcp/exercises/schedule'
    | '/bcp/plans/bcp'
    | '/bcp/plans/crisis-comm'
    | '/bcp/plans/it-dr'
    | '/bcp/plans/new'
    | '/bcp/plans/new-crisis-communication'
    | '/bcp/plans/new-it-dr'
    | '/bcp/plans/new-recovery-procedure'
    | '/bcp/plans/recovery'
    | '/bcp/reports/exercise-summary'
    | '/bcp/reports/gap-analysis'
    | '/bcp/reports/iso-22301'
    | '/bcp/reports/nis2-compliance'
    | '/bcp/reports/plan-status'
    | '/bcp/resources/sites'
    | '/datahub/datapoints/$datapointId'
    | '/datahub/entry/wizard'
    | '/datahub/governance/approval-config'
    | '/datahub/governance/approval-queue'
    | '/datahub/governance/scheduled-exports'
    | '/datahub/integrations/transformation-rules'
    | '/employees/$employeeId/edit'
    | '/esg/double-materiality/datapoints-policies'
    | '/esg/onboarding/$onboardingId'
    | '/evidence/attestations/new'
    | '/ghg/activity-data/$entryId'
    | '/ghg/activity-data/assignment-queue'
    | '/ghg/activity-data/document-ocr'
    | '/ghg/activity-data/import'
    | '/ghg/calculations/scope1'
    | '/ghg/calculations/scope2'
    | '/ghg/calculations/scope3'
    | '/ghg/commuting-surveys/$surveyId'
    | '/ghg/commuting-surveys/new'
    | '/ghg/facilities/dashboard'
    | '/ghg/integrations/$connectorId'
    | '/ghg/recalculations/$recalculationId'
    | '/ghg/reduction-initiatives/$initiativeId'
    | '/ghg/reduction-initiatives/new'
    | '/ghg/scenarios/$scenarioId'
    | '/ghg/scenarios/compare'
    | '/ghg/scenarios/new'
    | '/ghg/scope3/add'
    | '/ghg/scope3/sold-products'
    | '/ghg/settings/scope1'
    | '/ghg/settings/scope2'
    | '/ghg/targets/$targetId'
    | '/ghg/targets/new'
    | '/ghg/third-party-verification/$engagementId'
    | '/ghg/verification-statements/$statementId'
    | '/ghg/verification/$checklistId'
    | '/incidents/settings/sla'
    | '/nis2/inspection-preparation/$preparationId'
    | '/nis2/measures/$measureCode'
    | '/nis2/reports/activity'
    | '/nis2/reports/audit-preparation'
    | '/nis2/reports/board'
    | '/nis2/reports/compliance'
    | '/nis2/reports/consolidated'
    | '/nis2/reports/cross-border'
    | '/nis2/reports/executive'
    | '/nis2/reports/scheduled'
    | '/policies/$policyId/edit'
    | '/policies/$policyId/review'
    | '/settings/ai-conversations/$conversationId'
    | '/settings/nis2/reminders'
    | '/settings/security/sessions'
    | '/suppliers/admin/risk-config'
    | '/surveys/campaigns/$campaignId'
    | '/surveys/campaigns/new'
    | '/surveys/templates/$templateId'
    | '/surveys/templates/new'
    | '/tasks/console/approvals'
    | '/tasks/playbooks/activate'
    | '/workforce-readiness/awareness-campaigns/$campaignId'
    | '/workforce-readiness/training-register/$trainingId'
    | '/auditor/access/$accessId/assets'
    | '/auditor/access/$accessId/audit'
    | '/auditor/access/$accessId/bcp'
    | '/auditor/access/$accessId/controls'
    | '/auditor/access/$accessId/nis2'
    | '/auditor/access/$accessId/tasks'
    | '/portal/auth/create-account/$token'
    | '/portal/auth/reset-password/$token'
    | '/ai/documents'
    | '/ai/scans'
    | '/analytics/dashboards'
    | '/analytics/report-studio'
    | '/audit/audits'
    | '/audit/evidence'
    | '/bcp/exercises'
    | '/bcp/plans'
    | '/bcp/resources'
    | '/datahub/collections'
    | '/datahub/datapoints'
    | '/datahub/integrations'
    | '/employees/$employeeId'
    | '/esg/double-materiality'
    | '/esg/onboarding'
    | '/ghg/activity-data'
    | '/ghg/approvals'
    | '/ghg/commuting-surveys'
    | '/ghg/exports'
    | '/ghg/integrations'
    | '/ghg/recalculations'
    | '/ghg/reduction-initiatives'
    | '/ghg/reports'
    | '/ghg/scenarios'
    | '/ghg/settings'
    | '/ghg/setup'
    | '/ghg/targets'
    | '/ghg/third-party-verification'
    | '/ghg/verification-statements'
    | '/ghg/verification'
    | '/nis2/inspection-preparation'
    | '/nis2/measures'
    | '/nis2/reports'
    | '/risks/approvals'
    | '/settings/security'
    | '/surveys/campaigns'
    | '/surveys/schedules'
    | '/tasks/playbooks'
    | '/vulnerabilities/approvals'
    | '/portal/auth/forgot-password'
    | '/ai/documents/$documentId/extract'
    | '/audit/audits/$auditId/settings'
    | '/bcp/exercises/$exerciseId/conduct'
    | '/bcp/plans/$planId/edit'
    | '/bcp/plans/$planId/review'
    | '/bcp/resources/sites/$siteId'
    | '/datahub/collections/$collectionId/entry'
    | '/datahub/collections/$collectionId/import'
    | '/datahub/datapoints/$datapointId/entry'
    | '/datahub/integrations/$integrationId/mappings'
    | '/datahub/uploads/$uploadId/map'
    | '/datahub/uploads/$uploadId/review'
    | '/esg/double-materiality/$assessmentId/assessment'
    | '/esg/double-materiality/$assessmentId/impacts'
    | '/esg/double-materiality/$assessmentId/matrix'
    | '/esg/double-materiality/$assessmentId/overview'
    | '/esg/double-materiality/$assessmentId/quality'
    | '/esg/double-materiality/$assessmentId/risks'
    | '/esg/double-materiality/$assessmentId/stakeholders'
    | '/esg/double-materiality/$assessmentId/value-chain'
    | '/ghg/reports/custom/$reportId'
    | '/ghg/reports/custom/new'
    | '/ghg/scope3/$category/derive'
    | '/ghg/verification/internal/$verificationId'
    | '/nis2/incidents/$incidentId/early-warning'
    | '/nis2/incidents/$incidentId/final-report'
    | '/nis2/incidents/$incidentId/notification'
    | '/nis2/incidents/$incidentId/progress-updates'
    | '/policies/$policyId/scans/$scanId'
    | '/policies/procedures/$instanceId/execute'
    | '/settings/team/members/$userId'
    | '/suppliers/$supplierId/reviews/$reviewId'
    | '/suppliers/admin/questionnaire-templates/$templateId'
    | '/suppliers/admin/questionnaire-templates/new'
    | '/suppliers/questionnaires/$sentId/review'
    | '/tasks/playbooks/$activationId/setup'
    | '/tasks/playbooks/templates/$templateId'
    | '/tasks/playbooks/templates/new'
    | '/tasks/playbooks/templates/task-templates'
    | '/auditor/access/$accessId/bcp/exercises'
    | '/auditor/access/$accessId/bcp/findings'
    | '/auditor/access/$accessId/bcp/plans'
    | '/auditor/access/$accessId/nis2/assessments'
    | '/auditor/access/$accessId/nis2/evidence'
    | '/auditor/access/$accessId/nis2/gaps'
    | '/auditor/access/$accessId/nis2/incidents'
    | '/auditor/access/$accessId/nis2/measures'
    | '/audit/audits/$auditId'
    | '/bcp/exercises/$exerciseId'
    | '/bcp/plans/$planId'
    | '/datahub/collections/$collectionId'
    | '/esg/double-materiality/$assessmentId'
    | '/ghg/reports/custom'
    | '/ghg/scope3/$category'
    | '/ghg/verification/internal'
    | '/suppliers/admin/questionnaire-templates'
    | '/tasks/playbooks/$activationId'
    | '/tasks/playbooks/templates'
    | '/settings/team/members/$userId/history-connections'
    | '/auditor/access/$accessId/bcp/plans/$planId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/analytics'
    | '/_authenticated/bcp'
    | '/_authenticated/controls'
    | '/_authenticated/dashboard'
    | '/_authenticated/esg'
    | '/_authenticated/eu-taxonomy'
    | '/_authenticated/ghg'
    | '/_authenticated/help-centre'
    | '/_authenticated/nis2'
    | '/_authenticated/settings'
    | '/_authenticated/vsme'
    | '/_authenticated/workforce-readiness'
    | '/auditor/$token'
    | '/ghg-survey/$token'
    | '/invite/$token'
    | '/quick-report/$shareToken'
    | '/session-tasks/setup-mfa'
    | '/sign-in/$'
    | '/sign-up/$orgId'
    | '/survey-respond/$token'
    | '/forgot-password/'
    | '/reset-password/'
    | '/sign-in/'
    | '/sign-up/'
    | '/_authenticated/admin/ai-costs'
    | '/_authenticated/admin/knowledge-bases'
    | '/_authenticated/admin/llm-settings'
    | '/_authenticated/admin/organizations'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/system-prompts'
    | '/_authenticated/ai/documents'
    | '/_authenticated/ai/insights'
    | '/_authenticated/ai/quality'
    | '/_authenticated/ai/usage'
    | '/_authenticated/analytics/ghg-overview'
    | '/_authenticated/assets/$assetId'
    | '/_authenticated/assets/import'
    | '/_authenticated/audit/calendar'
    | '/_authenticated/audit/evidence-library'
    | '/_authenticated/audit/evidence-upload'
    | '/_authenticated/audit/findings'
    | '/_authenticated/audit/reports'
    | '/_authenticated/bcp/bcp'
    | '/_authenticated/bcp/bia'
    | '/_authenticated/bcp/continuity'
    | '/_authenticated/bcp/dashboard'
    | '/_authenticated/bcp/findings'
    | '/_authenticated/bcp/plans'
    | '/_authenticated/compliance/alerts'
    | '/_authenticated/controls/$controlId'
    | '/_authenticated/datahub/audit'
    | '/_authenticated/datahub/comparison'
    | '/_authenticated/datahub/consolidated'
    | '/_authenticated/datahub/documents'
    | '/_authenticated/datahub/entry'
    | '/_authenticated/datahub/my-entries'
    | '/_authenticated/datahub/periods'
    | '/_authenticated/datahub/quality-dashboard'
    | '/_authenticated/datahub/quality-issues'
    | '/_authenticated/datahub/templates'
    | '/_authenticated/datahub/upload'
    | '/_authenticated/datahub/validation-errors'
    | '/_authenticated/employees/$employeeId'
    | '/_authenticated/employees/import'
    | '/_authenticated/employees/new'
    | '/_authenticated/esg/$section'
    | '/_authenticated/eu-taxonomy/$section'
    | '/_authenticated/evidence/$evidenceId'
    | '/_authenticated/evidence/logs'
    | '/_authenticated/evidence/repository'
    | '/_authenticated/external-reporting/$reportId'
    | '/_authenticated/ghg/activity-groups'
    | '/_authenticated/ghg/audit'
    | '/_authenticated/ghg/best-practices'
    | '/_authenticated/ghg/business-travel'
    | '/_authenticated/ghg/cdp-questionnaire'
    | '/_authenticated/ghg/collect'
    | '/_authenticated/ghg/commuting'
    | '/_authenticated/ghg/dashboard'
    | '/_authenticated/ghg/data-quality'
    | '/_authenticated/ghg/emission-factors'
    | '/_authenticated/ghg/emission-insights'
    | '/_authenticated/ghg/emissions'
    | '/_authenticated/ghg/gap-analysis'
    | '/_authenticated/ghg/industry-comparison'
    | '/_authenticated/ghg/iso14064-compliance'
    | '/_authenticated/ghg/market-instruments'
    | '/_authenticated/ghg/net-zero'
    | '/_authenticated/ghg/overview'
    | '/_authenticated/ghg/policies'
    | '/_authenticated/ghg/protocol-compliance'
    | '/_authenticated/ghg/recalculations'
    | '/_authenticated/ghg/report'
    | '/_authenticated/ghg/scope1'
    | '/_authenticated/ghg/scope2'
    | '/_authenticated/ghg/scope3-screening'
    | '/_authenticated/ghg/tasks'
    | '/_authenticated/ghg/travel-import'
    | '/_authenticated/ghg/waste'
    | '/_authenticated/ghg/yoy-comparison'
    | '/_authenticated/help-centre/platform-guides'
    | '/_authenticated/help-centre/regulations'
    | '/_authenticated/incidents/$incidentId'
    | '/_authenticated/incidents/dashboard'
    | '/_authenticated/incidents/new'
    | '/_authenticated/incidents/quick-report'
    | '/_authenticated/incidents/settings'
    | '/_authenticated/incidents/subsidiaries'
    | '/_authenticated/nis2/asset-register'
    | '/_authenticated/nis2/assets-and-measures'
    | '/_authenticated/nis2/assets-measures'
    | '/_authenticated/nis2/business-continuity'
    | '/_authenticated/nis2/dashboard'
    | '/_authenticated/nis2/entity-classification'
    | '/_authenticated/nis2/evidence'
    | '/_authenticated/nis2/gap-analysis'
    | '/_authenticated/nis2/gaps'
    | '/_authenticated/nis2/hr-training'
    | '/_authenticated/nis2/human-resources-security'
    | '/_authenticated/nis2/incident-management'
    | '/_authenticated/nis2/isms'
    | '/_authenticated/nis2/knowledge-base'
    | '/_authenticated/nis2/measure-a'
    | '/_authenticated/nis2/measure-d'
    | '/_authenticated/nis2/onboarding'
    | '/_authenticated/nis2/overview'
    | '/_authenticated/nis2/policies-governance'
    | '/_authenticated/nis2/policy-governance'
    | '/_authenticated/nis2/risk-management'
    | '/_authenticated/nis2/self-assessment'
    | '/_authenticated/nis2/supply-chain-security'
    | '/_authenticated/policies/$policyId'
    | '/_authenticated/policies/compliance-dashboard'
    | '/_authenticated/policies/create'
    | '/_authenticated/policies/documents'
    | '/_authenticated/policies/wizard'
    | '/_authenticated/procedures/$procedureId'
    | '/_authenticated/risks/$riskId'
    | '/_authenticated/risks/ai-suggestions'
    | '/_authenticated/risks/dashboard'
    | '/_authenticated/risks/heatmap'
    | '/_authenticated/risks/new'
    | '/_authenticated/settings/access-log'
    | '/_authenticated/settings/ai-conversations'
    | '/_authenticated/settings/ai-settings'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/asset-categories'
    | '/_authenticated/settings/asset-connectors'
    | '/_authenticated/settings/asset-custom-fields'
    | '/_authenticated/settings/asset-tags'
    | '/_authenticated/settings/audit-alerts'
    | '/_authenticated/settings/audit-log'
    | '/_authenticated/settings/audit-settings'
    | '/_authenticated/settings/audit-webhooks'
    | '/_authenticated/settings/auditors'
    | '/_authenticated/settings/bcp-exercise-settings'
    | '/_authenticated/settings/bcp-review-settings'
    | '/_authenticated/settings/compliance-frameworks'
    | '/_authenticated/settings/configration'
    | '/_authenticated/settings/credentials'
    | '/_authenticated/settings/evidence-collections'
    | '/_authenticated/settings/gap-detection-rules'
    | '/_authenticated/settings/ghg-boundary'
    | '/_authenticated/settings/ghg-facilities'
    | '/_authenticated/settings/ghg-permissions'
    | '/_authenticated/settings/ghg-sources'
    | '/_authenticated/settings/incident-categories'
    | '/_authenticated/settings/my-activity'
    | '/_authenticated/settings/nis2-classification'
    | '/_authenticated/settings/nis2-gap-priority'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/organisation-structure'
    | '/_authenticated/settings/organizations'
    | '/_authenticated/settings/policy-categories'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/reporting-periods'
    | '/_authenticated/settings/risk'
    | '/_authenticated/settings/roles'
    | '/_authenticated/settings/scanner-integrations'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/subsidiaries'
    | '/_authenticated/settings/supplier-categories'
    | '/_authenticated/settings/task-schedules'
    | '/_authenticated/settings/team'
    | '/_authenticated/settings/vulnerability-settings'
    | '/_authenticated/suppliers/$supplierId'
    | '/_authenticated/suppliers/compliance-matrix'
    | '/_authenticated/suppliers/register'
    | '/_authenticated/suppliers/risk'
    | '/_authenticated/tasks/$taskId'
    | '/_authenticated/tasks/approvals'
    | '/_authenticated/tasks/console'
    | '/_authenticated/tasks/my'
    | '/_authenticated/vsme/$section'
    | '/_authenticated/vulnerabilities/$vulnerabilityId'
    | '/_authenticated/vulnerabilities/audit-report'
    | '/_authenticated/vulnerabilities/consolidated-report'
    | '/_authenticated/vulnerabilities/dashboard'
    | '/_authenticated/vulnerabilities/new'
    | '/_authenticated/vulnerabilities/nis2-report'
    | '/_authenticated/vulnerabilities/settings'
    | '/_authenticated/vulnerabilities/sla-report'
    | '/_authenticated/vulnerabilities/soc2-compliance'
    | '/_authenticated/vulnerabilities/subsidiaries'
    | '/_authenticated/vulnerabilities/workspace'
    | '/_authenticated/workforce-readiness/awareness-campaigns'
    | '/_authenticated/workforce-readiness/my-trainings'
    | '/_authenticated/workforce-readiness/training-register'
    | '/portal/auth/login'
    | '/portal/history/$token'
    | '/portal/home/$token'
    | '/portal/profile/$token'
    | '/portal/questionnaire/$token'
    | '/_authenticated/admin/'
    | '/_authenticated/ai/'
    | '/_authenticated/analytics/'
    | '/_authenticated/assets/'
    | '/_authenticated/audit/'
    | '/_authenticated/controls/'
    | '/_authenticated/datahub/'
    | '/_authenticated/employees/'
    | '/_authenticated/evidence/'
    | '/_authenticated/external-reporting/'
    | '/_authenticated/gaps/'
    | '/_authenticated/incidents/'
    | '/_authenticated/policies/'
    | '/_authenticated/procedures/'
    | '/_authenticated/risks/'
    | '/_authenticated/settings/'
    | '/_authenticated/suppliers/'
    | '/_authenticated/surveys/'
    | '/_authenticated/threats/'
    | '/_authenticated/vulnerabilities/'
    | '/_authenticated/admin/incidents/tags'
    | '/_authenticated/admin/policies/access-controls'
    | '/_authenticated/admin/policies/approval-configs'
    | '/_authenticated/admin/policies/templates'
    | '/_authenticated/ai/onboarding/$module'
    | '/_authenticated/ai/scans/$scanId'
    | '/_authenticated/analytics/dashboards/$dashboardId'
    | '/_authenticated/analytics/report-studio/$reportId'
    | '/_authenticated/analytics/report-studio/new'
    | '/_authenticated/analytics/report-studio/templates'
    | '/_authenticated/audit/audits/new'
    | '/_authenticated/audit/evidence/$evidenceId'
    | '/_authenticated/bcp/bia/$biaId'
    | '/_authenticated/bcp/exercises/$exerciseId'
    | '/_authenticated/bcp/exercises/new'
    | '/_authenticated/bcp/exercises/schedule'
    | '/_authenticated/bcp/plans/$planId'
    | '/_authenticated/bcp/plans/bcp'
    | '/_authenticated/bcp/plans/crisis-comm'
    | '/_authenticated/bcp/plans/it-dr'
    | '/_authenticated/bcp/plans/new'
    | '/_authenticated/bcp/plans/new-crisis-communication'
    | '/_authenticated/bcp/plans/new-it-dr'
    | '/_authenticated/bcp/plans/new-recovery-procedure'
    | '/_authenticated/bcp/plans/recovery'
    | '/_authenticated/bcp/reports/exercise-summary'
    | '/_authenticated/bcp/reports/gap-analysis'
    | '/_authenticated/bcp/reports/iso-22301'
    | '/_authenticated/bcp/reports/nis2-compliance'
    | '/_authenticated/bcp/reports/plan-status'
    | '/_authenticated/bcp/resources/sites'
    | '/_authenticated/datahub/collections/$collectionId'
    | '/_authenticated/datahub/datapoints/$datapointId'
    | '/_authenticated/datahub/entry/wizard'
    | '/_authenticated/datahub/governance/approval-config'
    | '/_authenticated/datahub/governance/approval-queue'
    | '/_authenticated/datahub/governance/scheduled-exports'
    | '/_authenticated/datahub/integrations/transformation-rules'
    | '/_authenticated/employees/$employeeId/edit'
    | '/_authenticated/esg/double-materiality/$assessmentId'
    | '/_authenticated/esg/double-materiality/datapoints-policies'
    | '/_authenticated/esg/onboarding/$onboardingId'
    | '/_authenticated/evidence/attestations/new'
    | '/_authenticated/ghg/activity-data/$entryId'
    | '/_authenticated/ghg/activity-data/assignment-queue'
    | '/_authenticated/ghg/activity-data/document-ocr'
    | '/_authenticated/ghg/activity-data/import'
    | '/_authenticated/ghg/calculations/scope1'
    | '/_authenticated/ghg/calculations/scope2'
    | '/_authenticated/ghg/calculations/scope3'
    | '/_authenticated/ghg/commuting-surveys/$surveyId'
    | '/_authenticated/ghg/commuting-surveys/new'
    | '/_authenticated/ghg/facilities/dashboard'
    | '/_authenticated/ghg/integrations/$connectorId'
    | '/_authenticated/ghg/recalculations/$recalculationId'
    | '/_authenticated/ghg/reduction-initiatives/$initiativeId'
    | '/_authenticated/ghg/reduction-initiatives/new'
    | '/_authenticated/ghg/scenarios/$scenarioId'
    | '/_authenticated/ghg/scenarios/compare'
    | '/_authenticated/ghg/scenarios/new'
    | '/_authenticated/ghg/scope3/$category'
    | '/_authenticated/ghg/scope3/add'
    | '/_authenticated/ghg/scope3/sold-products'
    | '/_authenticated/ghg/settings/scope1'
    | '/_authenticated/ghg/settings/scope2'
    | '/_authenticated/ghg/targets/$targetId'
    | '/_authenticated/ghg/targets/new'
    | '/_authenticated/ghg/third-party-verification/$engagementId'
    | '/_authenticated/ghg/verification-statements/$statementId'
    | '/_authenticated/ghg/verification/$checklistId'
    | '/_authenticated/incidents/settings/sla'
    | '/_authenticated/nis2/inspection-preparation/$preparationId'
    | '/_authenticated/nis2/measures/$measureCode'
    | '/_authenticated/nis2/reports/activity'
    | '/_authenticated/nis2/reports/audit-preparation'
    | '/_authenticated/nis2/reports/board'
    | '/_authenticated/nis2/reports/compliance'
    | '/_authenticated/nis2/reports/consolidated'
    | '/_authenticated/nis2/reports/cross-border'
    | '/_authenticated/nis2/reports/executive'
    | '/_authenticated/nis2/reports/scheduled'
    | '/_authenticated/policies/$policyId/edit'
    | '/_authenticated/policies/$policyId/review'
    | '/_authenticated/settings/ai-conversations/$conversationId'
    | '/_authenticated/settings/nis2/reminders'
    | '/_authenticated/settings/security/sessions'
    | '/_authenticated/suppliers/admin/risk-config'
    | '/_authenticated/surveys/campaigns/$campaignId'
    | '/_authenticated/surveys/campaigns/new'
    | '/_authenticated/surveys/templates/$templateId'
    | '/_authenticated/surveys/templates/new'
    | '/_authenticated/tasks/console/approvals'
    | '/_authenticated/tasks/playbooks/activate'
    | '/_authenticated/workforce-readiness/awareness-campaigns/$campaignId'
    | '/_authenticated/workforce-readiness/training-register/$trainingId'
    | '/auditor/access/$accessId/assets'
    | '/auditor/access/$accessId/audit'
    | '/auditor/access/$accessId/bcp'
    | '/auditor/access/$accessId/controls'
    | '/auditor/access/$accessId/nis2'
    | '/auditor/access/$accessId/tasks'
    | '/portal/auth/create-account/$token'
    | '/portal/auth/reset-password/$token'
    | '/_authenticated/ai/documents/'
    | '/_authenticated/ai/scans/'
    | '/_authenticated/analytics/dashboards/'
    | '/_authenticated/analytics/report-studio/'
    | '/_authenticated/audit/audits/'
    | '/_authenticated/audit/evidence/'
    | '/_authenticated/bcp/exercises/'
    | '/_authenticated/bcp/plans/'
    | '/_authenticated/bcp/resources/'
    | '/_authenticated/datahub/collections/'
    | '/_authenticated/datahub/datapoints/'
    | '/_authenticated/datahub/integrations/'
    | '/_authenticated/employees/$employeeId/'
    | '/_authenticated/esg/double-materiality/'
    | '/_authenticated/esg/onboarding/'
    | '/_authenticated/ghg/activity-data/'
    | '/_authenticated/ghg/approvals/'
    | '/_authenticated/ghg/commuting-surveys/'
    | '/_authenticated/ghg/exports/'
    | '/_authenticated/ghg/integrations/'
    | '/_authenticated/ghg/recalculations/'
    | '/_authenticated/ghg/reduction-initiatives/'
    | '/_authenticated/ghg/reports/'
    | '/_authenticated/ghg/scenarios/'
    | '/_authenticated/ghg/settings/'
    | '/_authenticated/ghg/setup/'
    | '/_authenticated/ghg/targets/'
    | '/_authenticated/ghg/third-party-verification/'
    | '/_authenticated/ghg/verification-statements/'
    | '/_authenticated/ghg/verification/'
    | '/_authenticated/nis2/inspection-preparation/'
    | '/_authenticated/nis2/measures/'
    | '/_authenticated/nis2/reports/'
    | '/_authenticated/risks/approvals/'
    | '/_authenticated/settings/security/'
    | '/_authenticated/surveys/campaigns/'
    | '/_authenticated/surveys/schedules/'
    | '/_authenticated/tasks/playbooks/'
    | '/_authenticated/vulnerabilities/approvals/'
    | '/portal/auth/forgot-password/'
    | '/_authenticated/ai/documents/$documentId/extract'
    | '/_authenticated/audit/audits/$auditId/settings'
    | '/_authenticated/bcp/exercises/$exerciseId/conduct'
    | '/_authenticated/bcp/plans/$planId/edit'
    | '/_authenticated/bcp/plans/$planId/review'
    | '/_authenticated/bcp/resources/sites/$siteId'
    | '/_authenticated/datahub/collections/$collectionId/entry'
    | '/_authenticated/datahub/collections/$collectionId/import'
    | '/_authenticated/datahub/datapoints/$datapointId/entry'
    | '/_authenticated/datahub/integrations/$integrationId/mappings'
    | '/_authenticated/datahub/uploads/$uploadId/map'
    | '/_authenticated/datahub/uploads/$uploadId/review'
    | '/_authenticated/esg/double-materiality/$assessmentId/assessment'
    | '/_authenticated/esg/double-materiality/$assessmentId/impacts'
    | '/_authenticated/esg/double-materiality/$assessmentId/matrix'
    | '/_authenticated/esg/double-materiality/$assessmentId/overview'
    | '/_authenticated/esg/double-materiality/$assessmentId/quality'
    | '/_authenticated/esg/double-materiality/$assessmentId/risks'
    | '/_authenticated/esg/double-materiality/$assessmentId/stakeholders'
    | '/_authenticated/esg/double-materiality/$assessmentId/value-chain'
    | '/_authenticated/ghg/reports/custom/$reportId'
    | '/_authenticated/ghg/reports/custom/new'
    | '/_authenticated/ghg/scope3/$category/derive'
    | '/_authenticated/ghg/verification/internal/$verificationId'
    | '/_authenticated/nis2/incidents/$incidentId/early-warning'
    | '/_authenticated/nis2/incidents/$incidentId/final-report'
    | '/_authenticated/nis2/incidents/$incidentId/notification'
    | '/_authenticated/nis2/incidents/$incidentId/progress-updates'
    | '/_authenticated/policies/$policyId/scans/$scanId'
    | '/_authenticated/policies/procedures/$instanceId/execute'
    | '/_authenticated/settings/team/members/$userId'
    | '/_authenticated/suppliers/$supplierId/reviews/$reviewId'
    | '/_authenticated/suppliers/admin/questionnaire-templates/$templateId'
    | '/_authenticated/suppliers/admin/questionnaire-templates/new'
    | '/_authenticated/suppliers/questionnaires/$sentId/review'
    | '/_authenticated/tasks/playbooks/$activationId/setup'
    | '/_authenticated/tasks/playbooks/templates/$templateId'
    | '/_authenticated/tasks/playbooks/templates/new'
    | '/_authenticated/tasks/playbooks/templates/task-templates'
    | '/auditor/access/$accessId/bcp/exercises'
    | '/auditor/access/$accessId/bcp/findings'
    | '/auditor/access/$accessId/bcp/plans'
    | '/auditor/access/$accessId/nis2/assessments'
    | '/auditor/access/$accessId/nis2/evidence'
    | '/auditor/access/$accessId/nis2/gaps'
    | '/auditor/access/$accessId/nis2/incidents'
    | '/auditor/access/$accessId/nis2/measures'
    | '/_authenticated/audit/audits/$auditId/'
    | '/_authenticated/bcp/exercises/$exerciseId/'
    | '/_authenticated/bcp/plans/$planId/'
    | '/_authenticated/datahub/collections/$collectionId/'
    | '/_authenticated/esg/double-materiality/$assessmentId/'
    | '/_authenticated/ghg/reports/custom/'
    | '/_authenticated/ghg/scope3/$category/'
    | '/_authenticated/ghg/verification/internal/'
    | '/_authenticated/suppliers/admin/questionnaire-templates/'
    | '/_authenticated/tasks/playbooks/$activationId/'
    | '/_authenticated/tasks/playbooks/templates/'
    | '/_authenticated/settings/team/members/$userId/history-connections'
    | '/auditor/access/$accessId/bcp/plans/$planId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuditorTokenRoute: typeof AuditorTokenRoute
  GhgSurveyTokenRoute: typeof GhgSurveyTokenRoute
  InviteTokenRoute: typeof InviteTokenRoute
  QuickReportShareTokenRoute: typeof QuickReportShareTokenRoute
  SessionTasksSetupMfaRoute: typeof SessionTasksSetupMfaRoute
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpOrgIdRoute: typeof SignUpOrgIdRoute
  SurveyRespondTokenRoute: typeof SurveyRespondTokenRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  SignInIndexRoute: typeof SignInIndexRoute
  SignUpIndexRoute: typeof SignUpIndexRoute
  PortalAuthLoginRoute: typeof PortalAuthLoginRoute
  PortalHistoryTokenRoute: typeof PortalHistoryTokenRoute
  PortalHomeTokenRoute: typeof PortalHomeTokenRoute
  PortalProfileTokenRoute: typeof PortalProfileTokenRoute
  PortalQuestionnaireTokenRoute: typeof PortalQuestionnaireTokenRoute
  AuditorAccessAccessIdAssetsRoute: typeof AuditorAccessAccessIdAssetsRoute
  AuditorAccessAccessIdAuditRoute: typeof AuditorAccessAccessIdAuditRoute
  AuditorAccessAccessIdBcpRoute: typeof AuditorAccessAccessIdBcpRouteWithChildren
  AuditorAccessAccessIdControlsRoute: typeof AuditorAccessAccessIdControlsRoute
  AuditorAccessAccessIdNis2Route: typeof AuditorAccessAccessIdNis2RouteWithChildren
  AuditorAccessAccessIdTasksRoute: typeof AuditorAccessAccessIdTasksRoute
  PortalAuthCreateAccountTokenRoute: typeof PortalAuthCreateAccountTokenRoute
  PortalAuthResetPasswordTokenRoute: typeof PortalAuthResetPasswordTokenRoute
  PortalAuthForgotPasswordIndexRoute: typeof PortalAuthForgotPasswordIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up/': {
      id: '/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey-respond/$token': {
      id: '/survey-respond/$token'
      path: '/survey-respond/$token'
      fullPath: '/survey-respond/$token'
      preLoaderRoute: typeof SurveyRespondTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up/$orgId': {
      id: '/sign-up/$orgId'
      path: '/sign-up/$orgId'
      fullPath: '/sign-up/$orgId'
      preLoaderRoute: typeof SignUpOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session-tasks/setup-mfa': {
      id: '/session-tasks/setup-mfa'
      path: '/session-tasks/setup-mfa'
      fullPath: '/session-tasks/setup-mfa'
      preLoaderRoute: typeof SessionTasksSetupMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quick-report/$shareToken': {
      id: '/quick-report/$shareToken'
      path: '/quick-report/$shareToken'
      fullPath: '/quick-report/$shareToken'
      preLoaderRoute: typeof QuickReportShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ghg-survey/$token': {
      id: '/ghg-survey/$token'
      path: '/ghg-survey/$token'
      fullPath: '/ghg-survey/$token'
      preLoaderRoute: typeof GhgSurveyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/$token': {
      id: '/auditor/$token'
      path: '/auditor/$token'
      fullPath: '/auditor/$token'
      preLoaderRoute: typeof AuditorTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workforce-readiness': {
      id: '/_authenticated/workforce-readiness'
      path: '/workforce-readiness'
      fullPath: '/workforce-readiness'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vsme': {
      id: '/_authenticated/vsme'
      path: '/vsme'
      fullPath: '/vsme'
      preLoaderRoute: typeof AuthenticatedVsmeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/nis2': {
      id: '/_authenticated/nis2'
      path: '/nis2'
      fullPath: '/nis2'
      preLoaderRoute: typeof AuthenticatedNis2RouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help-centre': {
      id: '/_authenticated/help-centre'
      path: '/help-centre'
      fullPath: '/help-centre'
      preLoaderRoute: typeof AuthenticatedHelpCentreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ghg': {
      id: '/_authenticated/ghg'
      path: '/ghg'
      fullPath: '/ghg'
      preLoaderRoute: typeof AuthenticatedGhgRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/eu-taxonomy': {
      id: '/_authenticated/eu-taxonomy'
      path: '/eu-taxonomy'
      fullPath: '/eu-taxonomy'
      preLoaderRoute: typeof AuthenticatedEuTaxonomyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/esg': {
      id: '/_authenticated/esg'
      path: '/esg'
      fullPath: '/esg'
      preLoaderRoute: typeof AuthenticatedEsgRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/controls': {
      id: '/_authenticated/controls'
      path: '/controls'
      fullPath: '/controls'
      preLoaderRoute: typeof AuthenticatedControlsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bcp': {
      id: '/_authenticated/bcp'
      path: '/bcp'
      fullPath: '/bcp'
      preLoaderRoute: typeof AuthenticatedBcpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/': {
      id: '/_authenticated/vulnerabilities/'
      path: '/vulnerabilities'
      fullPath: '/vulnerabilities'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/threats/': {
      id: '/_authenticated/threats/'
      path: '/threats'
      fullPath: '/threats'
      preLoaderRoute: typeof AuthenticatedThreatsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/': {
      id: '/_authenticated/surveys/'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof AuthenticatedSurveysIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/': {
      id: '/_authenticated/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthenticatedSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/risks/': {
      id: '/_authenticated/risks/'
      path: '/risks'
      fullPath: '/risks'
      preLoaderRoute: typeof AuthenticatedRisksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procedures/': {
      id: '/_authenticated/procedures/'
      path: '/procedures'
      fullPath: '/procedures'
      preLoaderRoute: typeof AuthenticatedProceduresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/': {
      id: '/_authenticated/policies/'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AuthenticatedPoliciesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/': {
      id: '/_authenticated/incidents/'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof AuthenticatedIncidentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gaps/': {
      id: '/_authenticated/gaps/'
      path: '/gaps'
      fullPath: '/gaps'
      preLoaderRoute: typeof AuthenticatedGapsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/external-reporting/': {
      id: '/_authenticated/external-reporting/'
      path: '/external-reporting'
      fullPath: '/external-reporting'
      preLoaderRoute: typeof AuthenticatedExternalReportingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/evidence/': {
      id: '/_authenticated/evidence/'
      path: '/evidence'
      fullPath: '/evidence'
      preLoaderRoute: typeof AuthenticatedEvidenceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/': {
      id: '/_authenticated/employees/'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/': {
      id: '/_authenticated/datahub/'
      path: '/datahub'
      fullPath: '/datahub'
      preLoaderRoute: typeof AuthenticatedDatahubIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/controls/': {
      id: '/_authenticated/controls/'
      path: '/'
      fullPath: '/controls/'
      preLoaderRoute: typeof AuthenticatedControlsIndexRouteImport
      parentRoute: typeof AuthenticatedControlsRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/ai/': {
      id: '/_authenticated/ai/'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthenticatedAiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/portal/questionnaire/$token': {
      id: '/portal/questionnaire/$token'
      path: '/portal/questionnaire/$token'
      fullPath: '/portal/questionnaire/$token'
      preLoaderRoute: typeof PortalQuestionnaireTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/profile/$token': {
      id: '/portal/profile/$token'
      path: '/portal/profile/$token'
      fullPath: '/portal/profile/$token'
      preLoaderRoute: typeof PortalProfileTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/home/$token': {
      id: '/portal/home/$token'
      path: '/portal/home/$token'
      fullPath: '/portal/home/$token'
      preLoaderRoute: typeof PortalHomeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/history/$token': {
      id: '/portal/history/$token'
      path: '/portal/history/$token'
      fullPath: '/portal/history/$token'
      preLoaderRoute: typeof PortalHistoryTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/auth/login': {
      id: '/portal/auth/login'
      path: '/portal/auth/login'
      fullPath: '/portal/auth/login'
      preLoaderRoute: typeof PortalAuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workforce-readiness/training-register': {
      id: '/_authenticated/workforce-readiness/training-register'
      path: '/training-register'
      fullPath: '/workforce-readiness/training-register'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessTrainingRegisterRouteImport
      parentRoute: typeof AuthenticatedWorkforceReadinessRoute
    }
    '/_authenticated/workforce-readiness/my-trainings': {
      id: '/_authenticated/workforce-readiness/my-trainings'
      path: '/my-trainings'
      fullPath: '/workforce-readiness/my-trainings'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessMyTrainingsRouteImport
      parentRoute: typeof AuthenticatedWorkforceReadinessRoute
    }
    '/_authenticated/workforce-readiness/awareness-campaigns': {
      id: '/_authenticated/workforce-readiness/awareness-campaigns'
      path: '/awareness-campaigns'
      fullPath: '/workforce-readiness/awareness-campaigns'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRouteImport
      parentRoute: typeof AuthenticatedWorkforceReadinessRoute
    }
    '/_authenticated/vulnerabilities/workspace': {
      id: '/_authenticated/vulnerabilities/workspace'
      path: '/vulnerabilities/workspace'
      fullPath: '/vulnerabilities/workspace'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/subsidiaries': {
      id: '/_authenticated/vulnerabilities/subsidiaries'
      path: '/vulnerabilities/subsidiaries'
      fullPath: '/vulnerabilities/subsidiaries'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesSubsidiariesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/soc2-compliance': {
      id: '/_authenticated/vulnerabilities/soc2-compliance'
      path: '/vulnerabilities/soc2-compliance'
      fullPath: '/vulnerabilities/soc2-compliance'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesSoc2ComplianceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/sla-report': {
      id: '/_authenticated/vulnerabilities/sla-report'
      path: '/vulnerabilities/sla-report'
      fullPath: '/vulnerabilities/sla-report'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesSlaReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/settings': {
      id: '/_authenticated/vulnerabilities/settings'
      path: '/vulnerabilities/settings'
      fullPath: '/vulnerabilities/settings'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/nis2-report': {
      id: '/_authenticated/vulnerabilities/nis2-report'
      path: '/vulnerabilities/nis2-report'
      fullPath: '/vulnerabilities/nis2-report'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesNis2ReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/new': {
      id: '/_authenticated/vulnerabilities/new'
      path: '/vulnerabilities/new'
      fullPath: '/vulnerabilities/new'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/dashboard': {
      id: '/_authenticated/vulnerabilities/dashboard'
      path: '/vulnerabilities/dashboard'
      fullPath: '/vulnerabilities/dashboard'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/consolidated-report': {
      id: '/_authenticated/vulnerabilities/consolidated-report'
      path: '/vulnerabilities/consolidated-report'
      fullPath: '/vulnerabilities/consolidated-report'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesConsolidatedReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/audit-report': {
      id: '/_authenticated/vulnerabilities/audit-report'
      path: '/vulnerabilities/audit-report'
      fullPath: '/vulnerabilities/audit-report'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesAuditReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vulnerabilities/$vulnerabilityId': {
      id: '/_authenticated/vulnerabilities/$vulnerabilityId'
      path: '/vulnerabilities/$vulnerabilityId'
      fullPath: '/vulnerabilities/$vulnerabilityId'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesVulnerabilityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vsme/$section': {
      id: '/_authenticated/vsme/$section'
      path: '/$section'
      fullPath: '/vsme/$section'
      preLoaderRoute: typeof AuthenticatedVsmeSectionRouteImport
      parentRoute: typeof AuthenticatedVsmeRoute
    }
    '/_authenticated/tasks/my': {
      id: '/_authenticated/tasks/my'
      path: '/tasks/my'
      fullPath: '/tasks/my'
      preLoaderRoute: typeof AuthenticatedTasksMyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/console': {
      id: '/_authenticated/tasks/console'
      path: '/tasks/console'
      fullPath: '/tasks/console'
      preLoaderRoute: typeof AuthenticatedTasksConsoleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/approvals': {
      id: '/_authenticated/tasks/approvals'
      path: '/tasks/approvals'
      fullPath: '/tasks/approvals'
      preLoaderRoute: typeof AuthenticatedTasksApprovalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId': {
      id: '/_authenticated/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/risk': {
      id: '/_authenticated/suppliers/risk'
      path: '/suppliers/risk'
      fullPath: '/suppliers/risk'
      preLoaderRoute: typeof AuthenticatedSuppliersRiskRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/register': {
      id: '/_authenticated/suppliers/register'
      path: '/suppliers/register'
      fullPath: '/suppliers/register'
      preLoaderRoute: typeof AuthenticatedSuppliersRegisterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/compliance-matrix': {
      id: '/_authenticated/suppliers/compliance-matrix'
      path: '/suppliers/compliance-matrix'
      fullPath: '/suppliers/compliance-matrix'
      preLoaderRoute: typeof AuthenticatedSuppliersComplianceMatrixRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/$supplierId': {
      id: '/_authenticated/suppliers/$supplierId'
      path: '/suppliers/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/vulnerability-settings': {
      id: '/_authenticated/settings/vulnerability-settings'
      path: '/vulnerability-settings'
      fullPath: '/settings/vulnerability-settings'
      preLoaderRoute: typeof AuthenticatedSettingsVulnerabilitySettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/task-schedules': {
      id: '/_authenticated/settings/task-schedules'
      path: '/task-schedules'
      fullPath: '/settings/task-schedules'
      preLoaderRoute: typeof AuthenticatedSettingsTaskSchedulesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/supplier-categories': {
      id: '/_authenticated/settings/supplier-categories'
      path: '/supplier-categories'
      fullPath: '/settings/supplier-categories'
      preLoaderRoute: typeof AuthenticatedSettingsSupplierCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/subsidiaries': {
      id: '/_authenticated/settings/subsidiaries'
      path: '/subsidiaries'
      fullPath: '/settings/subsidiaries'
      preLoaderRoute: typeof AuthenticatedSettingsSubsidiariesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/scanner-integrations': {
      id: '/_authenticated/settings/scanner-integrations'
      path: '/scanner-integrations'
      fullPath: '/settings/scanner-integrations'
      preLoaderRoute: typeof AuthenticatedSettingsScannerIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/roles': {
      id: '/_authenticated/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedSettingsRolesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/risk': {
      id: '/_authenticated/settings/risk'
      path: '/risk'
      fullPath: '/settings/risk'
      preLoaderRoute: typeof AuthenticatedSettingsRiskRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/reporting-periods': {
      id: '/_authenticated/settings/reporting-periods'
      path: '/reporting-periods'
      fullPath: '/settings/reporting-periods'
      preLoaderRoute: typeof AuthenticatedSettingsReportingPeriodsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/policy-categories': {
      id: '/_authenticated/settings/policy-categories'
      path: '/policy-categories'
      fullPath: '/settings/policy-categories'
      preLoaderRoute: typeof AuthenticatedSettingsPolicyCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organizations': {
      id: '/_authenticated/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organisation-structure': {
      id: '/_authenticated/settings/organisation-structure'
      path: '/organisation-structure'
      fullPath: '/settings/organisation-structure'
      preLoaderRoute: typeof AuthenticatedSettingsOrganisationStructureRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/nis2-gap-priority': {
      id: '/_authenticated/settings/nis2-gap-priority'
      path: '/nis2-gap-priority'
      fullPath: '/settings/nis2-gap-priority'
      preLoaderRoute: typeof AuthenticatedSettingsNis2GapPriorityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/nis2-classification': {
      id: '/_authenticated/settings/nis2-classification'
      path: '/nis2-classification'
      fullPath: '/settings/nis2-classification'
      preLoaderRoute: typeof AuthenticatedSettingsNis2ClassificationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/my-activity': {
      id: '/_authenticated/settings/my-activity'
      path: '/my-activity'
      fullPath: '/settings/my-activity'
      preLoaderRoute: typeof AuthenticatedSettingsMyActivityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/incident-categories': {
      id: '/_authenticated/settings/incident-categories'
      path: '/incident-categories'
      fullPath: '/settings/incident-categories'
      preLoaderRoute: typeof AuthenticatedSettingsIncidentCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ghg-sources': {
      id: '/_authenticated/settings/ghg-sources'
      path: '/ghg-sources'
      fullPath: '/settings/ghg-sources'
      preLoaderRoute: typeof AuthenticatedSettingsGhgSourcesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ghg-permissions': {
      id: '/_authenticated/settings/ghg-permissions'
      path: '/ghg-permissions'
      fullPath: '/settings/ghg-permissions'
      preLoaderRoute: typeof AuthenticatedSettingsGhgPermissionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ghg-facilities': {
      id: '/_authenticated/settings/ghg-facilities'
      path: '/ghg-facilities'
      fullPath: '/settings/ghg-facilities'
      preLoaderRoute: typeof AuthenticatedSettingsGhgFacilitiesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ghg-boundary': {
      id: '/_authenticated/settings/ghg-boundary'
      path: '/ghg-boundary'
      fullPath: '/settings/ghg-boundary'
      preLoaderRoute: typeof AuthenticatedSettingsGhgBoundaryRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/gap-detection-rules': {
      id: '/_authenticated/settings/gap-detection-rules'
      path: '/gap-detection-rules'
      fullPath: '/settings/gap-detection-rules'
      preLoaderRoute: typeof AuthenticatedSettingsGapDetectionRulesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/evidence-collections': {
      id: '/_authenticated/settings/evidence-collections'
      path: '/evidence-collections'
      fullPath: '/settings/evidence-collections'
      preLoaderRoute: typeof AuthenticatedSettingsEvidenceCollectionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/credentials': {
      id: '/_authenticated/settings/credentials'
      path: '/credentials'
      fullPath: '/settings/credentials'
      preLoaderRoute: typeof AuthenticatedSettingsCredentialsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/configration': {
      id: '/_authenticated/settings/configration'
      path: '/configration'
      fullPath: '/settings/configration'
      preLoaderRoute: typeof AuthenticatedSettingsConfigrationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/compliance-frameworks': {
      id: '/_authenticated/settings/compliance-frameworks'
      path: '/compliance-frameworks'
      fullPath: '/settings/compliance-frameworks'
      preLoaderRoute: typeof AuthenticatedSettingsComplianceFrameworksRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/bcp-review-settings': {
      id: '/_authenticated/settings/bcp-review-settings'
      path: '/bcp-review-settings'
      fullPath: '/settings/bcp-review-settings'
      preLoaderRoute: typeof AuthenticatedSettingsBcpReviewSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/bcp-exercise-settings': {
      id: '/_authenticated/settings/bcp-exercise-settings'
      path: '/bcp-exercise-settings'
      fullPath: '/settings/bcp-exercise-settings'
      preLoaderRoute: typeof AuthenticatedSettingsBcpExerciseSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/auditors': {
      id: '/_authenticated/settings/auditors'
      path: '/auditors'
      fullPath: '/settings/auditors'
      preLoaderRoute: typeof AuthenticatedSettingsAuditorsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit-webhooks': {
      id: '/_authenticated/settings/audit-webhooks'
      path: '/audit-webhooks'
      fullPath: '/settings/audit-webhooks'
      preLoaderRoute: typeof AuthenticatedSettingsAuditWebhooksRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit-settings': {
      id: '/_authenticated/settings/audit-settings'
      path: '/audit-settings'
      fullPath: '/settings/audit-settings'
      preLoaderRoute: typeof AuthenticatedSettingsAuditSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit-log': {
      id: '/_authenticated/settings/audit-log'
      path: '/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit-alerts': {
      id: '/_authenticated/settings/audit-alerts'
      path: '/audit-alerts'
      fullPath: '/settings/audit-alerts'
      preLoaderRoute: typeof AuthenticatedSettingsAuditAlertsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/asset-tags': {
      id: '/_authenticated/settings/asset-tags'
      path: '/asset-tags'
      fullPath: '/settings/asset-tags'
      preLoaderRoute: typeof AuthenticatedSettingsAssetTagsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/asset-custom-fields': {
      id: '/_authenticated/settings/asset-custom-fields'
      path: '/asset-custom-fields'
      fullPath: '/settings/asset-custom-fields'
      preLoaderRoute: typeof AuthenticatedSettingsAssetCustomFieldsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/asset-connectors': {
      id: '/_authenticated/settings/asset-connectors'
      path: '/asset-connectors'
      fullPath: '/settings/asset-connectors'
      preLoaderRoute: typeof AuthenticatedSettingsAssetConnectorsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/asset-categories': {
      id: '/_authenticated/settings/asset-categories'
      path: '/asset-categories'
      fullPath: '/settings/asset-categories'
      preLoaderRoute: typeof AuthenticatedSettingsAssetCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ai-settings': {
      id: '/_authenticated/settings/ai-settings'
      path: '/ai-settings'
      fullPath: '/settings/ai-settings'
      preLoaderRoute: typeof AuthenticatedSettingsAiSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ai-conversations': {
      id: '/_authenticated/settings/ai-conversations'
      path: '/ai-conversations'
      fullPath: '/settings/ai-conversations'
      preLoaderRoute: typeof AuthenticatedSettingsAiConversationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/access-log': {
      id: '/_authenticated/settings/access-log'
      path: '/access-log'
      fullPath: '/settings/access-log'
      preLoaderRoute: typeof AuthenticatedSettingsAccessLogRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/risks/new': {
      id: '/_authenticated/risks/new'
      path: '/risks/new'
      fullPath: '/risks/new'
      preLoaderRoute: typeof AuthenticatedRisksNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risks/heatmap': {
      id: '/_authenticated/risks/heatmap'
      path: '/risks/heatmap'
      fullPath: '/risks/heatmap'
      preLoaderRoute: typeof AuthenticatedRisksHeatmapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risks/dashboard': {
      id: '/_authenticated/risks/dashboard'
      path: '/risks/dashboard'
      fullPath: '/risks/dashboard'
      preLoaderRoute: typeof AuthenticatedRisksDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risks/ai-suggestions': {
      id: '/_authenticated/risks/ai-suggestions'
      path: '/risks/ai-suggestions'
      fullPath: '/risks/ai-suggestions'
      preLoaderRoute: typeof AuthenticatedRisksAiSuggestionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risks/$riskId': {
      id: '/_authenticated/risks/$riskId'
      path: '/risks/$riskId'
      fullPath: '/risks/$riskId'
      preLoaderRoute: typeof AuthenticatedRisksRiskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/procedures/$procedureId': {
      id: '/_authenticated/procedures/$procedureId'
      path: '/procedures/$procedureId'
      fullPath: '/procedures/$procedureId'
      preLoaderRoute: typeof AuthenticatedProceduresProcedureIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/wizard': {
      id: '/_authenticated/policies/wizard'
      path: '/policies/wizard'
      fullPath: '/policies/wizard'
      preLoaderRoute: typeof AuthenticatedPoliciesWizardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/documents': {
      id: '/_authenticated/policies/documents'
      path: '/policies/documents'
      fullPath: '/policies/documents'
      preLoaderRoute: typeof AuthenticatedPoliciesDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/create': {
      id: '/_authenticated/policies/create'
      path: '/policies/create'
      fullPath: '/policies/create'
      preLoaderRoute: typeof AuthenticatedPoliciesCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/compliance-dashboard': {
      id: '/_authenticated/policies/compliance-dashboard'
      path: '/policies/compliance-dashboard'
      fullPath: '/policies/compliance-dashboard'
      preLoaderRoute: typeof AuthenticatedPoliciesComplianceDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/$policyId': {
      id: '/_authenticated/policies/$policyId'
      path: '/policies/$policyId'
      fullPath: '/policies/$policyId'
      preLoaderRoute: typeof AuthenticatedPoliciesPolicyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/nis2/supply-chain-security': {
      id: '/_authenticated/nis2/supply-chain-security'
      path: '/supply-chain-security'
      fullPath: '/nis2/supply-chain-security'
      preLoaderRoute: typeof AuthenticatedNis2SupplyChainSecurityRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/self-assessment': {
      id: '/_authenticated/nis2/self-assessment'
      path: '/self-assessment'
      fullPath: '/nis2/self-assessment'
      preLoaderRoute: typeof AuthenticatedNis2SelfAssessmentRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/risk-management': {
      id: '/_authenticated/nis2/risk-management'
      path: '/risk-management'
      fullPath: '/nis2/risk-management'
      preLoaderRoute: typeof AuthenticatedNis2RiskManagementRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/policy-governance': {
      id: '/_authenticated/nis2/policy-governance'
      path: '/policy-governance'
      fullPath: '/nis2/policy-governance'
      preLoaderRoute: typeof AuthenticatedNis2PolicyGovernanceRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/policies-governance': {
      id: '/_authenticated/nis2/policies-governance'
      path: '/policies-governance'
      fullPath: '/nis2/policies-governance'
      preLoaderRoute: typeof AuthenticatedNis2PoliciesGovernanceRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/overview': {
      id: '/_authenticated/nis2/overview'
      path: '/overview'
      fullPath: '/nis2/overview'
      preLoaderRoute: typeof AuthenticatedNis2OverviewRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/onboarding': {
      id: '/_authenticated/nis2/onboarding'
      path: '/onboarding'
      fullPath: '/nis2/onboarding'
      preLoaderRoute: typeof AuthenticatedNis2OnboardingRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/measure-d': {
      id: '/_authenticated/nis2/measure-d'
      path: '/measure-d'
      fullPath: '/nis2/measure-d'
      preLoaderRoute: typeof AuthenticatedNis2MeasureDRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/measure-a': {
      id: '/_authenticated/nis2/measure-a'
      path: '/measure-a'
      fullPath: '/nis2/measure-a'
      preLoaderRoute: typeof AuthenticatedNis2MeasureARouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/knowledge-base': {
      id: '/_authenticated/nis2/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/nis2/knowledge-base'
      preLoaderRoute: typeof AuthenticatedNis2KnowledgeBaseRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/isms': {
      id: '/_authenticated/nis2/isms'
      path: '/isms'
      fullPath: '/nis2/isms'
      preLoaderRoute: typeof AuthenticatedNis2IsmsRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/incident-management': {
      id: '/_authenticated/nis2/incident-management'
      path: '/incident-management'
      fullPath: '/nis2/incident-management'
      preLoaderRoute: typeof AuthenticatedNis2IncidentManagementRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/human-resources-security': {
      id: '/_authenticated/nis2/human-resources-security'
      path: '/human-resources-security'
      fullPath: '/nis2/human-resources-security'
      preLoaderRoute: typeof AuthenticatedNis2HumanResourcesSecurityRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/hr-training': {
      id: '/_authenticated/nis2/hr-training'
      path: '/hr-training'
      fullPath: '/nis2/hr-training'
      preLoaderRoute: typeof AuthenticatedNis2HrTrainingRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/gaps': {
      id: '/_authenticated/nis2/gaps'
      path: '/gaps'
      fullPath: '/nis2/gaps'
      preLoaderRoute: typeof AuthenticatedNis2GapsRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/gap-analysis': {
      id: '/_authenticated/nis2/gap-analysis'
      path: '/gap-analysis'
      fullPath: '/nis2/gap-analysis'
      preLoaderRoute: typeof AuthenticatedNis2GapAnalysisRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/evidence': {
      id: '/_authenticated/nis2/evidence'
      path: '/evidence'
      fullPath: '/nis2/evidence'
      preLoaderRoute: typeof AuthenticatedNis2EvidenceRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/entity-classification': {
      id: '/_authenticated/nis2/entity-classification'
      path: '/entity-classification'
      fullPath: '/nis2/entity-classification'
      preLoaderRoute: typeof AuthenticatedNis2EntityClassificationRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/dashboard': {
      id: '/_authenticated/nis2/dashboard'
      path: '/dashboard'
      fullPath: '/nis2/dashboard'
      preLoaderRoute: typeof AuthenticatedNis2DashboardRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/business-continuity': {
      id: '/_authenticated/nis2/business-continuity'
      path: '/business-continuity'
      fullPath: '/nis2/business-continuity'
      preLoaderRoute: typeof AuthenticatedNis2BusinessContinuityRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/assets-measures': {
      id: '/_authenticated/nis2/assets-measures'
      path: '/assets-measures'
      fullPath: '/nis2/assets-measures'
      preLoaderRoute: typeof AuthenticatedNis2AssetsMeasuresRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/assets-and-measures': {
      id: '/_authenticated/nis2/assets-and-measures'
      path: '/assets-and-measures'
      fullPath: '/nis2/assets-and-measures'
      preLoaderRoute: typeof AuthenticatedNis2AssetsAndMeasuresRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/asset-register': {
      id: '/_authenticated/nis2/asset-register'
      path: '/asset-register'
      fullPath: '/nis2/asset-register'
      preLoaderRoute: typeof AuthenticatedNis2AssetRegisterRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/incidents/subsidiaries': {
      id: '/_authenticated/incidents/subsidiaries'
      path: '/incidents/subsidiaries'
      fullPath: '/incidents/subsidiaries'
      preLoaderRoute: typeof AuthenticatedIncidentsSubsidiariesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/settings': {
      id: '/_authenticated/incidents/settings'
      path: '/incidents/settings'
      fullPath: '/incidents/settings'
      preLoaderRoute: typeof AuthenticatedIncidentsSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/quick-report': {
      id: '/_authenticated/incidents/quick-report'
      path: '/incidents/quick-report'
      fullPath: '/incidents/quick-report'
      preLoaderRoute: typeof AuthenticatedIncidentsQuickReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/new': {
      id: '/_authenticated/incidents/new'
      path: '/incidents/new'
      fullPath: '/incidents/new'
      preLoaderRoute: typeof AuthenticatedIncidentsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/dashboard': {
      id: '/_authenticated/incidents/dashboard'
      path: '/incidents/dashboard'
      fullPath: '/incidents/dashboard'
      preLoaderRoute: typeof AuthenticatedIncidentsDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/$incidentId': {
      id: '/_authenticated/incidents/$incidentId'
      path: '/incidents/$incidentId'
      fullPath: '/incidents/$incidentId'
      preLoaderRoute: typeof AuthenticatedIncidentsIncidentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help-centre/regulations': {
      id: '/_authenticated/help-centre/regulations'
      path: '/regulations'
      fullPath: '/help-centre/regulations'
      preLoaderRoute: typeof AuthenticatedHelpCentreRegulationsRouteImport
      parentRoute: typeof AuthenticatedHelpCentreRoute
    }
    '/_authenticated/help-centre/platform-guides': {
      id: '/_authenticated/help-centre/platform-guides'
      path: '/platform-guides'
      fullPath: '/help-centre/platform-guides'
      preLoaderRoute: typeof AuthenticatedHelpCentrePlatformGuidesRouteImport
      parentRoute: typeof AuthenticatedHelpCentreRoute
    }
    '/_authenticated/ghg/yoy-comparison': {
      id: '/_authenticated/ghg/yoy-comparison'
      path: '/yoy-comparison'
      fullPath: '/ghg/yoy-comparison'
      preLoaderRoute: typeof AuthenticatedGhgYoyComparisonRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/waste': {
      id: '/_authenticated/ghg/waste'
      path: '/waste'
      fullPath: '/ghg/waste'
      preLoaderRoute: typeof AuthenticatedGhgWasteRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/travel-import': {
      id: '/_authenticated/ghg/travel-import'
      path: '/travel-import'
      fullPath: '/ghg/travel-import'
      preLoaderRoute: typeof AuthenticatedGhgTravelImportRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/tasks': {
      id: '/_authenticated/ghg/tasks'
      path: '/tasks'
      fullPath: '/ghg/tasks'
      preLoaderRoute: typeof AuthenticatedGhgTasksRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3-screening': {
      id: '/_authenticated/ghg/scope3-screening'
      path: '/scope3-screening'
      fullPath: '/ghg/scope3-screening'
      preLoaderRoute: typeof AuthenticatedGhgScope3ScreeningRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope2': {
      id: '/_authenticated/ghg/scope2'
      path: '/scope2'
      fullPath: '/ghg/scope2'
      preLoaderRoute: typeof AuthenticatedGhgScope2RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope1': {
      id: '/_authenticated/ghg/scope1'
      path: '/scope1'
      fullPath: '/ghg/scope1'
      preLoaderRoute: typeof AuthenticatedGhgScope1RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/report': {
      id: '/_authenticated/ghg/report'
      path: '/report'
      fullPath: '/ghg/report'
      preLoaderRoute: typeof AuthenticatedGhgReportRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/recalculations': {
      id: '/_authenticated/ghg/recalculations'
      path: '/recalculations'
      fullPath: '/ghg/recalculations'
      preLoaderRoute: typeof AuthenticatedGhgRecalculationsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/protocol-compliance': {
      id: '/_authenticated/ghg/protocol-compliance'
      path: '/protocol-compliance'
      fullPath: '/ghg/protocol-compliance'
      preLoaderRoute: typeof AuthenticatedGhgProtocolComplianceRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/policies': {
      id: '/_authenticated/ghg/policies'
      path: '/policies'
      fullPath: '/ghg/policies'
      preLoaderRoute: typeof AuthenticatedGhgPoliciesRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/overview': {
      id: '/_authenticated/ghg/overview'
      path: '/overview'
      fullPath: '/ghg/overview'
      preLoaderRoute: typeof AuthenticatedGhgOverviewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/net-zero': {
      id: '/_authenticated/ghg/net-zero'
      path: '/net-zero'
      fullPath: '/ghg/net-zero'
      preLoaderRoute: typeof AuthenticatedGhgNetZeroRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/market-instruments': {
      id: '/_authenticated/ghg/market-instruments'
      path: '/market-instruments'
      fullPath: '/ghg/market-instruments'
      preLoaderRoute: typeof AuthenticatedGhgMarketInstrumentsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/iso14064-compliance': {
      id: '/_authenticated/ghg/iso14064-compliance'
      path: '/iso14064-compliance'
      fullPath: '/ghg/iso14064-compliance'
      preLoaderRoute: typeof AuthenticatedGhgIso14064ComplianceRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/industry-comparison': {
      id: '/_authenticated/ghg/industry-comparison'
      path: '/industry-comparison'
      fullPath: '/ghg/industry-comparison'
      preLoaderRoute: typeof AuthenticatedGhgIndustryComparisonRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/gap-analysis': {
      id: '/_authenticated/ghg/gap-analysis'
      path: '/gap-analysis'
      fullPath: '/ghg/gap-analysis'
      preLoaderRoute: typeof AuthenticatedGhgGapAnalysisRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/emissions': {
      id: '/_authenticated/ghg/emissions'
      path: '/emissions'
      fullPath: '/ghg/emissions'
      preLoaderRoute: typeof AuthenticatedGhgEmissionsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/emission-insights': {
      id: '/_authenticated/ghg/emission-insights'
      path: '/emission-insights'
      fullPath: '/ghg/emission-insights'
      preLoaderRoute: typeof AuthenticatedGhgEmissionInsightsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/emission-factors': {
      id: '/_authenticated/ghg/emission-factors'
      path: '/emission-factors'
      fullPath: '/ghg/emission-factors'
      preLoaderRoute: typeof AuthenticatedGhgEmissionFactorsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/data-quality': {
      id: '/_authenticated/ghg/data-quality'
      path: '/data-quality'
      fullPath: '/ghg/data-quality'
      preLoaderRoute: typeof AuthenticatedGhgDataQualityRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/dashboard': {
      id: '/_authenticated/ghg/dashboard'
      path: '/dashboard'
      fullPath: '/ghg/dashboard'
      preLoaderRoute: typeof AuthenticatedGhgDashboardRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/commuting': {
      id: '/_authenticated/ghg/commuting'
      path: '/commuting'
      fullPath: '/ghg/commuting'
      preLoaderRoute: typeof AuthenticatedGhgCommutingRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/collect': {
      id: '/_authenticated/ghg/collect'
      path: '/collect'
      fullPath: '/ghg/collect'
      preLoaderRoute: typeof AuthenticatedGhgCollectRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/cdp-questionnaire': {
      id: '/_authenticated/ghg/cdp-questionnaire'
      path: '/cdp-questionnaire'
      fullPath: '/ghg/cdp-questionnaire'
      preLoaderRoute: typeof AuthenticatedGhgCdpQuestionnaireRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/business-travel': {
      id: '/_authenticated/ghg/business-travel'
      path: '/business-travel'
      fullPath: '/ghg/business-travel'
      preLoaderRoute: typeof AuthenticatedGhgBusinessTravelRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/best-practices': {
      id: '/_authenticated/ghg/best-practices'
      path: '/best-practices'
      fullPath: '/ghg/best-practices'
      preLoaderRoute: typeof AuthenticatedGhgBestPracticesRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/audit': {
      id: '/_authenticated/ghg/audit'
      path: '/audit'
      fullPath: '/ghg/audit'
      preLoaderRoute: typeof AuthenticatedGhgAuditRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-groups': {
      id: '/_authenticated/ghg/activity-groups'
      path: '/activity-groups'
      fullPath: '/ghg/activity-groups'
      preLoaderRoute: typeof AuthenticatedGhgActivityGroupsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/external-reporting/$reportId': {
      id: '/_authenticated/external-reporting/$reportId'
      path: '/external-reporting/$reportId'
      fullPath: '/external-reporting/$reportId'
      preLoaderRoute: typeof AuthenticatedExternalReportingReportIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/evidence/repository': {
      id: '/_authenticated/evidence/repository'
      path: '/evidence/repository'
      fullPath: '/evidence/repository'
      preLoaderRoute: typeof AuthenticatedEvidenceRepositoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/evidence/logs': {
      id: '/_authenticated/evidence/logs'
      path: '/evidence/logs'
      fullPath: '/evidence/logs'
      preLoaderRoute: typeof AuthenticatedEvidenceLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/evidence/$evidenceId': {
      id: '/_authenticated/evidence/$evidenceId'
      path: '/evidence/$evidenceId'
      fullPath: '/evidence/$evidenceId'
      preLoaderRoute: typeof AuthenticatedEvidenceEvidenceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/eu-taxonomy/$section': {
      id: '/_authenticated/eu-taxonomy/$section'
      path: '/$section'
      fullPath: '/eu-taxonomy/$section'
      preLoaderRoute: typeof AuthenticatedEuTaxonomySectionRouteImport
      parentRoute: typeof AuthenticatedEuTaxonomyRoute
    }
    '/_authenticated/esg/$section': {
      id: '/_authenticated/esg/$section'
      path: '/$section'
      fullPath: '/esg/$section'
      preLoaderRoute: typeof AuthenticatedEsgSectionRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/employees/new': {
      id: '/_authenticated/employees/new'
      path: '/employees/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof AuthenticatedEmployeesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/import': {
      id: '/_authenticated/employees/import'
      path: '/employees/import'
      fullPath: '/employees/import'
      preLoaderRoute: typeof AuthenticatedEmployeesImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/$employeeId': {
      id: '/_authenticated/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AuthenticatedEmployeesEmployeeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/validation-errors': {
      id: '/_authenticated/datahub/validation-errors'
      path: '/datahub/validation-errors'
      fullPath: '/datahub/validation-errors'
      preLoaderRoute: typeof AuthenticatedDatahubValidationErrorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/upload': {
      id: '/_authenticated/datahub/upload'
      path: '/datahub/upload'
      fullPath: '/datahub/upload'
      preLoaderRoute: typeof AuthenticatedDatahubUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/templates': {
      id: '/_authenticated/datahub/templates'
      path: '/datahub/templates'
      fullPath: '/datahub/templates'
      preLoaderRoute: typeof AuthenticatedDatahubTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/quality-issues': {
      id: '/_authenticated/datahub/quality-issues'
      path: '/datahub/quality-issues'
      fullPath: '/datahub/quality-issues'
      preLoaderRoute: typeof AuthenticatedDatahubQualityIssuesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/quality-dashboard': {
      id: '/_authenticated/datahub/quality-dashboard'
      path: '/datahub/quality-dashboard'
      fullPath: '/datahub/quality-dashboard'
      preLoaderRoute: typeof AuthenticatedDatahubQualityDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/periods': {
      id: '/_authenticated/datahub/periods'
      path: '/datahub/periods'
      fullPath: '/datahub/periods'
      preLoaderRoute: typeof AuthenticatedDatahubPeriodsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/my-entries': {
      id: '/_authenticated/datahub/my-entries'
      path: '/datahub/my-entries'
      fullPath: '/datahub/my-entries'
      preLoaderRoute: typeof AuthenticatedDatahubMyEntriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/entry': {
      id: '/_authenticated/datahub/entry'
      path: '/datahub/entry'
      fullPath: '/datahub/entry'
      preLoaderRoute: typeof AuthenticatedDatahubEntryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/documents': {
      id: '/_authenticated/datahub/documents'
      path: '/datahub/documents'
      fullPath: '/datahub/documents'
      preLoaderRoute: typeof AuthenticatedDatahubDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/consolidated': {
      id: '/_authenticated/datahub/consolidated'
      path: '/datahub/consolidated'
      fullPath: '/datahub/consolidated'
      preLoaderRoute: typeof AuthenticatedDatahubConsolidatedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/comparison': {
      id: '/_authenticated/datahub/comparison'
      path: '/datahub/comparison'
      fullPath: '/datahub/comparison'
      preLoaderRoute: typeof AuthenticatedDatahubComparisonRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/audit': {
      id: '/_authenticated/datahub/audit'
      path: '/datahub/audit'
      fullPath: '/datahub/audit'
      preLoaderRoute: typeof AuthenticatedDatahubAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/controls/$controlId': {
      id: '/_authenticated/controls/$controlId'
      path: '/$controlId'
      fullPath: '/controls/$controlId'
      preLoaderRoute: typeof AuthenticatedControlsControlIdRouteImport
      parentRoute: typeof AuthenticatedControlsRoute
    }
    '/_authenticated/compliance/alerts': {
      id: '/_authenticated/compliance/alerts'
      path: '/compliance/alerts'
      fullPath: '/compliance/alerts'
      preLoaderRoute: typeof AuthenticatedComplianceAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bcp/plans': {
      id: '/_authenticated/bcp/plans'
      path: '/plans'
      fullPath: '/bcp/plans'
      preLoaderRoute: typeof AuthenticatedBcpPlansRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/findings': {
      id: '/_authenticated/bcp/findings'
      path: '/findings'
      fullPath: '/bcp/findings'
      preLoaderRoute: typeof AuthenticatedBcpFindingsRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/dashboard': {
      id: '/_authenticated/bcp/dashboard'
      path: '/dashboard'
      fullPath: '/bcp/dashboard'
      preLoaderRoute: typeof AuthenticatedBcpDashboardRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/continuity': {
      id: '/_authenticated/bcp/continuity'
      path: '/continuity'
      fullPath: '/bcp/continuity'
      preLoaderRoute: typeof AuthenticatedBcpContinuityRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/bia': {
      id: '/_authenticated/bcp/bia'
      path: '/bia'
      fullPath: '/bcp/bia'
      preLoaderRoute: typeof AuthenticatedBcpBiaRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/bcp': {
      id: '/_authenticated/bcp/bcp'
      path: '/bcp'
      fullPath: '/bcp/bcp'
      preLoaderRoute: typeof AuthenticatedBcpBcpRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/audit/reports': {
      id: '/_authenticated/audit/reports'
      path: '/audit/reports'
      fullPath: '/audit/reports'
      preLoaderRoute: typeof AuthenticatedAuditReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/findings': {
      id: '/_authenticated/audit/findings'
      path: '/audit/findings'
      fullPath: '/audit/findings'
      preLoaderRoute: typeof AuthenticatedAuditFindingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/evidence-upload': {
      id: '/_authenticated/audit/evidence-upload'
      path: '/audit/evidence-upload'
      fullPath: '/audit/evidence-upload'
      preLoaderRoute: typeof AuthenticatedAuditEvidenceUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/evidence-library': {
      id: '/_authenticated/audit/evidence-library'
      path: '/audit/evidence-library'
      fullPath: '/audit/evidence-library'
      preLoaderRoute: typeof AuthenticatedAuditEvidenceLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/calendar': {
      id: '/_authenticated/audit/calendar'
      path: '/audit/calendar'
      fullPath: '/audit/calendar'
      preLoaderRoute: typeof AuthenticatedAuditCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/import': {
      id: '/_authenticated/assets/import'
      path: '/assets/import'
      fullPath: '/assets/import'
      preLoaderRoute: typeof AuthenticatedAssetsImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/$assetId': {
      id: '/_authenticated/assets/$assetId'
      path: '/assets/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/ghg-overview': {
      id: '/_authenticated/analytics/ghg-overview'
      path: '/ghg-overview'
      fullPath: '/analytics/ghg-overview'
      preLoaderRoute: typeof AuthenticatedAnalyticsGhgOverviewRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/ai/usage': {
      id: '/_authenticated/ai/usage'
      path: '/ai/usage'
      fullPath: '/ai/usage'
      preLoaderRoute: typeof AuthenticatedAiUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/quality': {
      id: '/_authenticated/ai/quality'
      path: '/ai/quality'
      fullPath: '/ai/quality'
      preLoaderRoute: typeof AuthenticatedAiQualityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/insights': {
      id: '/_authenticated/ai/insights'
      path: '/ai/insights'
      fullPath: '/ai/insights'
      preLoaderRoute: typeof AuthenticatedAiInsightsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/documents': {
      id: '/_authenticated/ai/documents'
      path: '/ai/documents'
      fullPath: '/ai/documents'
      preLoaderRoute: typeof AuthenticatedAiDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/system-prompts': {
      id: '/_authenticated/admin/system-prompts'
      path: '/admin/system-prompts'
      fullPath: '/admin/system-prompts'
      preLoaderRoute: typeof AuthenticatedAdminSystemPromptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/organizations': {
      id: '/_authenticated/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/llm-settings': {
      id: '/_authenticated/admin/llm-settings'
      path: '/admin/llm-settings'
      fullPath: '/admin/llm-settings'
      preLoaderRoute: typeof AuthenticatedAdminLlmSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/knowledge-bases': {
      id: '/_authenticated/admin/knowledge-bases'
      path: '/admin/knowledge-bases'
      fullPath: '/admin/knowledge-bases'
      preLoaderRoute: typeof AuthenticatedAdminKnowledgeBasesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/ai-costs': {
      id: '/_authenticated/admin/ai-costs'
      path: '/admin/ai-costs'
      fullPath: '/admin/ai-costs'
      preLoaderRoute: typeof AuthenticatedAdminAiCostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/portal/auth/forgot-password/': {
      id: '/portal/auth/forgot-password/'
      path: '/portal/auth/forgot-password'
      fullPath: '/portal/auth/forgot-password'
      preLoaderRoute: typeof PortalAuthForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/vulnerabilities/approvals/': {
      id: '/_authenticated/vulnerabilities/approvals/'
      path: '/vulnerabilities/approvals'
      fullPath: '/vulnerabilities/approvals'
      preLoaderRoute: typeof AuthenticatedVulnerabilitiesApprovalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/': {
      id: '/_authenticated/tasks/playbooks/'
      path: '/tasks/playbooks'
      fullPath: '/tasks/playbooks'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/schedules/': {
      id: '/_authenticated/surveys/schedules/'
      path: '/surveys/schedules'
      fullPath: '/surveys/schedules'
      preLoaderRoute: typeof AuthenticatedSurveysSchedulesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/campaigns/': {
      id: '/_authenticated/surveys/campaigns/'
      path: '/surveys/campaigns'
      fullPath: '/surveys/campaigns'
      preLoaderRoute: typeof AuthenticatedSurveysCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/security/': {
      id: '/_authenticated/settings/security/'
      path: '/'
      fullPath: '/settings/security/'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsSecurityRoute
    }
    '/_authenticated/risks/approvals/': {
      id: '/_authenticated/risks/approvals/'
      path: '/risks/approvals'
      fullPath: '/risks/approvals'
      preLoaderRoute: typeof AuthenticatedRisksApprovalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/nis2/reports/': {
      id: '/_authenticated/nis2/reports/'
      path: '/reports'
      fullPath: '/nis2/reports'
      preLoaderRoute: typeof AuthenticatedNis2ReportsIndexRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/measures/': {
      id: '/_authenticated/nis2/measures/'
      path: '/measures'
      fullPath: '/nis2/measures'
      preLoaderRoute: typeof AuthenticatedNis2MeasuresIndexRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/inspection-preparation/': {
      id: '/_authenticated/nis2/inspection-preparation/'
      path: '/inspection-preparation'
      fullPath: '/nis2/inspection-preparation'
      preLoaderRoute: typeof AuthenticatedNis2InspectionPreparationIndexRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/ghg/verification/': {
      id: '/_authenticated/ghg/verification/'
      path: '/verification'
      fullPath: '/ghg/verification'
      preLoaderRoute: typeof AuthenticatedGhgVerificationIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/verification-statements/': {
      id: '/_authenticated/ghg/verification-statements/'
      path: '/verification-statements'
      fullPath: '/ghg/verification-statements'
      preLoaderRoute: typeof AuthenticatedGhgVerificationStatementsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/third-party-verification/': {
      id: '/_authenticated/ghg/third-party-verification/'
      path: '/third-party-verification'
      fullPath: '/ghg/third-party-verification'
      preLoaderRoute: typeof AuthenticatedGhgThirdPartyVerificationIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/targets/': {
      id: '/_authenticated/ghg/targets/'
      path: '/targets'
      fullPath: '/ghg/targets'
      preLoaderRoute: typeof AuthenticatedGhgTargetsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/setup/': {
      id: '/_authenticated/ghg/setup/'
      path: '/setup'
      fullPath: '/ghg/setup'
      preLoaderRoute: typeof AuthenticatedGhgSetupIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/settings/': {
      id: '/_authenticated/ghg/settings/'
      path: '/settings'
      fullPath: '/ghg/settings'
      preLoaderRoute: typeof AuthenticatedGhgSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scenarios/': {
      id: '/_authenticated/ghg/scenarios/'
      path: '/scenarios'
      fullPath: '/ghg/scenarios'
      preLoaderRoute: typeof AuthenticatedGhgScenariosIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/reports/': {
      id: '/_authenticated/ghg/reports/'
      path: '/reports'
      fullPath: '/ghg/reports'
      preLoaderRoute: typeof AuthenticatedGhgReportsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/reduction-initiatives/': {
      id: '/_authenticated/ghg/reduction-initiatives/'
      path: '/reduction-initiatives'
      fullPath: '/ghg/reduction-initiatives'
      preLoaderRoute: typeof AuthenticatedGhgReductionInitiativesIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/recalculations/': {
      id: '/_authenticated/ghg/recalculations/'
      path: '/'
      fullPath: '/ghg/recalculations/'
      preLoaderRoute: typeof AuthenticatedGhgRecalculationsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRecalculationsRoute
    }
    '/_authenticated/ghg/integrations/': {
      id: '/_authenticated/ghg/integrations/'
      path: '/integrations'
      fullPath: '/ghg/integrations'
      preLoaderRoute: typeof AuthenticatedGhgIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/exports/': {
      id: '/_authenticated/ghg/exports/'
      path: '/exports'
      fullPath: '/ghg/exports'
      preLoaderRoute: typeof AuthenticatedGhgExportsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/commuting-surveys/': {
      id: '/_authenticated/ghg/commuting-surveys/'
      path: '/commuting-surveys'
      fullPath: '/ghg/commuting-surveys'
      preLoaderRoute: typeof AuthenticatedGhgCommutingSurveysIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/approvals/': {
      id: '/_authenticated/ghg/approvals/'
      path: '/approvals'
      fullPath: '/ghg/approvals'
      preLoaderRoute: typeof AuthenticatedGhgApprovalsIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-data/': {
      id: '/_authenticated/ghg/activity-data/'
      path: '/activity-data'
      fullPath: '/ghg/activity-data'
      preLoaderRoute: typeof AuthenticatedGhgActivityDataIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/esg/onboarding/': {
      id: '/_authenticated/esg/onboarding/'
      path: '/onboarding'
      fullPath: '/esg/onboarding'
      preLoaderRoute: typeof AuthenticatedEsgOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/esg/double-materiality/': {
      id: '/_authenticated/esg/double-materiality/'
      path: '/double-materiality'
      fullPath: '/esg/double-materiality'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityIndexRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/employees/$employeeId/': {
      id: '/_authenticated/employees/$employeeId/'
      path: '/'
      fullPath: '/employees/$employeeId/'
      preLoaderRoute: typeof AuthenticatedEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof AuthenticatedEmployeesEmployeeIdRoute
    }
    '/_authenticated/datahub/integrations/': {
      id: '/_authenticated/datahub/integrations/'
      path: '/datahub/integrations'
      fullPath: '/datahub/integrations'
      preLoaderRoute: typeof AuthenticatedDatahubIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/datapoints/': {
      id: '/_authenticated/datahub/datapoints/'
      path: '/datahub/datapoints'
      fullPath: '/datahub/datapoints'
      preLoaderRoute: typeof AuthenticatedDatahubDatapointsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/collections/': {
      id: '/_authenticated/datahub/collections/'
      path: '/datahub/collections'
      fullPath: '/datahub/collections'
      preLoaderRoute: typeof AuthenticatedDatahubCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bcp/resources/': {
      id: '/_authenticated/bcp/resources/'
      path: '/resources'
      fullPath: '/bcp/resources'
      preLoaderRoute: typeof AuthenticatedBcpResourcesIndexRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/plans/': {
      id: '/_authenticated/bcp/plans/'
      path: '/'
      fullPath: '/bcp/plans/'
      preLoaderRoute: typeof AuthenticatedBcpPlansIndexRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/exercises/': {
      id: '/_authenticated/bcp/exercises/'
      path: '/exercises'
      fullPath: '/bcp/exercises'
      preLoaderRoute: typeof AuthenticatedBcpExercisesIndexRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/audit/evidence/': {
      id: '/_authenticated/audit/evidence/'
      path: '/audit/evidence'
      fullPath: '/audit/evidence'
      preLoaderRoute: typeof AuthenticatedAuditEvidenceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/audits/': {
      id: '/_authenticated/audit/audits/'
      path: '/audit/audits'
      fullPath: '/audit/audits'
      preLoaderRoute: typeof AuthenticatedAuditAuditsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/report-studio/': {
      id: '/_authenticated/analytics/report-studio/'
      path: '/report-studio'
      fullPath: '/analytics/report-studio'
      preLoaderRoute: typeof AuthenticatedAnalyticsReportStudioIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/dashboards/': {
      id: '/_authenticated/analytics/dashboards/'
      path: '/dashboards'
      fullPath: '/analytics/dashboards'
      preLoaderRoute: typeof AuthenticatedAnalyticsDashboardsIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/ai/scans/': {
      id: '/_authenticated/ai/scans/'
      path: '/ai/scans'
      fullPath: '/ai/scans'
      preLoaderRoute: typeof AuthenticatedAiScansIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/documents/': {
      id: '/_authenticated/ai/documents/'
      path: '/'
      fullPath: '/ai/documents/'
      preLoaderRoute: typeof AuthenticatedAiDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedAiDocumentsRoute
    }
    '/portal/auth/reset-password/$token': {
      id: '/portal/auth/reset-password/$token'
      path: '/portal/auth/reset-password/$token'
      fullPath: '/portal/auth/reset-password/$token'
      preLoaderRoute: typeof PortalAuthResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/auth/create-account/$token': {
      id: '/portal/auth/create-account/$token'
      path: '/portal/auth/create-account/$token'
      fullPath: '/portal/auth/create-account/$token'
      preLoaderRoute: typeof PortalAuthCreateAccountTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/tasks': {
      id: '/auditor/access/$accessId/tasks'
      path: '/auditor/access/$accessId/tasks'
      fullPath: '/auditor/access/$accessId/tasks'
      preLoaderRoute: typeof AuditorAccessAccessIdTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/nis2': {
      id: '/auditor/access/$accessId/nis2'
      path: '/auditor/access/$accessId/nis2'
      fullPath: '/auditor/access/$accessId/nis2'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/controls': {
      id: '/auditor/access/$accessId/controls'
      path: '/auditor/access/$accessId/controls'
      fullPath: '/auditor/access/$accessId/controls'
      preLoaderRoute: typeof AuditorAccessAccessIdControlsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/bcp': {
      id: '/auditor/access/$accessId/bcp'
      path: '/auditor/access/$accessId/bcp'
      fullPath: '/auditor/access/$accessId/bcp'
      preLoaderRoute: typeof AuditorAccessAccessIdBcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/audit': {
      id: '/auditor/access/$accessId/audit'
      path: '/auditor/access/$accessId/audit'
      fullPath: '/auditor/access/$accessId/audit'
      preLoaderRoute: typeof AuditorAccessAccessIdAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auditor/access/$accessId/assets': {
      id: '/auditor/access/$accessId/assets'
      path: '/auditor/access/$accessId/assets'
      fullPath: '/auditor/access/$accessId/assets'
      preLoaderRoute: typeof AuditorAccessAccessIdAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workforce-readiness/training-register/$trainingId': {
      id: '/_authenticated/workforce-readiness/training-register/$trainingId'
      path: '/$trainingId'
      fullPath: '/workforce-readiness/training-register/$trainingId'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRouteImport
      parentRoute: typeof AuthenticatedWorkforceReadinessTrainingRegisterRoute
    }
    '/_authenticated/workforce-readiness/awareness-campaigns/$campaignId': {
      id: '/_authenticated/workforce-readiness/awareness-campaigns/$campaignId'
      path: '/$campaignId'
      fullPath: '/workforce-readiness/awareness-campaigns/$campaignId'
      preLoaderRoute: typeof AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRoute
    }
    '/_authenticated/tasks/playbooks/activate': {
      id: '/_authenticated/tasks/playbooks/activate'
      path: '/tasks/playbooks/activate'
      fullPath: '/tasks/playbooks/activate'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksActivateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/console/approvals': {
      id: '/_authenticated/tasks/console/approvals'
      path: '/approvals'
      fullPath: '/tasks/console/approvals'
      preLoaderRoute: typeof AuthenticatedTasksConsoleApprovalsRouteImport
      parentRoute: typeof AuthenticatedTasksConsoleRoute
    }
    '/_authenticated/surveys/templates/new': {
      id: '/_authenticated/surveys/templates/new'
      path: '/surveys/templates/new'
      fullPath: '/surveys/templates/new'
      preLoaderRoute: typeof AuthenticatedSurveysTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/templates/$templateId': {
      id: '/_authenticated/surveys/templates/$templateId'
      path: '/surveys/templates/$templateId'
      fullPath: '/surveys/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedSurveysTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/campaigns/new': {
      id: '/_authenticated/surveys/campaigns/new'
      path: '/surveys/campaigns/new'
      fullPath: '/surveys/campaigns/new'
      preLoaderRoute: typeof AuthenticatedSurveysCampaignsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/campaigns/$campaignId': {
      id: '/_authenticated/surveys/campaigns/$campaignId'
      path: '/surveys/campaigns/$campaignId'
      fullPath: '/surveys/campaigns/$campaignId'
      preLoaderRoute: typeof AuthenticatedSurveysCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/admin/risk-config': {
      id: '/_authenticated/suppliers/admin/risk-config'
      path: '/suppliers/admin/risk-config'
      fullPath: '/suppliers/admin/risk-config'
      preLoaderRoute: typeof AuthenticatedSuppliersAdminRiskConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/security/sessions': {
      id: '/_authenticated/settings/security/sessions'
      path: '/sessions'
      fullPath: '/settings/security/sessions'
      preLoaderRoute: typeof AuthenticatedSettingsSecuritySessionsRouteImport
      parentRoute: typeof AuthenticatedSettingsSecurityRoute
    }
    '/_authenticated/settings/nis2/reminders': {
      id: '/_authenticated/settings/nis2/reminders'
      path: '/nis2/reminders'
      fullPath: '/settings/nis2/reminders'
      preLoaderRoute: typeof AuthenticatedSettingsNis2RemindersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/ai-conversations/$conversationId': {
      id: '/_authenticated/settings/ai-conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/settings/ai-conversations/$conversationId'
      preLoaderRoute: typeof AuthenticatedSettingsAiConversationsConversationIdRouteImport
      parentRoute: typeof AuthenticatedSettingsAiConversationsRoute
    }
    '/_authenticated/policies/$policyId/review': {
      id: '/_authenticated/policies/$policyId/review'
      path: '/review'
      fullPath: '/policies/$policyId/review'
      preLoaderRoute: typeof AuthenticatedPoliciesPolicyIdReviewRouteImport
      parentRoute: typeof AuthenticatedPoliciesPolicyIdRoute
    }
    '/_authenticated/policies/$policyId/edit': {
      id: '/_authenticated/policies/$policyId/edit'
      path: '/edit'
      fullPath: '/policies/$policyId/edit'
      preLoaderRoute: typeof AuthenticatedPoliciesPolicyIdEditRouteImport
      parentRoute: typeof AuthenticatedPoliciesPolicyIdRoute
    }
    '/_authenticated/nis2/reports/scheduled': {
      id: '/_authenticated/nis2/reports/scheduled'
      path: '/reports/scheduled'
      fullPath: '/nis2/reports/scheduled'
      preLoaderRoute: typeof AuthenticatedNis2ReportsScheduledRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/executive': {
      id: '/_authenticated/nis2/reports/executive'
      path: '/reports/executive'
      fullPath: '/nis2/reports/executive'
      preLoaderRoute: typeof AuthenticatedNis2ReportsExecutiveRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/cross-border': {
      id: '/_authenticated/nis2/reports/cross-border'
      path: '/reports/cross-border'
      fullPath: '/nis2/reports/cross-border'
      preLoaderRoute: typeof AuthenticatedNis2ReportsCrossBorderRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/consolidated': {
      id: '/_authenticated/nis2/reports/consolidated'
      path: '/reports/consolidated'
      fullPath: '/nis2/reports/consolidated'
      preLoaderRoute: typeof AuthenticatedNis2ReportsConsolidatedRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/compliance': {
      id: '/_authenticated/nis2/reports/compliance'
      path: '/reports/compliance'
      fullPath: '/nis2/reports/compliance'
      preLoaderRoute: typeof AuthenticatedNis2ReportsComplianceRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/board': {
      id: '/_authenticated/nis2/reports/board'
      path: '/reports/board'
      fullPath: '/nis2/reports/board'
      preLoaderRoute: typeof AuthenticatedNis2ReportsBoardRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/audit-preparation': {
      id: '/_authenticated/nis2/reports/audit-preparation'
      path: '/reports/audit-preparation'
      fullPath: '/nis2/reports/audit-preparation'
      preLoaderRoute: typeof AuthenticatedNis2ReportsAuditPreparationRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/reports/activity': {
      id: '/_authenticated/nis2/reports/activity'
      path: '/reports/activity'
      fullPath: '/nis2/reports/activity'
      preLoaderRoute: typeof AuthenticatedNis2ReportsActivityRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/measures/$measureCode': {
      id: '/_authenticated/nis2/measures/$measureCode'
      path: '/measures/$measureCode'
      fullPath: '/nis2/measures/$measureCode'
      preLoaderRoute: typeof AuthenticatedNis2MeasuresMeasureCodeRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/inspection-preparation/$preparationId': {
      id: '/_authenticated/nis2/inspection-preparation/$preparationId'
      path: '/inspection-preparation/$preparationId'
      fullPath: '/nis2/inspection-preparation/$preparationId'
      preLoaderRoute: typeof AuthenticatedNis2InspectionPreparationPreparationIdRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/incidents/settings/sla': {
      id: '/_authenticated/incidents/settings/sla'
      path: '/sla'
      fullPath: '/incidents/settings/sla'
      preLoaderRoute: typeof AuthenticatedIncidentsSettingsSlaRouteImport
      parentRoute: typeof AuthenticatedIncidentsSettingsRoute
    }
    '/_authenticated/ghg/verification/$checklistId': {
      id: '/_authenticated/ghg/verification/$checklistId'
      path: '/verification/$checklistId'
      fullPath: '/ghg/verification/$checklistId'
      preLoaderRoute: typeof AuthenticatedGhgVerificationChecklistIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/verification-statements/$statementId': {
      id: '/_authenticated/ghg/verification-statements/$statementId'
      path: '/verification-statements/$statementId'
      fullPath: '/ghg/verification-statements/$statementId'
      preLoaderRoute: typeof AuthenticatedGhgVerificationStatementsStatementIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/third-party-verification/$engagementId': {
      id: '/_authenticated/ghg/third-party-verification/$engagementId'
      path: '/third-party-verification/$engagementId'
      fullPath: '/ghg/third-party-verification/$engagementId'
      preLoaderRoute: typeof AuthenticatedGhgThirdPartyVerificationEngagementIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/targets/new': {
      id: '/_authenticated/ghg/targets/new'
      path: '/targets/new'
      fullPath: '/ghg/targets/new'
      preLoaderRoute: typeof AuthenticatedGhgTargetsNewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/targets/$targetId': {
      id: '/_authenticated/ghg/targets/$targetId'
      path: '/targets/$targetId'
      fullPath: '/ghg/targets/$targetId'
      preLoaderRoute: typeof AuthenticatedGhgTargetsTargetIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/settings/scope2': {
      id: '/_authenticated/ghg/settings/scope2'
      path: '/settings/scope2'
      fullPath: '/ghg/settings/scope2'
      preLoaderRoute: typeof AuthenticatedGhgSettingsScope2RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/settings/scope1': {
      id: '/_authenticated/ghg/settings/scope1'
      path: '/settings/scope1'
      fullPath: '/ghg/settings/scope1'
      preLoaderRoute: typeof AuthenticatedGhgSettingsScope1RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3/sold-products': {
      id: '/_authenticated/ghg/scope3/sold-products'
      path: '/scope3/sold-products'
      fullPath: '/ghg/scope3/sold-products'
      preLoaderRoute: typeof AuthenticatedGhgScope3SoldProductsRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3/add': {
      id: '/_authenticated/ghg/scope3/add'
      path: '/scope3/add'
      fullPath: '/ghg/scope3/add'
      preLoaderRoute: typeof AuthenticatedGhgScope3AddRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3/$category': {
      id: '/_authenticated/ghg/scope3/$category'
      path: '/scope3/$category'
      fullPath: '/ghg/scope3/$category'
      preLoaderRoute: typeof AuthenticatedGhgScope3CategoryRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scenarios/new': {
      id: '/_authenticated/ghg/scenarios/new'
      path: '/scenarios/new'
      fullPath: '/ghg/scenarios/new'
      preLoaderRoute: typeof AuthenticatedGhgScenariosNewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scenarios/compare': {
      id: '/_authenticated/ghg/scenarios/compare'
      path: '/scenarios/compare'
      fullPath: '/ghg/scenarios/compare'
      preLoaderRoute: typeof AuthenticatedGhgScenariosCompareRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scenarios/$scenarioId': {
      id: '/_authenticated/ghg/scenarios/$scenarioId'
      path: '/scenarios/$scenarioId'
      fullPath: '/ghg/scenarios/$scenarioId'
      preLoaderRoute: typeof AuthenticatedGhgScenariosScenarioIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/reduction-initiatives/new': {
      id: '/_authenticated/ghg/reduction-initiatives/new'
      path: '/reduction-initiatives/new'
      fullPath: '/ghg/reduction-initiatives/new'
      preLoaderRoute: typeof AuthenticatedGhgReductionInitiativesNewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/reduction-initiatives/$initiativeId': {
      id: '/_authenticated/ghg/reduction-initiatives/$initiativeId'
      path: '/reduction-initiatives/$initiativeId'
      fullPath: '/ghg/reduction-initiatives/$initiativeId'
      preLoaderRoute: typeof AuthenticatedGhgReductionInitiativesInitiativeIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/recalculations/$recalculationId': {
      id: '/_authenticated/ghg/recalculations/$recalculationId'
      path: '/$recalculationId'
      fullPath: '/ghg/recalculations/$recalculationId'
      preLoaderRoute: typeof AuthenticatedGhgRecalculationsRecalculationIdRouteImport
      parentRoute: typeof AuthenticatedGhgRecalculationsRoute
    }
    '/_authenticated/ghg/integrations/$connectorId': {
      id: '/_authenticated/ghg/integrations/$connectorId'
      path: '/integrations/$connectorId'
      fullPath: '/ghg/integrations/$connectorId'
      preLoaderRoute: typeof AuthenticatedGhgIntegrationsConnectorIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/facilities/dashboard': {
      id: '/_authenticated/ghg/facilities/dashboard'
      path: '/facilities/dashboard'
      fullPath: '/ghg/facilities/dashboard'
      preLoaderRoute: typeof AuthenticatedGhgFacilitiesDashboardRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/commuting-surveys/new': {
      id: '/_authenticated/ghg/commuting-surveys/new'
      path: '/commuting-surveys/new'
      fullPath: '/ghg/commuting-surveys/new'
      preLoaderRoute: typeof AuthenticatedGhgCommutingSurveysNewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/commuting-surveys/$surveyId': {
      id: '/_authenticated/ghg/commuting-surveys/$surveyId'
      path: '/commuting-surveys/$surveyId'
      fullPath: '/ghg/commuting-surveys/$surveyId'
      preLoaderRoute: typeof AuthenticatedGhgCommutingSurveysSurveyIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/calculations/scope3': {
      id: '/_authenticated/ghg/calculations/scope3'
      path: '/calculations/scope3'
      fullPath: '/ghg/calculations/scope3'
      preLoaderRoute: typeof AuthenticatedGhgCalculationsScope3RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/calculations/scope2': {
      id: '/_authenticated/ghg/calculations/scope2'
      path: '/calculations/scope2'
      fullPath: '/ghg/calculations/scope2'
      preLoaderRoute: typeof AuthenticatedGhgCalculationsScope2RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/calculations/scope1': {
      id: '/_authenticated/ghg/calculations/scope1'
      path: '/calculations/scope1'
      fullPath: '/ghg/calculations/scope1'
      preLoaderRoute: typeof AuthenticatedGhgCalculationsScope1RouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-data/import': {
      id: '/_authenticated/ghg/activity-data/import'
      path: '/activity-data/import'
      fullPath: '/ghg/activity-data/import'
      preLoaderRoute: typeof AuthenticatedGhgActivityDataImportRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-data/document-ocr': {
      id: '/_authenticated/ghg/activity-data/document-ocr'
      path: '/activity-data/document-ocr'
      fullPath: '/ghg/activity-data/document-ocr'
      preLoaderRoute: typeof AuthenticatedGhgActivityDataDocumentOcrRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-data/assignment-queue': {
      id: '/_authenticated/ghg/activity-data/assignment-queue'
      path: '/activity-data/assignment-queue'
      fullPath: '/ghg/activity-data/assignment-queue'
      preLoaderRoute: typeof AuthenticatedGhgActivityDataAssignmentQueueRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/activity-data/$entryId': {
      id: '/_authenticated/ghg/activity-data/$entryId'
      path: '/activity-data/$entryId'
      fullPath: '/ghg/activity-data/$entryId'
      preLoaderRoute: typeof AuthenticatedGhgActivityDataEntryIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/evidence/attestations/new': {
      id: '/_authenticated/evidence/attestations/new'
      path: '/evidence/attestations/new'
      fullPath: '/evidence/attestations/new'
      preLoaderRoute: typeof AuthenticatedEvidenceAttestationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/esg/onboarding/$onboardingId': {
      id: '/_authenticated/esg/onboarding/$onboardingId'
      path: '/onboarding/$onboardingId'
      fullPath: '/esg/onboarding/$onboardingId'
      preLoaderRoute: typeof AuthenticatedEsgOnboardingOnboardingIdRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/esg/double-materiality/datapoints-policies': {
      id: '/_authenticated/esg/double-materiality/datapoints-policies'
      path: '/double-materiality/datapoints-policies'
      fullPath: '/esg/double-materiality/datapoints-policies'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId': {
      id: '/_authenticated/esg/double-materiality/$assessmentId'
      path: '/double-materiality/$assessmentId'
      fullPath: '/esg/double-materiality/$assessmentId'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRouteImport
      parentRoute: typeof AuthenticatedEsgRoute
    }
    '/_authenticated/employees/$employeeId/edit': {
      id: '/_authenticated/employees/$employeeId/edit'
      path: '/edit'
      fullPath: '/employees/$employeeId/edit'
      preLoaderRoute: typeof AuthenticatedEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof AuthenticatedEmployeesEmployeeIdRoute
    }
    '/_authenticated/datahub/integrations/transformation-rules': {
      id: '/_authenticated/datahub/integrations/transformation-rules'
      path: '/datahub/integrations/transformation-rules'
      fullPath: '/datahub/integrations/transformation-rules'
      preLoaderRoute: typeof AuthenticatedDatahubIntegrationsTransformationRulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/governance/scheduled-exports': {
      id: '/_authenticated/datahub/governance/scheduled-exports'
      path: '/datahub/governance/scheduled-exports'
      fullPath: '/datahub/governance/scheduled-exports'
      preLoaderRoute: typeof AuthenticatedDatahubGovernanceScheduledExportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/governance/approval-queue': {
      id: '/_authenticated/datahub/governance/approval-queue'
      path: '/datahub/governance/approval-queue'
      fullPath: '/datahub/governance/approval-queue'
      preLoaderRoute: typeof AuthenticatedDatahubGovernanceApprovalQueueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/governance/approval-config': {
      id: '/_authenticated/datahub/governance/approval-config'
      path: '/datahub/governance/approval-config'
      fullPath: '/datahub/governance/approval-config'
      preLoaderRoute: typeof AuthenticatedDatahubGovernanceApprovalConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/entry/wizard': {
      id: '/_authenticated/datahub/entry/wizard'
      path: '/wizard'
      fullPath: '/datahub/entry/wizard'
      preLoaderRoute: typeof AuthenticatedDatahubEntryWizardRouteImport
      parentRoute: typeof AuthenticatedDatahubEntryRoute
    }
    '/_authenticated/datahub/datapoints/$datapointId': {
      id: '/_authenticated/datahub/datapoints/$datapointId'
      path: '/datahub/datapoints/$datapointId'
      fullPath: '/datahub/datapoints/$datapointId'
      preLoaderRoute: typeof AuthenticatedDatahubDatapointsDatapointIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/collections/$collectionId': {
      id: '/_authenticated/datahub/collections/$collectionId'
      path: '/datahub/collections/$collectionId'
      fullPath: '/datahub/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedDatahubCollectionsCollectionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bcp/resources/sites': {
      id: '/_authenticated/bcp/resources/sites'
      path: '/resources/sites'
      fullPath: '/bcp/resources/sites'
      preLoaderRoute: typeof AuthenticatedBcpResourcesSitesRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/reports/plan-status': {
      id: '/_authenticated/bcp/reports/plan-status'
      path: '/reports/plan-status'
      fullPath: '/bcp/reports/plan-status'
      preLoaderRoute: typeof AuthenticatedBcpReportsPlanStatusRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/reports/nis2-compliance': {
      id: '/_authenticated/bcp/reports/nis2-compliance'
      path: '/reports/nis2-compliance'
      fullPath: '/bcp/reports/nis2-compliance'
      preLoaderRoute: typeof AuthenticatedBcpReportsNis2ComplianceRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/reports/iso-22301': {
      id: '/_authenticated/bcp/reports/iso-22301'
      path: '/reports/iso-22301'
      fullPath: '/bcp/reports/iso-22301'
      preLoaderRoute: typeof AuthenticatedBcpReportsIso22301RouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/reports/gap-analysis': {
      id: '/_authenticated/bcp/reports/gap-analysis'
      path: '/reports/gap-analysis'
      fullPath: '/bcp/reports/gap-analysis'
      preLoaderRoute: typeof AuthenticatedBcpReportsGapAnalysisRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/reports/exercise-summary': {
      id: '/_authenticated/bcp/reports/exercise-summary'
      path: '/reports/exercise-summary'
      fullPath: '/bcp/reports/exercise-summary'
      preLoaderRoute: typeof AuthenticatedBcpReportsExerciseSummaryRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/plans/recovery': {
      id: '/_authenticated/bcp/plans/recovery'
      path: '/recovery'
      fullPath: '/bcp/plans/recovery'
      preLoaderRoute: typeof AuthenticatedBcpPlansRecoveryRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/new-recovery-procedure': {
      id: '/_authenticated/bcp/plans/new-recovery-procedure'
      path: '/new-recovery-procedure'
      fullPath: '/bcp/plans/new-recovery-procedure'
      preLoaderRoute: typeof AuthenticatedBcpPlansNewRecoveryProcedureRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/new-it-dr': {
      id: '/_authenticated/bcp/plans/new-it-dr'
      path: '/new-it-dr'
      fullPath: '/bcp/plans/new-it-dr'
      preLoaderRoute: typeof AuthenticatedBcpPlansNewItDrRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/new-crisis-communication': {
      id: '/_authenticated/bcp/plans/new-crisis-communication'
      path: '/new-crisis-communication'
      fullPath: '/bcp/plans/new-crisis-communication'
      preLoaderRoute: typeof AuthenticatedBcpPlansNewCrisisCommunicationRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/new': {
      id: '/_authenticated/bcp/plans/new'
      path: '/new'
      fullPath: '/bcp/plans/new'
      preLoaderRoute: typeof AuthenticatedBcpPlansNewRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/it-dr': {
      id: '/_authenticated/bcp/plans/it-dr'
      path: '/it-dr'
      fullPath: '/bcp/plans/it-dr'
      preLoaderRoute: typeof AuthenticatedBcpPlansItDrRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/crisis-comm': {
      id: '/_authenticated/bcp/plans/crisis-comm'
      path: '/crisis-comm'
      fullPath: '/bcp/plans/crisis-comm'
      preLoaderRoute: typeof AuthenticatedBcpPlansCrisisCommRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/bcp': {
      id: '/_authenticated/bcp/plans/bcp'
      path: '/bcp'
      fullPath: '/bcp/plans/bcp'
      preLoaderRoute: typeof AuthenticatedBcpPlansBcpRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/plans/$planId': {
      id: '/_authenticated/bcp/plans/$planId'
      path: '/$planId'
      fullPath: '/bcp/plans/$planId'
      preLoaderRoute: typeof AuthenticatedBcpPlansPlanIdRouteImport
      parentRoute: typeof AuthenticatedBcpPlansRoute
    }
    '/_authenticated/bcp/exercises/schedule': {
      id: '/_authenticated/bcp/exercises/schedule'
      path: '/exercises/schedule'
      fullPath: '/bcp/exercises/schedule'
      preLoaderRoute: typeof AuthenticatedBcpExercisesScheduleRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/exercises/new': {
      id: '/_authenticated/bcp/exercises/new'
      path: '/exercises/new'
      fullPath: '/bcp/exercises/new'
      preLoaderRoute: typeof AuthenticatedBcpExercisesNewRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/exercises/$exerciseId': {
      id: '/_authenticated/bcp/exercises/$exerciseId'
      path: '/exercises/$exerciseId'
      fullPath: '/bcp/exercises/$exerciseId'
      preLoaderRoute: typeof AuthenticatedBcpExercisesExerciseIdRouteImport
      parentRoute: typeof AuthenticatedBcpRoute
    }
    '/_authenticated/bcp/bia/$biaId': {
      id: '/_authenticated/bcp/bia/$biaId'
      path: '/$biaId'
      fullPath: '/bcp/bia/$biaId'
      preLoaderRoute: typeof AuthenticatedBcpBiaBiaIdRouteImport
      parentRoute: typeof AuthenticatedBcpBiaRoute
    }
    '/_authenticated/audit/evidence/$evidenceId': {
      id: '/_authenticated/audit/evidence/$evidenceId'
      path: '/audit/evidence/$evidenceId'
      fullPath: '/audit/evidence/$evidenceId'
      preLoaderRoute: typeof AuthenticatedAuditEvidenceEvidenceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/audits/new': {
      id: '/_authenticated/audit/audits/new'
      path: '/audit/audits/new'
      fullPath: '/audit/audits/new'
      preLoaderRoute: typeof AuthenticatedAuditAuditsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/report-studio/templates': {
      id: '/_authenticated/analytics/report-studio/templates'
      path: '/report-studio/templates'
      fullPath: '/analytics/report-studio/templates'
      preLoaderRoute: typeof AuthenticatedAnalyticsReportStudioTemplatesRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/report-studio/new': {
      id: '/_authenticated/analytics/report-studio/new'
      path: '/report-studio/new'
      fullPath: '/analytics/report-studio/new'
      preLoaderRoute: typeof AuthenticatedAnalyticsReportStudioNewRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/report-studio/$reportId': {
      id: '/_authenticated/analytics/report-studio/$reportId'
      path: '/report-studio/$reportId'
      fullPath: '/analytics/report-studio/$reportId'
      preLoaderRoute: typeof AuthenticatedAnalyticsReportStudioReportIdRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/dashboards/$dashboardId': {
      id: '/_authenticated/analytics/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/analytics/dashboards/$dashboardId'
      preLoaderRoute: typeof AuthenticatedAnalyticsDashboardsDashboardIdRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/ai/scans/$scanId': {
      id: '/_authenticated/ai/scans/$scanId'
      path: '/ai/scans/$scanId'
      fullPath: '/ai/scans/$scanId'
      preLoaderRoute: typeof AuthenticatedAiScansScanIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/onboarding/$module': {
      id: '/_authenticated/ai/onboarding/$module'
      path: '/ai/onboarding/$module'
      fullPath: '/ai/onboarding/$module'
      preLoaderRoute: typeof AuthenticatedAiOnboardingModuleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/policies/templates': {
      id: '/_authenticated/admin/policies/templates'
      path: '/admin/policies/templates'
      fullPath: '/admin/policies/templates'
      preLoaderRoute: typeof AuthenticatedAdminPoliciesTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/policies/approval-configs': {
      id: '/_authenticated/admin/policies/approval-configs'
      path: '/admin/policies/approval-configs'
      fullPath: '/admin/policies/approval-configs'
      preLoaderRoute: typeof AuthenticatedAdminPoliciesApprovalConfigsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/policies/access-controls': {
      id: '/_authenticated/admin/policies/access-controls'
      path: '/admin/policies/access-controls'
      fullPath: '/admin/policies/access-controls'
      preLoaderRoute: typeof AuthenticatedAdminPoliciesAccessControlsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/incidents/tags': {
      id: '/_authenticated/admin/incidents/tags'
      path: '/admin/incidents/tags'
      fullPath: '/admin/incidents/tags'
      preLoaderRoute: typeof AuthenticatedAdminIncidentsTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/templates/': {
      id: '/_authenticated/tasks/playbooks/templates/'
      path: '/tasks/playbooks/templates'
      fullPath: '/tasks/playbooks/templates'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/$activationId/': {
      id: '/_authenticated/tasks/playbooks/$activationId/'
      path: '/tasks/playbooks/$activationId'
      fullPath: '/tasks/playbooks/$activationId'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksActivationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/admin/questionnaire-templates/': {
      id: '/_authenticated/suppliers/admin/questionnaire-templates/'
      path: '/suppliers/admin/questionnaire-templates'
      fullPath: '/suppliers/admin/questionnaire-templates'
      preLoaderRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ghg/verification/internal/': {
      id: '/_authenticated/ghg/verification/internal/'
      path: '/verification/internal'
      fullPath: '/ghg/verification/internal'
      preLoaderRoute: typeof AuthenticatedGhgVerificationInternalIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3/$category/': {
      id: '/_authenticated/ghg/scope3/$category/'
      path: '/'
      fullPath: '/ghg/scope3/$category/'
      preLoaderRoute: typeof AuthenticatedGhgScope3CategoryIndexRouteImport
      parentRoute: typeof AuthenticatedGhgScope3CategoryRoute
    }
    '/_authenticated/ghg/reports/custom/': {
      id: '/_authenticated/ghg/reports/custom/'
      path: '/reports/custom'
      fullPath: '/ghg/reports/custom'
      preLoaderRoute: typeof AuthenticatedGhgReportsCustomIndexRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/'
      path: '/'
      fullPath: '/esg/double-materiality/$assessmentId/'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/datahub/collections/$collectionId/': {
      id: '/_authenticated/datahub/collections/$collectionId/'
      path: '/'
      fullPath: '/datahub/collections/$collectionId/'
      preLoaderRoute: typeof AuthenticatedDatahubCollectionsCollectionIdIndexRouteImport
      parentRoute: typeof AuthenticatedDatahubCollectionsCollectionIdRoute
    }
    '/_authenticated/bcp/plans/$planId/': {
      id: '/_authenticated/bcp/plans/$planId/'
      path: '/'
      fullPath: '/bcp/plans/$planId/'
      preLoaderRoute: typeof AuthenticatedBcpPlansPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedBcpPlansPlanIdRoute
    }
    '/_authenticated/bcp/exercises/$exerciseId/': {
      id: '/_authenticated/bcp/exercises/$exerciseId/'
      path: '/'
      fullPath: '/bcp/exercises/$exerciseId/'
      preLoaderRoute: typeof AuthenticatedBcpExercisesExerciseIdIndexRouteImport
      parentRoute: typeof AuthenticatedBcpExercisesExerciseIdRoute
    }
    '/_authenticated/audit/audits/$auditId/': {
      id: '/_authenticated/audit/audits/$auditId/'
      path: '/audit/audits/$auditId'
      fullPath: '/audit/audits/$auditId'
      preLoaderRoute: typeof AuthenticatedAuditAuditsAuditIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auditor/access/$accessId/nis2/measures': {
      id: '/auditor/access/$accessId/nis2/measures'
      path: '/measures'
      fullPath: '/auditor/access/$accessId/nis2/measures'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2MeasuresRouteImport
      parentRoute: typeof AuditorAccessAccessIdNis2Route
    }
    '/auditor/access/$accessId/nis2/incidents': {
      id: '/auditor/access/$accessId/nis2/incidents'
      path: '/incidents'
      fullPath: '/auditor/access/$accessId/nis2/incidents'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2IncidentsRouteImport
      parentRoute: typeof AuditorAccessAccessIdNis2Route
    }
    '/auditor/access/$accessId/nis2/gaps': {
      id: '/auditor/access/$accessId/nis2/gaps'
      path: '/gaps'
      fullPath: '/auditor/access/$accessId/nis2/gaps'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2GapsRouteImport
      parentRoute: typeof AuditorAccessAccessIdNis2Route
    }
    '/auditor/access/$accessId/nis2/evidence': {
      id: '/auditor/access/$accessId/nis2/evidence'
      path: '/evidence'
      fullPath: '/auditor/access/$accessId/nis2/evidence'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2EvidenceRouteImport
      parentRoute: typeof AuditorAccessAccessIdNis2Route
    }
    '/auditor/access/$accessId/nis2/assessments': {
      id: '/auditor/access/$accessId/nis2/assessments'
      path: '/assessments'
      fullPath: '/auditor/access/$accessId/nis2/assessments'
      preLoaderRoute: typeof AuditorAccessAccessIdNis2AssessmentsRouteImport
      parentRoute: typeof AuditorAccessAccessIdNis2Route
    }
    '/auditor/access/$accessId/bcp/plans': {
      id: '/auditor/access/$accessId/bcp/plans'
      path: '/plans'
      fullPath: '/auditor/access/$accessId/bcp/plans'
      preLoaderRoute: typeof AuditorAccessAccessIdBcpPlansRouteImport
      parentRoute: typeof AuditorAccessAccessIdBcpRoute
    }
    '/auditor/access/$accessId/bcp/findings': {
      id: '/auditor/access/$accessId/bcp/findings'
      path: '/findings'
      fullPath: '/auditor/access/$accessId/bcp/findings'
      preLoaderRoute: typeof AuditorAccessAccessIdBcpFindingsRouteImport
      parentRoute: typeof AuditorAccessAccessIdBcpRoute
    }
    '/auditor/access/$accessId/bcp/exercises': {
      id: '/auditor/access/$accessId/bcp/exercises'
      path: '/exercises'
      fullPath: '/auditor/access/$accessId/bcp/exercises'
      preLoaderRoute: typeof AuditorAccessAccessIdBcpExercisesRouteImport
      parentRoute: typeof AuditorAccessAccessIdBcpRoute
    }
    '/_authenticated/tasks/playbooks/templates/task-templates': {
      id: '/_authenticated/tasks/playbooks/templates/task-templates'
      path: '/tasks/playbooks/templates/task-templates'
      fullPath: '/tasks/playbooks/templates/task-templates'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/templates/new': {
      id: '/_authenticated/tasks/playbooks/templates/new'
      path: '/tasks/playbooks/templates/new'
      fullPath: '/tasks/playbooks/templates/new'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/templates/$templateId': {
      id: '/_authenticated/tasks/playbooks/templates/$templateId'
      path: '/tasks/playbooks/templates/$templateId'
      fullPath: '/tasks/playbooks/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/playbooks/$activationId/setup': {
      id: '/_authenticated/tasks/playbooks/$activationId/setup'
      path: '/tasks/playbooks/$activationId/setup'
      fullPath: '/tasks/playbooks/$activationId/setup'
      preLoaderRoute: typeof AuthenticatedTasksPlaybooksActivationIdSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/questionnaires/$sentId/review': {
      id: '/_authenticated/suppliers/questionnaires/$sentId/review'
      path: '/suppliers/questionnaires/$sentId/review'
      fullPath: '/suppliers/questionnaires/$sentId/review'
      preLoaderRoute: typeof AuthenticatedSuppliersQuestionnairesSentIdReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/admin/questionnaire-templates/new': {
      id: '/_authenticated/suppliers/admin/questionnaire-templates/new'
      path: '/suppliers/admin/questionnaire-templates/new'
      fullPath: '/suppliers/admin/questionnaire-templates/new'
      preLoaderRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/admin/questionnaire-templates/$templateId': {
      id: '/_authenticated/suppliers/admin/questionnaire-templates/$templateId'
      path: '/suppliers/admin/questionnaire-templates/$templateId'
      fullPath: '/suppliers/admin/questionnaire-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/$supplierId/reviews/$reviewId': {
      id: '/_authenticated/suppliers/$supplierId/reviews/$reviewId'
      path: '/reviews/$reviewId'
      fullPath: '/suppliers/$supplierId/reviews/$reviewId'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdReviewsReviewIdRouteImport
      parentRoute: typeof AuthenticatedSuppliersSupplierIdRoute
    }
    '/_authenticated/settings/team/members/$userId': {
      id: '/_authenticated/settings/team/members/$userId'
      path: '/members/$userId'
      fullPath: '/settings/team/members/$userId'
      preLoaderRoute: typeof AuthenticatedSettingsTeamMembersUserIdRouteImport
      parentRoute: typeof AuthenticatedSettingsTeamRoute
    }
    '/_authenticated/policies/procedures/$instanceId/execute': {
      id: '/_authenticated/policies/procedures/$instanceId/execute'
      path: '/policies/procedures/$instanceId/execute'
      fullPath: '/policies/procedures/$instanceId/execute'
      preLoaderRoute: typeof AuthenticatedPoliciesProceduresInstanceIdExecuteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/policies/$policyId/scans/$scanId': {
      id: '/_authenticated/policies/$policyId/scans/$scanId'
      path: '/scans/$scanId'
      fullPath: '/policies/$policyId/scans/$scanId'
      preLoaderRoute: typeof AuthenticatedPoliciesPolicyIdScansScanIdRouteImport
      parentRoute: typeof AuthenticatedPoliciesPolicyIdRoute
    }
    '/_authenticated/nis2/incidents/$incidentId/progress-updates': {
      id: '/_authenticated/nis2/incidents/$incidentId/progress-updates'
      path: '/incidents/$incidentId/progress-updates'
      fullPath: '/nis2/incidents/$incidentId/progress-updates'
      preLoaderRoute: typeof AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/incidents/$incidentId/notification': {
      id: '/_authenticated/nis2/incidents/$incidentId/notification'
      path: '/incidents/$incidentId/notification'
      fullPath: '/nis2/incidents/$incidentId/notification'
      preLoaderRoute: typeof AuthenticatedNis2IncidentsIncidentIdNotificationRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/incidents/$incidentId/final-report': {
      id: '/_authenticated/nis2/incidents/$incidentId/final-report'
      path: '/incidents/$incidentId/final-report'
      fullPath: '/nis2/incidents/$incidentId/final-report'
      preLoaderRoute: typeof AuthenticatedNis2IncidentsIncidentIdFinalReportRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/nis2/incidents/$incidentId/early-warning': {
      id: '/_authenticated/nis2/incidents/$incidentId/early-warning'
      path: '/incidents/$incidentId/early-warning'
      fullPath: '/nis2/incidents/$incidentId/early-warning'
      preLoaderRoute: typeof AuthenticatedNis2IncidentsIncidentIdEarlyWarningRouteImport
      parentRoute: typeof AuthenticatedNis2Route
    }
    '/_authenticated/ghg/verification/internal/$verificationId': {
      id: '/_authenticated/ghg/verification/internal/$verificationId'
      path: '/verification/internal/$verificationId'
      fullPath: '/ghg/verification/internal/$verificationId'
      preLoaderRoute: typeof AuthenticatedGhgVerificationInternalVerificationIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/scope3/$category/derive': {
      id: '/_authenticated/ghg/scope3/$category/derive'
      path: '/derive'
      fullPath: '/ghg/scope3/$category/derive'
      preLoaderRoute: typeof AuthenticatedGhgScope3CategoryDeriveRouteImport
      parentRoute: typeof AuthenticatedGhgScope3CategoryRoute
    }
    '/_authenticated/ghg/reports/custom/new': {
      id: '/_authenticated/ghg/reports/custom/new'
      path: '/reports/custom/new'
      fullPath: '/ghg/reports/custom/new'
      preLoaderRoute: typeof AuthenticatedGhgReportsCustomNewRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/ghg/reports/custom/$reportId': {
      id: '/_authenticated/ghg/reports/custom/$reportId'
      path: '/reports/custom/$reportId'
      fullPath: '/ghg/reports/custom/$reportId'
      preLoaderRoute: typeof AuthenticatedGhgReportsCustomReportIdRouteImport
      parentRoute: typeof AuthenticatedGhgRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/value-chain': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/value-chain'
      path: '/value-chain'
      fullPath: '/esg/double-materiality/$assessmentId/value-chain'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/stakeholders': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/stakeholders'
      path: '/stakeholders'
      fullPath: '/esg/double-materiality/$assessmentId/stakeholders'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/risks': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/risks'
      path: '/risks'
      fullPath: '/esg/double-materiality/$assessmentId/risks'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/quality': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/quality'
      path: '/quality'
      fullPath: '/esg/double-materiality/$assessmentId/quality'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/overview': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/overview'
      path: '/overview'
      fullPath: '/esg/double-materiality/$assessmentId/overview'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/matrix': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/matrix'
      path: '/matrix'
      fullPath: '/esg/double-materiality/$assessmentId/matrix'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/impacts': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/impacts'
      path: '/impacts'
      fullPath: '/esg/double-materiality/$assessmentId/impacts'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/esg/double-materiality/$assessmentId/assessment': {
      id: '/_authenticated/esg/double-materiality/$assessmentId/assessment'
      path: '/assessment'
      fullPath: '/esg/double-materiality/$assessmentId/assessment'
      preLoaderRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRouteImport
      parentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRoute
    }
    '/_authenticated/datahub/uploads/$uploadId/review': {
      id: '/_authenticated/datahub/uploads/$uploadId/review'
      path: '/datahub/uploads/$uploadId/review'
      fullPath: '/datahub/uploads/$uploadId/review'
      preLoaderRoute: typeof AuthenticatedDatahubUploadsUploadIdReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/uploads/$uploadId/map': {
      id: '/_authenticated/datahub/uploads/$uploadId/map'
      path: '/datahub/uploads/$uploadId/map'
      fullPath: '/datahub/uploads/$uploadId/map'
      preLoaderRoute: typeof AuthenticatedDatahubUploadsUploadIdMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/integrations/$integrationId/mappings': {
      id: '/_authenticated/datahub/integrations/$integrationId/mappings'
      path: '/datahub/integrations/$integrationId/mappings'
      fullPath: '/datahub/integrations/$integrationId/mappings'
      preLoaderRoute: typeof AuthenticatedDatahubIntegrationsIntegrationIdMappingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/datahub/datapoints/$datapointId/entry': {
      id: '/_authenticated/datahub/datapoints/$datapointId/entry'
      path: '/entry'
      fullPath: '/datahub/datapoints/$datapointId/entry'
      preLoaderRoute: typeof AuthenticatedDatahubDatapointsDatapointIdEntryRouteImport
      parentRoute: typeof AuthenticatedDatahubDatapointsDatapointIdRoute
    }
    '/_authenticated/datahub/collections/$collectionId/import': {
      id: '/_authenticated/datahub/collections/$collectionId/import'
      path: '/import'
      fullPath: '/datahub/collections/$collectionId/import'
      preLoaderRoute: typeof AuthenticatedDatahubCollectionsCollectionIdImportRouteImport
      parentRoute: typeof AuthenticatedDatahubCollectionsCollectionIdRoute
    }
    '/_authenticated/datahub/collections/$collectionId/entry': {
      id: '/_authenticated/datahub/collections/$collectionId/entry'
      path: '/entry'
      fullPath: '/datahub/collections/$collectionId/entry'
      preLoaderRoute: typeof AuthenticatedDatahubCollectionsCollectionIdEntryRouteImport
      parentRoute: typeof AuthenticatedDatahubCollectionsCollectionIdRoute
    }
    '/_authenticated/bcp/resources/sites/$siteId': {
      id: '/_authenticated/bcp/resources/sites/$siteId'
      path: '/$siteId'
      fullPath: '/bcp/resources/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedBcpResourcesSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedBcpResourcesSitesRoute
    }
    '/_authenticated/bcp/plans/$planId/review': {
      id: '/_authenticated/bcp/plans/$planId/review'
      path: '/review'
      fullPath: '/bcp/plans/$planId/review'
      preLoaderRoute: typeof AuthenticatedBcpPlansPlanIdReviewRouteImport
      parentRoute: typeof AuthenticatedBcpPlansPlanIdRoute
    }
    '/_authenticated/bcp/plans/$planId/edit': {
      id: '/_authenticated/bcp/plans/$planId/edit'
      path: '/edit'
      fullPath: '/bcp/plans/$planId/edit'
      preLoaderRoute: typeof AuthenticatedBcpPlansPlanIdEditRouteImport
      parentRoute: typeof AuthenticatedBcpPlansPlanIdRoute
    }
    '/_authenticated/bcp/exercises/$exerciseId/conduct': {
      id: '/_authenticated/bcp/exercises/$exerciseId/conduct'
      path: '/conduct'
      fullPath: '/bcp/exercises/$exerciseId/conduct'
      preLoaderRoute: typeof AuthenticatedBcpExercisesExerciseIdConductRouteImport
      parentRoute: typeof AuthenticatedBcpExercisesExerciseIdRoute
    }
    '/_authenticated/audit/audits/$auditId/settings': {
      id: '/_authenticated/audit/audits/$auditId/settings'
      path: '/audit/audits/$auditId/settings'
      fullPath: '/audit/audits/$auditId/settings'
      preLoaderRoute: typeof AuthenticatedAuditAuditsAuditIdSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/documents/$documentId/extract': {
      id: '/_authenticated/ai/documents/$documentId/extract'
      path: '/$documentId/extract'
      fullPath: '/ai/documents/$documentId/extract'
      preLoaderRoute: typeof AuthenticatedAiDocumentsDocumentIdExtractRouteImport
      parentRoute: typeof AuthenticatedAiDocumentsRoute
    }
    '/auditor/access/$accessId/bcp/plans/$planId': {
      id: '/auditor/access/$accessId/bcp/plans/$planId'
      path: '/$planId'
      fullPath: '/auditor/access/$accessId/bcp/plans/$planId'
      preLoaderRoute: typeof AuditorAccessAccessIdBcpPlansPlanIdRouteImport
      parentRoute: typeof AuditorAccessAccessIdBcpPlansRoute
    }
    '/_authenticated/settings/team/members/$userId/history-connections': {
      id: '/_authenticated/settings/team/members/$userId/history-connections'
      path: '/history-connections'
      fullPath: '/settings/team/members/$userId/history-connections'
      preLoaderRoute: typeof AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRouteImport
      parentRoute: typeof AuthenticatedSettingsTeamMembersUserIdRoute
    }
  }
}

interface AuthenticatedAnalyticsRouteChildren {
  AuthenticatedAnalyticsGhgOverviewRoute: typeof AuthenticatedAnalyticsGhgOverviewRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedAnalyticsDashboardsDashboardIdRoute: typeof AuthenticatedAnalyticsDashboardsDashboardIdRoute
  AuthenticatedAnalyticsReportStudioReportIdRoute: typeof AuthenticatedAnalyticsReportStudioReportIdRoute
  AuthenticatedAnalyticsReportStudioNewRoute: typeof AuthenticatedAnalyticsReportStudioNewRoute
  AuthenticatedAnalyticsReportStudioTemplatesRoute: typeof AuthenticatedAnalyticsReportStudioTemplatesRoute
  AuthenticatedAnalyticsDashboardsIndexRoute: typeof AuthenticatedAnalyticsDashboardsIndexRoute
  AuthenticatedAnalyticsReportStudioIndexRoute: typeof AuthenticatedAnalyticsReportStudioIndexRoute
}

const AuthenticatedAnalyticsRouteChildren: AuthenticatedAnalyticsRouteChildren =
  {
    AuthenticatedAnalyticsGhgOverviewRoute:
      AuthenticatedAnalyticsGhgOverviewRoute,
    AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
    AuthenticatedAnalyticsDashboardsDashboardIdRoute:
      AuthenticatedAnalyticsDashboardsDashboardIdRoute,
    AuthenticatedAnalyticsReportStudioReportIdRoute:
      AuthenticatedAnalyticsReportStudioReportIdRoute,
    AuthenticatedAnalyticsReportStudioNewRoute:
      AuthenticatedAnalyticsReportStudioNewRoute,
    AuthenticatedAnalyticsReportStudioTemplatesRoute:
      AuthenticatedAnalyticsReportStudioTemplatesRoute,
    AuthenticatedAnalyticsDashboardsIndexRoute:
      AuthenticatedAnalyticsDashboardsIndexRoute,
    AuthenticatedAnalyticsReportStudioIndexRoute:
      AuthenticatedAnalyticsReportStudioIndexRoute,
  }

const AuthenticatedAnalyticsRouteWithChildren =
  AuthenticatedAnalyticsRoute._addFileChildren(
    AuthenticatedAnalyticsRouteChildren,
  )

interface AuthenticatedBcpBiaRouteChildren {
  AuthenticatedBcpBiaBiaIdRoute: typeof AuthenticatedBcpBiaBiaIdRoute
}

const AuthenticatedBcpBiaRouteChildren: AuthenticatedBcpBiaRouteChildren = {
  AuthenticatedBcpBiaBiaIdRoute: AuthenticatedBcpBiaBiaIdRoute,
}

const AuthenticatedBcpBiaRouteWithChildren =
  AuthenticatedBcpBiaRoute._addFileChildren(AuthenticatedBcpBiaRouteChildren)

interface AuthenticatedBcpPlansPlanIdRouteChildren {
  AuthenticatedBcpPlansPlanIdEditRoute: typeof AuthenticatedBcpPlansPlanIdEditRoute
  AuthenticatedBcpPlansPlanIdReviewRoute: typeof AuthenticatedBcpPlansPlanIdReviewRoute
  AuthenticatedBcpPlansPlanIdIndexRoute: typeof AuthenticatedBcpPlansPlanIdIndexRoute
}

const AuthenticatedBcpPlansPlanIdRouteChildren: AuthenticatedBcpPlansPlanIdRouteChildren =
  {
    AuthenticatedBcpPlansPlanIdEditRoute: AuthenticatedBcpPlansPlanIdEditRoute,
    AuthenticatedBcpPlansPlanIdReviewRoute:
      AuthenticatedBcpPlansPlanIdReviewRoute,
    AuthenticatedBcpPlansPlanIdIndexRoute:
      AuthenticatedBcpPlansPlanIdIndexRoute,
  }

const AuthenticatedBcpPlansPlanIdRouteWithChildren =
  AuthenticatedBcpPlansPlanIdRoute._addFileChildren(
    AuthenticatedBcpPlansPlanIdRouteChildren,
  )

interface AuthenticatedBcpPlansRouteChildren {
  AuthenticatedBcpPlansPlanIdRoute: typeof AuthenticatedBcpPlansPlanIdRouteWithChildren
  AuthenticatedBcpPlansBcpRoute: typeof AuthenticatedBcpPlansBcpRoute
  AuthenticatedBcpPlansCrisisCommRoute: typeof AuthenticatedBcpPlansCrisisCommRoute
  AuthenticatedBcpPlansItDrRoute: typeof AuthenticatedBcpPlansItDrRoute
  AuthenticatedBcpPlansNewRoute: typeof AuthenticatedBcpPlansNewRoute
  AuthenticatedBcpPlansNewCrisisCommunicationRoute: typeof AuthenticatedBcpPlansNewCrisisCommunicationRoute
  AuthenticatedBcpPlansNewItDrRoute: typeof AuthenticatedBcpPlansNewItDrRoute
  AuthenticatedBcpPlansNewRecoveryProcedureRoute: typeof AuthenticatedBcpPlansNewRecoveryProcedureRoute
  AuthenticatedBcpPlansRecoveryRoute: typeof AuthenticatedBcpPlansRecoveryRoute
  AuthenticatedBcpPlansIndexRoute: typeof AuthenticatedBcpPlansIndexRoute
}

const AuthenticatedBcpPlansRouteChildren: AuthenticatedBcpPlansRouteChildren = {
  AuthenticatedBcpPlansPlanIdRoute:
    AuthenticatedBcpPlansPlanIdRouteWithChildren,
  AuthenticatedBcpPlansBcpRoute: AuthenticatedBcpPlansBcpRoute,
  AuthenticatedBcpPlansCrisisCommRoute: AuthenticatedBcpPlansCrisisCommRoute,
  AuthenticatedBcpPlansItDrRoute: AuthenticatedBcpPlansItDrRoute,
  AuthenticatedBcpPlansNewRoute: AuthenticatedBcpPlansNewRoute,
  AuthenticatedBcpPlansNewCrisisCommunicationRoute:
    AuthenticatedBcpPlansNewCrisisCommunicationRoute,
  AuthenticatedBcpPlansNewItDrRoute: AuthenticatedBcpPlansNewItDrRoute,
  AuthenticatedBcpPlansNewRecoveryProcedureRoute:
    AuthenticatedBcpPlansNewRecoveryProcedureRoute,
  AuthenticatedBcpPlansRecoveryRoute: AuthenticatedBcpPlansRecoveryRoute,
  AuthenticatedBcpPlansIndexRoute: AuthenticatedBcpPlansIndexRoute,
}

const AuthenticatedBcpPlansRouteWithChildren =
  AuthenticatedBcpPlansRoute._addFileChildren(
    AuthenticatedBcpPlansRouteChildren,
  )

interface AuthenticatedBcpExercisesExerciseIdRouteChildren {
  AuthenticatedBcpExercisesExerciseIdConductRoute: typeof AuthenticatedBcpExercisesExerciseIdConductRoute
  AuthenticatedBcpExercisesExerciseIdIndexRoute: typeof AuthenticatedBcpExercisesExerciseIdIndexRoute
}

const AuthenticatedBcpExercisesExerciseIdRouteChildren: AuthenticatedBcpExercisesExerciseIdRouteChildren =
  {
    AuthenticatedBcpExercisesExerciseIdConductRoute:
      AuthenticatedBcpExercisesExerciseIdConductRoute,
    AuthenticatedBcpExercisesExerciseIdIndexRoute:
      AuthenticatedBcpExercisesExerciseIdIndexRoute,
  }

const AuthenticatedBcpExercisesExerciseIdRouteWithChildren =
  AuthenticatedBcpExercisesExerciseIdRoute._addFileChildren(
    AuthenticatedBcpExercisesExerciseIdRouteChildren,
  )

interface AuthenticatedBcpResourcesSitesRouteChildren {
  AuthenticatedBcpResourcesSitesSiteIdRoute: typeof AuthenticatedBcpResourcesSitesSiteIdRoute
}

const AuthenticatedBcpResourcesSitesRouteChildren: AuthenticatedBcpResourcesSitesRouteChildren =
  {
    AuthenticatedBcpResourcesSitesSiteIdRoute:
      AuthenticatedBcpResourcesSitesSiteIdRoute,
  }

const AuthenticatedBcpResourcesSitesRouteWithChildren =
  AuthenticatedBcpResourcesSitesRoute._addFileChildren(
    AuthenticatedBcpResourcesSitesRouteChildren,
  )

interface AuthenticatedBcpRouteChildren {
  AuthenticatedBcpBcpRoute: typeof AuthenticatedBcpBcpRoute
  AuthenticatedBcpBiaRoute: typeof AuthenticatedBcpBiaRouteWithChildren
  AuthenticatedBcpContinuityRoute: typeof AuthenticatedBcpContinuityRoute
  AuthenticatedBcpDashboardRoute: typeof AuthenticatedBcpDashboardRoute
  AuthenticatedBcpFindingsRoute: typeof AuthenticatedBcpFindingsRoute
  AuthenticatedBcpPlansRoute: typeof AuthenticatedBcpPlansRouteWithChildren
  AuthenticatedBcpExercisesExerciseIdRoute: typeof AuthenticatedBcpExercisesExerciseIdRouteWithChildren
  AuthenticatedBcpExercisesNewRoute: typeof AuthenticatedBcpExercisesNewRoute
  AuthenticatedBcpExercisesScheduleRoute: typeof AuthenticatedBcpExercisesScheduleRoute
  AuthenticatedBcpReportsExerciseSummaryRoute: typeof AuthenticatedBcpReportsExerciseSummaryRoute
  AuthenticatedBcpReportsGapAnalysisRoute: typeof AuthenticatedBcpReportsGapAnalysisRoute
  AuthenticatedBcpReportsIso22301Route: typeof AuthenticatedBcpReportsIso22301Route
  AuthenticatedBcpReportsNis2ComplianceRoute: typeof AuthenticatedBcpReportsNis2ComplianceRoute
  AuthenticatedBcpReportsPlanStatusRoute: typeof AuthenticatedBcpReportsPlanStatusRoute
  AuthenticatedBcpResourcesSitesRoute: typeof AuthenticatedBcpResourcesSitesRouteWithChildren
  AuthenticatedBcpExercisesIndexRoute: typeof AuthenticatedBcpExercisesIndexRoute
  AuthenticatedBcpResourcesIndexRoute: typeof AuthenticatedBcpResourcesIndexRoute
}

const AuthenticatedBcpRouteChildren: AuthenticatedBcpRouteChildren = {
  AuthenticatedBcpBcpRoute: AuthenticatedBcpBcpRoute,
  AuthenticatedBcpBiaRoute: AuthenticatedBcpBiaRouteWithChildren,
  AuthenticatedBcpContinuityRoute: AuthenticatedBcpContinuityRoute,
  AuthenticatedBcpDashboardRoute: AuthenticatedBcpDashboardRoute,
  AuthenticatedBcpFindingsRoute: AuthenticatedBcpFindingsRoute,
  AuthenticatedBcpPlansRoute: AuthenticatedBcpPlansRouteWithChildren,
  AuthenticatedBcpExercisesExerciseIdRoute:
    AuthenticatedBcpExercisesExerciseIdRouteWithChildren,
  AuthenticatedBcpExercisesNewRoute: AuthenticatedBcpExercisesNewRoute,
  AuthenticatedBcpExercisesScheduleRoute:
    AuthenticatedBcpExercisesScheduleRoute,
  AuthenticatedBcpReportsExerciseSummaryRoute:
    AuthenticatedBcpReportsExerciseSummaryRoute,
  AuthenticatedBcpReportsGapAnalysisRoute:
    AuthenticatedBcpReportsGapAnalysisRoute,
  AuthenticatedBcpReportsIso22301Route: AuthenticatedBcpReportsIso22301Route,
  AuthenticatedBcpReportsNis2ComplianceRoute:
    AuthenticatedBcpReportsNis2ComplianceRoute,
  AuthenticatedBcpReportsPlanStatusRoute:
    AuthenticatedBcpReportsPlanStatusRoute,
  AuthenticatedBcpResourcesSitesRoute:
    AuthenticatedBcpResourcesSitesRouteWithChildren,
  AuthenticatedBcpExercisesIndexRoute: AuthenticatedBcpExercisesIndexRoute,
  AuthenticatedBcpResourcesIndexRoute: AuthenticatedBcpResourcesIndexRoute,
}

const AuthenticatedBcpRouteWithChildren =
  AuthenticatedBcpRoute._addFileChildren(AuthenticatedBcpRouteChildren)

interface AuthenticatedControlsRouteChildren {
  AuthenticatedControlsControlIdRoute: typeof AuthenticatedControlsControlIdRoute
  AuthenticatedControlsIndexRoute: typeof AuthenticatedControlsIndexRoute
}

const AuthenticatedControlsRouteChildren: AuthenticatedControlsRouteChildren = {
  AuthenticatedControlsControlIdRoute: AuthenticatedControlsControlIdRoute,
  AuthenticatedControlsIndexRoute: AuthenticatedControlsIndexRoute,
}

const AuthenticatedControlsRouteWithChildren =
  AuthenticatedControlsRoute._addFileChildren(
    AuthenticatedControlsRouteChildren,
  )

interface AuthenticatedEsgDoubleMaterialityAssessmentIdRouteChildren {
  AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute
}

const AuthenticatedEsgDoubleMaterialityAssessmentIdRouteChildren: AuthenticatedEsgDoubleMaterialityAssessmentIdRouteChildren =
  {
    AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdAssessmentRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdImpactsRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdMatrixRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdOverviewRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdQualityRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdRisksRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdStakeholdersRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdValueChainRoute,
    AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute:
      AuthenticatedEsgDoubleMaterialityAssessmentIdIndexRoute,
  }

const AuthenticatedEsgDoubleMaterialityAssessmentIdRouteWithChildren =
  AuthenticatedEsgDoubleMaterialityAssessmentIdRoute._addFileChildren(
    AuthenticatedEsgDoubleMaterialityAssessmentIdRouteChildren,
  )

interface AuthenticatedEsgRouteChildren {
  AuthenticatedEsgSectionRoute: typeof AuthenticatedEsgSectionRoute
  AuthenticatedEsgDoubleMaterialityAssessmentIdRoute: typeof AuthenticatedEsgDoubleMaterialityAssessmentIdRouteWithChildren
  AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute: typeof AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute
  AuthenticatedEsgOnboardingOnboardingIdRoute: typeof AuthenticatedEsgOnboardingOnboardingIdRoute
  AuthenticatedEsgDoubleMaterialityIndexRoute: typeof AuthenticatedEsgDoubleMaterialityIndexRoute
  AuthenticatedEsgOnboardingIndexRoute: typeof AuthenticatedEsgOnboardingIndexRoute
}

const AuthenticatedEsgRouteChildren: AuthenticatedEsgRouteChildren = {
  AuthenticatedEsgSectionRoute: AuthenticatedEsgSectionRoute,
  AuthenticatedEsgDoubleMaterialityAssessmentIdRoute:
    AuthenticatedEsgDoubleMaterialityAssessmentIdRouteWithChildren,
  AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute:
    AuthenticatedEsgDoubleMaterialityDatapointsPoliciesRoute,
  AuthenticatedEsgOnboardingOnboardingIdRoute:
    AuthenticatedEsgOnboardingOnboardingIdRoute,
  AuthenticatedEsgDoubleMaterialityIndexRoute:
    AuthenticatedEsgDoubleMaterialityIndexRoute,
  AuthenticatedEsgOnboardingIndexRoute: AuthenticatedEsgOnboardingIndexRoute,
}

const AuthenticatedEsgRouteWithChildren =
  AuthenticatedEsgRoute._addFileChildren(AuthenticatedEsgRouteChildren)

interface AuthenticatedEuTaxonomyRouteChildren {
  AuthenticatedEuTaxonomySectionRoute: typeof AuthenticatedEuTaxonomySectionRoute
}

const AuthenticatedEuTaxonomyRouteChildren: AuthenticatedEuTaxonomyRouteChildren =
  {
    AuthenticatedEuTaxonomySectionRoute: AuthenticatedEuTaxonomySectionRoute,
  }

const AuthenticatedEuTaxonomyRouteWithChildren =
  AuthenticatedEuTaxonomyRoute._addFileChildren(
    AuthenticatedEuTaxonomyRouteChildren,
  )

interface AuthenticatedGhgRecalculationsRouteChildren {
  AuthenticatedGhgRecalculationsRecalculationIdRoute: typeof AuthenticatedGhgRecalculationsRecalculationIdRoute
  AuthenticatedGhgRecalculationsIndexRoute: typeof AuthenticatedGhgRecalculationsIndexRoute
}

const AuthenticatedGhgRecalculationsRouteChildren: AuthenticatedGhgRecalculationsRouteChildren =
  {
    AuthenticatedGhgRecalculationsRecalculationIdRoute:
      AuthenticatedGhgRecalculationsRecalculationIdRoute,
    AuthenticatedGhgRecalculationsIndexRoute:
      AuthenticatedGhgRecalculationsIndexRoute,
  }

const AuthenticatedGhgRecalculationsRouteWithChildren =
  AuthenticatedGhgRecalculationsRoute._addFileChildren(
    AuthenticatedGhgRecalculationsRouteChildren,
  )

interface AuthenticatedGhgScope3CategoryRouteChildren {
  AuthenticatedGhgScope3CategoryDeriveRoute: typeof AuthenticatedGhgScope3CategoryDeriveRoute
  AuthenticatedGhgScope3CategoryIndexRoute: typeof AuthenticatedGhgScope3CategoryIndexRoute
}

const AuthenticatedGhgScope3CategoryRouteChildren: AuthenticatedGhgScope3CategoryRouteChildren =
  {
    AuthenticatedGhgScope3CategoryDeriveRoute:
      AuthenticatedGhgScope3CategoryDeriveRoute,
    AuthenticatedGhgScope3CategoryIndexRoute:
      AuthenticatedGhgScope3CategoryIndexRoute,
  }

const AuthenticatedGhgScope3CategoryRouteWithChildren =
  AuthenticatedGhgScope3CategoryRoute._addFileChildren(
    AuthenticatedGhgScope3CategoryRouteChildren,
  )

interface AuthenticatedGhgRouteChildren {
  AuthenticatedGhgActivityGroupsRoute: typeof AuthenticatedGhgActivityGroupsRoute
  AuthenticatedGhgAuditRoute: typeof AuthenticatedGhgAuditRoute
  AuthenticatedGhgBestPracticesRoute: typeof AuthenticatedGhgBestPracticesRoute
  AuthenticatedGhgBusinessTravelRoute: typeof AuthenticatedGhgBusinessTravelRoute
  AuthenticatedGhgCdpQuestionnaireRoute: typeof AuthenticatedGhgCdpQuestionnaireRoute
  AuthenticatedGhgCollectRoute: typeof AuthenticatedGhgCollectRoute
  AuthenticatedGhgCommutingRoute: typeof AuthenticatedGhgCommutingRoute
  AuthenticatedGhgDashboardRoute: typeof AuthenticatedGhgDashboardRoute
  AuthenticatedGhgDataQualityRoute: typeof AuthenticatedGhgDataQualityRoute
  AuthenticatedGhgEmissionFactorsRoute: typeof AuthenticatedGhgEmissionFactorsRoute
  AuthenticatedGhgEmissionInsightsRoute: typeof AuthenticatedGhgEmissionInsightsRoute
  AuthenticatedGhgEmissionsRoute: typeof AuthenticatedGhgEmissionsRoute
  AuthenticatedGhgGapAnalysisRoute: typeof AuthenticatedGhgGapAnalysisRoute
  AuthenticatedGhgIndustryComparisonRoute: typeof AuthenticatedGhgIndustryComparisonRoute
  AuthenticatedGhgIso14064ComplianceRoute: typeof AuthenticatedGhgIso14064ComplianceRoute
  AuthenticatedGhgMarketInstrumentsRoute: typeof AuthenticatedGhgMarketInstrumentsRoute
  AuthenticatedGhgNetZeroRoute: typeof AuthenticatedGhgNetZeroRoute
  AuthenticatedGhgOverviewRoute: typeof AuthenticatedGhgOverviewRoute
  AuthenticatedGhgPoliciesRoute: typeof AuthenticatedGhgPoliciesRoute
  AuthenticatedGhgProtocolComplianceRoute: typeof AuthenticatedGhgProtocolComplianceRoute
  AuthenticatedGhgRecalculationsRoute: typeof AuthenticatedGhgRecalculationsRouteWithChildren
  AuthenticatedGhgReportRoute: typeof AuthenticatedGhgReportRoute
  AuthenticatedGhgScope1Route: typeof AuthenticatedGhgScope1Route
  AuthenticatedGhgScope2Route: typeof AuthenticatedGhgScope2Route
  AuthenticatedGhgScope3ScreeningRoute: typeof AuthenticatedGhgScope3ScreeningRoute
  AuthenticatedGhgTasksRoute: typeof AuthenticatedGhgTasksRoute
  AuthenticatedGhgTravelImportRoute: typeof AuthenticatedGhgTravelImportRoute
  AuthenticatedGhgWasteRoute: typeof AuthenticatedGhgWasteRoute
  AuthenticatedGhgYoyComparisonRoute: typeof AuthenticatedGhgYoyComparisonRoute
  AuthenticatedGhgActivityDataEntryIdRoute: typeof AuthenticatedGhgActivityDataEntryIdRoute
  AuthenticatedGhgActivityDataAssignmentQueueRoute: typeof AuthenticatedGhgActivityDataAssignmentQueueRoute
  AuthenticatedGhgActivityDataDocumentOcrRoute: typeof AuthenticatedGhgActivityDataDocumentOcrRoute
  AuthenticatedGhgActivityDataImportRoute: typeof AuthenticatedGhgActivityDataImportRoute
  AuthenticatedGhgCalculationsScope1Route: typeof AuthenticatedGhgCalculationsScope1Route
  AuthenticatedGhgCalculationsScope2Route: typeof AuthenticatedGhgCalculationsScope2Route
  AuthenticatedGhgCalculationsScope3Route: typeof AuthenticatedGhgCalculationsScope3Route
  AuthenticatedGhgCommutingSurveysSurveyIdRoute: typeof AuthenticatedGhgCommutingSurveysSurveyIdRoute
  AuthenticatedGhgCommutingSurveysNewRoute: typeof AuthenticatedGhgCommutingSurveysNewRoute
  AuthenticatedGhgFacilitiesDashboardRoute: typeof AuthenticatedGhgFacilitiesDashboardRoute
  AuthenticatedGhgIntegrationsConnectorIdRoute: typeof AuthenticatedGhgIntegrationsConnectorIdRoute
  AuthenticatedGhgReductionInitiativesInitiativeIdRoute: typeof AuthenticatedGhgReductionInitiativesInitiativeIdRoute
  AuthenticatedGhgReductionInitiativesNewRoute: typeof AuthenticatedGhgReductionInitiativesNewRoute
  AuthenticatedGhgScenariosScenarioIdRoute: typeof AuthenticatedGhgScenariosScenarioIdRoute
  AuthenticatedGhgScenariosCompareRoute: typeof AuthenticatedGhgScenariosCompareRoute
  AuthenticatedGhgScenariosNewRoute: typeof AuthenticatedGhgScenariosNewRoute
  AuthenticatedGhgScope3CategoryRoute: typeof AuthenticatedGhgScope3CategoryRouteWithChildren
  AuthenticatedGhgScope3AddRoute: typeof AuthenticatedGhgScope3AddRoute
  AuthenticatedGhgScope3SoldProductsRoute: typeof AuthenticatedGhgScope3SoldProductsRoute
  AuthenticatedGhgSettingsScope1Route: typeof AuthenticatedGhgSettingsScope1Route
  AuthenticatedGhgSettingsScope2Route: typeof AuthenticatedGhgSettingsScope2Route
  AuthenticatedGhgTargetsTargetIdRoute: typeof AuthenticatedGhgTargetsTargetIdRoute
  AuthenticatedGhgTargetsNewRoute: typeof AuthenticatedGhgTargetsNewRoute
  AuthenticatedGhgThirdPartyVerificationEngagementIdRoute: typeof AuthenticatedGhgThirdPartyVerificationEngagementIdRoute
  AuthenticatedGhgVerificationStatementsStatementIdRoute: typeof AuthenticatedGhgVerificationStatementsStatementIdRoute
  AuthenticatedGhgVerificationChecklistIdRoute: typeof AuthenticatedGhgVerificationChecklistIdRoute
  AuthenticatedGhgActivityDataIndexRoute: typeof AuthenticatedGhgActivityDataIndexRoute
  AuthenticatedGhgApprovalsIndexRoute: typeof AuthenticatedGhgApprovalsIndexRoute
  AuthenticatedGhgCommutingSurveysIndexRoute: typeof AuthenticatedGhgCommutingSurveysIndexRoute
  AuthenticatedGhgExportsIndexRoute: typeof AuthenticatedGhgExportsIndexRoute
  AuthenticatedGhgIntegrationsIndexRoute: typeof AuthenticatedGhgIntegrationsIndexRoute
  AuthenticatedGhgReductionInitiativesIndexRoute: typeof AuthenticatedGhgReductionInitiativesIndexRoute
  AuthenticatedGhgReportsIndexRoute: typeof AuthenticatedGhgReportsIndexRoute
  AuthenticatedGhgScenariosIndexRoute: typeof AuthenticatedGhgScenariosIndexRoute
  AuthenticatedGhgSettingsIndexRoute: typeof AuthenticatedGhgSettingsIndexRoute
  AuthenticatedGhgSetupIndexRoute: typeof AuthenticatedGhgSetupIndexRoute
  AuthenticatedGhgTargetsIndexRoute: typeof AuthenticatedGhgTargetsIndexRoute
  AuthenticatedGhgThirdPartyVerificationIndexRoute: typeof AuthenticatedGhgThirdPartyVerificationIndexRoute
  AuthenticatedGhgVerificationStatementsIndexRoute: typeof AuthenticatedGhgVerificationStatementsIndexRoute
  AuthenticatedGhgVerificationIndexRoute: typeof AuthenticatedGhgVerificationIndexRoute
  AuthenticatedGhgReportsCustomReportIdRoute: typeof AuthenticatedGhgReportsCustomReportIdRoute
  AuthenticatedGhgReportsCustomNewRoute: typeof AuthenticatedGhgReportsCustomNewRoute
  AuthenticatedGhgVerificationInternalVerificationIdRoute: typeof AuthenticatedGhgVerificationInternalVerificationIdRoute
  AuthenticatedGhgReportsCustomIndexRoute: typeof AuthenticatedGhgReportsCustomIndexRoute
  AuthenticatedGhgVerificationInternalIndexRoute: typeof AuthenticatedGhgVerificationInternalIndexRoute
}

const AuthenticatedGhgRouteChildren: AuthenticatedGhgRouteChildren = {
  AuthenticatedGhgActivityGroupsRoute: AuthenticatedGhgActivityGroupsRoute,
  AuthenticatedGhgAuditRoute: AuthenticatedGhgAuditRoute,
  AuthenticatedGhgBestPracticesRoute: AuthenticatedGhgBestPracticesRoute,
  AuthenticatedGhgBusinessTravelRoute: AuthenticatedGhgBusinessTravelRoute,
  AuthenticatedGhgCdpQuestionnaireRoute: AuthenticatedGhgCdpQuestionnaireRoute,
  AuthenticatedGhgCollectRoute: AuthenticatedGhgCollectRoute,
  AuthenticatedGhgCommutingRoute: AuthenticatedGhgCommutingRoute,
  AuthenticatedGhgDashboardRoute: AuthenticatedGhgDashboardRoute,
  AuthenticatedGhgDataQualityRoute: AuthenticatedGhgDataQualityRoute,
  AuthenticatedGhgEmissionFactorsRoute: AuthenticatedGhgEmissionFactorsRoute,
  AuthenticatedGhgEmissionInsightsRoute: AuthenticatedGhgEmissionInsightsRoute,
  AuthenticatedGhgEmissionsRoute: AuthenticatedGhgEmissionsRoute,
  AuthenticatedGhgGapAnalysisRoute: AuthenticatedGhgGapAnalysisRoute,
  AuthenticatedGhgIndustryComparisonRoute:
    AuthenticatedGhgIndustryComparisonRoute,
  AuthenticatedGhgIso14064ComplianceRoute:
    AuthenticatedGhgIso14064ComplianceRoute,
  AuthenticatedGhgMarketInstrumentsRoute:
    AuthenticatedGhgMarketInstrumentsRoute,
  AuthenticatedGhgNetZeroRoute: AuthenticatedGhgNetZeroRoute,
  AuthenticatedGhgOverviewRoute: AuthenticatedGhgOverviewRoute,
  AuthenticatedGhgPoliciesRoute: AuthenticatedGhgPoliciesRoute,
  AuthenticatedGhgProtocolComplianceRoute:
    AuthenticatedGhgProtocolComplianceRoute,
  AuthenticatedGhgRecalculationsRoute:
    AuthenticatedGhgRecalculationsRouteWithChildren,
  AuthenticatedGhgReportRoute: AuthenticatedGhgReportRoute,
  AuthenticatedGhgScope1Route: AuthenticatedGhgScope1Route,
  AuthenticatedGhgScope2Route: AuthenticatedGhgScope2Route,
  AuthenticatedGhgScope3ScreeningRoute: AuthenticatedGhgScope3ScreeningRoute,
  AuthenticatedGhgTasksRoute: AuthenticatedGhgTasksRoute,
  AuthenticatedGhgTravelImportRoute: AuthenticatedGhgTravelImportRoute,
  AuthenticatedGhgWasteRoute: AuthenticatedGhgWasteRoute,
  AuthenticatedGhgYoyComparisonRoute: AuthenticatedGhgYoyComparisonRoute,
  AuthenticatedGhgActivityDataEntryIdRoute:
    AuthenticatedGhgActivityDataEntryIdRoute,
  AuthenticatedGhgActivityDataAssignmentQueueRoute:
    AuthenticatedGhgActivityDataAssignmentQueueRoute,
  AuthenticatedGhgActivityDataDocumentOcrRoute:
    AuthenticatedGhgActivityDataDocumentOcrRoute,
  AuthenticatedGhgActivityDataImportRoute:
    AuthenticatedGhgActivityDataImportRoute,
  AuthenticatedGhgCalculationsScope1Route:
    AuthenticatedGhgCalculationsScope1Route,
  AuthenticatedGhgCalculationsScope2Route:
    AuthenticatedGhgCalculationsScope2Route,
  AuthenticatedGhgCalculationsScope3Route:
    AuthenticatedGhgCalculationsScope3Route,
  AuthenticatedGhgCommutingSurveysSurveyIdRoute:
    AuthenticatedGhgCommutingSurveysSurveyIdRoute,
  AuthenticatedGhgCommutingSurveysNewRoute:
    AuthenticatedGhgCommutingSurveysNewRoute,
  AuthenticatedGhgFacilitiesDashboardRoute:
    AuthenticatedGhgFacilitiesDashboardRoute,
  AuthenticatedGhgIntegrationsConnectorIdRoute:
    AuthenticatedGhgIntegrationsConnectorIdRoute,
  AuthenticatedGhgReductionInitiativesInitiativeIdRoute:
    AuthenticatedGhgReductionInitiativesInitiativeIdRoute,
  AuthenticatedGhgReductionInitiativesNewRoute:
    AuthenticatedGhgReductionInitiativesNewRoute,
  AuthenticatedGhgScenariosScenarioIdRoute:
    AuthenticatedGhgScenariosScenarioIdRoute,
  AuthenticatedGhgScenariosCompareRoute: AuthenticatedGhgScenariosCompareRoute,
  AuthenticatedGhgScenariosNewRoute: AuthenticatedGhgScenariosNewRoute,
  AuthenticatedGhgScope3CategoryRoute:
    AuthenticatedGhgScope3CategoryRouteWithChildren,
  AuthenticatedGhgScope3AddRoute: AuthenticatedGhgScope3AddRoute,
  AuthenticatedGhgScope3SoldProductsRoute:
    AuthenticatedGhgScope3SoldProductsRoute,
  AuthenticatedGhgSettingsScope1Route: AuthenticatedGhgSettingsScope1Route,
  AuthenticatedGhgSettingsScope2Route: AuthenticatedGhgSettingsScope2Route,
  AuthenticatedGhgTargetsTargetIdRoute: AuthenticatedGhgTargetsTargetIdRoute,
  AuthenticatedGhgTargetsNewRoute: AuthenticatedGhgTargetsNewRoute,
  AuthenticatedGhgThirdPartyVerificationEngagementIdRoute:
    AuthenticatedGhgThirdPartyVerificationEngagementIdRoute,
  AuthenticatedGhgVerificationStatementsStatementIdRoute:
    AuthenticatedGhgVerificationStatementsStatementIdRoute,
  AuthenticatedGhgVerificationChecklistIdRoute:
    AuthenticatedGhgVerificationChecklistIdRoute,
  AuthenticatedGhgActivityDataIndexRoute:
    AuthenticatedGhgActivityDataIndexRoute,
  AuthenticatedGhgApprovalsIndexRoute: AuthenticatedGhgApprovalsIndexRoute,
  AuthenticatedGhgCommutingSurveysIndexRoute:
    AuthenticatedGhgCommutingSurveysIndexRoute,
  AuthenticatedGhgExportsIndexRoute: AuthenticatedGhgExportsIndexRoute,
  AuthenticatedGhgIntegrationsIndexRoute:
    AuthenticatedGhgIntegrationsIndexRoute,
  AuthenticatedGhgReductionInitiativesIndexRoute:
    AuthenticatedGhgReductionInitiativesIndexRoute,
  AuthenticatedGhgReportsIndexRoute: AuthenticatedGhgReportsIndexRoute,
  AuthenticatedGhgScenariosIndexRoute: AuthenticatedGhgScenariosIndexRoute,
  AuthenticatedGhgSettingsIndexRoute: AuthenticatedGhgSettingsIndexRoute,
  AuthenticatedGhgSetupIndexRoute: AuthenticatedGhgSetupIndexRoute,
  AuthenticatedGhgTargetsIndexRoute: AuthenticatedGhgTargetsIndexRoute,
  AuthenticatedGhgThirdPartyVerificationIndexRoute:
    AuthenticatedGhgThirdPartyVerificationIndexRoute,
  AuthenticatedGhgVerificationStatementsIndexRoute:
    AuthenticatedGhgVerificationStatementsIndexRoute,
  AuthenticatedGhgVerificationIndexRoute:
    AuthenticatedGhgVerificationIndexRoute,
  AuthenticatedGhgReportsCustomReportIdRoute:
    AuthenticatedGhgReportsCustomReportIdRoute,
  AuthenticatedGhgReportsCustomNewRoute: AuthenticatedGhgReportsCustomNewRoute,
  AuthenticatedGhgVerificationInternalVerificationIdRoute:
    AuthenticatedGhgVerificationInternalVerificationIdRoute,
  AuthenticatedGhgReportsCustomIndexRoute:
    AuthenticatedGhgReportsCustomIndexRoute,
  AuthenticatedGhgVerificationInternalIndexRoute:
    AuthenticatedGhgVerificationInternalIndexRoute,
}

const AuthenticatedGhgRouteWithChildren =
  AuthenticatedGhgRoute._addFileChildren(AuthenticatedGhgRouteChildren)

interface AuthenticatedHelpCentreRouteChildren {
  AuthenticatedHelpCentrePlatformGuidesRoute: typeof AuthenticatedHelpCentrePlatformGuidesRoute
  AuthenticatedHelpCentreRegulationsRoute: typeof AuthenticatedHelpCentreRegulationsRoute
}

const AuthenticatedHelpCentreRouteChildren: AuthenticatedHelpCentreRouteChildren =
  {
    AuthenticatedHelpCentrePlatformGuidesRoute:
      AuthenticatedHelpCentrePlatformGuidesRoute,
    AuthenticatedHelpCentreRegulationsRoute:
      AuthenticatedHelpCentreRegulationsRoute,
  }

const AuthenticatedHelpCentreRouteWithChildren =
  AuthenticatedHelpCentreRoute._addFileChildren(
    AuthenticatedHelpCentreRouteChildren,
  )

interface AuthenticatedNis2RouteChildren {
  AuthenticatedNis2AssetRegisterRoute: typeof AuthenticatedNis2AssetRegisterRoute
  AuthenticatedNis2AssetsAndMeasuresRoute: typeof AuthenticatedNis2AssetsAndMeasuresRoute
  AuthenticatedNis2AssetsMeasuresRoute: typeof AuthenticatedNis2AssetsMeasuresRoute
  AuthenticatedNis2BusinessContinuityRoute: typeof AuthenticatedNis2BusinessContinuityRoute
  AuthenticatedNis2DashboardRoute: typeof AuthenticatedNis2DashboardRoute
  AuthenticatedNis2EntityClassificationRoute: typeof AuthenticatedNis2EntityClassificationRoute
  AuthenticatedNis2EvidenceRoute: typeof AuthenticatedNis2EvidenceRoute
  AuthenticatedNis2GapAnalysisRoute: typeof AuthenticatedNis2GapAnalysisRoute
  AuthenticatedNis2GapsRoute: typeof AuthenticatedNis2GapsRoute
  AuthenticatedNis2HrTrainingRoute: typeof AuthenticatedNis2HrTrainingRoute
  AuthenticatedNis2HumanResourcesSecurityRoute: typeof AuthenticatedNis2HumanResourcesSecurityRoute
  AuthenticatedNis2IncidentManagementRoute: typeof AuthenticatedNis2IncidentManagementRoute
  AuthenticatedNis2IsmsRoute: typeof AuthenticatedNis2IsmsRoute
  AuthenticatedNis2KnowledgeBaseRoute: typeof AuthenticatedNis2KnowledgeBaseRoute
  AuthenticatedNis2MeasureARoute: typeof AuthenticatedNis2MeasureARoute
  AuthenticatedNis2MeasureDRoute: typeof AuthenticatedNis2MeasureDRoute
  AuthenticatedNis2OnboardingRoute: typeof AuthenticatedNis2OnboardingRoute
  AuthenticatedNis2OverviewRoute: typeof AuthenticatedNis2OverviewRoute
  AuthenticatedNis2PoliciesGovernanceRoute: typeof AuthenticatedNis2PoliciesGovernanceRoute
  AuthenticatedNis2PolicyGovernanceRoute: typeof AuthenticatedNis2PolicyGovernanceRoute
  AuthenticatedNis2RiskManagementRoute: typeof AuthenticatedNis2RiskManagementRoute
  AuthenticatedNis2SelfAssessmentRoute: typeof AuthenticatedNis2SelfAssessmentRoute
  AuthenticatedNis2SupplyChainSecurityRoute: typeof AuthenticatedNis2SupplyChainSecurityRoute
  AuthenticatedNis2InspectionPreparationPreparationIdRoute: typeof AuthenticatedNis2InspectionPreparationPreparationIdRoute
  AuthenticatedNis2MeasuresMeasureCodeRoute: typeof AuthenticatedNis2MeasuresMeasureCodeRoute
  AuthenticatedNis2ReportsActivityRoute: typeof AuthenticatedNis2ReportsActivityRoute
  AuthenticatedNis2ReportsAuditPreparationRoute: typeof AuthenticatedNis2ReportsAuditPreparationRoute
  AuthenticatedNis2ReportsBoardRoute: typeof AuthenticatedNis2ReportsBoardRoute
  AuthenticatedNis2ReportsComplianceRoute: typeof AuthenticatedNis2ReportsComplianceRoute
  AuthenticatedNis2ReportsConsolidatedRoute: typeof AuthenticatedNis2ReportsConsolidatedRoute
  AuthenticatedNis2ReportsCrossBorderRoute: typeof AuthenticatedNis2ReportsCrossBorderRoute
  AuthenticatedNis2ReportsExecutiveRoute: typeof AuthenticatedNis2ReportsExecutiveRoute
  AuthenticatedNis2ReportsScheduledRoute: typeof AuthenticatedNis2ReportsScheduledRoute
  AuthenticatedNis2InspectionPreparationIndexRoute: typeof AuthenticatedNis2InspectionPreparationIndexRoute
  AuthenticatedNis2MeasuresIndexRoute: typeof AuthenticatedNis2MeasuresIndexRoute
  AuthenticatedNis2ReportsIndexRoute: typeof AuthenticatedNis2ReportsIndexRoute
  AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute: typeof AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute
  AuthenticatedNis2IncidentsIncidentIdFinalReportRoute: typeof AuthenticatedNis2IncidentsIncidentIdFinalReportRoute
  AuthenticatedNis2IncidentsIncidentIdNotificationRoute: typeof AuthenticatedNis2IncidentsIncidentIdNotificationRoute
  AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute: typeof AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute
}

const AuthenticatedNis2RouteChildren: AuthenticatedNis2RouteChildren = {
  AuthenticatedNis2AssetRegisterRoute: AuthenticatedNis2AssetRegisterRoute,
  AuthenticatedNis2AssetsAndMeasuresRoute:
    AuthenticatedNis2AssetsAndMeasuresRoute,
  AuthenticatedNis2AssetsMeasuresRoute: AuthenticatedNis2AssetsMeasuresRoute,
  AuthenticatedNis2BusinessContinuityRoute:
    AuthenticatedNis2BusinessContinuityRoute,
  AuthenticatedNis2DashboardRoute: AuthenticatedNis2DashboardRoute,
  AuthenticatedNis2EntityClassificationRoute:
    AuthenticatedNis2EntityClassificationRoute,
  AuthenticatedNis2EvidenceRoute: AuthenticatedNis2EvidenceRoute,
  AuthenticatedNis2GapAnalysisRoute: AuthenticatedNis2GapAnalysisRoute,
  AuthenticatedNis2GapsRoute: AuthenticatedNis2GapsRoute,
  AuthenticatedNis2HrTrainingRoute: AuthenticatedNis2HrTrainingRoute,
  AuthenticatedNis2HumanResourcesSecurityRoute:
    AuthenticatedNis2HumanResourcesSecurityRoute,
  AuthenticatedNis2IncidentManagementRoute:
    AuthenticatedNis2IncidentManagementRoute,
  AuthenticatedNis2IsmsRoute: AuthenticatedNis2IsmsRoute,
  AuthenticatedNis2KnowledgeBaseRoute: AuthenticatedNis2KnowledgeBaseRoute,
  AuthenticatedNis2MeasureARoute: AuthenticatedNis2MeasureARoute,
  AuthenticatedNis2MeasureDRoute: AuthenticatedNis2MeasureDRoute,
  AuthenticatedNis2OnboardingRoute: AuthenticatedNis2OnboardingRoute,
  AuthenticatedNis2OverviewRoute: AuthenticatedNis2OverviewRoute,
  AuthenticatedNis2PoliciesGovernanceRoute:
    AuthenticatedNis2PoliciesGovernanceRoute,
  AuthenticatedNis2PolicyGovernanceRoute:
    AuthenticatedNis2PolicyGovernanceRoute,
  AuthenticatedNis2RiskManagementRoute: AuthenticatedNis2RiskManagementRoute,
  AuthenticatedNis2SelfAssessmentRoute: AuthenticatedNis2SelfAssessmentRoute,
  AuthenticatedNis2SupplyChainSecurityRoute:
    AuthenticatedNis2SupplyChainSecurityRoute,
  AuthenticatedNis2InspectionPreparationPreparationIdRoute:
    AuthenticatedNis2InspectionPreparationPreparationIdRoute,
  AuthenticatedNis2MeasuresMeasureCodeRoute:
    AuthenticatedNis2MeasuresMeasureCodeRoute,
  AuthenticatedNis2ReportsActivityRoute: AuthenticatedNis2ReportsActivityRoute,
  AuthenticatedNis2ReportsAuditPreparationRoute:
    AuthenticatedNis2ReportsAuditPreparationRoute,
  AuthenticatedNis2ReportsBoardRoute: AuthenticatedNis2ReportsBoardRoute,
  AuthenticatedNis2ReportsComplianceRoute:
    AuthenticatedNis2ReportsComplianceRoute,
  AuthenticatedNis2ReportsConsolidatedRoute:
    AuthenticatedNis2ReportsConsolidatedRoute,
  AuthenticatedNis2ReportsCrossBorderRoute:
    AuthenticatedNis2ReportsCrossBorderRoute,
  AuthenticatedNis2ReportsExecutiveRoute:
    AuthenticatedNis2ReportsExecutiveRoute,
  AuthenticatedNis2ReportsScheduledRoute:
    AuthenticatedNis2ReportsScheduledRoute,
  AuthenticatedNis2InspectionPreparationIndexRoute:
    AuthenticatedNis2InspectionPreparationIndexRoute,
  AuthenticatedNis2MeasuresIndexRoute: AuthenticatedNis2MeasuresIndexRoute,
  AuthenticatedNis2ReportsIndexRoute: AuthenticatedNis2ReportsIndexRoute,
  AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute:
    AuthenticatedNis2IncidentsIncidentIdEarlyWarningRoute,
  AuthenticatedNis2IncidentsIncidentIdFinalReportRoute:
    AuthenticatedNis2IncidentsIncidentIdFinalReportRoute,
  AuthenticatedNis2IncidentsIncidentIdNotificationRoute:
    AuthenticatedNis2IncidentsIncidentIdNotificationRoute,
  AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute:
    AuthenticatedNis2IncidentsIncidentIdProgressUpdatesRoute,
}

const AuthenticatedNis2RouteWithChildren =
  AuthenticatedNis2Route._addFileChildren(AuthenticatedNis2RouteChildren)

interface AuthenticatedSettingsAiConversationsRouteChildren {
  AuthenticatedSettingsAiConversationsConversationIdRoute: typeof AuthenticatedSettingsAiConversationsConversationIdRoute
}

const AuthenticatedSettingsAiConversationsRouteChildren: AuthenticatedSettingsAiConversationsRouteChildren =
  {
    AuthenticatedSettingsAiConversationsConversationIdRoute:
      AuthenticatedSettingsAiConversationsConversationIdRoute,
  }

const AuthenticatedSettingsAiConversationsRouteWithChildren =
  AuthenticatedSettingsAiConversationsRoute._addFileChildren(
    AuthenticatedSettingsAiConversationsRouteChildren,
  )

interface AuthenticatedSettingsSecurityRouteChildren {
  AuthenticatedSettingsSecuritySessionsRoute: typeof AuthenticatedSettingsSecuritySessionsRoute
  AuthenticatedSettingsSecurityIndexRoute: typeof AuthenticatedSettingsSecurityIndexRoute
}

const AuthenticatedSettingsSecurityRouteChildren: AuthenticatedSettingsSecurityRouteChildren =
  {
    AuthenticatedSettingsSecuritySessionsRoute:
      AuthenticatedSettingsSecuritySessionsRoute,
    AuthenticatedSettingsSecurityIndexRoute:
      AuthenticatedSettingsSecurityIndexRoute,
  }

const AuthenticatedSettingsSecurityRouteWithChildren =
  AuthenticatedSettingsSecurityRoute._addFileChildren(
    AuthenticatedSettingsSecurityRouteChildren,
  )

interface AuthenticatedSettingsTeamMembersUserIdRouteChildren {
  AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute: typeof AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute
}

const AuthenticatedSettingsTeamMembersUserIdRouteChildren: AuthenticatedSettingsTeamMembersUserIdRouteChildren =
  {
    AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute:
      AuthenticatedSettingsTeamMembersUserIdHistoryConnectionsRoute,
  }

const AuthenticatedSettingsTeamMembersUserIdRouteWithChildren =
  AuthenticatedSettingsTeamMembersUserIdRoute._addFileChildren(
    AuthenticatedSettingsTeamMembersUserIdRouteChildren,
  )

interface AuthenticatedSettingsTeamRouteChildren {
  AuthenticatedSettingsTeamMembersUserIdRoute: typeof AuthenticatedSettingsTeamMembersUserIdRouteWithChildren
}

const AuthenticatedSettingsTeamRouteChildren: AuthenticatedSettingsTeamRouteChildren =
  {
    AuthenticatedSettingsTeamMembersUserIdRoute:
      AuthenticatedSettingsTeamMembersUserIdRouteWithChildren,
  }

const AuthenticatedSettingsTeamRouteWithChildren =
  AuthenticatedSettingsTeamRoute._addFileChildren(
    AuthenticatedSettingsTeamRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccessLogRoute: typeof AuthenticatedSettingsAccessLogRoute
  AuthenticatedSettingsAiConversationsRoute: typeof AuthenticatedSettingsAiConversationsRouteWithChildren
  AuthenticatedSettingsAiSettingsRoute: typeof AuthenticatedSettingsAiSettingsRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsAssetCategoriesRoute: typeof AuthenticatedSettingsAssetCategoriesRoute
  AuthenticatedSettingsAssetConnectorsRoute: typeof AuthenticatedSettingsAssetConnectorsRoute
  AuthenticatedSettingsAssetCustomFieldsRoute: typeof AuthenticatedSettingsAssetCustomFieldsRoute
  AuthenticatedSettingsAssetTagsRoute: typeof AuthenticatedSettingsAssetTagsRoute
  AuthenticatedSettingsAuditAlertsRoute: typeof AuthenticatedSettingsAuditAlertsRoute
  AuthenticatedSettingsAuditLogRoute: typeof AuthenticatedSettingsAuditLogRoute
  AuthenticatedSettingsAuditSettingsRoute: typeof AuthenticatedSettingsAuditSettingsRoute
  AuthenticatedSettingsAuditWebhooksRoute: typeof AuthenticatedSettingsAuditWebhooksRoute
  AuthenticatedSettingsAuditorsRoute: typeof AuthenticatedSettingsAuditorsRoute
  AuthenticatedSettingsBcpExerciseSettingsRoute: typeof AuthenticatedSettingsBcpExerciseSettingsRoute
  AuthenticatedSettingsBcpReviewSettingsRoute: typeof AuthenticatedSettingsBcpReviewSettingsRoute
  AuthenticatedSettingsComplianceFrameworksRoute: typeof AuthenticatedSettingsComplianceFrameworksRoute
  AuthenticatedSettingsConfigrationRoute: typeof AuthenticatedSettingsConfigrationRoute
  AuthenticatedSettingsCredentialsRoute: typeof AuthenticatedSettingsCredentialsRoute
  AuthenticatedSettingsEvidenceCollectionsRoute: typeof AuthenticatedSettingsEvidenceCollectionsRoute
  AuthenticatedSettingsGapDetectionRulesRoute: typeof AuthenticatedSettingsGapDetectionRulesRoute
  AuthenticatedSettingsGhgBoundaryRoute: typeof AuthenticatedSettingsGhgBoundaryRoute
  AuthenticatedSettingsGhgFacilitiesRoute: typeof AuthenticatedSettingsGhgFacilitiesRoute
  AuthenticatedSettingsGhgPermissionsRoute: typeof AuthenticatedSettingsGhgPermissionsRoute
  AuthenticatedSettingsGhgSourcesRoute: typeof AuthenticatedSettingsGhgSourcesRoute
  AuthenticatedSettingsIncidentCategoriesRoute: typeof AuthenticatedSettingsIncidentCategoriesRoute
  AuthenticatedSettingsMyActivityRoute: typeof AuthenticatedSettingsMyActivityRoute
  AuthenticatedSettingsNis2ClassificationRoute: typeof AuthenticatedSettingsNis2ClassificationRoute
  AuthenticatedSettingsNis2GapPriorityRoute: typeof AuthenticatedSettingsNis2GapPriorityRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsOrganisationStructureRoute: typeof AuthenticatedSettingsOrganisationStructureRoute
  AuthenticatedSettingsOrganizationsRoute: typeof AuthenticatedSettingsOrganizationsRoute
  AuthenticatedSettingsPolicyCategoriesRoute: typeof AuthenticatedSettingsPolicyCategoriesRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsReportingPeriodsRoute: typeof AuthenticatedSettingsReportingPeriodsRoute
  AuthenticatedSettingsRiskRoute: typeof AuthenticatedSettingsRiskRoute
  AuthenticatedSettingsRolesRoute: typeof AuthenticatedSettingsRolesRoute
  AuthenticatedSettingsScannerIntegrationsRoute: typeof AuthenticatedSettingsScannerIntegrationsRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRouteWithChildren
  AuthenticatedSettingsSubsidiariesRoute: typeof AuthenticatedSettingsSubsidiariesRoute
  AuthenticatedSettingsSupplierCategoriesRoute: typeof AuthenticatedSettingsSupplierCategoriesRoute
  AuthenticatedSettingsTaskSchedulesRoute: typeof AuthenticatedSettingsTaskSchedulesRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRouteWithChildren
  AuthenticatedSettingsVulnerabilitySettingsRoute: typeof AuthenticatedSettingsVulnerabilitySettingsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsNis2RemindersRoute: typeof AuthenticatedSettingsNis2RemindersRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccessLogRoute: AuthenticatedSettingsAccessLogRoute,
  AuthenticatedSettingsAiConversationsRoute:
    AuthenticatedSettingsAiConversationsRouteWithChildren,
  AuthenticatedSettingsAiSettingsRoute: AuthenticatedSettingsAiSettingsRoute,
  AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
  AuthenticatedSettingsAssetCategoriesRoute:
    AuthenticatedSettingsAssetCategoriesRoute,
  AuthenticatedSettingsAssetConnectorsRoute:
    AuthenticatedSettingsAssetConnectorsRoute,
  AuthenticatedSettingsAssetCustomFieldsRoute:
    AuthenticatedSettingsAssetCustomFieldsRoute,
  AuthenticatedSettingsAssetTagsRoute: AuthenticatedSettingsAssetTagsRoute,
  AuthenticatedSettingsAuditAlertsRoute: AuthenticatedSettingsAuditAlertsRoute,
  AuthenticatedSettingsAuditLogRoute: AuthenticatedSettingsAuditLogRoute,
  AuthenticatedSettingsAuditSettingsRoute:
    AuthenticatedSettingsAuditSettingsRoute,
  AuthenticatedSettingsAuditWebhooksRoute:
    AuthenticatedSettingsAuditWebhooksRoute,
  AuthenticatedSettingsAuditorsRoute: AuthenticatedSettingsAuditorsRoute,
  AuthenticatedSettingsBcpExerciseSettingsRoute:
    AuthenticatedSettingsBcpExerciseSettingsRoute,
  AuthenticatedSettingsBcpReviewSettingsRoute:
    AuthenticatedSettingsBcpReviewSettingsRoute,
  AuthenticatedSettingsComplianceFrameworksRoute:
    AuthenticatedSettingsComplianceFrameworksRoute,
  AuthenticatedSettingsConfigrationRoute:
    AuthenticatedSettingsConfigrationRoute,
  AuthenticatedSettingsCredentialsRoute: AuthenticatedSettingsCredentialsRoute,
  AuthenticatedSettingsEvidenceCollectionsRoute:
    AuthenticatedSettingsEvidenceCollectionsRoute,
  AuthenticatedSettingsGapDetectionRulesRoute:
    AuthenticatedSettingsGapDetectionRulesRoute,
  AuthenticatedSettingsGhgBoundaryRoute: AuthenticatedSettingsGhgBoundaryRoute,
  AuthenticatedSettingsGhgFacilitiesRoute:
    AuthenticatedSettingsGhgFacilitiesRoute,
  AuthenticatedSettingsGhgPermissionsRoute:
    AuthenticatedSettingsGhgPermissionsRoute,
  AuthenticatedSettingsGhgSourcesRoute: AuthenticatedSettingsGhgSourcesRoute,
  AuthenticatedSettingsIncidentCategoriesRoute:
    AuthenticatedSettingsIncidentCategoriesRoute,
  AuthenticatedSettingsMyActivityRoute: AuthenticatedSettingsMyActivityRoute,
  AuthenticatedSettingsNis2ClassificationRoute:
    AuthenticatedSettingsNis2ClassificationRoute,
  AuthenticatedSettingsNis2GapPriorityRoute:
    AuthenticatedSettingsNis2GapPriorityRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsOrganisationStructureRoute:
    AuthenticatedSettingsOrganisationStructureRoute,
  AuthenticatedSettingsOrganizationsRoute:
    AuthenticatedSettingsOrganizationsRoute,
  AuthenticatedSettingsPolicyCategoriesRoute:
    AuthenticatedSettingsPolicyCategoriesRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsReportingPeriodsRoute:
    AuthenticatedSettingsReportingPeriodsRoute,
  AuthenticatedSettingsRiskRoute: AuthenticatedSettingsRiskRoute,
  AuthenticatedSettingsRolesRoute: AuthenticatedSettingsRolesRoute,
  AuthenticatedSettingsScannerIntegrationsRoute:
    AuthenticatedSettingsScannerIntegrationsRoute,
  AuthenticatedSettingsSecurityRoute:
    AuthenticatedSettingsSecurityRouteWithChildren,
  AuthenticatedSettingsSubsidiariesRoute:
    AuthenticatedSettingsSubsidiariesRoute,
  AuthenticatedSettingsSupplierCategoriesRoute:
    AuthenticatedSettingsSupplierCategoriesRoute,
  AuthenticatedSettingsTaskSchedulesRoute:
    AuthenticatedSettingsTaskSchedulesRoute,
  AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRouteWithChildren,
  AuthenticatedSettingsVulnerabilitySettingsRoute:
    AuthenticatedSettingsVulnerabilitySettingsRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsNis2RemindersRoute:
    AuthenticatedSettingsNis2RemindersRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedVsmeRouteChildren {
  AuthenticatedVsmeSectionRoute: typeof AuthenticatedVsmeSectionRoute
}

const AuthenticatedVsmeRouteChildren: AuthenticatedVsmeRouteChildren = {
  AuthenticatedVsmeSectionRoute: AuthenticatedVsmeSectionRoute,
}

const AuthenticatedVsmeRouteWithChildren =
  AuthenticatedVsmeRoute._addFileChildren(AuthenticatedVsmeRouteChildren)

interface AuthenticatedWorkforceReadinessAwarenessCampaignsRouteChildren {
  AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute: typeof AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute
}

const AuthenticatedWorkforceReadinessAwarenessCampaignsRouteChildren: AuthenticatedWorkforceReadinessAwarenessCampaignsRouteChildren =
  {
    AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute:
      AuthenticatedWorkforceReadinessAwarenessCampaignsCampaignIdRoute,
  }

const AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren =
  AuthenticatedWorkforceReadinessAwarenessCampaignsRoute._addFileChildren(
    AuthenticatedWorkforceReadinessAwarenessCampaignsRouteChildren,
  )

interface AuthenticatedWorkforceReadinessTrainingRegisterRouteChildren {
  AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute: typeof AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute
}

const AuthenticatedWorkforceReadinessTrainingRegisterRouteChildren: AuthenticatedWorkforceReadinessTrainingRegisterRouteChildren =
  {
    AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute:
      AuthenticatedWorkforceReadinessTrainingRegisterTrainingIdRoute,
  }

const AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren =
  AuthenticatedWorkforceReadinessTrainingRegisterRoute._addFileChildren(
    AuthenticatedWorkforceReadinessTrainingRegisterRouteChildren,
  )

interface AuthenticatedWorkforceReadinessRouteChildren {
  AuthenticatedWorkforceReadinessAwarenessCampaignsRoute: typeof AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren
  AuthenticatedWorkforceReadinessMyTrainingsRoute: typeof AuthenticatedWorkforceReadinessMyTrainingsRoute
  AuthenticatedWorkforceReadinessTrainingRegisterRoute: typeof AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren
}

const AuthenticatedWorkforceReadinessRouteChildren: AuthenticatedWorkforceReadinessRouteChildren =
  {
    AuthenticatedWorkforceReadinessAwarenessCampaignsRoute:
      AuthenticatedWorkforceReadinessAwarenessCampaignsRouteWithChildren,
    AuthenticatedWorkforceReadinessMyTrainingsRoute:
      AuthenticatedWorkforceReadinessMyTrainingsRoute,
    AuthenticatedWorkforceReadinessTrainingRegisterRoute:
      AuthenticatedWorkforceReadinessTrainingRegisterRouteWithChildren,
  }

const AuthenticatedWorkforceReadinessRouteWithChildren =
  AuthenticatedWorkforceReadinessRoute._addFileChildren(
    AuthenticatedWorkforceReadinessRouteChildren,
  )

interface AuthenticatedAiDocumentsRouteChildren {
  AuthenticatedAiDocumentsIndexRoute: typeof AuthenticatedAiDocumentsIndexRoute
  AuthenticatedAiDocumentsDocumentIdExtractRoute: typeof AuthenticatedAiDocumentsDocumentIdExtractRoute
}

const AuthenticatedAiDocumentsRouteChildren: AuthenticatedAiDocumentsRouteChildren =
  {
    AuthenticatedAiDocumentsIndexRoute: AuthenticatedAiDocumentsIndexRoute,
    AuthenticatedAiDocumentsDocumentIdExtractRoute:
      AuthenticatedAiDocumentsDocumentIdExtractRoute,
  }

const AuthenticatedAiDocumentsRouteWithChildren =
  AuthenticatedAiDocumentsRoute._addFileChildren(
    AuthenticatedAiDocumentsRouteChildren,
  )

interface AuthenticatedDatahubEntryRouteChildren {
  AuthenticatedDatahubEntryWizardRoute: typeof AuthenticatedDatahubEntryWizardRoute
}

const AuthenticatedDatahubEntryRouteChildren: AuthenticatedDatahubEntryRouteChildren =
  {
    AuthenticatedDatahubEntryWizardRoute: AuthenticatedDatahubEntryWizardRoute,
  }

const AuthenticatedDatahubEntryRouteWithChildren =
  AuthenticatedDatahubEntryRoute._addFileChildren(
    AuthenticatedDatahubEntryRouteChildren,
  )

interface AuthenticatedEmployeesEmployeeIdRouteChildren {
  AuthenticatedEmployeesEmployeeIdEditRoute: typeof AuthenticatedEmployeesEmployeeIdEditRoute
  AuthenticatedEmployeesEmployeeIdIndexRoute: typeof AuthenticatedEmployeesEmployeeIdIndexRoute
}

const AuthenticatedEmployeesEmployeeIdRouteChildren: AuthenticatedEmployeesEmployeeIdRouteChildren =
  {
    AuthenticatedEmployeesEmployeeIdEditRoute:
      AuthenticatedEmployeesEmployeeIdEditRoute,
    AuthenticatedEmployeesEmployeeIdIndexRoute:
      AuthenticatedEmployeesEmployeeIdIndexRoute,
  }

const AuthenticatedEmployeesEmployeeIdRouteWithChildren =
  AuthenticatedEmployeesEmployeeIdRoute._addFileChildren(
    AuthenticatedEmployeesEmployeeIdRouteChildren,
  )

interface AuthenticatedIncidentsSettingsRouteChildren {
  AuthenticatedIncidentsSettingsSlaRoute: typeof AuthenticatedIncidentsSettingsSlaRoute
}

const AuthenticatedIncidentsSettingsRouteChildren: AuthenticatedIncidentsSettingsRouteChildren =
  {
    AuthenticatedIncidentsSettingsSlaRoute:
      AuthenticatedIncidentsSettingsSlaRoute,
  }

const AuthenticatedIncidentsSettingsRouteWithChildren =
  AuthenticatedIncidentsSettingsRoute._addFileChildren(
    AuthenticatedIncidentsSettingsRouteChildren,
  )

interface AuthenticatedPoliciesPolicyIdRouteChildren {
  AuthenticatedPoliciesPolicyIdEditRoute: typeof AuthenticatedPoliciesPolicyIdEditRoute
  AuthenticatedPoliciesPolicyIdReviewRoute: typeof AuthenticatedPoliciesPolicyIdReviewRoute
  AuthenticatedPoliciesPolicyIdScansScanIdRoute: typeof AuthenticatedPoliciesPolicyIdScansScanIdRoute
}

const AuthenticatedPoliciesPolicyIdRouteChildren: AuthenticatedPoliciesPolicyIdRouteChildren =
  {
    AuthenticatedPoliciesPolicyIdEditRoute:
      AuthenticatedPoliciesPolicyIdEditRoute,
    AuthenticatedPoliciesPolicyIdReviewRoute:
      AuthenticatedPoliciesPolicyIdReviewRoute,
    AuthenticatedPoliciesPolicyIdScansScanIdRoute:
      AuthenticatedPoliciesPolicyIdScansScanIdRoute,
  }

const AuthenticatedPoliciesPolicyIdRouteWithChildren =
  AuthenticatedPoliciesPolicyIdRoute._addFileChildren(
    AuthenticatedPoliciesPolicyIdRouteChildren,
  )

interface AuthenticatedSuppliersSupplierIdRouteChildren {
  AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute: typeof AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute
}

const AuthenticatedSuppliersSupplierIdRouteChildren: AuthenticatedSuppliersSupplierIdRouteChildren =
  {
    AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute:
      AuthenticatedSuppliersSupplierIdReviewsReviewIdRoute,
  }

const AuthenticatedSuppliersSupplierIdRouteWithChildren =
  AuthenticatedSuppliersSupplierIdRoute._addFileChildren(
    AuthenticatedSuppliersSupplierIdRouteChildren,
  )

interface AuthenticatedTasksConsoleRouteChildren {
  AuthenticatedTasksConsoleApprovalsRoute: typeof AuthenticatedTasksConsoleApprovalsRoute
}

const AuthenticatedTasksConsoleRouteChildren: AuthenticatedTasksConsoleRouteChildren =
  {
    AuthenticatedTasksConsoleApprovalsRoute:
      AuthenticatedTasksConsoleApprovalsRoute,
  }

const AuthenticatedTasksConsoleRouteWithChildren =
  AuthenticatedTasksConsoleRoute._addFileChildren(
    AuthenticatedTasksConsoleRouteChildren,
  )

interface AuthenticatedDatahubCollectionsCollectionIdRouteChildren {
  AuthenticatedDatahubCollectionsCollectionIdEntryRoute: typeof AuthenticatedDatahubCollectionsCollectionIdEntryRoute
  AuthenticatedDatahubCollectionsCollectionIdImportRoute: typeof AuthenticatedDatahubCollectionsCollectionIdImportRoute
  AuthenticatedDatahubCollectionsCollectionIdIndexRoute: typeof AuthenticatedDatahubCollectionsCollectionIdIndexRoute
}

const AuthenticatedDatahubCollectionsCollectionIdRouteChildren: AuthenticatedDatahubCollectionsCollectionIdRouteChildren =
  {
    AuthenticatedDatahubCollectionsCollectionIdEntryRoute:
      AuthenticatedDatahubCollectionsCollectionIdEntryRoute,
    AuthenticatedDatahubCollectionsCollectionIdImportRoute:
      AuthenticatedDatahubCollectionsCollectionIdImportRoute,
    AuthenticatedDatahubCollectionsCollectionIdIndexRoute:
      AuthenticatedDatahubCollectionsCollectionIdIndexRoute,
  }

const AuthenticatedDatahubCollectionsCollectionIdRouteWithChildren =
  AuthenticatedDatahubCollectionsCollectionIdRoute._addFileChildren(
    AuthenticatedDatahubCollectionsCollectionIdRouteChildren,
  )

interface AuthenticatedDatahubDatapointsDatapointIdRouteChildren {
  AuthenticatedDatahubDatapointsDatapointIdEntryRoute: typeof AuthenticatedDatahubDatapointsDatapointIdEntryRoute
}

const AuthenticatedDatahubDatapointsDatapointIdRouteChildren: AuthenticatedDatahubDatapointsDatapointIdRouteChildren =
  {
    AuthenticatedDatahubDatapointsDatapointIdEntryRoute:
      AuthenticatedDatahubDatapointsDatapointIdEntryRoute,
  }

const AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren =
  AuthenticatedDatahubDatapointsDatapointIdRoute._addFileChildren(
    AuthenticatedDatahubDatapointsDatapointIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRouteWithChildren
  AuthenticatedBcpRoute: typeof AuthenticatedBcpRouteWithChildren
  AuthenticatedControlsRoute: typeof AuthenticatedControlsRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEsgRoute: typeof AuthenticatedEsgRouteWithChildren
  AuthenticatedEuTaxonomyRoute: typeof AuthenticatedEuTaxonomyRouteWithChildren
  AuthenticatedGhgRoute: typeof AuthenticatedGhgRouteWithChildren
  AuthenticatedHelpCentreRoute: typeof AuthenticatedHelpCentreRouteWithChildren
  AuthenticatedNis2Route: typeof AuthenticatedNis2RouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedVsmeRoute: typeof AuthenticatedVsmeRouteWithChildren
  AuthenticatedWorkforceReadinessRoute: typeof AuthenticatedWorkforceReadinessRouteWithChildren
  AuthenticatedAdminAiCostsRoute: typeof AuthenticatedAdminAiCostsRoute
  AuthenticatedAdminKnowledgeBasesRoute: typeof AuthenticatedAdminKnowledgeBasesRoute
  AuthenticatedAdminLlmSettingsRoute: typeof AuthenticatedAdminLlmSettingsRoute
  AuthenticatedAdminOrganizationsRoute: typeof AuthenticatedAdminOrganizationsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminSystemPromptsRoute: typeof AuthenticatedAdminSystemPromptsRoute
  AuthenticatedAiDocumentsRoute: typeof AuthenticatedAiDocumentsRouteWithChildren
  AuthenticatedAiInsightsRoute: typeof AuthenticatedAiInsightsRoute
  AuthenticatedAiQualityRoute: typeof AuthenticatedAiQualityRoute
  AuthenticatedAiUsageRoute: typeof AuthenticatedAiUsageRoute
  AuthenticatedAssetsAssetIdRoute: typeof AuthenticatedAssetsAssetIdRoute
  AuthenticatedAssetsImportRoute: typeof AuthenticatedAssetsImportRoute
  AuthenticatedAuditCalendarRoute: typeof AuthenticatedAuditCalendarRoute
  AuthenticatedAuditEvidenceLibraryRoute: typeof AuthenticatedAuditEvidenceLibraryRoute
  AuthenticatedAuditEvidenceUploadRoute: typeof AuthenticatedAuditEvidenceUploadRoute
  AuthenticatedAuditFindingsRoute: typeof AuthenticatedAuditFindingsRoute
  AuthenticatedAuditReportsRoute: typeof AuthenticatedAuditReportsRoute
  AuthenticatedComplianceAlertsRoute: typeof AuthenticatedComplianceAlertsRoute
  AuthenticatedDatahubAuditRoute: typeof AuthenticatedDatahubAuditRoute
  AuthenticatedDatahubComparisonRoute: typeof AuthenticatedDatahubComparisonRoute
  AuthenticatedDatahubConsolidatedRoute: typeof AuthenticatedDatahubConsolidatedRoute
  AuthenticatedDatahubDocumentsRoute: typeof AuthenticatedDatahubDocumentsRoute
  AuthenticatedDatahubEntryRoute: typeof AuthenticatedDatahubEntryRouteWithChildren
  AuthenticatedDatahubMyEntriesRoute: typeof AuthenticatedDatahubMyEntriesRoute
  AuthenticatedDatahubPeriodsRoute: typeof AuthenticatedDatahubPeriodsRoute
  AuthenticatedDatahubQualityDashboardRoute: typeof AuthenticatedDatahubQualityDashboardRoute
  AuthenticatedDatahubQualityIssuesRoute: typeof AuthenticatedDatahubQualityIssuesRoute
  AuthenticatedDatahubTemplatesRoute: typeof AuthenticatedDatahubTemplatesRoute
  AuthenticatedDatahubUploadRoute: typeof AuthenticatedDatahubUploadRoute
  AuthenticatedDatahubValidationErrorsRoute: typeof AuthenticatedDatahubValidationErrorsRoute
  AuthenticatedEmployeesEmployeeIdRoute: typeof AuthenticatedEmployeesEmployeeIdRouteWithChildren
  AuthenticatedEmployeesImportRoute: typeof AuthenticatedEmployeesImportRoute
  AuthenticatedEmployeesNewRoute: typeof AuthenticatedEmployeesNewRoute
  AuthenticatedEvidenceEvidenceIdRoute: typeof AuthenticatedEvidenceEvidenceIdRoute
  AuthenticatedEvidenceLogsRoute: typeof AuthenticatedEvidenceLogsRoute
  AuthenticatedEvidenceRepositoryRoute: typeof AuthenticatedEvidenceRepositoryRoute
  AuthenticatedExternalReportingReportIdRoute: typeof AuthenticatedExternalReportingReportIdRoute
  AuthenticatedIncidentsIncidentIdRoute: typeof AuthenticatedIncidentsIncidentIdRoute
  AuthenticatedIncidentsDashboardRoute: typeof AuthenticatedIncidentsDashboardRoute
  AuthenticatedIncidentsNewRoute: typeof AuthenticatedIncidentsNewRoute
  AuthenticatedIncidentsQuickReportRoute: typeof AuthenticatedIncidentsQuickReportRoute
  AuthenticatedIncidentsSettingsRoute: typeof AuthenticatedIncidentsSettingsRouteWithChildren
  AuthenticatedIncidentsSubsidiariesRoute: typeof AuthenticatedIncidentsSubsidiariesRoute
  AuthenticatedPoliciesPolicyIdRoute: typeof AuthenticatedPoliciesPolicyIdRouteWithChildren
  AuthenticatedPoliciesComplianceDashboardRoute: typeof AuthenticatedPoliciesComplianceDashboardRoute
  AuthenticatedPoliciesCreateRoute: typeof AuthenticatedPoliciesCreateRoute
  AuthenticatedPoliciesDocumentsRoute: typeof AuthenticatedPoliciesDocumentsRoute
  AuthenticatedPoliciesWizardRoute: typeof AuthenticatedPoliciesWizardRoute
  AuthenticatedProceduresProcedureIdRoute: typeof AuthenticatedProceduresProcedureIdRoute
  AuthenticatedRisksRiskIdRoute: typeof AuthenticatedRisksRiskIdRoute
  AuthenticatedRisksAiSuggestionsRoute: typeof AuthenticatedRisksAiSuggestionsRoute
  AuthenticatedRisksDashboardRoute: typeof AuthenticatedRisksDashboardRoute
  AuthenticatedRisksHeatmapRoute: typeof AuthenticatedRisksHeatmapRoute
  AuthenticatedRisksNewRoute: typeof AuthenticatedRisksNewRoute
  AuthenticatedSuppliersSupplierIdRoute: typeof AuthenticatedSuppliersSupplierIdRouteWithChildren
  AuthenticatedSuppliersComplianceMatrixRoute: typeof AuthenticatedSuppliersComplianceMatrixRoute
  AuthenticatedSuppliersRegisterRoute: typeof AuthenticatedSuppliersRegisterRoute
  AuthenticatedSuppliersRiskRoute: typeof AuthenticatedSuppliersRiskRoute
  AuthenticatedTasksTaskIdRoute: typeof AuthenticatedTasksTaskIdRoute
  AuthenticatedTasksApprovalsRoute: typeof AuthenticatedTasksApprovalsRoute
  AuthenticatedTasksConsoleRoute: typeof AuthenticatedTasksConsoleRouteWithChildren
  AuthenticatedTasksMyRoute: typeof AuthenticatedTasksMyRoute
  AuthenticatedVulnerabilitiesVulnerabilityIdRoute: typeof AuthenticatedVulnerabilitiesVulnerabilityIdRoute
  AuthenticatedVulnerabilitiesAuditReportRoute: typeof AuthenticatedVulnerabilitiesAuditReportRoute
  AuthenticatedVulnerabilitiesConsolidatedReportRoute: typeof AuthenticatedVulnerabilitiesConsolidatedReportRoute
  AuthenticatedVulnerabilitiesDashboardRoute: typeof AuthenticatedVulnerabilitiesDashboardRoute
  AuthenticatedVulnerabilitiesNewRoute: typeof AuthenticatedVulnerabilitiesNewRoute
  AuthenticatedVulnerabilitiesNis2ReportRoute: typeof AuthenticatedVulnerabilitiesNis2ReportRoute
  AuthenticatedVulnerabilitiesSettingsRoute: typeof AuthenticatedVulnerabilitiesSettingsRoute
  AuthenticatedVulnerabilitiesSlaReportRoute: typeof AuthenticatedVulnerabilitiesSlaReportRoute
  AuthenticatedVulnerabilitiesSoc2ComplianceRoute: typeof AuthenticatedVulnerabilitiesSoc2ComplianceRoute
  AuthenticatedVulnerabilitiesSubsidiariesRoute: typeof AuthenticatedVulnerabilitiesSubsidiariesRoute
  AuthenticatedVulnerabilitiesWorkspaceRoute: typeof AuthenticatedVulnerabilitiesWorkspaceRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAiIndexRoute: typeof AuthenticatedAiIndexRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedDatahubIndexRoute: typeof AuthenticatedDatahubIndexRoute
  AuthenticatedEmployeesIndexRoute: typeof AuthenticatedEmployeesIndexRoute
  AuthenticatedEvidenceIndexRoute: typeof AuthenticatedEvidenceIndexRoute
  AuthenticatedExternalReportingIndexRoute: typeof AuthenticatedExternalReportingIndexRoute
  AuthenticatedGapsIndexRoute: typeof AuthenticatedGapsIndexRoute
  AuthenticatedIncidentsIndexRoute: typeof AuthenticatedIncidentsIndexRoute
  AuthenticatedPoliciesIndexRoute: typeof AuthenticatedPoliciesIndexRoute
  AuthenticatedProceduresIndexRoute: typeof AuthenticatedProceduresIndexRoute
  AuthenticatedRisksIndexRoute: typeof AuthenticatedRisksIndexRoute
  AuthenticatedSuppliersIndexRoute: typeof AuthenticatedSuppliersIndexRoute
  AuthenticatedSurveysIndexRoute: typeof AuthenticatedSurveysIndexRoute
  AuthenticatedThreatsIndexRoute: typeof AuthenticatedThreatsIndexRoute
  AuthenticatedVulnerabilitiesIndexRoute: typeof AuthenticatedVulnerabilitiesIndexRoute
  AuthenticatedAdminIncidentsTagsRoute: typeof AuthenticatedAdminIncidentsTagsRoute
  AuthenticatedAdminPoliciesAccessControlsRoute: typeof AuthenticatedAdminPoliciesAccessControlsRoute
  AuthenticatedAdminPoliciesApprovalConfigsRoute: typeof AuthenticatedAdminPoliciesApprovalConfigsRoute
  AuthenticatedAdminPoliciesTemplatesRoute: typeof AuthenticatedAdminPoliciesTemplatesRoute
  AuthenticatedAiOnboardingModuleRoute: typeof AuthenticatedAiOnboardingModuleRoute
  AuthenticatedAiScansScanIdRoute: typeof AuthenticatedAiScansScanIdRoute
  AuthenticatedAuditAuditsNewRoute: typeof AuthenticatedAuditAuditsNewRoute
  AuthenticatedAuditEvidenceEvidenceIdRoute: typeof AuthenticatedAuditEvidenceEvidenceIdRoute
  AuthenticatedDatahubCollectionsCollectionIdRoute: typeof AuthenticatedDatahubCollectionsCollectionIdRouteWithChildren
  AuthenticatedDatahubDatapointsDatapointIdRoute: typeof AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren
  AuthenticatedDatahubGovernanceApprovalConfigRoute: typeof AuthenticatedDatahubGovernanceApprovalConfigRoute
  AuthenticatedDatahubGovernanceApprovalQueueRoute: typeof AuthenticatedDatahubGovernanceApprovalQueueRoute
  AuthenticatedDatahubGovernanceScheduledExportsRoute: typeof AuthenticatedDatahubGovernanceScheduledExportsRoute
  AuthenticatedDatahubIntegrationsTransformationRulesRoute: typeof AuthenticatedDatahubIntegrationsTransformationRulesRoute
  AuthenticatedEvidenceAttestationsNewRoute: typeof AuthenticatedEvidenceAttestationsNewRoute
  AuthenticatedSuppliersAdminRiskConfigRoute: typeof AuthenticatedSuppliersAdminRiskConfigRoute
  AuthenticatedSurveysCampaignsCampaignIdRoute: typeof AuthenticatedSurveysCampaignsCampaignIdRoute
  AuthenticatedSurveysCampaignsNewRoute: typeof AuthenticatedSurveysCampaignsNewRoute
  AuthenticatedSurveysTemplatesTemplateIdRoute: typeof AuthenticatedSurveysTemplatesTemplateIdRoute
  AuthenticatedSurveysTemplatesNewRoute: typeof AuthenticatedSurveysTemplatesNewRoute
  AuthenticatedTasksPlaybooksActivateRoute: typeof AuthenticatedTasksPlaybooksActivateRoute
  AuthenticatedAiScansIndexRoute: typeof AuthenticatedAiScansIndexRoute
  AuthenticatedAuditAuditsIndexRoute: typeof AuthenticatedAuditAuditsIndexRoute
  AuthenticatedAuditEvidenceIndexRoute: typeof AuthenticatedAuditEvidenceIndexRoute
  AuthenticatedDatahubCollectionsIndexRoute: typeof AuthenticatedDatahubCollectionsIndexRoute
  AuthenticatedDatahubDatapointsIndexRoute: typeof AuthenticatedDatahubDatapointsIndexRoute
  AuthenticatedDatahubIntegrationsIndexRoute: typeof AuthenticatedDatahubIntegrationsIndexRoute
  AuthenticatedRisksApprovalsIndexRoute: typeof AuthenticatedRisksApprovalsIndexRoute
  AuthenticatedSurveysCampaignsIndexRoute: typeof AuthenticatedSurveysCampaignsIndexRoute
  AuthenticatedSurveysSchedulesIndexRoute: typeof AuthenticatedSurveysSchedulesIndexRoute
  AuthenticatedTasksPlaybooksIndexRoute: typeof AuthenticatedTasksPlaybooksIndexRoute
  AuthenticatedVulnerabilitiesApprovalsIndexRoute: typeof AuthenticatedVulnerabilitiesApprovalsIndexRoute
  AuthenticatedAuditAuditsAuditIdSettingsRoute: typeof AuthenticatedAuditAuditsAuditIdSettingsRoute
  AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute: typeof AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute
  AuthenticatedDatahubUploadsUploadIdMapRoute: typeof AuthenticatedDatahubUploadsUploadIdMapRoute
  AuthenticatedDatahubUploadsUploadIdReviewRoute: typeof AuthenticatedDatahubUploadsUploadIdReviewRoute
  AuthenticatedPoliciesProceduresInstanceIdExecuteRoute: typeof AuthenticatedPoliciesProceduresInstanceIdExecuteRoute
  AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute
  AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute
  AuthenticatedSuppliersQuestionnairesSentIdReviewRoute: typeof AuthenticatedSuppliersQuestionnairesSentIdReviewRoute
  AuthenticatedTasksPlaybooksActivationIdSetupRoute: typeof AuthenticatedTasksPlaybooksActivationIdSetupRoute
  AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute: typeof AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute
  AuthenticatedTasksPlaybooksTemplatesNewRoute: typeof AuthenticatedTasksPlaybooksTemplatesNewRoute
  AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute: typeof AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute
  AuthenticatedAuditAuditsAuditIdIndexRoute: typeof AuthenticatedAuditAuditsAuditIdIndexRoute
  AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute: typeof AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute
  AuthenticatedTasksPlaybooksActivationIdIndexRoute: typeof AuthenticatedTasksPlaybooksActivationIdIndexRoute
  AuthenticatedTasksPlaybooksTemplatesIndexRoute: typeof AuthenticatedTasksPlaybooksTemplatesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRouteWithChildren,
  AuthenticatedBcpRoute: AuthenticatedBcpRouteWithChildren,
  AuthenticatedControlsRoute: AuthenticatedControlsRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEsgRoute: AuthenticatedEsgRouteWithChildren,
  AuthenticatedEuTaxonomyRoute: AuthenticatedEuTaxonomyRouteWithChildren,
  AuthenticatedGhgRoute: AuthenticatedGhgRouteWithChildren,
  AuthenticatedHelpCentreRoute: AuthenticatedHelpCentreRouteWithChildren,
  AuthenticatedNis2Route: AuthenticatedNis2RouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedVsmeRoute: AuthenticatedVsmeRouteWithChildren,
  AuthenticatedWorkforceReadinessRoute:
    AuthenticatedWorkforceReadinessRouteWithChildren,
  AuthenticatedAdminAiCostsRoute: AuthenticatedAdminAiCostsRoute,
  AuthenticatedAdminKnowledgeBasesRoute: AuthenticatedAdminKnowledgeBasesRoute,
  AuthenticatedAdminLlmSettingsRoute: AuthenticatedAdminLlmSettingsRoute,
  AuthenticatedAdminOrganizationsRoute: AuthenticatedAdminOrganizationsRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminSystemPromptsRoute: AuthenticatedAdminSystemPromptsRoute,
  AuthenticatedAiDocumentsRoute: AuthenticatedAiDocumentsRouteWithChildren,
  AuthenticatedAiInsightsRoute: AuthenticatedAiInsightsRoute,
  AuthenticatedAiQualityRoute: AuthenticatedAiQualityRoute,
  AuthenticatedAiUsageRoute: AuthenticatedAiUsageRoute,
  AuthenticatedAssetsAssetIdRoute: AuthenticatedAssetsAssetIdRoute,
  AuthenticatedAssetsImportRoute: AuthenticatedAssetsImportRoute,
  AuthenticatedAuditCalendarRoute: AuthenticatedAuditCalendarRoute,
  AuthenticatedAuditEvidenceLibraryRoute:
    AuthenticatedAuditEvidenceLibraryRoute,
  AuthenticatedAuditEvidenceUploadRoute: AuthenticatedAuditEvidenceUploadRoute,
  AuthenticatedAuditFindingsRoute: AuthenticatedAuditFindingsRoute,
  AuthenticatedAuditReportsRoute: AuthenticatedAuditReportsRoute,
  AuthenticatedComplianceAlertsRoute: AuthenticatedComplianceAlertsRoute,
  AuthenticatedDatahubAuditRoute: AuthenticatedDatahubAuditRoute,
  AuthenticatedDatahubComparisonRoute: AuthenticatedDatahubComparisonRoute,
  AuthenticatedDatahubConsolidatedRoute: AuthenticatedDatahubConsolidatedRoute,
  AuthenticatedDatahubDocumentsRoute: AuthenticatedDatahubDocumentsRoute,
  AuthenticatedDatahubEntryRoute: AuthenticatedDatahubEntryRouteWithChildren,
  AuthenticatedDatahubMyEntriesRoute: AuthenticatedDatahubMyEntriesRoute,
  AuthenticatedDatahubPeriodsRoute: AuthenticatedDatahubPeriodsRoute,
  AuthenticatedDatahubQualityDashboardRoute:
    AuthenticatedDatahubQualityDashboardRoute,
  AuthenticatedDatahubQualityIssuesRoute:
    AuthenticatedDatahubQualityIssuesRoute,
  AuthenticatedDatahubTemplatesRoute: AuthenticatedDatahubTemplatesRoute,
  AuthenticatedDatahubUploadRoute: AuthenticatedDatahubUploadRoute,
  AuthenticatedDatahubValidationErrorsRoute:
    AuthenticatedDatahubValidationErrorsRoute,
  AuthenticatedEmployeesEmployeeIdRoute:
    AuthenticatedEmployeesEmployeeIdRouteWithChildren,
  AuthenticatedEmployeesImportRoute: AuthenticatedEmployeesImportRoute,
  AuthenticatedEmployeesNewRoute: AuthenticatedEmployeesNewRoute,
  AuthenticatedEvidenceEvidenceIdRoute: AuthenticatedEvidenceEvidenceIdRoute,
  AuthenticatedEvidenceLogsRoute: AuthenticatedEvidenceLogsRoute,
  AuthenticatedEvidenceRepositoryRoute: AuthenticatedEvidenceRepositoryRoute,
  AuthenticatedExternalReportingReportIdRoute:
    AuthenticatedExternalReportingReportIdRoute,
  AuthenticatedIncidentsIncidentIdRoute: AuthenticatedIncidentsIncidentIdRoute,
  AuthenticatedIncidentsDashboardRoute: AuthenticatedIncidentsDashboardRoute,
  AuthenticatedIncidentsNewRoute: AuthenticatedIncidentsNewRoute,
  AuthenticatedIncidentsQuickReportRoute:
    AuthenticatedIncidentsQuickReportRoute,
  AuthenticatedIncidentsSettingsRoute:
    AuthenticatedIncidentsSettingsRouteWithChildren,
  AuthenticatedIncidentsSubsidiariesRoute:
    AuthenticatedIncidentsSubsidiariesRoute,
  AuthenticatedPoliciesPolicyIdRoute:
    AuthenticatedPoliciesPolicyIdRouteWithChildren,
  AuthenticatedPoliciesComplianceDashboardRoute:
    AuthenticatedPoliciesComplianceDashboardRoute,
  AuthenticatedPoliciesCreateRoute: AuthenticatedPoliciesCreateRoute,
  AuthenticatedPoliciesDocumentsRoute: AuthenticatedPoliciesDocumentsRoute,
  AuthenticatedPoliciesWizardRoute: AuthenticatedPoliciesWizardRoute,
  AuthenticatedProceduresProcedureIdRoute:
    AuthenticatedProceduresProcedureIdRoute,
  AuthenticatedRisksRiskIdRoute: AuthenticatedRisksRiskIdRoute,
  AuthenticatedRisksAiSuggestionsRoute: AuthenticatedRisksAiSuggestionsRoute,
  AuthenticatedRisksDashboardRoute: AuthenticatedRisksDashboardRoute,
  AuthenticatedRisksHeatmapRoute: AuthenticatedRisksHeatmapRoute,
  AuthenticatedRisksNewRoute: AuthenticatedRisksNewRoute,
  AuthenticatedSuppliersSupplierIdRoute:
    AuthenticatedSuppliersSupplierIdRouteWithChildren,
  AuthenticatedSuppliersComplianceMatrixRoute:
    AuthenticatedSuppliersComplianceMatrixRoute,
  AuthenticatedSuppliersRegisterRoute: AuthenticatedSuppliersRegisterRoute,
  AuthenticatedSuppliersRiskRoute: AuthenticatedSuppliersRiskRoute,
  AuthenticatedTasksTaskIdRoute: AuthenticatedTasksTaskIdRoute,
  AuthenticatedTasksApprovalsRoute: AuthenticatedTasksApprovalsRoute,
  AuthenticatedTasksConsoleRoute: AuthenticatedTasksConsoleRouteWithChildren,
  AuthenticatedTasksMyRoute: AuthenticatedTasksMyRoute,
  AuthenticatedVulnerabilitiesVulnerabilityIdRoute:
    AuthenticatedVulnerabilitiesVulnerabilityIdRoute,
  AuthenticatedVulnerabilitiesAuditReportRoute:
    AuthenticatedVulnerabilitiesAuditReportRoute,
  AuthenticatedVulnerabilitiesConsolidatedReportRoute:
    AuthenticatedVulnerabilitiesConsolidatedReportRoute,
  AuthenticatedVulnerabilitiesDashboardRoute:
    AuthenticatedVulnerabilitiesDashboardRoute,
  AuthenticatedVulnerabilitiesNewRoute: AuthenticatedVulnerabilitiesNewRoute,
  AuthenticatedVulnerabilitiesNis2ReportRoute:
    AuthenticatedVulnerabilitiesNis2ReportRoute,
  AuthenticatedVulnerabilitiesSettingsRoute:
    AuthenticatedVulnerabilitiesSettingsRoute,
  AuthenticatedVulnerabilitiesSlaReportRoute:
    AuthenticatedVulnerabilitiesSlaReportRoute,
  AuthenticatedVulnerabilitiesSoc2ComplianceRoute:
    AuthenticatedVulnerabilitiesSoc2ComplianceRoute,
  AuthenticatedVulnerabilitiesSubsidiariesRoute:
    AuthenticatedVulnerabilitiesSubsidiariesRoute,
  AuthenticatedVulnerabilitiesWorkspaceRoute:
    AuthenticatedVulnerabilitiesWorkspaceRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAiIndexRoute: AuthenticatedAiIndexRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedDatahubIndexRoute: AuthenticatedDatahubIndexRoute,
  AuthenticatedEmployeesIndexRoute: AuthenticatedEmployeesIndexRoute,
  AuthenticatedEvidenceIndexRoute: AuthenticatedEvidenceIndexRoute,
  AuthenticatedExternalReportingIndexRoute:
    AuthenticatedExternalReportingIndexRoute,
  AuthenticatedGapsIndexRoute: AuthenticatedGapsIndexRoute,
  AuthenticatedIncidentsIndexRoute: AuthenticatedIncidentsIndexRoute,
  AuthenticatedPoliciesIndexRoute: AuthenticatedPoliciesIndexRoute,
  AuthenticatedProceduresIndexRoute: AuthenticatedProceduresIndexRoute,
  AuthenticatedRisksIndexRoute: AuthenticatedRisksIndexRoute,
  AuthenticatedSuppliersIndexRoute: AuthenticatedSuppliersIndexRoute,
  AuthenticatedSurveysIndexRoute: AuthenticatedSurveysIndexRoute,
  AuthenticatedThreatsIndexRoute: AuthenticatedThreatsIndexRoute,
  AuthenticatedVulnerabilitiesIndexRoute:
    AuthenticatedVulnerabilitiesIndexRoute,
  AuthenticatedAdminIncidentsTagsRoute: AuthenticatedAdminIncidentsTagsRoute,
  AuthenticatedAdminPoliciesAccessControlsRoute:
    AuthenticatedAdminPoliciesAccessControlsRoute,
  AuthenticatedAdminPoliciesApprovalConfigsRoute:
    AuthenticatedAdminPoliciesApprovalConfigsRoute,
  AuthenticatedAdminPoliciesTemplatesRoute:
    AuthenticatedAdminPoliciesTemplatesRoute,
  AuthenticatedAiOnboardingModuleRoute: AuthenticatedAiOnboardingModuleRoute,
  AuthenticatedAiScansScanIdRoute: AuthenticatedAiScansScanIdRoute,
  AuthenticatedAuditAuditsNewRoute: AuthenticatedAuditAuditsNewRoute,
  AuthenticatedAuditEvidenceEvidenceIdRoute:
    AuthenticatedAuditEvidenceEvidenceIdRoute,
  AuthenticatedDatahubCollectionsCollectionIdRoute:
    AuthenticatedDatahubCollectionsCollectionIdRouteWithChildren,
  AuthenticatedDatahubDatapointsDatapointIdRoute:
    AuthenticatedDatahubDatapointsDatapointIdRouteWithChildren,
  AuthenticatedDatahubGovernanceApprovalConfigRoute:
    AuthenticatedDatahubGovernanceApprovalConfigRoute,
  AuthenticatedDatahubGovernanceApprovalQueueRoute:
    AuthenticatedDatahubGovernanceApprovalQueueRoute,
  AuthenticatedDatahubGovernanceScheduledExportsRoute:
    AuthenticatedDatahubGovernanceScheduledExportsRoute,
  AuthenticatedDatahubIntegrationsTransformationRulesRoute:
    AuthenticatedDatahubIntegrationsTransformationRulesRoute,
  AuthenticatedEvidenceAttestationsNewRoute:
    AuthenticatedEvidenceAttestationsNewRoute,
  AuthenticatedSuppliersAdminRiskConfigRoute:
    AuthenticatedSuppliersAdminRiskConfigRoute,
  AuthenticatedSurveysCampaignsCampaignIdRoute:
    AuthenticatedSurveysCampaignsCampaignIdRoute,
  AuthenticatedSurveysCampaignsNewRoute: AuthenticatedSurveysCampaignsNewRoute,
  AuthenticatedSurveysTemplatesTemplateIdRoute:
    AuthenticatedSurveysTemplatesTemplateIdRoute,
  AuthenticatedSurveysTemplatesNewRoute: AuthenticatedSurveysTemplatesNewRoute,
  AuthenticatedTasksPlaybooksActivateRoute:
    AuthenticatedTasksPlaybooksActivateRoute,
  AuthenticatedAiScansIndexRoute: AuthenticatedAiScansIndexRoute,
  AuthenticatedAuditAuditsIndexRoute: AuthenticatedAuditAuditsIndexRoute,
  AuthenticatedAuditEvidenceIndexRoute: AuthenticatedAuditEvidenceIndexRoute,
  AuthenticatedDatahubCollectionsIndexRoute:
    AuthenticatedDatahubCollectionsIndexRoute,
  AuthenticatedDatahubDatapointsIndexRoute:
    AuthenticatedDatahubDatapointsIndexRoute,
  AuthenticatedDatahubIntegrationsIndexRoute:
    AuthenticatedDatahubIntegrationsIndexRoute,
  AuthenticatedRisksApprovalsIndexRoute: AuthenticatedRisksApprovalsIndexRoute,
  AuthenticatedSurveysCampaignsIndexRoute:
    AuthenticatedSurveysCampaignsIndexRoute,
  AuthenticatedSurveysSchedulesIndexRoute:
    AuthenticatedSurveysSchedulesIndexRoute,
  AuthenticatedTasksPlaybooksIndexRoute: AuthenticatedTasksPlaybooksIndexRoute,
  AuthenticatedVulnerabilitiesApprovalsIndexRoute:
    AuthenticatedVulnerabilitiesApprovalsIndexRoute,
  AuthenticatedAuditAuditsAuditIdSettingsRoute:
    AuthenticatedAuditAuditsAuditIdSettingsRoute,
  AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute:
    AuthenticatedDatahubIntegrationsIntegrationIdMappingsRoute,
  AuthenticatedDatahubUploadsUploadIdMapRoute:
    AuthenticatedDatahubUploadsUploadIdMapRoute,
  AuthenticatedDatahubUploadsUploadIdReviewRoute:
    AuthenticatedDatahubUploadsUploadIdReviewRoute,
  AuthenticatedPoliciesProceduresInstanceIdExecuteRoute:
    AuthenticatedPoliciesProceduresInstanceIdExecuteRoute,
  AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute:
    AuthenticatedSuppliersAdminQuestionnaireTemplatesTemplateIdRoute,
  AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute:
    AuthenticatedSuppliersAdminQuestionnaireTemplatesNewRoute,
  AuthenticatedSuppliersQuestionnairesSentIdReviewRoute:
    AuthenticatedSuppliersQuestionnairesSentIdReviewRoute,
  AuthenticatedTasksPlaybooksActivationIdSetupRoute:
    AuthenticatedTasksPlaybooksActivationIdSetupRoute,
  AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute:
    AuthenticatedTasksPlaybooksTemplatesTemplateIdRoute,
  AuthenticatedTasksPlaybooksTemplatesNewRoute:
    AuthenticatedTasksPlaybooksTemplatesNewRoute,
  AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute:
    AuthenticatedTasksPlaybooksTemplatesTaskTemplatesRoute,
  AuthenticatedAuditAuditsAuditIdIndexRoute:
    AuthenticatedAuditAuditsAuditIdIndexRoute,
  AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute:
    AuthenticatedSuppliersAdminQuestionnaireTemplatesIndexRoute,
  AuthenticatedTasksPlaybooksActivationIdIndexRoute:
    AuthenticatedTasksPlaybooksActivationIdIndexRoute,
  AuthenticatedTasksPlaybooksTemplatesIndexRoute:
    AuthenticatedTasksPlaybooksTemplatesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuditorAccessAccessIdBcpPlansRouteChildren {
  AuditorAccessAccessIdBcpPlansPlanIdRoute: typeof AuditorAccessAccessIdBcpPlansPlanIdRoute
}

const AuditorAccessAccessIdBcpPlansRouteChildren: AuditorAccessAccessIdBcpPlansRouteChildren =
  {
    AuditorAccessAccessIdBcpPlansPlanIdRoute:
      AuditorAccessAccessIdBcpPlansPlanIdRoute,
  }

const AuditorAccessAccessIdBcpPlansRouteWithChildren =
  AuditorAccessAccessIdBcpPlansRoute._addFileChildren(
    AuditorAccessAccessIdBcpPlansRouteChildren,
  )

interface AuditorAccessAccessIdBcpRouteChildren {
  AuditorAccessAccessIdBcpExercisesRoute: typeof AuditorAccessAccessIdBcpExercisesRoute
  AuditorAccessAccessIdBcpFindingsRoute: typeof AuditorAccessAccessIdBcpFindingsRoute
  AuditorAccessAccessIdBcpPlansRoute: typeof AuditorAccessAccessIdBcpPlansRouteWithChildren
}

const AuditorAccessAccessIdBcpRouteChildren: AuditorAccessAccessIdBcpRouteChildren =
  {
    AuditorAccessAccessIdBcpExercisesRoute:
      AuditorAccessAccessIdBcpExercisesRoute,
    AuditorAccessAccessIdBcpFindingsRoute:
      AuditorAccessAccessIdBcpFindingsRoute,
    AuditorAccessAccessIdBcpPlansRoute:
      AuditorAccessAccessIdBcpPlansRouteWithChildren,
  }

const AuditorAccessAccessIdBcpRouteWithChildren =
  AuditorAccessAccessIdBcpRoute._addFileChildren(
    AuditorAccessAccessIdBcpRouteChildren,
  )

interface AuditorAccessAccessIdNis2RouteChildren {
  AuditorAccessAccessIdNis2AssessmentsRoute: typeof AuditorAccessAccessIdNis2AssessmentsRoute
  AuditorAccessAccessIdNis2EvidenceRoute: typeof AuditorAccessAccessIdNis2EvidenceRoute
  AuditorAccessAccessIdNis2GapsRoute: typeof AuditorAccessAccessIdNis2GapsRoute
  AuditorAccessAccessIdNis2IncidentsRoute: typeof AuditorAccessAccessIdNis2IncidentsRoute
  AuditorAccessAccessIdNis2MeasuresRoute: typeof AuditorAccessAccessIdNis2MeasuresRoute
}

const AuditorAccessAccessIdNis2RouteChildren: AuditorAccessAccessIdNis2RouteChildren =
  {
    AuditorAccessAccessIdNis2AssessmentsRoute:
      AuditorAccessAccessIdNis2AssessmentsRoute,
    AuditorAccessAccessIdNis2EvidenceRoute:
      AuditorAccessAccessIdNis2EvidenceRoute,
    AuditorAccessAccessIdNis2GapsRoute: AuditorAccessAccessIdNis2GapsRoute,
    AuditorAccessAccessIdNis2IncidentsRoute:
      AuditorAccessAccessIdNis2IncidentsRoute,
    AuditorAccessAccessIdNis2MeasuresRoute:
      AuditorAccessAccessIdNis2MeasuresRoute,
  }

const AuditorAccessAccessIdNis2RouteWithChildren =
  AuditorAccessAccessIdNis2Route._addFileChildren(
    AuditorAccessAccessIdNis2RouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuditorTokenRoute: AuditorTokenRoute,
  GhgSurveyTokenRoute: GhgSurveyTokenRoute,
  InviteTokenRoute: InviteTokenRoute,
  QuickReportShareTokenRoute: QuickReportShareTokenRoute,
  SessionTasksSetupMfaRoute: SessionTasksSetupMfaRoute,
  SignInSplatRoute: SignInSplatRoute,
  SignUpOrgIdRoute: SignUpOrgIdRoute,
  SurveyRespondTokenRoute: SurveyRespondTokenRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  SignInIndexRoute: SignInIndexRoute,
  SignUpIndexRoute: SignUpIndexRoute,
  PortalAuthLoginRoute: PortalAuthLoginRoute,
  PortalHistoryTokenRoute: PortalHistoryTokenRoute,
  PortalHomeTokenRoute: PortalHomeTokenRoute,
  PortalProfileTokenRoute: PortalProfileTokenRoute,
  PortalQuestionnaireTokenRoute: PortalQuestionnaireTokenRoute,
  AuditorAccessAccessIdAssetsRoute: AuditorAccessAccessIdAssetsRoute,
  AuditorAccessAccessIdAuditRoute: AuditorAccessAccessIdAuditRoute,
  AuditorAccessAccessIdBcpRoute: AuditorAccessAccessIdBcpRouteWithChildren,
  AuditorAccessAccessIdControlsRoute: AuditorAccessAccessIdControlsRoute,
  AuditorAccessAccessIdNis2Route: AuditorAccessAccessIdNis2RouteWithChildren,
  AuditorAccessAccessIdTasksRoute: AuditorAccessAccessIdTasksRoute,
  PortalAuthCreateAccountTokenRoute: PortalAuthCreateAccountTokenRoute,
  PortalAuthResetPasswordTokenRoute: PortalAuthResetPasswordTokenRoute,
  PortalAuthForgotPasswordIndexRoute: PortalAuthForgotPasswordIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
